
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("4LDqh", function(module, exports) {
$parcel$export(module.exports, "default", () => $327d2828b647ffdb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CLIENT_VERSION", () => (parcelRequire("kwcVN")).CLIENT_VERSION);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $5CHp0 = parcelRequire("5CHp0");

var $kwcVN = parcelRequire("kwcVN");



var $jNPuf = parcelRequire("jNPuf");
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $327d2828b647ffdb$var$FeatureGates {
    static{
        this.client = new (0, $5CHp0.Client)();
    }
    static{
        this.hasCheckGateErrorOccurred = false;
    }
    static{
        this.hasGetExperimentValueErrorOccurred = false;
    }
    static{
        this.checkGate = (gateName, options)=>{
            try {
                // Check if the CRITERION override mechanism is available
                if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
                    // Attempt to retrieve an override value for the feature gate
                    const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
                    // If an override value is found, return it immediately
                    if (overrideValue !== undefined) return overrideValue;
                }
            } catch (error) {
                // Log the first occurrence of the error
                if (!$327d2828b647ffdb$var$FeatureGates.hasCheckGateErrorOccurred) {
                    // eslint-disable-next-line no-console
                    console.warn({
                        msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                        gateName: gateName,
                        error: error
                    });
                    $327d2828b647ffdb$var$FeatureGates.hasCheckGateErrorOccurred = true;
                }
            }
            // Proceed with the main logic if no override is found
            return this.client.checkGate(gateName, options);
        };
    }
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
    static{
        this.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
            try {
                // Check if the CRITERION override mechanism is available
                if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
                    const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
                    if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
                }
            } catch (error) {
                // Log the first occurrence of the error
                if (!$327d2828b647ffdb$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                    // eslint-disable-next-line no-console
                    console.warn({
                        msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                        experimentName: experimentName,
                        defaultValue: defaultValue,
                        options: options,
                        error: error
                    });
                    this.hasGetExperimentValueErrorOccurred = true;
                }
                return defaultValue;
            }
            // Proceed with the main logic if no override is found
            return this.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
        };
    }
    static{
        this.initializeCalled = this.client.initializeCalled.bind(this.client);
    }
    static{
        this.initializeCompleted = this.client.initializeCompleted.bind(this.client);
    }
    static{
        this.waitUntilInitializeCompleted = this.client.waitUntilInitializeCompleted.bind(this.client);
    }
    static{
        this.initialize = this.client.initialize.bind(this.client);
    }
    static{
        this.initializeWithProvider = this.client.initializeWithProvider.bind(this.client);
    }
    static{
        this.initializeFromValues = this.client.initializeFromValues.bind(this.client);
    }
    static{
        this.manuallyLogGateExposure = this.client.manuallyLogGateExposure.bind(this.client);
    }
    static{
        this.getExperiment = this.client.getExperiment.bind(this.client);
    }
    static{
        this.manuallyLogExperimentExposure = this.client.manuallyLogExperimentExposure.bind(this.client);
    }
    static{
        this.manuallyLogLayerExposure = this.client.manuallyLogLayerExposure.bind(this.client);
    }
    static{
        this.shutdownStatsig = this.client.shutdownStatsig.bind(this.client);
    }
    static{
        this.overrideGate = this.client.overrideGate.bind(this.client);
    }
    static{
        this.clearGateOverride = this.client.clearGateOverride.bind(this.client);
    }
    static{
        this.overrideConfig = this.client.overrideConfig.bind(this.client);
    }
    static{
        this.clearConfigOverride = this.client.clearConfigOverride.bind(this.client);
    }
    static{
        this.setOverrides = this.client.setOverrides.bind(this.client);
    }
    static{
        this.getOverrides = this.client.getOverrides.bind(this.client);
    }
    static{
        this.clearAllOverrides = this.client.clearAllOverrides.bind(this.client);
    }
    static{
        this.isCurrentUser = this.client.isCurrentUser.bind(this.client);
    }
    static{
        this.onGateUpdated = this.client.onGateUpdated.bind(this.client);
    }
    static{
        this.onExperimentValueUpdated = this.client.onExperimentValueUpdated.bind(this.client);
    }
    static{
        this.onAnyUpdated = this.client.onAnyUpdated.bind(this.client);
    }
    static{
        this.updateUser = this.client.updateUser.bind(this.client);
    }
    static{
        this.updateUserWithProvider = this.client.updateUserWithProvider.bind(this.client);
    }
    static{
        this.updateUserWithValues = this.client.updateUserWithValues.bind(this.client);
    }
    static{
        this.getPackageVersion = this.client.getPackageVersion.bind(this.client);
    }
    static{
        this.getTargetApp = this.client.getTargetApp.bind(this.client);
    }
    static{
        this.getLayer = this.client.getLayer.bind(this.client);
    }
    static{
        this.getLayerValue = this.client.getLayerValue.bind(this.client);
    }
}
let $327d2828b647ffdb$var$boundFGJS = $327d2828b647ffdb$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $327d2828b647ffdb$var$FeatureGates;
    else {
        $327d2828b647ffdb$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = $327d2828b647ffdb$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
        if (boundVersion !== (0, $kwcVN.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $kwcVN.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $327d2828b647ffdb$export$2e2bcd8739ae039 = $327d2828b647ffdb$var$boundFGJS;

});
parcelRegister("5CHp0", function(module, exports) {
$parcel$export(module.exports, "Client", () => $5ef9dacf0360177d$export$1f2bb630327ac4b6);

var $f9W1l = parcelRequire("f9W1l");

var $1IKjf = parcelRequire("1IKjf");

var $j3gY5 = parcelRequire("j3gY5");

var $1Hadb = parcelRequire("1Hadb");

var $cpdNK = parcelRequire("cpdNK");

var $50f8M = parcelRequire("50f8M");

var $50qJq = parcelRequire("50qJq");

var $9xnWg = parcelRequire("9xnWg");

var $lbarY = parcelRequire("lbarY");

var $dsBRj = parcelRequire("dsBRj");

var $9Bhub = parcelRequire("9Bhub");

var $7SglJ = parcelRequire("7SglJ");

var $2at1G = parcelRequire("2at1G");

var $jNPuf = parcelRequire("jNPuf");

var $kwcVN = parcelRequire("kwcVN");
const $5ef9dacf0360177d$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $5ef9dacf0360177d$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $5ef9dacf0360177d$export$1f2bb630327ac4b6 {
    constructor({ localStorageKey: localStorageKey = (0, $9Bhub.LOCAL_STORAGE_KEY), overrideAdapter: overrideAdapter } = {}){
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
	 * True if an initialize method was called and completed, meaning the client is now usable.
	 * However if there was an error during initialization it may have initialized with default
	 * values. Use {@link initCompleted} to check for this.
	 */ this.initWithDefaults = false;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.subscriptions = new (0, $1IKjf.default)();
        this.dataAdapter = new (0, $dsBRj.NoFetchDataAdapter)();
        /**
	 * Call this if modifying the values being served by the Statsig library since it has its own
	 * memoization cache which will not be updated if the values are changed outside of the library.
	 */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $9Bhub.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
	 * @description
	 * This method initializes the client using a network call to fetch the bootstrap values.
	 * If the client is inialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $9xnWg.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $7SglJ.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
	 * @description
	 * This method initializes the client using the provider given to call to fetch the bootstrap values.
	 * If the client is initialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param provider {Provider}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $9xnWg.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $7SglJ.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $kwcVN.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        this.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $kwcVN.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $jNPuf.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $9xnWg.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $7SglJ.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
	 * This method updates the user using a network call to fetch the new set of values.
	 * @param fetchOptions {FetcherOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $9xnWg.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $50qJq.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
	 * This method updates the user using the provider given on initialisation to get the new set of
	 * values.
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
	 * This method updates the user given a new set of bootstrap values obtained from one of the
	 * server-side SDKs.
	 *
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @param initializeValues {Record<string,unknown>}
	 */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    async waitUntilInitializeCompleted() {
        if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
        if (this.initCompleted) return;
        await this.initPromise;
    }
    /**
	 * Returns the value for a feature gate. Returns false if there are errors.
	 * @param {string} gateName - The name of the feature gate.
	 * @param {Object} options
	 * @param {boolean} options.fireGateExposure
	 *        Whether or not to fire the exposure event for the gate. Defaults to true.
	 *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
	 *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
	 * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
	 * <code>options.fireGateExposure</code> is false.
	 * @param gateName
	 */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
	 * Returns the entire config for a given experiment.
	 *
	 * @param {string} experimentName - The name of the experiment
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
	 * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns The config for an experiment
	 * @example
	 * ```ts
	 * const experimentConfig = client.getExperiment('example-experiment-name');
	 * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
	 * ```
	 */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $j3gY5.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $j3gY5.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $cpdNK.EvaluationReason).Error
            });
        }
    }
    /**
	 * Returns the value of a given parameter in an experiment config.
	 *
	 * @template T
	 * @param {string} experimentName - The name of the experiment
	 * @param {string} parameterName - The name of the parameter to fetch from the experiment config
	 * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
	 * if the returned value does not match the expected type.
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
	 * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
	 * @param {function} options.typeGuard - A function that asserts that the return value has the
	 * expected type. If this function returns false, then the default value will be returned
	 * instead. This can be set to protect your code from unexpected values being set remotely. By
	 * default, this will be done by asserting that the default value and value are the same primitive
	 * type.
	 * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
	 * default value.
	 * @example
	 ``` ts
	 type ValidColor = 'blue' | 'red' | 'yellow';
	 type ValidColorTypeCheck = (value: unknown) => value is ValidColor;

	 const isValidColor: ValidColorTypeCheck =
			(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);

	 const buttonColor: ValidColor = client.getExperimentValue(
			'example-experiment-name',
			'backgroundColor',
			'yellow',
			{
					typeGuard: isValidColor
			}
	 );
	 ```
	*/ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
	 * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
	 * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
	 * @param experimentName
	 */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
	 * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
	 * @param layerName
	 * @param parameterName
	 */ manuallyLogLayerExposure(layerName, parameterName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getLayer(layerName)?.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
	 * Adds a new override for the given gate.
	 *
	 * This method is additive, meaning you can call it multiple times with different gate names to
	 * build your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearGateOverride} after your tests are completed to remove this
	 * localStorage entry.
	 *
	 * @param {string} gateName
	 * @param {boolean} value
	 */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) this.statsigClient?.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.statsigValuesUpdated();
    }
    /**
	 * Removes any overrides that have been set for the given gate.
	 */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
	 * Adds a new override for the given config (or experiment).
	 *
	 * This method is additive, meaning you can call it multiple times with different experiment
	 * names to build your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearConfigOverride} after your tests are completed to remove this
	 * localStorage entry.
	 *
	 * @param {string} experimentName
	 * @param {object} values
	 */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
	 * Removes any overrides that have been set for the given experiment.
	 * @param {string} experimentName
	 */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
	 * Set overrides for gates, experiments and layers in batch.
	 *
	 * Note that these overrides are **not** additive and will completely replace any that have been
	 * added via prior calls to {@link Client.overrideConfig} or
	 * {@link Client.overrideGate}.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearAllOverrides} after your tests are completed to remove this
	 * localStorage entry.
	 */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
	 * @returns The current overrides for gates, configs (including experiments) and layers.
	 */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
	 * Clears overrides for all gates, configs (including experiments) and layers.
	 */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
	 * Returns whether the given identifiers and customAttributes align with the current
	 * set that is being used by the client.
	 *
	 * If this method returns false, then the {@link Client.updateUser},
	 * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
	 * methods can be used to re-align these values.
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @returns a flag indicating whether the clients current configuration aligns with the given values
	 */ isCurrentUser(identifiers, customAttributes) {
        return (0, $7SglJ.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $7SglJ.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
	 * Subscribe to updates where the given callback will be called with the current checkGate value
	 * @param gateName
	 * @param callback
	 * @param options
	 * @returns off function to unsubscribe from updates
	 */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
	 * Subscribe to updates where the given callback will be called with the current experiment value
	 * @param experimentName
	 * @param parameterName
	 * @param defaultValue
	 * @param callback
	 * @param options
	 * @returns off function to unsubscribe from updates
	 */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
	 * Subscribe so on any update the callback will be called.
	 * NOTE: The callback will be called whenever the values are updated even if the values have not
	 * changed.
	 * @param callback
	 * @returns off function to unsubscribe from updates
	 */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
	 * This method initializes the client using a network call to fetch the bootstrap values for the
	 * given user.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @private
	 */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        if (clientOptions.localMode) {
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            return;
        }
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $50qJq.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $50qJq.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
	 * This method initializes the client using a set of boostrap values obtained from one of the
	 * server-side SDKs.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValues
	 * @private
	 */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $lbarY.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $5ef9dacf0360177d$var$DEFAULT_CLIENT_KEY;
        if (!newClientOptions.networkConfig?.logEventUrl) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $5ef9dacf0360177d$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $jNPuf.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        const frontendUser = (0, $2at1G.toStatsigUser)(identifiers, customAttributes);
        this.user = (0, $50f8M.deepAssign)({}, initializeValues.user, frontendUser);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter,
            logEventCompressionMode: (0, $f9W1l.LogEventCompressionMode).Forced
        };
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, $f9W1l.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        try {
            this.statsigClient = new (0, $f9W1l.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $f9W1l.StatsigClient)($5ef9dacf0360177d$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
	 * This method updates the user for this client with the bootstrap values returned from a given
	 * Promise.
	 * It uses the customAttributes from fetching experiment values to update the Statsig user but
	 * uses the customAttributes from given input to check if the user has changed.
	 *
	 * @param {Identifiers} identifiers
	 * @param {CustomAttributes} customAttributes
	 * @param {Promise<InitializeValues>} getInitializeValues
	 * @private
	 */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
	 * This method updates the user on the nested Statsig client
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValuesPromise
	 * @private
	 */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            const frontendUser = (0, $2at1G.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
            user = (0, $50f8M.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
        } catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            this.initOptions.updateUserCompletionCallback?.(false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            if (this.user) await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        this.initOptions?.updateUserCompletionCallback?.(success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
	 * @returns string version of the current package in semver style.
	 */ getPackageVersion() {
        return 0, $kwcVN.CLIENT_VERSION;
    }
    /**
	 * Returns the `targetApp` value that was provided during client initialization.
	 * This identifies the product/app context (e.g., `'confluence_web'`, `'jira_web'`).
	 *
	 * Returns `undefined` if `initialize` has never been called.
	 *
	 * @returns The targetApp string, or undefined if initialize has never been called.
	 */ getTargetApp() {
        return this.initOptions?.targetApp;
    }
    /**
	 * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
	 *
	 * @param {string} layerName - The name of the layer
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
	 * layer. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns A layer
	 * @example
	 * ```ts
	 * const layer = client.getLayer('example-layer-name');
	 * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
	 * ```
	 */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $1Hadb.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $1Hadb.Layer).fromLayer((0, $f9W1l._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
	 * Returns the value of a given parameter in a layer config.
	 *
	 * @template T
	 * @param {string} layerName - The name of the layer
	 * @param {string} parameterName - The name of the parameter to fetch from the layer config
	 * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
	 * returned value does not match the expected type.
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
	 * layer. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
	 * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
	 * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
	 * @example
	 * ``` ts
	 * type ValidColor = 'blue' | 'red' | 'yellow';
	 * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
	 *
	 * const isValidColor: ValidColorTypeCheck =
	 *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
	 *
	 * const buttonColor: ValidColor = client.getLayerValue(
	 *    'example-layer-name',
	 *    'backgroundColor',
	 *    'yellow',
	 *    {
	 *        typeGuard: isValidColor
	 *    }
	 * );
	 * ```
	 */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
}

});
parcelRegister("1IKjf", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce8781e86530a897$export$2e2bcd8739ae039);

var $a1I0L = parcelRequire("a1I0L");
const $ce8781e86530a897$export$a66cbd9b2289cd78 = '@all-features';
class $ce8781e86530a897$export$2e2bcd8739ae039 {
    constructor(){
        this.eventToValue = new Map();
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($a1I0L)))();
    }
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($ce8781e86530a897$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($ce8781e86530a897$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($ce8781e86530a897$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $ce8781e86530a897$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
}

});

parcelRegister("j3gY5", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $d48c2464fd36b976$export$6dc24881a3d96325);

var $ihAI6 = parcelRequire("ihAI6");

var $ps4uJ = parcelRequire("ps4uJ");
class $d48c2464fd36b976$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        const config = new $d48c2464fd36b976$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $ihAI6.migrateEvaluationDetails)(experiment.details), (0, $ps4uJ.migrateSecondaryExposures)(experiment.__evaluation?.secondary_exposures ?? []), experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    get(key, defaultValue, typeGuard) {
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            this._onDefaultValueFallback?.(this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        this._onDefaultValueFallback?.(this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
}

});
parcelRegister("ihAI6", function(module, exports) {
$parcel$export(module.exports, "migrateEvaluationDetails", () => $e79c38a6dff5b0eb$export$18ad168d3dbac899);

var $cpdNK = parcelRequire("cpdNK");
const $e79c38a6dff5b0eb$var$evaluationReasonMappings = Object.entries((0, $cpdNK.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $e79c38a6dff5b0eb$export$18ad168d3dbac899 = (details)=>{
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: $e79c38a6dff5b0eb$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))?.[1] ?? (0, $cpdNK.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};

});
parcelRegister("cpdNK", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $ff183a8da5aaa166$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
const $ff183a8da5aaa166$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
};

});


parcelRegister("ps4uJ", function(module, exports) {
$parcel$export(module.exports, "migrateSecondaryExposures", () => $7b6baaedccf239fd$export$55fd683752d01e67);
const $7b6baaedccf239fd$export$55fd683752d01e67 = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("1Hadb", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $1bab467da18677c0$export$936d0764594b6eb3);

var $ihAI6 = parcelRequire("ihAI6");

var $ps4uJ = parcelRequire("ps4uJ");
class $1bab467da18677c0$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        const value = new $1bab467da18677c0$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $ihAI6.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, $ps4uJ.migrateSecondaryExposures)(layer.__evaluation?.secondary_exposures ?? []), (0, $ps4uJ.migrateSecondaryExposures)(layer.__evaluation?.undelegated_secondary_exposures ?? []), layer.__evaluation?.allocated_experiment_name, layer.__evaluation?.explicit_parameters);
        return value;
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        this._logParameterFunction?.(this, parameterName);
    }
}

});

parcelRegister("50f8M", function(module, exports) {
$parcel$export(module.exports, "deepAssign", () => $5f07204a765d4714$export$1148cb79ceecd5fa);
/**
 * Deeply merges source objects into the target object.
 * Handles nested objects, but arrays are not handled (replaced).
 */ function $5f07204a765d4714$export$1148cb79ceecd5fa(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (source === undefined || source === null) return $5f07204a765d4714$export$1148cb79ceecd5fa(target, ...sources);
    for (const [key, src] of Object.entries(source)){
        const dst = target[key];
        const srcIsObj = src && typeof src === 'object' && !Array.isArray(src);
        const dstIsObj = dst && typeof dst === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $5f07204a765d4714$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $5f07204a765d4714$export$1148cb79ceecd5fa(target, ...sources);
}

});

parcelRegister("50qJq", function(module, exports) {
$parcel$export(module.exports, "default", () => $d557f803b7279bc0$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $jNPuf = parcelRequire("jNPuf");

var $kwcVN = parcelRequire("kwcVN");

var $bB4yL = parcelRequire("bB4yL");
const $d557f803b7279bc0$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $d557f803b7279bc0$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $d557f803b7279bc0$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $d557f803b7279bc0$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $d557f803b7279bc0$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $d557f803b7279bc0$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $d557f803b7279bc0$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
const $d557f803b7279bc0$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
const $d557f803b7279bc0$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
const $d557f803b7279bc0$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $d557f803b7279bc0$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $bB4yL.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $bB4yL.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter, isolationContextId = null) {
        if (useGatewayUrl) return $d557f803b7279bc0$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $jNPuf.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $jNPuf.FeatureGateEnvironment).Production:
                return $d557f803b7279bc0$export$18c93900db9358a4;
            case (0, $jNPuf.FeatureGateEnvironment).Staging:
                return $d557f803b7279bc0$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $jNPuf.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $jNPuf.FeatureGateEnvironment).Development:
                return $d557f803b7279bc0$export$f058dbf75c3bc647;
            case (0, $jNPuf.FeatureGateEnvironment).Staging:
                const apiUrl = this.getApiUrl(isolationContextId);
                if (apiUrl !== null) return apiUrl;
                return $d557f803b7279bc0$export$942ba04389b0d5a2;
            default:
                const prodApiUrl = this.getApiUrl(isolationContextId);
                if (prodApiUrl !== null) return prodApiUrl;
                return $d557f803b7279bc0$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $d557f803b7279bc0$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $d557f803b7279bc0$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $kwcVN.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
    static getApiUrl(isolationContextId) {
        const window1 = this.getWindowLocation();
        if (window1 === undefined) {
            //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
            if (!isolationContextId) return null;
            return $d557f803b7279bc0$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
        }
        const { protocol: protocol, hostname: hostname } = window1;
        // Match last subdomain fragment before oasis-stg.com
        const oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
        if (oasisMatch) return `${protocol}//api.${oasisMatch[1]}.${$d557f803b7279bc0$export$cb3cd156f70d7e94}`;
        // Match last subdomain fragment before atlassian-isolated.net
        const isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
        if (isolatedMatch) return `${protocol}//api.${isolatedMatch[1]}.${$d557f803b7279bc0$export$921fbc6cdfd4eee0}`;
        return null;
    }
    static getWindowLocation() {
        if (typeof window !== 'undefined' && window.location) return window.location;
        return undefined;
    }
}

});
parcelRegister("jNPuf", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $c067ea76ef443660$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $c067ea76ef443660$export$c42b7bbc5e7ba555);
const $c067ea76ef443660$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
const $c067ea76ef443660$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
const $c067ea76ef443660$export$42f4885608027d0c = 'non_boolean';

});

parcelRegister("kwcVN", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $9c8b8221834ca0a3$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $9c8b8221834ca0a3$export$a59f8d67326bd1cb = "0.0.0-use.local";

});

parcelRegister("bB4yL", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $56588f9d8a5cf84e$export$286baf652d0b1206);
class $56588f9d8a5cf84e$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("9xnWg", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $a76afcf6556f021f$export$d119b37e5f788b43);

var $l1vE2 = parcelRequire("l1vE2");

var $jNPuf = parcelRequire("jNPuf");
const $a76afcf6556f021f$export$d119b37e5f788b43 = (options)=>({
        /**
	 * If more federal PerimeterTypes are added in the future, this should be updated so
	 * that isFedRamp() === true always returns the strictest perimeter.
	 */ perimeter: (0, $l1vE2.isFedRamp)() ? (0, $jNPuf.PerimeterType).FEDRAMP_MODERATE : (0, $jNPuf.PerimeterType).COMMERCIAL,
        ...options
    });

});
parcelRegister("l1vE2", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $584dba29b5cbd48c$export$64d6499adf9b2e51);

function $584dba29b5cbd48c$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $32f4f7c20d37fe6f$export$ce553301d55c2fd8);
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
const $32f4f7c20d37fe6f$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $32f4f7c20d37fe6f$export$f005e2e9f707cb5f = 'commercial';
const $32f4f7c20d37fe6f$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $32f4f7c20d37fe6f$export$a739cd5aac835909 = 'stg';
const $32f4f7c20d37fe6f$export$42dd0cdd351a4a9 = 'prod';
const $32f4f7c20d37fe6f$export$404582bc18fe4d9e = 'dev';



parcelRegister("lbarY", function(module, exports) {
$parcel$export(module.exports, "migrateInitializationOptions", () => $d0abcc5df61aa568$export$202946b690d26d22);
const $d0abcc5df61aa568$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};

});

parcelRegister("dsBRj", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $6893a496038bd546$export$55fffef3474104af);

var $f9W1l = parcelRequire("f9W1l");
class $6893a496038bd546$export$55fffef3474104af extends (0, $f9W1l.DataAdapterCore) {
    constructor(){
        super('NoFetchDataAdapter', 'nofetch'), this.bootstrapResult = null;
    }
    /**
	 * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
	 * after the Statsig client has been created!
	 */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $f9W1l.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $f9W1l._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $f9W1l._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $f9W1l._getStorageKey)(this._getSdkKey(), user);
        return `${0, $f9W1l.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
}

});

parcelRegister("9Bhub", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $73d9747e41b43981$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $73d9747e41b43981$export$bcb28fbac1def494);

var $pWbzR = parcelRequire("pWbzR");
const $73d9747e41b43981$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $73d9747e41b43981$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $73d9747e41b43981$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $73d9747e41b43981$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $73d9747e41b43981$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $73d9747e41b43981$export$bcb28fbac1def494 {
    constructor(localStorageKey){
        this._overrides = $73d9747e41b43981$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    parseStoredOverrides(localStorageKey) {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $73d9747e41b43981$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $73d9747e41b43981$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $73d9747e41b43981$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($73d9747e41b43981$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.removeItem($73d9747e41b43981$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $pWbzR._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$73d9747e41b43981$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($73d9747e41b43981$var$djb2MapKey((0, $pWbzR._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($73d9747e41b43981$var$djb2MapKey((0, $pWbzR._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($73d9747e41b43981$var$djb2MapKey((0, $pWbzR._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($73d9747e41b43981$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $73d9747e41b43981$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($73d9747e41b43981$var$djb2MapKey((0, $pWbzR._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($73d9747e41b43981$var$djb2MapKey((0, $pWbzR._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($73d9747e41b43981$var$djb2MapKey((0, $pWbzR._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($73d9747e41b43981$var$djb2MapKey((0, $pWbzR._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($73d9747e41b43981$var$djb2MapKey((0, $pWbzR._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($73d9747e41b43981$var$djb2MapKey((0, $pWbzR._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $73d9747e41b43981$var$makeEmptyStore();
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($73d9747e41b43981$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $pWbzR._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $73d9747e41b43981$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($73d9747e41b43981$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $pWbzR._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $73d9747e41b43981$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
}

});

parcelRegister("7SglJ", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $31edb08c2242d190$export$fa1c2bbf4100b8bc);
const $31edb08c2242d190$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};

});

parcelRegister("2at1G", function(module, exports) {
$parcel$export(module.exports, "toStatsigUser", () => $7e5a7e2ace335d45$export$3dad1db244472f32);
const $7e5a7e2ace335d45$export$3dad1db244472f32 = (identifiers, customAttributes)=>{
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    const { stableId: stableId, ...otherIdentifiers } = identifiers;
    const user = {
        customIDs: {
            ...otherIdentifiers,
            ...stableId !== undefined ? {
                stableID: stableId
            } : {}
        },
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});



parcelRegister("hbvZL", function(module, exports) {
$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $bb51bf09824af284$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $bb51bf09824af284$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $bb51bf09824af284$export$47fade9662f71000);

var $h4H80 = parcelRequire("h4H80");
const $bb51bf09824af284$export$5b78c989c8db2561 = new Map();
const $bb51bf09824af284$export$2a5c8df26bb89760 = new Map();
function $bb51bf09824af284$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $h4H80.redactValue)(featureFlagValue);
    $bb51bf09824af284$export$5b78c989c8db2561.set(featureFlagName, value);
    $bb51bf09824af284$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("h4H80", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $c30bc85058d7d415$export$fcc03ee4c944962f);


var $fZsSB = parcelRequire("fZsSB");
function $c30bc85058d7d415$export$fcc03ee4c944962f(featureFlagValue) {
    return (0, $fZsSB.shouldRedactValue)(featureFlagValue) ? (0, $454bc9fe95ddf677$export$42f4885608027d0c) : featureFlagValue;
}

});
const $454bc9fe95ddf677$export$42f4885608027d0c = 'non_boolean';

parcelRegister("fZsSB", function(module, exports) {
$parcel$export(module.exports, "shouldRedactValue", () => $9ea999bcae0c2248$export$7b4abba432e57989);
function $9ea999bcae0c2248$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch  {
        return false;
    }
    return false;
}
function $9ea999bcae0c2248$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $9ea999bcae0c2248$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch  {
        // swallow any errors
        result = false;
    }
    return result;
}
function $9ea999bcae0c2248$export$7b4abba432e57989(value) {
    return $9ea999bcae0c2248$var$isString(value) && $9ea999bcae0c2248$var$startsAsObject(value) || $9ea999bcae0c2248$var$isObject(value);
}

});



parcelRegister("d2Egp", function(module, exports) {
$parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", () => $23a54b50b06b699b$export$6e17cce6446848f9);

var $lvzrB = parcelRequire("lvzrB");

var $k1PNS = parcelRequire("k1PNS");
function $23a54b50b06b699b$export$6e17cce6446848f9(_url) {
    if ((0, $lvzrB.getActiveTrace)() === undefined) return null;
    const { traceId: traceId, spanId: spanId } = (0, $lvzrB.getActiveTrace)();
    return (0, $k1PNS.makeTraceHttpRequestHeaders)(traceId, spanId);
}

});
parcelRegister("lvzrB", function(module, exports) {
$parcel$export(module.exports, "getActiveTrace", () => $802c90bf9beca423$export$b6ac780db3a3cc77);

var $he2vg = parcelRequire("he2vg");

var $iqfTZ = parcelRequire("iqfTZ");

var $hYBvv = parcelRequire("hYBvv");

var $657FQ = parcelRequire("657FQ");

var $d0MxM = parcelRequire("d0MxM");

var $kfzjO = parcelRequire("kfzjO");
function $802c90bf9beca423$export$b6ac780db3a3cc77() {
    if ((0, $iqfTZ.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        const activeTraceContext = {
            traceId: String((0, $he2vg.context).active().getValue((0, $kfzjO.traceIdKey))),
            spanId: String((0, $he2vg.context).active().getValue((0, $657FQ.spanIdKey))),
            type: String((0, $he2vg.context).active().getValue((0, $hYBvv.experienceTypeKey)))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return (0, $d0MxM.state).context || undefined;
}

});
parcelRegister("iqfTZ", function(module, exports) {
$parcel$export(module.exports, "fg", () => $bf963bc0b507179f$export$b40ec24ac8275656);

var $ckovs = parcelRequire("ckovs");
function $bf963bc0b507179f$export$b40ec24ac8275656(name) {
    return (0, $ckovs.resolveBooleanFlag)(name);
}

});
parcelRegister("ckovs", function(module, exports) {
$parcel$export(module.exports, "resolveBooleanFlag", () => $956d698605dc6b5a$export$6333b6aff9fc6275);

var $4LDqh = parcelRequire("4LDqh");

var $bYiXp = parcelRequire("bYiXp");

var $cZp3Q = parcelRequire("cZp3Q");

var $d4VD6 = parcelRequire("d4VD6");

var $dReFn = parcelRequire("dReFn");

var $kIIKd = parcelRequire("kIIKd");
const $956d698605dc6b5a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $cZp3Q.ENV_ENABLE_PLATFORM_FF) || (0, $d4VD6.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $956d698605dc6b5a$export$6333b6aff9fc6275(flagKey) {
    if ($956d698605dc6b5a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $bYiXp.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $kIIKd.pkgName), flagKey);
        return true;
    }
    try {
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if ((0, $dReFn.globalVar)[0, $kIIKd.PFF_GLOBAL_KEY]?.booleanResolver === undefined || (0, $dReFn.globalVar)[0, $kIIKd.PFF_GLOBAL_KEY]?.booleanResolver === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $4LDqh.default).checkGate(flagKey);
        const result = (0, $dReFn.globalVar)[0, $kIIKd.PFF_GLOBAL_KEY]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("bYiXp", function(module, exports) {
$parcel$export(module.exports, "debug", () => $e1409ad31f27ca80$export$1c9f709888824e05);
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $e1409ad31f27ca80$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
const $e1409ad31f27ca80$var$DEBUG_MODE = !$e1409ad31f27ca80$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $e1409ad31f27ca80$export$1c9f709888824e05 = (...args)=>{
    if (!$e1409ad31f27ca80$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});

parcelRegister("cZp3Q", function(module, exports) {
$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $ea1fc757d39c635b$export$b574c24e1e6490f5);

var $kIIKd = parcelRequire("kIIKd");
const $ea1fc757d39c635b$export$b574c24e1e6490f5 = (0, $kIIKd.hasProcessEnv) ? false : false;

});
parcelRegister("kIIKd", function(module, exports) {
$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $016263e2a5923feb$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $016263e2a5923feb$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $016263e2a5923feb$export$75f4a1454eff2805);

var $gIMgJ = parcelRequire("gIMgJ");
const $016263e2a5923feb$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $016263e2a5923feb$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
const $016263e2a5923feb$export$75f4a1454eff2805 = typeof $gIMgJ !== 'undefined' && typeof $gIMgJ.env !== 'undefined';

});


parcelRegister("d4VD6", function(module, exports) {
$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $08c0f1675694be1b$export$92f8b531feaeb23d);

var $kIIKd = parcelRequire("kIIKd");
const $08c0f1675694be1b$export$92f8b531feaeb23d = (0, $kIIKd.hasProcessEnv) ? false : false;

});

parcelRegister("dReFn", function(module, exports) {
$parcel$export(module.exports, "globalVar", () => $e26afbea381c5521$export$54ea85357b4e0159);

var $kIIKd = parcelRequire("kIIKd");
const $e26afbea381c5521$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $e26afbea381c5521$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$e26afbea381c5521$export$54ea85357b4e0159[0, $kIIKd.PFF_GLOBAL_KEY] = $e26afbea381c5521$export$54ea85357b4e0159[0, $kIIKd.PFF_GLOBAL_KEY] || $e26afbea381c5521$var$DEFAULT_PFF_GLOBAL;

});



parcelRegister("hYBvv", function(module, exports) {
$parcel$export(module.exports, "experienceTypeKey", () => $2bc1c8dd5013ce89$export$1069c2293742749e);

var $3lwCO = parcelRequire("3lwCO");
const $2bc1c8dd5013ce89$export$1069c2293742749e = (0, $3lwCO.createContextKey)('type');

});

parcelRegister("657FQ", function(module, exports) {
$parcel$export(module.exports, "spanIdKey", () => $f8200bc1c592df87$export$ccdc89d1d45284c2);

var $3lwCO = parcelRequire("3lwCO");
const $f8200bc1c592df87$export$ccdc89d1d45284c2 = (0, $3lwCO.createContextKey)('spanId');

});

parcelRegister("d0MxM", function(module, exports) {
$parcel$export(module.exports, "state", () => $302ba88899dd4815$export$ca000e230c0caa3e);
const $302ba88899dd4815$export$ca000e230c0caa3e = {
    context: null
};

});

parcelRegister("kfzjO", function(module, exports) {
$parcel$export(module.exports, "traceIdKey", () => $343afa99847419cb$export$65f3d43d675bb81b);

var $3lwCO = parcelRequire("3lwCO");
const $343afa99847419cb$export$65f3d43d675bb81b = (0, $3lwCO.createContextKey)('traceId');

});


parcelRegister("k1PNS", function(module, exports) {
$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $294e195a67587d0d$export$1115c5277eb10d5e);
function $294e195a67587d0d$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});


parcelRegister("iZsuc", function(module, exports) {
$parcel$export(module.exports, "getActiveTraceHttpHeaders", () => $8dc4d561d71a0cac$export$63b3d412fff54e8d);

var $lqMeC = parcelRequire("lqMeC");

var $lI4qc = parcelRequire("lI4qc");
function $8dc4d561d71a0cac$export$63b3d412fff54e8d() {
    const trace = (0, $lqMeC.getActiveTrace)();
    if (!trace) return null;
    const { traceId: traceId, spanId: spanId } = trace;
    return (0, $lI4qc.makeTraceHttpHeaders)(traceId, spanId);
}

});
parcelRegister("lqMeC", function(module, exports) {
$parcel$export(module.exports, "getActiveTrace", () => $cf2e2fbbb86a4a07$export$b6ac780db3a3cc77);

var $dTrSd = parcelRequire("dTrSd");
function $cf2e2fbbb86a4a07$export$b6ac780db3a3cc77() {
    return (0, $dTrSd.state).context;
}

});
parcelRegister("dTrSd", function(module, exports) {
$parcel$export(module.exports, "state", () => $743c3d34462f7cc7$export$ca000e230c0caa3e);
const $743c3d34462f7cc7$export$ca000e230c0caa3e = {
    context: null
};

});


parcelRegister("lI4qc", function(module, exports) {
$parcel$export(module.exports, "makeTraceHttpHeaders", () => $97b4200797a7c11d$export$c7fbc6d88d400f6f);
/**
 * Creates HTTP headers from trace context.
 *
 * @param traceId - The trace ID
 * @param spanId - The span ID
 * @returns An object containing HTTP headers to add to outgoing requests in order to propagate the trace context
 */ function $97b4200797a7c11d$export$c7fbc6d88d400f6f(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});


parcelRegister("aXjxw", function(module, exports) {
$parcel$export(module.exports, "getInteractionId", () => $a7e7f9018d7ae538$export$37bca3107733ac1e);

var $8glX3 = parcelRequire("8glX3");
const $a7e7f9018d7ae538$export$37bca3107733ac1e = ()=>(0, $8glX3.default);

});
parcelRegister("8glX3", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5d6e3d817115df9$export$2e2bcd8739ae039);

var $cugCA = parcelRequire("cugCA");
class $d5d6e3d817115df9$var$ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        if (oldId !== newId) (0, $cugCA.listeners).forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
const $d5d6e3d817115df9$var$initializeGlobalDefaultInteractionID = ()=>{
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    const instance = new $d5d6e3d817115df9$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $d5d6e3d817115df9$var$DefaultInteractionID = $d5d6e3d817115df9$var$initializeGlobalDefaultInteractionID();
var $d5d6e3d817115df9$export$2e2bcd8739ae039 = $d5d6e3d817115df9$var$DefaultInteractionID;

});
parcelRegister("cugCA", function(module, exports) {
$parcel$export(module.exports, "listeners", () => $186af81c69f45ea0$export$58bed631278dbc67);
$parcel$export(module.exports, "subscribeToInteractionIdChanges", () => $186af81c69f45ea0$export$3e0c3023952f6774);
// Subscription system for interaction ID changes
const $186af81c69f45ea0$export$58bed631278dbc67 = new Set();
const $186af81c69f45ea0$export$3e0c3023952f6774 = (listener)=>{
    $186af81c69f45ea0$export$58bed631278dbc67.add(listener);
    return ()=>{
        $186af81c69f45ea0$export$58bed631278dbc67.delete(listener);
    };
};

});



parcelRegister("siTdT", function(module, exports) {
$parcel$export(module.exports, "PreviousInteractionLog", () => $bf967f18f77189b5$export$dbba6cdedab4e68b);
$parcel$export(module.exports, "postInteractionLog", () => $bf967f18f77189b5$export$d8f52e8f804021e8);
$parcel$export(module.exports, "segmentUnmountCache", () => $bf967f18f77189b5$export$a2b14406ded37d60);
$parcel$export(module.exports, "getActiveInteraction", () => $bf967f18f77189b5$export$2b3954d2e8509985);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $bf967f18f77189b5$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addMetadata", () => $bf967f18f77189b5$export$12f2b6cb85d59904);
$parcel$export(module.exports, "addCustomData", () => $bf967f18f77189b5$export$e4380431c2bdabee);
$parcel$export(module.exports, "addExcluded3pSegment", () => $bf967f18f77189b5$export$9bfdf89f35702b2e);
$parcel$export(module.exports, "addSegmentExtraData", () => $bf967f18f77189b5$export$35723c3772fda7dd);
$parcel$export(module.exports, "addIframeSegmentData", () => $bf967f18f77189b5$export$c227d812a1e08d80);
$parcel$export(module.exports, "addCohortingCustomData", () => $bf967f18f77189b5$export$20265b12c6625451);
$parcel$export(module.exports, "addCustomTiming", () => $bf967f18f77189b5$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $bf967f18f77189b5$export$728e28c22a0fba4);
$parcel$export(module.exports, "addSpan", () => $bf967f18f77189b5$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addSpanToAll", () => $bf967f18f77189b5$export$943a8b2b5d6b1809);
$parcel$export(module.exports, "extractModuleName", () => $bf967f18f77189b5$export$f5a8f10de74904da);
$parcel$export(module.exports, "addHold", () => $bf967f18f77189b5$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $bf967f18f77189b5$export$10582acd678c213);
$parcel$export(module.exports, "addCompletedHold", () => $bf967f18f77189b5$export$d6cf9650acfb0dab);
$parcel$export(module.exports, "removeHoldByID", () => $bf967f18f77189b5$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "getCurrentInteractionType", () => $bf967f18f77189b5$export$2df109852219d16e);
$parcel$export(module.exports, "ModuleLoadingProfiler", () => $bf967f18f77189b5$export$9591b52b33ccc510);
$parcel$export(module.exports, "addError", () => $bf967f18f77189b5$export$239c33984d9b1367);
$parcel$export(module.exports, "addErrorToAll", () => $bf967f18f77189b5$export$7379c15afd3840fa);
$parcel$export(module.exports, "addProfilerTimings", () => $bf967f18f77189b5$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $bf967f18f77189b5$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $bf967f18f77189b5$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $bf967f18f77189b5$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $bf967f18f77189b5$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $bf967f18f77189b5$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $bf967f18f77189b5$export$614a7af2affc5dff);
$parcel$export(module.exports, "addOnCancelCallback", () => $bf967f18f77189b5$export$7b9261a96cfe427b);
$parcel$export(module.exports, "addNewInteraction", () => $bf967f18f77189b5$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addBrowserMetricEvent", () => $bf967f18f77189b5$export$4a759336b50e86e3);
$parcel$export(module.exports, "addApdexToAll", () => $bf967f18f77189b5$export$ad216cc25852d44b);
$parcel$export(module.exports, "addApdex", () => $bf967f18f77189b5$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $bf967f18f77189b5$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $bf967f18f77189b5$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $bf967f18f77189b5$export$d0365e48b58231c3);
$parcel$export(module.exports, "addRedirect", () => $bf967f18f77189b5$export$bbf14d79614d9818);
$parcel$export(module.exports, "interactionSpans", () => $bf967f18f77189b5$export$6ce04c7ca6810a7e);
$parcel$export(module.exports, "addCustomSpans", () => $bf967f18f77189b5$export$5342dcad19138a1c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.

var $6pOqP = parcelRequire("6pOqP");

var $erszr = parcelRequire("erszr");

var $editX = parcelRequire("editX");

var $gmMRH = parcelRequire("gmMRH");

var $1yDnt = parcelRequire("1yDnt");

var $23KgL = parcelRequire("23KgL");

var $9VdNX = parcelRequire("9VdNX");

var $jSug1 = parcelRequire("jSug1");

var $hbvZL = parcelRequire("hbvZL");

var $aXjxw = parcelRequire("aXjxw");

var $fJjLT = parcelRequire("fJjLT");

var $jokam = parcelRequire("jokam");

var $5SEkW = parcelRequire("5SEkW");

var $5BIjs = parcelRequire("5BIjs");

var $l84xV = parcelRequire("l84xV");
const $bf967f18f77189b5$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
const $bf967f18f77189b5$export$d8f52e8f804021e8 = new (0, $l84xV.default)();
const $bf967f18f77189b5$var$interactionQueue = [];
const $bf967f18f77189b5$var$segmentCache = new Map();
const $bf967f18f77189b5$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
const $bf967f18f77189b5$var$segmentObservers = [];
function $bf967f18f77189b5$export$2b3954d2e8509985() {
    const interactionId = (0, $aXjxw.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $5BIjs.interactions).get(interactionId.current);
}
function $bf967f18f77189b5$var$isPerformanceTracingEnabled() {
    return (0, $gmMRH.getConfig)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $bf967f18f77189b5$var$performanceEventObserver;
const $bf967f18f77189b5$export$17afbba0f16b4b19 = ()=>{
    $bf967f18f77189b5$var$performanceEventObserver = $bf967f18f77189b5$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $bf967f18f77189b5$export$e6be05b411ce21a6(entry);
    });
    return $bf967f18f77189b5$var$performanceEventObserver;
};
const $bf967f18f77189b5$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $bf967f18f77189b5$export$2b3954d2e8509985();
    if (interaction?.type === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $bf967f18f77189b5$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $bf967f18f77189b5$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $bf967f18f77189b5$var$addSegmentObserver(observer) {
    $bf967f18f77189b5$var$segmentObservers.push(observer);
    for (const segmentInfo of $bf967f18f77189b5$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $bf967f18f77189b5$var$removeSegmentObserver(observer) {
    const index = $bf967f18f77189b5$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $bf967f18f77189b5$var$segmentObservers.splice(index, 1);
}
function $bf967f18f77189b5$export$cd7f480d6b8286c3(interactionId) {
    (0, $5BIjs.interactions).delete(interactionId);
}
function $bf967f18f77189b5$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $bf967f18f77189b5$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $bf967f18f77189b5$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $bf967f18f77189b5$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $bf967f18f77189b5$export$9bfdf89f35702b2e(interactionId, segmentId, data) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) (interaction.excluded3pSegmentData ??= {})[segmentId] = {
        segmentId: segmentId,
        ...interaction.excluded3pSegmentData[segmentId],
        ...data
    };
}
function $bf967f18f77189b5$export$35723c3772fda7dd(interactionId, segmentId, data) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) {
        if (!interaction.segmentExtraData) interaction.segmentExtraData = {};
        interaction.segmentExtraData[segmentId] = {
            ...interaction.segmentExtraData[segmentId],
            ...data
        };
    }
}
/**
 * Builds a stable cross-segment dedup key for a segment3pTimings entry.
 *
 * For `resource-timing`, query-stripped backend labels + timing fields identify a request without
 * depending on query parameters. Shared CSS/JS asset timings dedupe across segments, but backend
 * fetch/XHR entries are scoped by `segmentId` because each iframe can make its own backend request
 * to the same URL.
 *
 * For all other labels the data objects are small (a handful of fields), so we use a full
 * JSON fingerprint which is cheap and collision-free.
 */ function $bf967f18f77189b5$var$buildCrossSegmentDedupKey(entry, segmentId) {
    if (entry.label === 'resource-timing') {
        const { label: resourceLabel, startTime: startTime, duration: duration, requestStart: requestStart, fetchStart: fetchStart, ttfb: ttfb, type: type } = entry.data;
        if ((0, $fJjLT.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(String(type))) // Backend calls are separate requests per segment; include extra timings and segment scope.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}|${fetchStart}|${requestStart}|${ttfb}|${segmentId}`;
        // Shared CSS/JS assets keep the original B3 key so they can dedupe across segments.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}`;
    }
    return `${entry.label}|${JSON.stringify(entry.data)}`;
}
function $bf967f18f77189b5$export$c227d812a1e08d80(interactionId, segmentId, entry) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) {
        // B3: dedup by content — drops identical entries within and across iframes.
        // Abort markers are excluded so every segment's abort is recorded.
        if (entry.label !== 'segment-timing-abort') {
            if (!interaction.segment3pCrossSegmentSeen) interaction.segment3pCrossSegmentSeen = new Set();
            const key = $bf967f18f77189b5$var$buildCrossSegmentDedupKey(entry, segmentId);
            if (interaction.segment3pCrossSegmentSeen.has(key)) return;
            interaction.segment3pCrossSegmentSeen.add(key);
        }
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function $bf967f18f77189b5$export$20265b12c6625451(interactionId, key, value) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $bf967f18f77189b5$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) {
        const sanitizedData = Object.fromEntries(Object.entries(data).map(([key, timingData])=>[
                (0, $editX.sanitizeTimingName)(key),
                timingData
            ]));
        interaction.customTimings.push({
            labelStack: labelStack,
            data: sanitizedData
        });
        if ($bf967f18f77189b5$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(sanitizedData)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$bf967f18f77189b5$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
function $bf967f18f77189b5$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($bf967f18f77189b5$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$bf967f18f77189b5$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $bf967f18f77189b5$export$85d1eb835f669bf(_interactionId, _labelStack, _time) {}
function $bf967f18f77189b5$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $5BIjs.interactions).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($bf967f18f77189b5$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$bf967f18f77189b5$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $bf967f18f77189b5$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($bf967f18f77189b5$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$bf967f18f77189b5$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
}
function $bf967f18f77189b5$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $5BIjs.interactions).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($bf967f18f77189b5$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$bf967f18f77189b5$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch  {
    // do nothing
    }
}
function $bf967f18f77189b5$export$9e04fe1a58571ec(moduleId, timestamp) {
    $bf967f18f77189b5$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $bf967f18f77189b5$export$6f228d1fdc911d7(identifier, start, end) {
    $bf967f18f77189b5$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $bf967f18f77189b5$var$moduleLoadingRequests = {};
function $bf967f18f77189b5$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $bf967f18f77189b5$var$addHoldCriterion(id, labelStack, name, startTime) {
    if (!window.__CRITERION__?.addUFOHold) return;
    window.__CRITERION__.addUFOHold(id, $bf967f18f77189b5$var$labelStackToString(labelStack), name, startTime);
}
function $bf967f18f77189b5$var$removeHoldCriterion(id) {
    if (!window.__CRITERION__?.removeUFOHold) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $bf967f18f77189b5$export$7606887303596f82(interactionId, labelStack, name, _experimental) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $6pOqP.default)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $bf967f18f77189b5$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ($bf967f18f77189b5$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $bf967f18f77189b5$var$ensureExtendedHoldActive(interaction).set(id, {
            ...holdActive,
            start: start
        });
        else {
            interaction.holdActive.set(id, {
                ...holdActive,
                start: start
            });
            $bf967f18f77189b5$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if ($bf967f18f77189b5$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$bf967f18f77189b5$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
            $bf967f18f77189b5$var$removeHoldCriterion(id);
            const currentInteraction = (0, $5BIjs.interactions).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    const current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        $bf967f18f77189b5$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push({
                            ...current3pHold,
                            end: end
                        });
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return ()=>{};
}
function $bf967f18f77189b5$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        };
        if ($bf967f18f77189b5$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $bf967f18f77189b5$var$ensureExtendedHoldActive(interaction).set(id, holdActive);
        else {
            interaction.holdActive.set(id, holdActive);
            $bf967f18f77189b5$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function $bf967f18f77189b5$export$d6cf9650acfb0dab(interactionId, labelStack, name, start, end) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) {
        // `recordMetricVariantCategoryEnd` skips excluded (background-script) holds, so the completed
        // hold is retained in `hold3pInfo` for observability but never contributes a third-party
        // category end.
        $bf967f18f77189b5$var$recordMetricVariantCategoryEnd(interaction, labelStack, end);
        $bf967f18f77189b5$var$ensureExtendedHoldInfo(interaction).push({
            labelStack: labelStack,
            name: name,
            start: start,
            end: end
        });
    }
}
function $bf967f18f77189b5$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $5BIjs.interactions).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            if ($bf967f18f77189b5$var$shouldMoveHoldToExtendedBucket(currentInteraction, currentHold)) $bf967f18f77189b5$var$ensureExtendedHoldInfo(currentInteraction).push({
                ...currentHold,
                end: end
            });
            else currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $bf967f18f77189b5$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            const current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                $bf967f18f77189b5$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push({
                    ...current3pHold,
                    end: end
                });
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $bf967f18f77189b5$export$2df109852219d16e(interactionId) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $bf967f18f77189b5$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $bf967f18f77189b5$export$9e04fe1a58571ec($bf967f18f77189b5$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $bf967f18f77189b5$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $bf967f18f77189b5$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $bf967f18f77189b5$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $bf967f18f77189b5$var$moduleLoadingRequests[info.identifier];
            $bf967f18f77189b5$export$6f228d1fdc911d7($bf967f18f77189b5$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $aXjxw.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $bf967f18f77189b5$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $aXjxw.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $bf967f18f77189b5$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $bf967f18f77189b5$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $bf967f18f77189b5$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $5BIjs.interactions).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $bf967f18f77189b5$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    if ($bf967f18f77189b5$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$bf967f18f77189b5$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch  {
    // do nothing
    }
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((0, $gmMRH.getConfig)()?.postInteractionLog?.enabled) $bf967f18f77189b5$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $bf967f18f77189b5$var$pushToQueue(id, data) {
    $bf967f18f77189b5$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $bf967f18f77189b5$var$handleInteraction = $bf967f18f77189b5$var$pushToQueue;
const $bf967f18f77189b5$var$isKnownMetricVariantCategory = (type)=>type === 'third-party' || type === 'gen-ai';
const $bf967f18f77189b5$var$hasMetricVariantCategory = (labelStack, category)=>labelStack?.some((label)=>'type' in label && label.type === category) ?? false;
const $bf967f18f77189b5$var$hasAnyMetricVariantCategory = (labelStack)=>labelStack?.some((label)=>'type' in label && $bf967f18f77189b5$var$isKnownMetricVariantCategory(label.type)) ?? false;
/**
 * A hold is fully excluded from every metric window (standard and include-third-party) and from
 * completion gating iff its labelStack contains a single label that is BOTH `type: 'third-party'`
 * AND `excludeFromMetrics: true`. Requiring both on the same label guarantees exclusion can only
 * ever apply to third-party work, never first-party. Such holds are dropped at creation time, so
 * they never enter `holdActive`/`hold3pActive`, never block completion.
 */ const $bf967f18f77189b5$var$isExcludedThirdPartyHold = (labelStack)=>labelStack?.some((label)=>'type' in label && label.type === 'third-party' && 'excludeFromMetrics' in label && label.excludeFromMetrics === true) ?? false;
const $bf967f18f77189b5$var$getMetricVariantCategories = (labelStack)=>{
    const categories = new Set();
    labelStack?.forEach((label)=>{
        if ('type' in label && $bf967f18f77189b5$var$isKnownMetricVariantCategory(label.type)) categories.add(label.type);
    });
    return [
        ...categories
    ];
};
const $bf967f18f77189b5$var$hasMetricVariantCategoryInHoldData = (interaction, category)=>interaction.holdInfo.some((hold)=>$bf967f18f77189b5$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.holdActive.values() ?? []
    ].some((hold)=>$bf967f18f77189b5$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.hold3pInfo ?? []
    ].some((hold)=>$bf967f18f77189b5$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.hold3pActive?.values() ?? []
    ].some((hold)=>$bf967f18f77189b5$var$hasMetricVariantCategory(hold.labelStack, category));
const $bf967f18f77189b5$var$recordMetricVariantCategoryEnd = (interaction, labelStack, end)=>{
    // Excluded third-party holds (e.g. Forge background scripts) still live in `hold3pActive` and
    // gate completion like any third-party hold, but they must never contribute a third-party
    // category end. Skipping here covers every caller at once: the normal-release closure in
    // `addHold`, `removeHoldByID`, `addCompletedHold`, and the abort/timeout iterator
    // `recordActiveMetricVariantCategoryEnds`.
    if ($bf967f18f77189b5$var$isExcludedThirdPartyHold(labelStack)) return;
    const categories = $bf967f18f77189b5$var$getMetricVariantCategories(labelStack);
    if (categories.length === 0) return;
    interaction.metricCategoryEnds = interaction.metricCategoryEnds ?? {};
    categories.forEach((category)=>{
        interaction.metricCategoryEnds[category] = Math.max(interaction.metricCategoryEnds[category] ?? 0, end);
    });
};
const $bf967f18f77189b5$var$recordActiveMetricVariantCategoryEnds = (interaction, end)=>{
    interaction.hold3pActive?.forEach((hold)=>{
        $bf967f18f77189b5$var$recordMetricVariantCategoryEnd(interaction, hold.labelStack, end);
    });
};
const $bf967f18f77189b5$var$hasActiveMetricVariantCategory = (interaction, category)=>[
        ...interaction.hold3pActive?.values() ?? []
    ].some((hold)=>$bf967f18f77189b5$var$hasMetricVariantCategory(hold.labelStack, category));
function $bf967f18f77189b5$var$shouldMoveHoldToExtendedBucket(interaction, hold) {
    // Excluded third-party holds (e.g. Forge background scripts) are routed to the extended
    // (`hold3pActive`) bucket exactly like any other third-party hold: they carry `type: 'third-party'`
    // so `hasAnyMetricVariantCategory` is true. They therefore keep gating completion (which preserves
    // the standard-bucket VC parity), and are excluded ONLY at the third-party accounting sites
    // (`recordMetricVariantCategoryEnd` and the `end3p` computation via `getNonExcludedThirdPartyEnd`).
    return $bf967f18f77189b5$var$hasAnyMetricVariantCategory(hold.labelStack) || interaction.end !== 0 && hold.start > interaction.end;
}
/**
 * The third-party end marker (`end3p`), used as the `include-third-party` window end whenever no
 * genuine third-party category end was recorded, must reflect only NON-excluded third-party work.
 *
 * `currentTime` is the timestamp the caller would otherwise have used verbatim (e.g. the abort
 * time, or the interaction end on the success path). If there is any genuine (non-excluded)
 * third-party hold that is still ACTIVE at this point, that work legitimately extends to
 * `currentTime`, so we keep it. Otherwise the only active third-party holds are excluded
 * background scripts, which must NOT drag the marker, so we fall back to the latest end among the
 * already-released non-excluded holds, clamped to at least `interactionEnd`. This preserves the
 * pre-fix behaviour for real third-party work while preventing background scripts from inflating
 * `end3p` / the include-third-party window.
 *
 * Note the released entries in `hold3pInfo` are `HoldActive & { end: number }`, so we read `h.end`.
 */ const $bf967f18f77189b5$var$getNonExcludedThirdPartyEnd = (interaction, currentTime, interactionEnd)=>{
    const activeHolds = [
        ...interaction.hold3pActive?.values() ?? []
    ];
    const releasedHolds = interaction.hold3pInfo ?? [];
    // If this interaction never involved an excluded (background-script) hold at all
    // (none active AND none released), it is unaffected by an exclusion logic.
    // The derivation below only runs when at least one excluded hold actually exists.
    const hasAnyExcludedThirdParty = activeHolds.some((hold)=>$bf967f18f77189b5$var$isExcludedThirdPartyHold(hold.labelStack)) || releasedHolds.some((hold)=>$bf967f18f77189b5$var$isExcludedThirdPartyHold(hold.labelStack));
    if (!hasAnyExcludedThirdParty) return currentTime;
    // If a genuine (non-excluded) third-party hold is still active, the interaction is legitimately
    // being kept open by real third-party work, so the marker is the current time
    const hasActiveNonExcludedThirdParty = activeHolds.some((hold)=>!$bf967f18f77189b5$var$isExcludedThirdPartyHold(hold.labelStack));
    if (hasActiveNonExcludedThirdParty) return currentTime;
    // Otherwise, only excluded background-script holds (if any) remain active. `currentTime` may have
    // been pushed out purely by a background script, so derive the marker from the latest genuine
    // (non-excluded) third-party work instead, floored to the interaction end so it is never reported
    // earlier than the interaction itself and a background script can never drag it late.
    return Math.max(interactionEnd, ...releasedHolds.filter((hold)=>!$bf967f18f77189b5$var$isExcludedThirdPartyHold(hold.labelStack)).map((hold)=>hold.end));
};
function $bf967f18f77189b5$var$ensureExtendedHoldActive(interaction) {
    interaction.hold3pActive = interaction.hold3pActive ?? new Map();
    return interaction.hold3pActive;
}
function $bf967f18f77189b5$var$ensureExtendedHoldInfo(interaction) {
    interaction.hold3pInfo = interaction.hold3pInfo ?? [];
    return interaction.hold3pInfo;
}
function $bf967f18f77189b5$var$moveLateActiveHoldsToExtendedBucket(interaction) {
    if (interaction.end === 0) return;
    const holdsToMove = [
        ...interaction.holdActive.entries()
    ].filter(([, hold])=>$bf967f18f77189b5$var$shouldMoveHoldToExtendedBucket(interaction, hold));
    holdsToMove.forEach(([id, hold])=>{
        $bf967f18f77189b5$var$ensureExtendedHoldActive(interaction).set(id, hold);
        interaction.holdActive.delete(id);
    });
}
function $bf967f18f77189b5$var$ensureMetricWindows(interaction) {
    if (interaction.end === 0) return;
    const hasGenAI = $bf967f18f77189b5$var$hasMetricVariantCategoryInHoldData(interaction, 'gen-ai');
    const hasThirdParty = $bf967f18f77189b5$var$hasMetricVariantCategoryInHoldData(interaction, 'third-party');
    const includeThirdPartyEnd = interaction.metricCategoryEnds?.['third-party'] !== undefined ? Math.max(interaction.metricCategoryEnds['third-party'], interaction.end) : interaction.end3p;
    const includeGenAIEnd = interaction.metricCategoryEnds?.['gen-ai'] !== undefined ? Math.max(interaction.metricCategoryEnds['gen-ai'], interaction.end) : undefined;
    interaction.metricWindows = {
        ...interaction.metricWindows,
        standard: {
            start: interaction.start,
            end: interaction.end,
            includeCategories: [],
            excludeCategories: [
                'third-party',
                'gen-ai'
            ]
        }
    };
    if (includeThirdPartyEnd !== undefined && (hasThirdParty || !hasGenAI)) interaction.metricWindows['include-third-party'] = {
        start: interaction.start,
        end: includeThirdPartyEnd,
        includeCategories: [
            'third-party'
        ],
        excludeCategories: []
    };
    if (hasGenAI && includeGenAIEnd !== undefined) interaction.metricWindows['include-gen-ai'] = {
        start: interaction.start,
        end: includeGenAIEnd,
        includeCategories: [
            'gen-ai'
        ],
        excludeCategories: []
    };
}
function $bf967f18f77189b5$var$addLifecycleObservation(interaction, observation) {
    interaction.lifecycleObservations = interaction.lifecycleObservations ?? [];
    interaction.lifecycleObservations.push(observation);
}
function $bf967f18f77189b5$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $bf967f18f77189b5$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    $bf967f18f77189b5$var$ensureMetricWindows(data);
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch  {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $hbvZL.currentFeatureFlagsAccessed));
    (0, $jSug1.clearActiveTrace)();
    $bf967f18f77189b5$var$callCleanUpCallbacks(data);
    (0, $jokam.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, $gmMRH.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    if (!(0, $erszr.default)((0, $gmMRH.getPostInteractionRate)((0, $23KgL.sanitizeUfoName)(data.ufoName), data.type))) $bf967f18f77189b5$export$d8f52e8f804021e8.stopVCObserver();
    $bf967f18f77189b5$export$cd7f480d6b8286c3(id);
    $bf967f18f77189b5$export$dbba6cdedab4e68b.id = data.id;
    $bf967f18f77189b5$export$dbba6cdedab4e68b.type = data.type;
    $bf967f18f77189b5$export$dbba6cdedab4e68b.timestamp = data.end;
    $bf967f18f77189b5$export$dbba6cdedab4e68b.name = data.ufoName || 'unknown';
    $bf967f18f77189b5$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) $bf967f18f77189b5$var$handleInteraction(id, data);
    if ($bf967f18f77189b5$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $bf967f18f77189b5$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$bf967f18f77189b5$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch  {
    // do nothing
    }
}
function $bf967f18f77189b5$export$9e614a29a1ac213e(sinkFn) {
    if ($bf967f18f77189b5$var$handleInteraction === $bf967f18f77189b5$var$pushToQueue) {
        $bf967f18f77189b5$var$handleInteraction = sinkFn;
        $bf967f18f77189b5$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $bf967f18f77189b5$var$interactionQueue.length = 0;
    }
}
function $bf967f18f77189b5$export$8a1ba7bef607358a(sinkFn) {
    $bf967f18f77189b5$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $bf967f18f77189b5$var$activeSubmitted = false;
function $bf967f18f77189b5$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) {
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const shouldUseRawDataThirdParty = (0, $gmMRH.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const postInteraction = async ()=>{
            if ((0, $gmMRH.getConfig)()?.postInteractionLog?.enabled) $bf967f18f77189b5$export$d8f52e8f804021e8.onInteractionComplete(interaction);
            $bf967f18f77189b5$var$activeSubmitted = false;
        };
        const noMoreActiveMetricVariantHolds = interaction.hold3pActive?.size === 0 || interaction.hold3pActive === undefined;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $bf967f18f77189b5$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If using separated metric variant behavior, wait for extended category holds to clear.
        // The backing fields still use their legacy 3P names because they are part of the existing
        // third-party payload contract, but this bucket now also drives client metric windows.
        if (shouldUseSeparatedMetricVariantBehavior) {
            // If there are no standard holds active, mark the interaction as successful
            // but don't finish until extended metric variant holds are cleared.
            if (noMoreActiveHolds && !noMoreActiveMetricVariantHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                $bf967f18f77189b5$var$moveLateActiveHoldsToExtendedBucket(interaction);
                $bf967f18f77189b5$var$ensureMetricWindows(interaction);
                // Wait for extended metric variant holds to clear before finishing.
                return;
            }
            // If all holds, including extended metric variant holds, are cleared, finish the interaction.
            if (noMoreActiveHolds && noMoreActiveMetricVariantHolds) {
                if (!$bf967f18f77189b5$var$activeSubmitted) {
                    // Set the legacy third-party end marker when extended metric variant holds clear,
                    // preserving existing 3P payload behavior while category-specific end times are
                    // recorded separately in metricCategoryEnds. When a genuine third-party hold is still
                    // active (or was the last to release), `getNonExcludedThirdPartyEnd` returns the same
                    // clamped current time as before. When only excluded background-script holds remain,
                    // the marker is derived from the non-excluded third-party holds and floored to the
                    // interaction end, so a background script cannot drag it late.
                    const currentTime = endTime ?? performance.now();
                    interaction.end3p = $bf967f18f77189b5$var$getNonExcludedThirdPartyEnd(interaction, interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime, interaction.end !== 0 ? interaction.end : currentTime);
                    $bf967f18f77189b5$var$ensureMetricWindows(interaction);
                    $bf967f18f77189b5$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((0, $gmMRH.getConfig)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $gmMRH.getConfig)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $1yDnt.onSearchPageInteractionComplete)(interactionId, interaction);
                    $bf967f18f77189b5$var$activeSubmitted = true;
                }
                postInteraction();
            }
        } else if (noMoreActiveHolds) {
            if (!$bf967f18f77189b5$var$activeSubmitted) {
                $bf967f18f77189b5$var$finishInteraction(interactionId, interaction, endTime);
                if ((0, $gmMRH.getConfig)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $gmMRH.getConfig)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $1yDnt.onSearchPageInteractionComplete)(interactionId, interaction);
                $bf967f18f77189b5$var$activeSubmitted = true;
            }
            postInteraction();
        }
    }
}
function $bf967f18f77189b5$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $bf967f18f77189b5$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $gmMRH.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $bf967f18f77189b5$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds that are still active at abort/timeout must not drag
            // `end3p` (and thus the include-third-party window) past the real interaction end. Derive it
            // from the non-excluded third-party holds only. `recordActiveMetricVariantCategoryEnds`
            // likewise skips excluded holds internally.
            interaction.end3p = $bf967f18f77189b5$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $bf967f18f77189b5$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $bf967f18f77189b5$var$addLifecycleObservation(interaction, {
                type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
                timestamp: interaction.end3p,
                activeHoldCount: interaction.hold3pActive?.size ?? 0
            });
            $bf967f18f77189b5$var$ensureMetricWindows(interaction);
            $bf967f18f77189b5$var$finishInteraction(interactionId, interaction, endTime);
            $bf967f18f77189b5$export$d8f52e8f804021e8.reset();
            $bf967f18f77189b5$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $bf967f18f77189b5$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $bf967f18f77189b5$var$addLifecycleObservation(interaction, {
            type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
            timestamp: performance.now(),
            activeHoldCount: interaction.holdActive.size + (interaction.hold3pActive?.size ?? 0)
        });
        $bf967f18f77189b5$var$finishInteraction(interactionId, interaction);
        $bf967f18f77189b5$export$d8f52e8f804021e8.reset();
        $bf967f18f77189b5$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $bf967f18f77189b5$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $gmMRH.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $bf967f18f77189b5$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds still active at this point must not drag `end3p` (and
            // thus the include-third-party window) past the real interaction end. Derive it from the
            // non-excluded third-party holds only, clamped to at least the interaction end.
            interaction.end3p = $bf967f18f77189b5$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $bf967f18f77189b5$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $bf967f18f77189b5$var$addLifecycleObservation(interaction, {
                type: 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: interactionName
            });
            $bf967f18f77189b5$var$ensureMetricWindows(interaction);
            $bf967f18f77189b5$var$finishInteraction(interactionId, interaction, endTime);
            $bf967f18f77189b5$export$d8f52e8f804021e8.reset();
            $bf967f18f77189b5$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $bf967f18f77189b5$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $bf967f18f77189b5$var$addLifecycleObservation(interaction, {
            type: 'new_interaction_started',
            timestamp: performance.now(),
            triggerName: interactionName
        });
        $bf967f18f77189b5$var$finishInteraction(interactionId, interaction);
        $bf967f18f77189b5$export$d8f52e8f804021e8.reset();
        $bf967f18f77189b5$export$d8f52e8f804021e8.stopVCObserver();
    } else {
        // post-interaction log is active after interaction is aborted by new one
        $bf967f18f77189b5$export$d8f52e8f804021e8.reset();
        $bf967f18f77189b5$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $bf967f18f77189b5$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    const activeInteraction = $bf967f18f77189b5$export$2b3954d2e8509985();
    const finishInteractions = (0, $gmMRH.getFinishInteractionOnTransition)();
    (0, $5BIjs.interactions).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions?.includes(interaction.ufoName)) hasFinished = true;
        const shouldUseRawDataThirdParty = (0, $gmMRH.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $bf967f18f77189b5$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds still active at transition/new-interaction abort must not
            // drag `end3p` (and thus the include-third-party window) past the real interaction end.
            // Derive it from the non-excluded third-party holds only, clamped to at least the end.
            interaction.end3p = $bf967f18f77189b5$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $bf967f18f77189b5$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $bf967f18f77189b5$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: abortedByInteractionName
            });
            $bf967f18f77189b5$var$ensureMetricWindows(interaction);
            $bf967f18f77189b5$var$finishInteraction(interactionId, interaction, endTime);
            $bf967f18f77189b5$export$d8f52e8f804021e8.reset();
            $bf967f18f77189b5$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        if (!hasFinished) {
            $bf967f18f77189b5$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            $bf967f18f77189b5$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: performance.now(),
                triggerName: abortedByInteractionName
            });
        }
        $bf967f18f77189b5$var$finishInteraction(interactionId, interaction);
        $bf967f18f77189b5$export$d8f52e8f804021e8.reset();
        $bf967f18f77189b5$export$d8f52e8f804021e8.stopVCObserver();
    });
}
function $bf967f18f77189b5$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $5BIjs.interactions).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $bf967f18f77189b5$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    $bf967f18f77189b5$export$d8f52e8f804021e8.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, $gmMRH.getInteractionTimeout)(ufoName);
    const timerID = setTimeout(()=>{
        $bf967f18f77189b5$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $bf967f18f77189b5$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $erszr.default)((0, $gmMRH.getCapabilityRate)('feature_flag_access'));
    const config = (0, $gmMRH.getConfig)();
    const searchPageConfig = {
        enableSmartAnswersMutations: config?.extraSearchPageInteraction?.enabled,
        searchPageRoute: config?.extraSearchPageInteraction?.searchPageRoute
    };
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $gmMRH.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $5SEkW.newVCObserver)(vcOptions);
    }
    const priorAccessedFg = type === 'press' ? {} : Object.fromEntries((0, $hbvZL.allFeatureFlagsAccessed));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $bf967f18f77189b5$export$dbba6cdedab4e68b.name,
        isPreviousInteractionAborted: $bf967f18f77189b5$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        excluded3pSegmentData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $hbvZL.currentFeatureFlagsAccessed).clear();
    (0, $5BIjs.interactions).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $bf967f18f77189b5$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $bf967f18f77189b5$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, $gmMRH.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $bf967f18f77189b5$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((0, $gmMRH.getConfig)()?.postInteractionLog?.enabled) $bf967f18f77189b5$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function $bf967f18f77189b5$export$4a759336b50e86e3(event) {
    const interaction = $bf967f18f77189b5$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') $bf967f18f77189b5$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $bf967f18f77189b5$export$ad216cc25852d44b(apdex) {
    (0, $5BIjs.interactions).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $bf967f18f77189b5$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $bf967f18f77189b5$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $bf967f18f77189b5$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $bf967f18f77189b5$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $bf967f18f77189b5$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $bf967f18f77189b5$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($bf967f18f77189b5$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $bf967f18f77189b5$export$1c43f9ac826b6462(labelStack) {
    const key = $bf967f18f77189b5$var$getSegmentCacheKey(labelStack);
    const existingSegment = $bf967f18f77189b5$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $bf967f18f77189b5$var$segmentCache.set(key, segmentInfo);
        $bf967f18f77189b5$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $bf967f18f77189b5$export$d0365e48b58231c3(labelStack) {
    const key = $bf967f18f77189b5$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $bf967f18f77189b5$var$segmentCache.get(key);
    if (segmentInfo) {
        $bf967f18f77189b5$var$segmentCache.delete(JSON.stringify(labelStack));
        const cacheKey = (0, $9VdNX.stringifyLabelStackFully)(labelStack);
        $bf967f18f77189b5$export$a2b14406ded37d60.set(cacheKey, ($bf967f18f77189b5$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $bf967f18f77189b5$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $bf967f18f77189b5$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $5BIjs.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($bf967f18f77189b5$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: prevRedirect?.time ?? interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
const $bf967f18f77189b5$export$6ce04c7ca6810a7e = [];
const $bf967f18f77189b5$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $bf967f18f77189b5$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $bf967f18f77189b5$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $bf967f18f77189b5$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("erszr", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5609126f518f926$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $b5609126f518f926$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $b5609126f518f926$export$2e2bcd8739ae039 = $b5609126f518f926$var$coinflip;

});

parcelRegister("editX", function(module, exports) {
$parcel$export(module.exports, "sanitizeTimingName", () => $4d7531c302521413$export$23e69abaca7d0236);
const $4d7531c302521413$export$4c07c8a3507ce307 = 255;
const $4d7531c302521413$var$GQL_OPERATION_PARAMS = [
    'operation',
    'operationName',
    'q'
];
function $4d7531c302521413$var$isGqlUrl(name) {
    try {
        const url = new URL(name);
        const searchParams = url.search ? new URLSearchParams(url.search) : null;
        return $4d7531c302521413$var$GQL_OPERATION_PARAMS.some((param)=>Boolean(searchParams?.get(param)));
    } catch  {
        return false;
    }
}
function $4d7531c302521413$export$23e69abaca7d0236(name) {
    if (name.length <= $4d7531c302521413$export$4c07c8a3507ce307) return name;
    if ($4d7531c302521413$var$isGqlUrl(name)) return name;
    return name.slice(0, $4d7531c302521413$export$4c07c8a3507ce307);
}

});

parcelRegister("gmMRH", function(module, exports) {
$parcel$export(module.exports, "isFedrampOverrideActive", () => $79344d6b17638b03$export$1133b5e2873baa7a);
$parcel$export(module.exports, "DEFAULT_TTVC_REVISION", () => $79344d6b17638b03$export$f9bb3bb330fb9609);
$parcel$export(module.exports, "setUFOConfig", () => $79344d6b17638b03$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $79344d6b17638b03$export$44487a86467333c3);
$parcel$export(module.exports, "getSelectorConfig", () => $79344d6b17638b03$export$59e1f072477dfb48);
$parcel$export(module.exports, "isUFOEnabled", () => $79344d6b17638b03$export$74bdb753f1cf4860);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $79344d6b17638b03$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getMostRecentVCRevision", () => $79344d6b17638b03$export$70184d6e2c753893);
$parcel$export(module.exports, "getReactHydrationStats", () => $79344d6b17638b03$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "getInteractionRate", () => $79344d6b17638b03$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "shouldUseRawDataThirdPartyBehavior", () => $79344d6b17638b03$export$9c69f5a724f05f38);
$parcel$export(module.exports, "getPostInteractionRate", () => $79344d6b17638b03$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $79344d6b17638b03$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getTypingPerformanceTracingMethod", () => $79344d6b17638b03$export$7e32aae12bf9b50f);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $79344d6b17638b03$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $79344d6b17638b03$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getMinorInteractions", () => $79344d6b17638b03$export$b150ddad71c80d77);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $79344d6b17638b03$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $79344d6b17638b03$export$d6dc9444bd15f70f);
$parcel$export(module.exports, "getFinishInteractionOnTransition", () => $79344d6b17638b03$export$20e8108b8ccdd0bd);
$parcel$export(module.exports, "getInteractionTimeout", () => $79344d6b17638b03$export$c681731847989445);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $fS5dR = parcelRequire("fS5dR");

var $iqfTZ = parcelRequire("iqfTZ");
let $79344d6b17638b03$var$config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ let $79344d6b17638b03$var$cachedIsFedrampModerate;
function $79344d6b17638b03$var$detectIsFedrampModerate() {
    if ($79344d6b17638b03$var$cachedIsFedrampModerate !== undefined) return $79344d6b17638b03$var$cachedIsFedrampModerate;
    try {
        $79344d6b17638b03$var$cachedIsFedrampModerate = (0, $fS5dR.isFedrampModerate)();
    } catch  {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        $79344d6b17638b03$var$cachedIsFedrampModerate = false;
    }
    return $79344d6b17638b03$var$cachedIsFedrampModerate;
}
function $79344d6b17638b03$export$89dc2b6be8cc261() {
    $79344d6b17638b03$var$cachedIsFedrampModerate = undefined;
}
function $79344d6b17638b03$export$1133b5e2873baa7a() {
    try {
        return $79344d6b17638b03$var$detectIsFedrampModerate();
    } catch  {
        return false;
    }
}
const $79344d6b17638b03$var$FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
const $79344d6b17638b03$export$f9bb3bb330fb9609 = 'fy26.04';
function $79344d6b17638b03$export$2182e73d31080cbc() {
    return $79344d6b17638b03$export$f9bb3bb330fb9609;
}
const $79344d6b17638b03$export$d50dacda7fe6392b = 1000;
function $79344d6b17638b03$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = newConfig?.vc ?? {};
    if (enabledVCRevisions) {
        const byExperience = typeof enabledVCRevisions?.byExperience === 'object' ? enabledVCRevisions.byExperience : {};
        const allRevisions = [
            // Products control their own revisions.
            ...enabledVCRevisions?.all ?? [],
            ...Object.values(byExperience).flat()
        ];
        $79344d6b17638b03$var$config = {
            ...newConfig,
            vc: {
                ...newConfig.vc,
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            }
        };
    } else $79344d6b17638b03$var$config = newConfig;
}
function $79344d6b17638b03$export$44487a86467333c3() {
    return $79344d6b17638b03$var$config;
}
function $79344d6b17638b03$export$59e1f072477dfb48(callerOverride, defaultConfig) {
    // 1. FedRAMP override always wins.
    if ($79344d6b17638b03$var$detectIsFedrampModerate()) return $79344d6b17638b03$var$FEDRAMP_DISABLED_SELECTOR_CONFIG;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return callerOverride ?? $79344d6b17638b03$var$config?.vc?.selectorConfig ?? defaultConfig;
}
function $79344d6b17638b03$export$74bdb753f1cf4860() {
    // Default to enabled if config is not set or enabled is not explicitly false
    return $79344d6b17638b03$var$config?.enabled !== false;
}
const $79344d6b17638b03$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $79344d6b17638b03$export$87fbc8e01b137811(experienceKey = '') {
    try {
        if (!$79344d6b17638b03$var$config) return [];
        if ($79344d6b17638b03$var$config.vc?.enabled) {
            const { enabledVCRevisions: enabledVCRevisions } = $79344d6b17638b03$var$config.vc ?? {};
            if ($79344d6b17638b03$var$isValidConfigArray(enabledVCRevisions?.byExperience?.[experienceKey])) return enabledVCRevisions.byExperience?.[experienceKey];
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            const allRevisions = enabledVCRevisions?.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, $iqfTZ.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if ($79344d6b17638b03$var$isValidConfigArray(allRevisions)) return allRevisions;
            return [
                $79344d6b17638b03$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $79344d6b17638b03$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $79344d6b17638b03$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $79344d6b17638b03$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $79344d6b17638b03$export$87fbc8e01b137811(experienceKey);
    if (enabledVCRevisions.length === 0) return $79344d6b17638b03$export$2182e73d31080cbc();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $79344d6b17638b03$export$2d8f8d64dc343d7b() {
    if (!$79344d6b17638b03$var$config) return undefined;
    try {
        const stats = $79344d6b17638b03$var$config?.getReactHydrationStats?.();
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $79344d6b17638b03$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$79344d6b17638b03$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $79344d6b17638b03$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if (rates?.[name] != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $79344d6b17638b03$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        // Fallback
        return 0;
    }
}
function $79344d6b17638b03$export$48f4e0d964030a96(name, interactionType) {
    return $79344d6b17638b03$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $79344d6b17638b03$export$9c69f5a724f05f38(name, interactionType) {
    return $79344d6b17638b03$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $79344d6b17638b03$export$1d459f020c06ae34(name, interactionType) {
    return $79344d6b17638b03$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $79344d6b17638b03$export$29b9ffb14861a1d(capability) {
    if ((0, $iqfTZ.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$79344d6b17638b03$var$config) return 0;
        const { capability: capabilityRate } = $79344d6b17638b03$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $79344d6b17638b03$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$79344d6b17638b03$var$config) return 0;
        const gotConfig = $79344d6b17638b03$var$config[configName];
        if (!gotConfig?.enabled) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
const $79344d6b17638b03$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $79344d6b17638b03$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$79344d6b17638b03$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $79344d6b17638b03$var$config;
        if (typingMethod != null && $79344d6b17638b03$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch  {
        return defaultMethod;
    }
}
function $79344d6b17638b03$export$2d311b3fd18dcab1() {
    try {
        if (!$79344d6b17638b03$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $79344d6b17638b03$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch  {
        return [];
    }
}
function $79344d6b17638b03$export$4f4649ef27b6f5d6() {
    try {
        if (!$79344d6b17638b03$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $79344d6b17638b03$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch  {
        return undefined;
    }
}
function $79344d6b17638b03$export$b150ddad71c80d77() {
    try {
        if (!$79344d6b17638b03$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $79344d6b17638b03$var$config;
        return minorInteractions;
    } catch  {
        return undefined;
    }
}
function $79344d6b17638b03$export$3c170167645a0eff() {
    try {
        if (!$79344d6b17638b03$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $79344d6b17638b03$var$config;
        return doNotAbortActivePressInteraction;
    } catch  {
        return undefined;
    }
}
function $79344d6b17638b03$export$d6dc9444bd15f70f() {
    try {
        if (!$79344d6b17638b03$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $79344d6b17638b03$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
function $79344d6b17638b03$export$20e8108b8ccdd0bd() {
    try {
        if (!$79344d6b17638b03$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $79344d6b17638b03$var$config;
        return finishInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
const $79344d6b17638b03$export$2a8604960d7d23d9 = 60000;
function $79344d6b17638b03$export$c681731847989445(ufoName) {
    try {
        if (!$79344d6b17638b03$var$config) return $79344d6b17638b03$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $79344d6b17638b03$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $79344d6b17638b03$export$2a8604960d7d23d9;
    } catch  {
        return $79344d6b17638b03$export$2a8604960d7d23d9;
    }
}

});
parcelRegister("fS5dR", function(module, exports) {
$parcel$export(module.exports, "isFedrampModerate", () => $8792c9a9eecec9e1$export$104cb891a6e90b3a);


var $39qy8 = parcelRequire("39qy8");
function $8792c9a9eecec9e1$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInFedramp ?? false;
    const atlCtxCookieValues = (0, $39qy8.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $8fdfc4bb9d992697$export$ce553301d55c2fd8);
}

});
const $8fdfc4bb9d992697$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $8fdfc4bb9d992697$export$f005e2e9f707cb5f = 'commercial';
const $8fdfc4bb9d992697$export$17b81a3d6c98013c = 'isolated-cloud';
const $8fdfc4bb9d992697$export$a739cd5aac835909 = 'staging';
const $8fdfc4bb9d992697$export$42dd0cdd351a4a9 = 'prod';
const $8fdfc4bb9d992697$export$404582bc18fe4d9e = 'dev';
const $8fdfc4bb9d992697$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $8fdfc4bb9d992697$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $8fdfc4bb9d992697$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $8fdfc4bb9d992697$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $8fdfc4bb9d992697$export$b61e047ddcc35726 = 'GCP';
const $8fdfc4bb9d992697$export$1baf17f3e645a2b2 = 'AWS';

parcelRegister("39qy8", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $b6fadbc27d318eb8$export$3fa7b7af96286cc9);


var $bI52x = parcelRequire("bI52x");
function $b6fadbc27d318eb8$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = (0, $bI52x.getRawCookieValue)((0, $8fdfc4bb9d992697$export$87285944378c596), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = (0, $bI52x.getRawCookieValue)((0, $8fdfc4bb9d992697$export$715603e81922c3ec), cookies);
        const icId = (0, $bI52x.getRawCookieValue)((0, $8fdfc4bb9d992697$export$a0ffa0598c95dfb7), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("bI52x", function(module, exports) {
$parcel$export(module.exports, "getRawCookieValue", () => $18b19e2cc389af31$export$aa09aab30a92256c);
function $18b19e2cc389af31$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}

});




parcelRegister("1yDnt", function(module, exports) {
$parcel$export(module.exports, "sinkExtraSearchPageInteractionHandler", () => $70ed34cbd9e3f990$export$e6a07a94f3e112d4);
$parcel$export(module.exports, "onSearchPageInteractionComplete", () => $70ed34cbd9e3f990$export$74b9ce7e9d206a8);
const $70ed34cbd9e3f990$var$interactionBuffer = [];
let $70ed34cbd9e3f990$var$bufferInteractionData = (interactionId, data)=>{
    $70ed34cbd9e3f990$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $70ed34cbd9e3f990$var$clearInteractionBuffer() {
    $70ed34cbd9e3f990$var$interactionBuffer.length = 0;
}
function $70ed34cbd9e3f990$var$appendInteractionData(interactionId, data) {
    $70ed34cbd9e3f990$var$bufferInteractionData(interactionId, data);
}
function $70ed34cbd9e3f990$var$installInteractionSink(handler) {
    for (const { interactionId: interactionId, data: data } of $70ed34cbd9e3f990$var$interactionBuffer)handler(interactionId, data);
    $70ed34cbd9e3f990$var$clearInteractionBuffer();
    $70ed34cbd9e3f990$var$bufferInteractionData = handler;
}
function $70ed34cbd9e3f990$export$e6a07a94f3e112d4(sinkFn) {
    $70ed34cbd9e3f990$var$installInteractionSink(sinkFn);
}
function $70ed34cbd9e3f990$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        $70ed34cbd9e3f990$var$appendInteractionData(interactionId, data);
        $70ed34cbd9e3f990$var$clearInteractionBuffer();
    }
}

});

parcelRegister("23KgL", function(module, exports) {
$parcel$export(module.exports, "sanitizeUfoName", () => $8514d4a4969eb6f0$export$e08487ea3ae92adb);
function $8514d4a4969eb6f0$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}

});

parcelRegister("9VdNX", function(module, exports) {
$parcel$export(module.exports, "stringifyLabelStackFully", () => $a14f5e0aef5f9b79$export$caeee352b541de1f);

var $bWV5K = parcelRequire("bWV5K");

var $6xmKf = parcelRequire("6xmKf");
function $a14f5e0aef5f9b79$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        const name = (0, $6xmKf.sanitizeLabelStackName)(l.name);
        if ((0, $bWV5K.isSegmentLabel)(l)) return `${name}:${l.segmentId}`;
        return name;
    }).join('/');
}

});
parcelRegister("bWV5K", function(module, exports) {
$parcel$export(module.exports, "isSegmentLabel", () => $1c9bb17b03a5f959$export$1adbaf5c2363e4ae);
function $1c9bb17b03a5f959$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}

});

parcelRegister("6xmKf", function(module, exports) {
$parcel$export(module.exports, "sanitizeLabelStackName", () => $fd62aa37433782c0$export$3535cd9da4961282);
function $fd62aa37433782c0$export$3535cd9da4961282(name) {
    if (name.startsWith('/')) name = name.replace(/^\/+/, '');
    if (name.endsWith('/')) name = name.replace(/\/+$/, '');
    return name;
}

});


parcelRegister("jSug1", function(module, exports) {
$parcel$export(module.exports, "clearActiveTrace", () => $d518e88d82d5c768$export$17ab21d7be720b);

var $3lwCO = parcelRequire("3lwCO");

var $iqfTZ = parcelRequire("iqfTZ");

var $7Ri80 = parcelRequire("7Ri80");

var $d0MxM = parcelRequire("d0MxM");
function $d518e88d82d5c768$export$17ab21d7be720b() {
    if ((0, $iqfTZ.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $7Ri80.getContextManager)() instanceof (0, $7Ri80.UFOContextManager)) {
            let contextManager = (0, $7Ri80.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $3lwCO.ROOT_CONTEXT));
        }
    } else (0, $d0MxM.state).context = null;
}

});
parcelRegister("7Ri80", function(module, exports) {
$parcel$export(module.exports, "setContextManager", () => $098b4e78b70791f8$export$4a00ab8a5dd9b5cf);
$parcel$export(module.exports, "getContextManager", () => $098b4e78b70791f8$export$831109c9f7727010);
$parcel$export(module.exports, "UFOContextManager", () => $098b4e78b70791f8$export$dd301b96c16f583d);

var $3lwCO = parcelRequire("3lwCO");
/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ let $098b4e78b70791f8$var$contextManager;
function $098b4e78b70791f8$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $098b4e78b70791f8$var$contextManager = ctxMgr;
}
function $098b4e78b70791f8$export$831109c9f7727010() {
    return $098b4e78b70791f8$var$contextManager;
}
class $098b4e78b70791f8$export$dd301b96c16f583d {
    /**
	 *
	 * @param context
	 * @param target Function to be executed within the context
	 */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $3lwCO.ROOT_CONTEXT), target) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
	 * Returns the active context
	 */ active() {
        return this._currentContext;
    }
    /**
	 * Binds a the certain context or the active one to the target function and then returns the target
	 * @param context A context (span) to be bind to target
	 * @param target a function or event emitter. When target or one of its callbacks is called,
	 *  the provided context will be used as the active context for the duration of the call.
	 */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
	 * Disable the context manager (clears the current context)
	 */ disable() {
        this._currentContext = (0, $3lwCO.ROOT_CONTEXT);
        this._enabled = false;
        return this;
    }
    /**
	 * Enables the context manager and creates a default(root) context
	 */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $3lwCO.ROOT_CONTEXT);
        return this;
    }
    /**
	 * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
	 * The context will be set as active
	 * @param context
	 * @param fn Callback function
	 * @param thisArg optional receiver to be used for calling fn
	 * @param args optional arguments forwarded to fn
	 */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $3lwCO.ROOT_CONTEXT);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
    /**
	 * Sets the active context.
	 * This function is an extension of the OTel spec, in order to facilitate the current API of React UFO trace context handling.
	 * It doesn't keep track of any previously set active contexts, because it's assumed (for now) that only one trace context
	 * will ever exist at a time.
	 * The next step in the work to improve tracing in the FE will likely remove this function as we need to track the
	 * hierarchy of contexts (likely using the `with()` function above).
	 * @param context The context to be made the globally active one
	 */ setActive(context) {
        if (this._enabled) this._currentContext = context;
    }
    constructor(){
        /**
	 * whether the context manager is enabled or not
	 */ this._enabled = false;
        /**
	 * Keeps the reference to current context
	 */ this._currentContext = (0, $3lwCO.ROOT_CONTEXT);
    }
}

});


parcelRegister("fJjLT", function(module, exports) {
$parcel$export(module.exports, "BACKEND_RESOURCE_TIMING_INITIATOR_TYPES", () => $95f66e4f32a900b3$export$c3b002e13fbb9ef2);
const $95f66e4f32a900b3$export$c3b002e13fbb9ef2 = new Set([
    'fetch',
    'xmlhttprequest'
]);

});

parcelRegister("jokam", function(module, exports) {
$parcel$export(module.exports, "flushSsrRenderProfilerTraces", () => $9b76f0dc5855aaf1$export$c8760e11c713fafc);
$parcel$export(module.exports, "default", () => $9b76f0dc5855aaf1$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $gmMRH = parcelRequire("gmMRH");

var $6xmKf = parcelRequire("6xmKf");

var $siTdT = parcelRequire("siTdT");

var $gIMgJ = parcelRequire("gIMgJ");
// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
const $9b76f0dc5855aaf1$var$startTimes = new Map();
const $9b76f0dc5855aaf1$var$spanStates = new Map();
const $9b76f0dc5855aaf1$export$cf4e4023c0a34c8d = ()=>{
    $9b76f0dc5855aaf1$var$startTimes.clear();
    $9b76f0dc5855aaf1$var$spanStates.clear();
};
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
let $9b76f0dc5855aaf1$var$lastActiveInteraction;
function $9b76f0dc5855aaf1$var$checkActiveInteractionAndResetStartMarksIfSet() {
    const activeInteractionId = (0, $siTdT.getActiveInteraction)()?.id;
    if (!!$9b76f0dc5855aaf1$var$lastActiveInteraction && $9b76f0dc5855aaf1$var$lastActiveInteraction !== activeInteractionId) $9b76f0dc5855aaf1$export$cf4e4023c0a34c8d();
    $9b76f0dc5855aaf1$var$lastActiveInteraction = activeInteractionId;
}
const $9b76f0dc5855aaf1$var$getIsNativeTracingEnabled = ()=>(0, $gmMRH.getConfig)()?.ssr?.enableNativeTracing ?? false;
const $9b76f0dc5855aaf1$var$onStartRender = (id, currentSegmentName, parentContext)=>{
    if (!$9b76f0dc5855aaf1$var$startTimes.has(id)) $9b76f0dc5855aaf1$var$startTimes.set(id, []);
    $9b76f0dc5855aaf1$var$startTimes.get(id)?.push(performance.now());
    if (!$9b76f0dc5855aaf1$var$getIsNativeTracingEnabled()) return null;
    const startSpan = globalThis.__vm_internals__?.telemetry?.startSpan;
    let spanState = $9b76f0dc5855aaf1$var$spanStates.get(id) ?? null;
    if (!spanState && startSpan) {
        const span = startSpan(currentSegmentName, {
            parentSpanId: parentContext?.spanId
        });
        spanState = {
            span: span
        };
        $9b76f0dc5855aaf1$var$spanStates.set(id, spanState);
    }
    return spanState;
};
const $9b76f0dc5855aaf1$var$isInSSR = typeof false !== 'undefined' && false || typeof $gIMgJ !== 'undefined' && Boolean($gIMgJ?.env?.REACT_SSR || false);
const $9b76f0dc5855aaf1$var$ProfilerMarker = ({ onRender: onRender })=>{
    onRender?.();
    return null;
};
const $9b76f0dc5855aaf1$var$ParentSpanContext = /*#__PURE__*/ (0, $euxye.createContext)(null);
const $9b76f0dc5855aaf1$export$c8760e11c713fafc = ()=>{
    $9b76f0dc5855aaf1$var$spanStates.forEach((spanState)=>{
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    $9b76f0dc5855aaf1$var$spanStates.clear();
};
const $9b76f0dc5855aaf1$export$b8bd105b650b1c1e = ({ children: children, labelStack: labelStack, onRender: onRender })=>{
    const reactProfilerId = (0, $euxye.useMemo)(()=>labelStack.map((l)=>(0, $6xmKf.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    $9b76f0dc5855aaf1$var$checkActiveInteractionAndResetStartMarksIfSet();
    const parentSpan = (0, $euxye.useContext)($9b76f0dc5855aaf1$var$ParentSpanContext);
    const currentSpanState = $9b76f0dc5855aaf1$var$onStartRender(reactProfilerId, (0, $6xmKf.sanitizeLabelStackName)(labelStack[labelStack.length - 1].name), parentSpan);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)($9b76f0dc5855aaf1$var$ParentSpanContext.Provider, {
            value: currentSpanState?.span.getSpanContext() ?? null,
            children: [
                children,
                /*#__PURE__*/ (0, $e79Pd.jsx)($9b76f0dc5855aaf1$var$ProfilerMarker, {
                    onRender: ()=>{
                        const startTimesForId = $9b76f0dc5855aaf1$var$startTimes.get(reactProfilerId);
                        if (startTimesForId?.length) {
                            const endTime = performance.now();
                            const firstStartTime = startTimesForId[0];
                            const lastStartTime = startTimesForId[startTimesForId.length - 1];
                            const baseDuration = endTime - lastStartTime;
                            const actualDuration = endTime - firstStartTime;
                            onRender('mount', actualDuration, baseDuration, firstStartTime, endTime);
                        }
                        const spanState = $9b76f0dc5855aaf1$var$spanStates.get(reactProfilerId);
                        if (spanState) spanState.latestEndTime = performance.now();
                    }
                })
            ]
        })
    });
};
$9b76f0dc5855aaf1$export$b8bd105b650b1c1e.displayName = "SsrRenderProfilerInner";
const $9b76f0dc5855aaf1$var$SsrRenderProfiler = (props)=>{
    if ($9b76f0dc5855aaf1$var$isInSSR) return /*#__PURE__*/ (0, $e79Pd.jsx)($9b76f0dc5855aaf1$export$b8bd105b650b1c1e, {
        ...props
    });
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)($9b76f0dc5855aaf1$var$ProfilerMarker, {}),
            props.children
        ]
    });
};
$9b76f0dc5855aaf1$var$SsrRenderProfiler.displayName = "SsrRenderProfiler";
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$9b76f0dc5855aaf1$export$2e2bcd8739ae039 = $9b76f0dc5855aaf1$var$SsrRenderProfiler;

});

parcelRegister("5SEkW", function(module, exports) {
$parcel$export(module.exports, "newVCObserver", () => $ad3960387e05f963$export$c69731bddfc24d85);

var $eOQ1K = parcelRequire("eOQ1K");

var $luL1b = parcelRequire("luL1b");

var $k45ha = parcelRequire("k45ha");
function $ad3960387e05f963$export$c69731bddfc24d85(opts = {}) {
    const shouldMockVCObserver = !(0, $eOQ1K.isEnvironmentSupported)();
    const observer = shouldMockVCObserver ? new (0, $luL1b.VCObserverNOOP)() : new (0, $k45ha.VCObserverWrapper)(opts);
    return observer;
}

});
parcelRegister("eOQ1K", function(module, exports) {
$parcel$export(module.exports, "isEnvironmentSupported", () => $7409878bf0789123$export$68d57b133e88584d);
// Some products set this variable to indicate it is running in SSR

var $gIMgJ = parcelRequire("gIMgJ");
let $7409878bf0789123$var$isServer = Boolean(globalThis?.false);
// Other products set this other variable to indicate it is running in SSR
let $7409878bf0789123$var$isReactSSR = typeof $gIMgJ !== 'undefined' && Boolean($gIMgJ?.env?.REACT_SSR || false);
function $7409878bf0789123$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($7409878bf0789123$var$isReactSSR || $7409878bf0789123$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof globalThis?.WeakRef !== 'function') return false;
    if (typeof globalThis?.MutationObserver !== 'function' || typeof globalThis?.IntersectionObserver !== 'function' || typeof globalThis?.PerformanceObserver !== 'function') return false;
    return true;
}

});

parcelRegister("luL1b", function(module, exports) {
$parcel$export(module.exports, "VCObserverNOOP", () => $8f9eb2113b44b78f$export$24d07287b49da906);
class $8f9eb2113b44b78f$export$24d07287b49da906 {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}

});

parcelRegister("k45ha", function(module, exports) {
$parcel$export(module.exports, "VCObserverWrapper", () => $5983e1c10a21ef93$export$4a1fe1ab3c13bbf5);

var $gmMRH = parcelRequire("gmMRH");

var $2gtrF = parcelRequire("2gtrF");

var $4qaz4 = parcelRequire("4qaz4");

var $lzdBF = parcelRequire("lzdBF");

var $4iWJW = parcelRequire("4iWJW");
class $5983e1c10a21ef93$export$4a1fe1ab3c13bbf5 {
    constructor(opts = {}){
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $4iWJW.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
        });
        this.newVCObserver = new (0, $4qaz4.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: opts.trackLayoutShiftOffenders ?? false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, $gmMRH.isVCRevisionEnabled)('fy25.01') || (0, $gmMRH.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $2gtrF.VCObserver)({
            ...opts,
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
    }
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        // Process any SSR abort listeners that remain
        if (window?.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        if ((0, $gmMRH.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $gmMRH.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.start({
            startTime: startTime
        });
        this.newVCObserver?.start({
            startTime: startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        if ((0, $gmMRH.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $gmMRH.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.stop();
        this.newVCObserver?.stop();
        (0, $lzdBF.RLLPlaceholderHandlers).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        return this.oldVCObserver?.getVCRawData() ?? null;
    }
    async getVCResult(param) {
        const { experienceKey: experienceKey, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, includeRawData: includeRawData } = param;
        const v1v2Result = (0, $gmMRH.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $gmMRH.isVCRevisionEnabled)('fy25.02', experienceKey) ? await this.oldVCObserver?.getVCResult(param) : {};
        const v3v4Result = await this.newVCObserver?.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.ssr,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason,
            includeRawData: includeRawData,
            includeSSRInV3: param.includeSSRInV3,
            rawDataStopTime: param.rawDataStopTime,
            reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
        });
        if (!v3v4Result || v3v4Result.length === 0) return v1v2Result ?? {};
        const ssrRatio = v3v4Result?.[0]?.ssrRatio;
        return {
            ...includeSSRRatio && ssrRatio !== undefined ? {
                'ufo:vc:ssrRatio': ssrRatio
            } : {},
            ...v1v2Result,
            'ufo:vc:rev': [
                ...v1v2Result?.['ufo:vc:rev'] ?? [],
                ...v3v4Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        this.oldVCObserver?.setSSRElement(element);
        this.newVCObserver?.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        this.oldVCObserver?.setReactRootRenderStart(startTime || performance.now());
        this.newVCObserver?.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        this.oldVCObserver?.setReactRootRenderStop(stopTime || performance.now());
        this.newVCObserver?.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
}

});
parcelRegister("2gtrF", function(module, exports) {
$parcel$export(module.exports, "VCObserver", () => $0da4b467a5cb80b7$export$1f70d263701b1d01);

var $iqfTZ = parcelRequire("iqfTZ");

var $gmMRH = parcelRequire("gmMRH");

var $siTdT = parcelRequire("siTdT");

var $ga7ON = parcelRequire("ga7ON");

var $29Oat = parcelRequire("29Oat");

var $bAdhV = parcelRequire("bAdhV");

var $bRU6a = parcelRequire("bRU6a");

var $2xru9 = parcelRequire("2xru9");

var $kzFB7 = parcelRequire("kzFB7");
const $0da4b467a5cb80b7$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $0da4b467a5cb80b7$var$UNUSED_SECTOR = 0;
function $0da4b467a5cb80b7$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $0da4b467a5cb80b7$export$1f70d263701b1d01 {
    static{
        /** config * */ this.VCParts = [
            '25',
            '50',
            '75',
            '80',
            '85',
            '90',
            '95',
            '98',
            '99'
        ];
    }
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.unbind = [];
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId, includeSSRRatio: includeSSRRatio })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
            const isTTVCv1Disabled = !(0, $gmMRH.isVCRevisionEnabled)('fy25.01', experienceKey);
            if (abortReasonInfo !== null) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch  {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason,
                    abortTimestamp: Math.round(abortReason.timestamp)
                });
                return vcAbortedResultWithRevisions;
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $0da4b467a5cb80b7$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $0da4b467a5cb80b7$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $0da4b467a5cb80b7$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
                if (!this.isPostInteraction) {
                    // Only create revision debug details if callbacks exist
                    const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                    if (shouldCreateDebugDetails) {
                        const v1RevisionDebugDetails = (0, $29Oat.getVCRevisionDebugDetails)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        const v2RevisionDebugDetails = (0, $29Oat.getVCRevisionDebugDetails)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        // Add devtool callback for both v1 and v2
                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                            // Handle v1 if not disabled
                            if (!isTTVCv1Disabled) window.__ufo_devtool_onVCRevisionReady__?.(v1RevisionDebugDetails);
                            // Handle v2
                            window.__ufo_devtool_onVCRevisionReady__?.(v2RevisionDebugDetails);
                        }
                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                            if (!isTTVCv1Disabled) window.__on_ufo_vc_debug_data_ready?.(v1RevisionDebugDetails);
                            window.__on_ufo_vc_debug_data_ready?.(v2RevisionDebugDetails);
                        }
                    }
                }
            } catch  {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $bAdhV.getVCRevisionsData)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey,
                ratios: ratios
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            const SSRRatio = $0da4b467a5cb80b7$export$1f70d263701b1d01.getSSRRatio(VCEntries.rel, ssr);
            const SSRRatioNext = $0da4b467a5cb80b7$export$1f70d263701b1d01.getSSRRatio(vcNext.VCEntries.rel, ssr);
            const SSRRatioPayload = includeSSRRatio ? {
                [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
                [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
            } : {};
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext,
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $gmMRH.isVCRevisionEnabled)('fy25.03', experienceKey);
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatio,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, $siTdT.getActiveInteraction)();
                const isTTVCv1Disabled = !(0, $gmMRH.isVCRevisionEnabled)('fy25.01', interaction?.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($0da4b467a5cb80b7$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $iqfTZ.fg)('platform_ufo_keypress_interaction_abort')) {
                        const interaction = (0, $siTdT.getActiveInteraction)();
                        if (interaction?.type === 'press') break;
                    }
                    this.setAbortReason($0da4b467a5cb80b7$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($0da4b467a5cb80b7$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            this.detachAbortListeners();
            let unbinds = (0, $ga7ON.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if (window?.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler: ssrPlaceholderHandler } = options;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It enforces FedRAMP-override > caller-override >
        // centrally configured > caller default. When `getSelectorConfig()`
        // returns `undefined` we fall back to the legacy hard-coded default
        // to preserve pre-existing behaviour for callers that don't pass an
        // explicit `selectorConfig`.
        const LEGACY_DEFAULT_SELECTOR_CONFIG = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.observers = new (0, $kzFB7.Observers)({
            selectorConfig: (0, $gmMRH.getSelectorConfig)(options.selectorConfig, LEGACY_DEFAULT_SELECTOR_CONFIG) || options.selectorConfig || LEGACY_DEFAULT_SELECTOR_CONFIG,
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $gmMRH.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $0da4b467a5cb80b7$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport, fixSSRAttribution: fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== $0da4b467a5cb80b7$var$UNUSED_SECTOR) {
            const element = {
                __debug__element: new WeakRef(window.document?.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $0da4b467a5cb80b7$var$UNUSED_SECTOR && ssrTime !== $0da4b467a5cb80b7$var$UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== $0da4b467a5cb80b7$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $0da4b467a5cb80b7$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $0da4b467a5cb80b7$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $0da4b467a5cb80b7$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $0da4b467a5cb80b7$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set(componentsLog[time]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set(componentsLog[timestamp]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (acc.rel[i - 1]?.vc ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $0da4b467a5cb80b7$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $gmMRH.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($0da4b467a5cb80b7$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $2xru9.getViewportWidth)();
        this.viewport.h = (0, $bRU6a.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($0da4b467a5cb80b7$var$abortReason.error, time, `index - ${row}`);
                } catch  {
                    this.setAbortReason($0da4b467a5cb80b7$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $0da4b467a5cb80b7$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}
$0da4b467a5cb80b7$export$1f70d263701b1d01.displayName = "VCObserver";

});
parcelRegister("ga7ON", function(module, exports) {
$parcel$export(module.exports, "attachAbortListeners", () => $f7d0aed6d4456c09$export$9010aa71841a6887);

var $glbdM = parcelRequire("glbdM");

var $cyImo = parcelRequire("cyImo");

var $bRU6a = parcelRequire("bRU6a");

var $2xru9 = parcelRequire("2xru9");
function $f7d0aed6d4456c09$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $glbdM.bind)(window, {
        type: (0, $cyImo.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $cyImo.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $glbdM.bind)(window, {
        type: (0, $cyImo.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $cyImo.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $glbdM.bind)(window, {
        type: (0, $cyImo.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $2xru9.getViewportWidth)() !== initialViewPort.w || (0, $bRU6a.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $cyImo.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("cyImo", function(module, exports) {
$parcel$export(module.exports, "AbortEvent", () => $e5f512dd0c1f7c1f$export$199edc0307b5587f);
const $e5f512dd0c1f7c1f$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("bRU6a", function(module, exports) {
$parcel$export(module.exports, "getViewportHeight", () => $35a8b801ec9dcf0d$export$4f01c15d21ef9cc6);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $35a8b801ec9dcf0d$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});

parcelRegister("2xru9", function(module, exports) {
$parcel$export(module.exports, "getViewportWidth", () => $4d15981bd2de8bdf$export$a497a1dcb4408212);
function $4d15981bd2de8bdf$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}

});


parcelRegister("29Oat", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionDebugDetails", () => $0e97c638c8d8f208$export$72e6dda9d5859230);
function $0e97c638c8d8f208$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries?.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry?.type,
                    rect: logEntry?.intersectionRect,
                    visible: true,
                    attributeName: logEntry?.attributeName,
                    oldValue: logEntry?.oldValue,
                    newValue: logEntry?.newValue,
                    ignoreReason: logEntry?.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("bAdhV", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionsData", () => $fdcc7c306c198312$export$5c86a34c9becd6d0);

var $gmMRH = parcelRequire("gmMRH");

var $fPWhX = parcelRequire("fPWhX");
const $fdcc7c306c198312$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $fdcc7c306c198312$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $fdcc7c306c198312$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $fdcc7c306c198312$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $fdcc7c306c198312$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $fdcc7c306c198312$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey, ratios: ratios }) {
    const pageVisibilityUpToTTAI = (0, $fPWhX.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $gmMRH.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $fdcc7c306c198312$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $gmMRH.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $fdcc7c306c198312$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}

});
parcelRegister("fPWhX", function(module, exports) {
$parcel$export(module.exports, "getEarliestHiddenTiming", () => $91a512f2bf7fc89b$export$754443ce7c615bd7);
$parcel$export(module.exports, "isOpenedInBackground", () => $91a512f2bf7fc89b$export$21a1a62a307062f1);
$parcel$export(module.exports, "getHasHiddenTimingBeforeSetup", () => $91a512f2bf7fc89b$export$95f048bd8bcdda23);
$parcel$export(module.exports, "setupHiddenTimingCapture", () => $91a512f2bf7fc89b$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $91a512f2bf7fc89b$export$768b2008623433e1);
$parcel$export(module.exports, "setupThrottleDetection", () => $91a512f2bf7fc89b$export$fa0d29a9c87052da);
$parcel$export(module.exports, "isTabThrottled", () => $91a512f2bf7fc89b$export$62a28c860277b3bf);
$parcel$export(module.exports, "getPageVisibilityTimeline", () => $91a512f2bf7fc89b$export$5a06b84e47ad70d9);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $glbdM = parcelRequire("glbdM");

var $iqfTZ = parcelRequire("iqfTZ");
const $91a512f2bf7fc89b$var$timings = [];
let $91a512f2bf7fc89b$var$wasHiddenFlag;
let $91a512f2bf7fc89b$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
const $91a512f2bf7fc89b$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
let $91a512f2bf7fc89b$var$openedInBackground = null;
function $91a512f2bf7fc89b$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $91a512f2bf7fc89b$var$SIZE = 50;
let $91a512f2bf7fc89b$var$insertIndex = 0;
function $91a512f2bf7fc89b$export$754443ce7c615bd7(startTime, endTime) {
    const earliestHiddenTiming = $91a512f2bf7fc89b$var$timings.find(({ hidden: hidden, time: time })=>hidden && time > 0 && time >= startTime && time <= endTime)?.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function $91a512f2bf7fc89b$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        const entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some((entry)=>entry.name === 'hidden' && entry.startTime <= $91a512f2bf7fc89b$var$OPENED_IN_BACKGROUND_THRESHOLD_MS);
    } catch  {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $91a512f2bf7fc89b$var$openedInBackground === true;
}
function $91a512f2bf7fc89b$var$pushHidden(isPageHiddenFlag, time) {
    $91a512f2bf7fc89b$var$timings[$91a512f2bf7fc89b$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $91a512f2bf7fc89b$var$insertIndex = ($91a512f2bf7fc89b$var$insertIndex + 1) % $91a512f2bf7fc89b$var$SIZE;
    $91a512f2bf7fc89b$var$wasHiddenFlag = isPageHiddenFlag;
}
function $91a512f2bf7fc89b$var$handleChange() {
    const isPageHiddenFlag = $91a512f2bf7fc89b$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$91a512f2bf7fc89b$var$wasHiddenFlag) $91a512f2bf7fc89b$var$pushHidden(isPageHiddenFlag);
        $91a512f2bf7fc89b$var$wasHiddenFlag = true;
    } else {
        if ($91a512f2bf7fc89b$var$wasHiddenFlag) $91a512f2bf7fc89b$var$pushHidden(isPageHiddenFlag);
        $91a512f2bf7fc89b$var$wasHiddenFlag = false;
    }
}
let $91a512f2bf7fc89b$var$hasHiddenTimingBeforeSetup = false;
function $91a512f2bf7fc89b$export$95f048bd8bcdda23() {
    return $91a512f2bf7fc89b$var$hasHiddenTimingBeforeSetup;
}
function $91a512f2bf7fc89b$var$setup() {
    try {
        const results = performance.getEntriesByType('visibility-state');
        results?.forEach((result)=>{
            if ((0, $iqfTZ.fg)('platform_ufo_use_native_page_visibility_api')) $91a512f2bf7fc89b$var$pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') $91a512f2bf7fc89b$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch  {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $glbdM.bind)(window, {
        type: 'pageshow',
        listener: $91a512f2bf7fc89b$var$handleChange
    });
    (0, $glbdM.bind)(window, {
        type: 'pagehide',
        listener: $91a512f2bf7fc89b$var$handleChange
    });
    (0, $glbdM.bind)(document, {
        type: 'visibilitychange',
        listener: $91a512f2bf7fc89b$var$handleChange
    });
}
function $91a512f2bf7fc89b$export$554cefe0f0373da4() {
    if (!$91a512f2bf7fc89b$var$setupFlag) {
        const isPageHiddenFlag = $91a512f2bf7fc89b$var$isPageHidden();
        const setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($91a512f2bf7fc89b$var$openedInBackground === null) $91a512f2bf7fc89b$var$openedInBackground = isPageHiddenFlag && setupTime < $91a512f2bf7fc89b$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $91a512f2bf7fc89b$var$pushHidden(isPageHiddenFlag, 0);
        $91a512f2bf7fc89b$var$setup();
        $91a512f2bf7fc89b$var$setupFlag = true;
    }
}
function $91a512f2bf7fc89b$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($91a512f2bf7fc89b$var$timings.length === 0) return 'visible';
    const currentSize = $91a512f2bf7fc89b$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $91a512f2bf7fc89b$var$insertIndex;
    let endIdx = $91a512f2bf7fc89b$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($91a512f2bf7fc89b$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($91a512f2bf7fc89b$var$timings[tmpIdx] && $91a512f2bf7fc89b$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($91a512f2bf7fc89b$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $91a512f2bf7fc89b$var$timings[startIdx]) hiddenState = $91a512f2bf7fc89b$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
const $91a512f2bf7fc89b$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
const $91a512f2bf7fc89b$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
const $91a512f2bf7fc89b$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
const $91a512f2bf7fc89b$var$throttleMeasurements = [];
let $91a512f2bf7fc89b$var$throttleInsertIndex = 0;
let $91a512f2bf7fc89b$var$throttleIntervalId = null;
let $91a512f2bf7fc89b$var$lastThrottleCheckTime = null;
let $91a512f2bf7fc89b$var$throttleSetupDone = false;
function $91a512f2bf7fc89b$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    const isThrottled = actualElapsed > expectedElapsed * $91a512f2bf7fc89b$var$THROTTLE_DRIFT_THRESHOLD;
    $91a512f2bf7fc89b$var$throttleMeasurements[$91a512f2bf7fc89b$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $91a512f2bf7fc89b$var$throttleInsertIndex = ($91a512f2bf7fc89b$var$throttleInsertIndex + 1) % $91a512f2bf7fc89b$var$THROTTLE_BUFFER_SIZE;
}
function $91a512f2bf7fc89b$var$throttleCheckCallback() {
    const currentTime = performance.now();
    if ($91a512f2bf7fc89b$var$lastThrottleCheckTime !== null) {
        const actualElapsed = currentTime - $91a512f2bf7fc89b$var$lastThrottleCheckTime;
        $91a512f2bf7fc89b$var$recordThrottleMeasurement($91a512f2bf7fc89b$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $91a512f2bf7fc89b$var$lastThrottleCheckTime = currentTime;
}
function $91a512f2bf7fc89b$export$fa0d29a9c87052da() {
    if ($91a512f2bf7fc89b$var$throttleSetupDone) return;
    $91a512f2bf7fc89b$var$throttleSetupDone = true;
    // Record the initial timestamp
    $91a512f2bf7fc89b$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $91a512f2bf7fc89b$var$throttleIntervalId = setInterval($91a512f2bf7fc89b$var$throttleCheckCallback, $91a512f2bf7fc89b$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $91a512f2bf7fc89b$export$3279694d66e4a1() {
    if ($91a512f2bf7fc89b$var$throttleIntervalId !== null) {
        clearInterval($91a512f2bf7fc89b$var$throttleIntervalId);
        $91a512f2bf7fc89b$var$throttleIntervalId = null;
    }
    $91a512f2bf7fc89b$var$lastThrottleCheckTime = null;
    $91a512f2bf7fc89b$var$throttleSetupDone = false;
    $91a512f2bf7fc89b$var$throttleMeasurements.length = 0;
    $91a512f2bf7fc89b$var$throttleInsertIndex = 0;
}
function $91a512f2bf7fc89b$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($91a512f2bf7fc89b$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(let i = 0; i < $91a512f2bf7fc89b$var$throttleMeasurements.length; i++){
        const measurement = $91a512f2bf7fc89b$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $91a512f2bf7fc89b$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $91a512f2bf7fc89b$var$throttleMeasurements.filter((measurement)=>measurement && measurement.time >= startTime && measurement.time <= endTime);
}
function $91a512f2bf7fc89b$export$9332de935653b687(measurement) {
    $91a512f2bf7fc89b$var$throttleMeasurements[$91a512f2bf7fc89b$var$throttleInsertIndex] = measurement;
    $91a512f2bf7fc89b$var$throttleInsertIndex = ($91a512f2bf7fc89b$var$throttleInsertIndex + 1) % $91a512f2bf7fc89b$var$THROTTLE_BUFFER_SIZE;
}
function $91a512f2bf7fc89b$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($91a512f2bf7fc89b$var$timings.length === 0) return [];
    const result = [];
    // Find the most recent entry at or before startTime to establish initial state
    let initialEntry;
    const currentSize = $91a512f2bf7fc89b$var$timings.length;
    for(let i = 0; i < currentSize; i++){
        const idx = ($91a512f2bf7fc89b$var$insertIndex + i) % currentSize;
        const entry = $91a512f2bf7fc89b$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(let i = 0; i < currentSize; i++){
        const idx = ($91a512f2bf7fc89b$var$insertIndex + i) % currentSize;
        const entry = $91a512f2bf7fc89b$var$timings[idx];
        if (entry && entry.time > startTime && entry.time <= endTime) result.push({
            time: Math.round(entry.time - startTime),
            hidden: entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $91a512f2bf7fc89b$export$9332de935653b687
};

});


parcelRegister("kzFB7", function(module, exports) {
$parcel$export(module.exports, "Observers", () => $09f8593fa6c3b0c8$export$b65d046240060e78);

var $gmMRH = parcelRequire("gmMRH");

var $9Fepe = parcelRequire("9Fepe");

var $evPcU = parcelRequire("evPcU");

var $lzdBF = parcelRequire("lzdBF");

var $4iWJW = parcelRequire("4iWJW");
const $09f8593fa6c3b0c8$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $09f8593fa6c3b0c8$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $09f8593fa6c3b0c8$export$b65d046240060e78 {
    constructor(opts){
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            state: $09f8593fa6c3b0c8$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            this.intersectionObserver?.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        // Selector-config resolution is centralised in `getSelectorConfig()`.
        // It enforces FedRAMP-override > caller-override > centrally
        // configured > caller default.
        const resolved = (0, $gmMRH.getSelectorConfig)(opts.selectorConfig, this.selectorConfig);
        this.selectorConfig = resolved ?? {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $4iWJW.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.SSRConfig?.enablePageLayoutPlaceholder
        });
    }
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $09f8593fa6c3b0c8$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver?.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $09f8593fa6c3b0c8$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $09f8593fa6c3b0c8$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $09f8593fa6c3b0c8$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $09f8593fa6c3b0c8$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $09f8593fa6c3b0c8$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $9Fepe.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
							"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
							I think it might have been something along the lines that for consistency every setAttribute call should create a record.
							Conceptually there is after all a mutation: there is an old value replaced with a new one,
							and whether or not they are the same doesn't really matter.
							And Custom elements should work the same way as MutationObserver."
							https://github.com/whatwg/dom/issues/520#issuecomment-336574796
						*/ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $evPcU.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $9Fepe.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch  {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    if (!$09f8593fa6c3b0c8$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, $lzdBF.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch  {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}
$09f8593fa6c3b0c8$export$b65d046240060e78.displayName = "Observers";

});
parcelRegister("9Fepe", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $e6ffa012a3d58443$export$f61fbc3b9c4a9019);

var $2Gxre = parcelRequire("2Gxre");
function $e6ffa012a3d58443$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $2Gxre.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("2Gxre", function(module, exports) {
$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $ccf4ddd6f1c75f23$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $ccf4ddd6f1c75f23$export$7028e9efe569888c);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");
const $ccf4ddd6f1c75f23$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $ccf4ddd6f1c75f23$export$7028e9efe569888c = {
    [$ccf4ddd6f1c75f23$export$7674290405cc25b0]: true
};
function $ccf4ddd6f1c75f23$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ...$ccf4ddd6f1c75f23$export$7028e9efe569888c,
        children: children
    });
}
$ccf4ddd6f1c75f23$export$2e2bcd8739ae039.displayName = "MediaWrapper";

});


parcelRegister("evPcU", function(module, exports) {
$parcel$export(module.exports, "default", () => $c65700081e49ae00$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $c65700081e49ae00$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $c65700081e49ae00$export$2e2bcd8739ae039 = $c65700081e49ae00$var$isNonVisualStyleMutation;

});

parcelRegister("lzdBF", function(module, exports) {
$parcel$export(module.exports, "RLLPlaceholderHandlers", () => $ff1d0bf05982ce99$export$166779fc0f49d4df);
const $ff1d0bf05982ce99$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class $ff1d0bf05982ce99$export$166779fc0f49d4df {
    constructor(){
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    /**
	 * Gets the global singleton instance of RLLPlaceholderHandlers.
	 * Creates the instance if it doesn't exist and stores it in globalThis.
	 * @returns The singleton instance of RLLPlaceholderHandlers
	 */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[$ff1d0bf05982ce99$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$ff1d0bf05982ce99$var$GLOBAL_RLL_HANDLERS_KEY] = new $ff1d0bf05982ce99$export$166779fc0f49d4df();
            return globalThis[$ff1d0bf05982ce99$var$GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new $ff1d0bf05982ce99$export$166779fc0f49d4df();
    }
    reset() {
        this.placeholders = [];
    }
    /**
	 * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
	 * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
	 * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
	 * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
	 */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
	 * Traverses DOM siblings to find all elements between RLL begin and end markers.
	 * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
	 * Performance optimized to minimize iterations and early exit conditions.
	 *
	 * @param fromEl - The input element with data-lazy-begin attribute
	 * @param id - The placeholder ID to match against data-lazy-end
	 * @returns Array of DOM elements between the begin/end markers
	 */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            if (el.dataset?.lazyEnd === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
	 * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
	 * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
	 */ getPlaceholders() {
        return this.placeholders;
    }
    /**
	 * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
	 * This is designed to be called from IntersectionObserver with the intersectionRect.
	 * Performance optimized with early exits and minimal calculations.
	 * @param intersectingRect - The intersecting rectangle from IntersectionObserver
	 * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
	 */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
	 * Compares two DOMRect objects for equality with ±1 pixel tolerance.
	 * Performance optimized to minimize calculations and early exit on major differences.
	 * @param rect1 - First rectangle to compare
	 * @param rect2 - Second rectangle to compare
	 * @returns true if rectangles are within 1 pixel tolerance for all properties
	 */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
}
$ff1d0bf05982ce99$export$166779fc0f49d4df.displayName = "RLLPlaceholderHandlers";

});

parcelRegister("4iWJW", function(module, exports) {
$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $ea2291d87c190220$export$c0102f1a1198d10f);
const $ea2291d87c190220$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $ea2291d87c190220$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $ea2291d87c190220$export$c0102f1a1198d10f {
    constructor({ enablePageLayoutPlaceholder: enablePageLayoutPlaceholder = false }){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.EQUALITY_THRESHOLD = 1;
        this.getPlaceholderId = (el)=>{
            const ssrPlaceholderId = el?.dataset?.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $ea2291d87c190220$var$PAGE_LAYOUT_ID) return $ea2291d87c190220$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            const ssrPlaceholderReplaceId = el?.dataset?.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $ea2291d87c190220$var$PAGE_LAYOUT_ID) return $ea2291d87c190220$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver?.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = this.getEffectiveBoundingRect(target);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions. __SSR_PLACEHOLDERS_DIMENSIONS__ is
            // deliberately left in place: several VCObserverWrappers are built per page load and each
            // builds its own handler, so dropping it here would leave every later handler measuring
            // each placeholder with getBoundingClientRect() — a synchronous style recalc and a
            // full-document layout mid-hydration. Keeping it costs one small map per document.
            this.collectPlaceholdersInternal();
        } catch  {}
    }
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                });
                this.intersectionObserver?.observe(el);
            }
        });
    }
    /**
	 * Added this method to be utilised for testing purposes.
	 * In production it collection placeholder should only happens on constructor
	 */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch  {
        // Silently fail if there are any issues
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    isPlaceholderV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $ea2291d87c190220$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    isPlaceholderReplacementV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $ea2291d87c190220$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $ea2291d87c190220$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    findNearestPlaceholderOrContainer(element, limit = $ea2291d87c190220$var$ANCESTOR_LOOKUP_LIMIT) {
        let ancestor = element;
        if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < limit){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            if (ancestor.parentElement) {
                ancestor = ancestor.parentElement;
                i++;
            } else break;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            this.intersectionObserver?.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    validateReactComponentMatchToPlaceholderV4(el) {
        el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
        const id = this.getPlaceholderReplacementId(el);
        return this.staticPlaceholders.has(id);
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
	 * Gets the effective bounding rectangle for an element, handling display: contents elements
	 * by collecting dimensions from their children instead
	 */ getEffectiveBoundingRect(el) {
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
}
$ea2291d87c190220$export$c0102f1a1198d10f.displayName = "SSRPlaceholderHandlers";

});



parcelRegister("4qaz4", function(module, exports) {
$parcel$export(module.exports, "default", () => $5da87aad00266270$export$2e2bcd8739ae039);

var $iqfTZ = parcelRequire("iqfTZ");

var $gmMRH = parcelRequire("gmMRH");

var $6xmKf = parcelRequire("6xmKf");

var $siTdT = parcelRequire("siTdT");

var $4iWJW = parcelRequire("4iWJW");

var $8BTFS = parcelRequire("8BTFS");

var $5n5RM = parcelRequire("5n5RM");

var $gEk1Y = parcelRequire("gEk1Y");

var $6b6PA = parcelRequire("6b6PA");

var $cScib = parcelRequire("cScib");

var $aBafO = parcelRequire("aBafO");

var $d9eH4 = parcelRequire("d9eH4");

var $flnPm = parcelRequire("flnPm");

var $iZFHi = parcelRequire("iZFHi");

var $G7jF8 = parcelRequire("G7jF8");
const $5da87aad00266270$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const $5da87aad00266270$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
class $5da87aad00266270$export$2e2bcd8739ae039 {
    constructor(config){
        this.viewportObserver = null;
        this.windowEventObserver = null;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: $5da87aad00266270$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, $8BTFS.default)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It applies the FedRAMP all-`false` override when
        // `isFedrampModerate()` is true; otherwise it returns `caller-override
        // → setUFOConfig value → historical default`.
        this.selectorConfig = (0, $gmMRH.getSelectorConfig)(config.selectorConfig, $5da87aad00266270$var$DEFAULT_SELECTOR_CONFIG) ?? config.selectorConfig ?? $5da87aad00266270$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $4iWJW.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: config.SSRConfig?.enablePageLayoutPlaceholder ?? false
        });
        this.trackLayoutShiftOffenders = config.trackLayoutShiftOffenders ?? false;
        this.viewportObserver = new (0, $iZFHi.default)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData?.attributeName,
                    oldValue: mutationData?.oldValue,
                    newValue: mutationData?.newValue,
                    originalMutationTimestamp: mutationData?.timestamp
                };
                if (element) {
                    const labelStacks = $5da87aad00266270$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler(),
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $G7jF8.default)({
            onEvent: ({ time: time, type: type, event: event })=>{
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $iqfTZ.fg)('platform_ufo_keypress_interaction_abort')) {
                    const interaction = (0, $siTdT.getActiveInteraction)();
                    if (interaction?.type === 'press') return;
                }
                const abortEventTargetElement = $5da87aad00266270$var$isAbortEventTargetSupported(type) && event ? $5da87aad00266270$var$getAbortEventTargetElement(event.target) : null;
                const elementName = abortEventTargetElement ? this.getElementName(abortEventTargetElement) : undefined;
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type,
                        ...elementName ? {
                            elementName: elementName
                        } : {}
                    }
                });
            }
        });
    }
    start(_) {
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: $5da87aad00266270$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.viewportObserver?.start();
        this.entriesTimeline.clear();
        if (window?.__SSR_ABORT_LISTENERS__) {
            const abortListeners = window.__SSR_ABORT_LISTENERS__;
            const aborts = abortListeners.aborts;
            if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                if (typeof time === 'number') this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: key
                    }
                });
            });
        }
        this.windowEventObserver?.start();
    }
    stop() {
        this.viewportObserver?.stop();
        this.windowEventObserver?.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $5da87aad00266270$var$SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, $cScib.default)(),
                    width: (0, $aBafO.default)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, $cScib.default)(),
                    right: (0, $aBafO.default)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId, interactionType: interactionType, interactionAbortReason: interactionAbortReason, isPageVisible: isPageVisible, include3p: include3p, includeSSRRatio: includeSSRRatio, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, rawDataStopTime: rawDataStopTime } = param;
        const results = [];
        this.addStartEntry(start);
        const feVCCalculationStartTime = performance.now();
        const calculator_fy25_03 = new (0, $gEk1Y.default)();
        if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = (0, $gmMRH.isVCRevisionEnabled)('fy25.03') ? await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        }) : null;
        if (fy25_03) results.push(fy25_03);
        // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
        if (param.ssr) this.addSSR(param.ssr);
        const calculator_fy26_04 = new (0, $6b6PA.default)();
        const calculator_next = new (0, $d9eH4.default)();
        const calculatorParams = {
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        };
        const isFy2604Enabled = (0, $gmMRH.isVCRevisionEnabled)('fy26.04');
        const [fy26_04, vcNext] = await Promise.all([
            isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
            (0, $gmMRH.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
        ]);
        if (fy26_04) results.push(fy26_04);
        if (vcNext) results.push(vcNext);
        const feVCCalculationEndTime = performance.now();
        // Always include raw data so the server can recalculate metrics
        // (ssrRatio, labelStacks, speedIndex) from raw observations.
        const rawVCCalculationStartTime = performance.now();
        const rawHandler = new (0, $flnPm.default)();
        // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
        const rawStopTime = rawDataStopTime ?? stop;
        const rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: rawStopTime
        }) : orderedEntries;
        const raw = await rawHandler.getRawData({
            entries: rawOrderedEntries,
            startTime: start,
            stopTime: rawStopTime,
            isPageVisible: isPageVisible
        });
        results.forEach((result)=>{
            delete result.vcDetails;
            delete result.ratios;
        });
        if (raw) {
            raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
            raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
            results.push(raw);
        }
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, $5n5RM.default)(this.selectorConfig, element);
    }
}
function $5da87aad00266270$var$labelStackFromFiber(fiber) {
    const value = fiber?.child?.memoizedProps?.value;
    return Array.isArray(value?.labelStack) ? value.labelStack : [];
}
function $5da87aad00266270$var$labelStackToString(labelStack) {
    return labelStack.map((label)=>(0, $6xmKf.sanitizeLabelStackName)(label.name)).join('/');
}
function $5da87aad00266270$var$labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>(0, $6xmKf.sanitizeLabelStackName)(label.name)).join('/');
}
function $5da87aad00266270$var$traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = $5da87aad00266270$var$labelStackFromFiber(currentFiber);
                labelStackString = $5da87aad00266270$var$labelStackToString(labelStack) || 'unknown';
                segment = $5da87aad00266270$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $5da87aad00266270$var$getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? $5da87aad00266270$var$traverseFiber(fiber) : null;
}
const $5da87aad00266270$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES = new Set([
    'scroll-container',
    'scroll',
    'wheel'
]);
function $5da87aad00266270$var$isAbortEventTargetSupported(type) {
    return $5da87aad00266270$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES.has(type);
}
function $5da87aad00266270$var$getAbortEventTargetElement(target) {
    if (target instanceof HTMLElement) return target;
    if (target instanceof Document) {
        const scrollingElement = target.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.documentElement ?? null;
    }
    if (target instanceof Window) {
        const scrollingElement = target.document.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.document.documentElement ?? null;
    }
    if (target instanceof Node) return target.parentElement;
    return null;
}

});
parcelRegister("8BTFS", function(module, exports) {
$parcel$export(module.exports, "default", () => $296f75a1f026d90b$export$2e2bcd8739ae039);
class $296f75a1f026d90b$export$2e2bcd8739ae039 {
    constructor(){
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = this.sortedEntriesCache.get(cacheKey)?.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
}

});

parcelRegister("5n5RM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f74b3ddb9490f4b1$export$2e2bcd8739ae039);
const $f74b3ddb9490f4b1$var$nameCache = new WeakMap();
function $f74b3ddb9490f4b1$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = $f74b3ddb9490f4b1$var$getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = $f74b3ddb9490f4b1$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch  {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $f74b3ddb9490f4b1$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $f74b3ddb9490f4b1$var$nameCache.set(element, name);
    return name;
}
var $f74b3ddb9490f4b1$export$2e2bcd8739ae039 = $f74b3ddb9490f4b1$var$getElementName;

});

parcelRegister("gEk1Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $afb82bc8a6056687$export$2e2bcd8739ae039);

var $iqfTZ = parcelRequire("iqfTZ");

var $eawzt = parcelRequire("eawzt");

var $fHmhN = parcelRequire("fHmhN");

var $itsbR = parcelRequire("itsbR");

var $hOXsq = parcelRequire("hOXsq");

var $lHKTe = parcelRequire("lHKTe");
const $afb82bc8a6056687$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $afb82bc8a6056687$var$REVISION_NO = 'fy25.03';
const $afb82bc8a6056687$var$getConsideredEntryTypes = (include3p, excludeSmartAnswersInSearch)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested.
    // GenAI elements intentionally remain excluded from core TTVC; a server-side metric variant
    // can derive "including GenAI" from the emitted metricWindows payload.
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
class $afb82bc8a6056687$export$2e2bcd8739ae039 extends (0, $itsbR.default) {
    constructor(revisionNo){
        super(revisionNo ?? $afb82bc8a6056687$var$REVISION_NO);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!$afb82bc8a6056687$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
        if (entry.data.type === 'mutation:attribute:framework-routing') return false;
        if (entry.data.type === 'mutation:media' && (0, $iqfTZ.fg)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $eawzt.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
            // special case for style attribute to ignore only anchor-name changes
            if ((0, $eawzt.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                if ((0, $fHmhN.containsDnDMutationInStyle)({
                    attributeName: entryData.attributeName,
                    oldValue: entryData.oldValue,
                    newValue: entryData.newValue
                })) return false;
            }
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || (0, $hOXsq.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || (0, $hOXsq.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || (0, $hOXsq.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, $iqfTZ.fg)('platform_ufo_exclude_3p_extensions_from_ttvc') || (0, $hOXsq.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) || (0, $hOXsq.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, $iqfTZ.fg)('platform_ufo_exclude_fdprocessedid_attribute')) return false;
            return true;
        }
        if ((0, $lHKTe.default)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($afb82bc8a6056687$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});
parcelRegister("eawzt", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $96a9521940cbb6a2$export$9db1624a8af791a4);

var $4LDqh = parcelRequire("4LDqh");

var $hbvZL = parcelRequire("hbvZL");
const $96a9521940cbb6a2$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, $4LDqh.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $4LDqh.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $hbvZL.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};

});

parcelRegister("fHmhN", function(module, exports) {
$parcel$export(module.exports, "containsDnDMutationInStyle", () => $da446f9fd45f947e$export$7867ddcf372cd2bf);
$parcel$export(module.exports, "default", () => $da446f9fd45f947e$export$2e2bcd8739ae039);
const $da446f9fd45f947e$var$isDnDStyleChange = (style)=>{
    return style.startsWith('anchor-name: --node-anchor');
};
const $da446f9fd45f947e$var$parseStyleSet = (style)=>{
    if (!style) return null;
    const set = new Set();
    for (const part of style.split(';')){
        const t = part.trim();
        if (t) set.add(t);
    }
    return set;
};
/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */ function $da446f9fd45f947e$export$e20e7bf2c822f3df({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (!(target instanceof Element)) return false;
    return $da446f9fd45f947e$export$7867ddcf372cd2bf({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $da446f9fd45f947e$export$7867ddcf372cd2bf({ attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (attributeName !== 'style') return false;
    const oldStyles = $da446f9fd45f947e$var$parseStyleSet(oldValue);
    const newStyles = $da446f9fd45f947e$var$parseStyleSet(newValue);
    let isDnDMutation = false;
    for (const s of oldStyles ?? [])if (!newStyles?.has(s)) {
        if (!$da446f9fd45f947e$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    for (const s of newStyles ?? [])if (!oldStyles?.has(s)) {
        if (!$da446f9fd45f947e$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    return isDnDMutation;
}
var $da446f9fd45f947e$export$2e2bcd8739ae039 = $da446f9fd45f947e$export$e20e7bf2c822f3df;

});

parcelRegister("itsbR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e709c5d276e71577$export$2e2bcd8739ae039);

var $2gOF7 = parcelRequire("2gOF7");

var $hc4ku = parcelRequire("hc4ku");

var $cScib = parcelRequire("cScib");

var $aBafO = parcelRequire("aBafO");

var $lHKTe = parcelRequire("lHKTe");
// Helper function for reporting ratios
function $e709c5d276e71577$var$roundDecimal(value, decimals = 3) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
class $e709c5d276e71577$export$2e2bcd8739ae039 {
    constructor(revisionNo){
        this.revisionNo = revisionNo;
    }
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
	 * Calculate ratios for each element based on their viewport coverage.
	 */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, $aBafO.default)();
        const viewportHeight = (0, $cScib.default)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = $e709c5d276e71577$var$roundDecimal(elementArea / totalViewportArea);
        }
        return ratios;
    }
    getLabelStacks(filteredEntries, isPostInteraction) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ((0, $lHKTe.default)(entry.data) && entry.data.labelStacks) {
            if (isPostInteraction) labelStacks[entry.data.elementName] = {
                segment: entry.data.labelStacks.segment,
                labelStack: entry.data.labelStacks.labelStack
            };
            else labelStacks[entry.data.elementName] = entry.data.labelStacks.labelStack;
        }
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const { entries: vcLogs, speedIndex: speedIndex } = await (0, $2gOF7.calculateTTVCPercentilesWithDebugInfo)({
            viewport: {
                width: (0, $aBafO.default)(),
                height: (0, $cScib.default)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        let layoutShiftInsights = null;
        let previousViewportPercentage = 0;
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = [
                    ...new Set(entries.map((e)=>e.elementName))
                ];
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some((e)=>e.type === 'layout-shift')) {
                        const layoutShiftEntries = entries.filter((e)=>e.type === 'layout-shift');
                        layoutShiftInsights = {
                            layoutShiftOffendersResult: (0, $hc4ku.detectLayoutShiftCause)({
                                viewportEntries: viewportEntries,
                                layoutShiftEntries: layoutShiftEntries,
                                time: time,
                                startTime: startTime
                            }),
                            layoutShiftEntriesCount: layoutShiftEntries.length,
                            layoutShiftImpact: viewportPercentage - previousViewportPercentage
                        };
                    }
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
            previousViewportPercentage = viewportPercentage;
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>({
                ...log,
                entries: log.entries.map((entry)=>({
                        ...entry,
                        rect: entry.rect?.toJSON(),
                        previousRect: entry.previousRect?.toJSON()
                    })),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p;
        // Only calculate enhanced debug details if devtool callbacks exist
        const shouldCalculateDebugDetails = !isPostInteraction && (typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window?.__on_ufo_vc_debug_data_ready === 'function' || typeof window?.__ufo_devtool_vc_3p_debug_data === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                ignoredEntriesByTime.get(timestamp)?.push({
                    ...viewportData,
                    rect: viewportData.rect?.toJSON(),
                    previousRect: viewportData.previousRect?.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                });
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage: viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason ?? interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId: interactionId,
            interactionType: interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' && !include3p) try {
            window?.__ufo_devtool_onVCRevisionReady__?.(v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof window?.__on_ufo_vc_debug_data_ready === 'function' && !include3p) try {
            window?.__on_ufo_vc_debug_data_ready?.(v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails: vcDetails,
            ssrRatio: ssrRatio,
            speedIndex: speedIndex,
            VC90layoutShiftInsights: layoutShiftInsights
        };
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, interactionType: interactionType, isPageVisible: isPageVisible, interactionAbortReason: interactionAbortReason, reportLayoutShiftOffenders: reportLayoutShiftOffenders }) {
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails: vcDetails, ssrRatio: ssrRatio, speedIndex: speedIndex, VC90layoutShiftInsights: VC90layoutShiftInsights } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
        let layoutShiftInsightsPayload;
        if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
            const { layoutShiftOffendersResult: layoutShiftOffendersResult, layoutShiftEntriesCount: layoutShiftEntriesCount, layoutShiftImpact: layoutShiftImpact } = VC90layoutShiftInsights;
            layoutShiftInsightsPayload = {
                impact: layoutShiftImpact,
                sources: layoutShiftEntriesCount ?? 0,
                same: {
                    dir: layoutShiftOffendersResult?.layoutShiftVariables.allMovedSameWay ?? false,
                    dist: layoutShiftOffendersResult?.layoutShiftVariables.allMovedSameAmount ?? false
                },
                total_mut: layoutShiftOffendersResult?.layoutShiftOffenders.length ?? 0,
                mut: layoutShiftOffendersResult?.layoutShiftOffenders.sort((a, b)=>Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS)).slice(0, 5).map((offender)=>({
                        e: offender.offender,
                        size: -1,
                        attr: {
                            t_before: offender.happenedBefore,
                            t_distance: offender.distanceToLS,
                            p_above: offender.isAbove,
                            p_left: offender.isLeft,
                            p_right: offender.isRight,
                            p_h_overlap: offender.hasHorizontalOverlap,
                            p_v_overlap: offender.hasVerticalOverlap,
                            p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                        }
                    }))
            };
        }
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': vcDetails?.['90']?.t ?? null,
            vcDetails: vcDetails ?? undefined,
            'vc90:ls': layoutShiftInsightsPayload ?? undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        // speedIndex is only included in the result when it has a meaningful value (> 0)
        if (speedIndex > 0) result.speedIndex = speedIndex;
        result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
        return result;
    }
}

});
parcelRegister("2gOF7", function(module, exports) {
$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", () => $39599e9f5b378ea5$export$96ea73435089b05a);

var $iqfTZ = parcelRequire("iqfTZ");

var $2gzN5 = parcelRequire("2gzN5");

var $bhbYF = parcelRequire("bhbYF");

var $lf3HA = parcelRequire("lf3HA");
async function $39599e9f5b378ea5$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $lf3HA.ViewportCanvas)(viewport, (0, $iqfTZ.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return (0, $2gzN5.calculatePercentiles)(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $39599e9f5b378ea5$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $lf3HA.ViewportCanvas)(viewport, (0, $iqfTZ.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return (0, $bhbYF.calculatePercentilesWithDebugInfo)(timePixelCounts, elementMap, totalPixels, startTime);
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$39599e9f5b378ea5$export$2e2bcd8739ae039 = $39599e9f5b378ea5$var$calculateTTVCPercentiles;

});
parcelRegister("2gzN5", function(module, exports) {
$parcel$export(module.exports, "calculatePercentiles", () => $830330e1c0f869c4$export$89c8da9b65eff678);
function $830330e1c0f869c4$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}

});

parcelRegister("bhbYF", function(module, exports) {
$parcel$export(module.exports, "calculatePercentilesWithDebugInfo", () => $1df1987cb5569fca$export$a532ce01ea38d882);
function $1df1987cb5569fca$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const entries = new Array(elementMap.size);
    let cumulativePixels = 0;
    let speedIndex = 0;
    let previousPercentCovered = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        const relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        const ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}

});

parcelRegister("lf3HA", function(module, exports) {
$parcel$export(module.exports, "ViewportCanvas", () => $270f0116d1eca49e$export$3e59ac9de7402fb1);

var $h7F0r = parcelRequire("h7F0r");

var $6q27g = parcelRequire("6q27g");
class $270f0116d1eca49e$export$3e59ac9de7402fb1 {
    /**
	 * Creates a new ViewportCanvas instance.
	 * @param viewport - The dimensions of the viewport
	 * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
	 * @throws {Error} If canvas context cannot be obtained
	 */ constructor(viewport, scaleFactor = 1){
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            willReadFrequently: true,
            colorSpace: 'srgb'
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
	 * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
	 */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
	 * Clears the entire canvas by removing all drawn content.
	 * @private
	 */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
	 * Generates a unique RGB color from an incrementing counter.
	 * Uses a 24-bit color space (16,777,216 possible colors).
	 *
	 * @private
	 * @returns A unique RGB color string
	 *
	 * @example
	 * // Example bit operations for color 0x00FF8040:
	 * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
	 * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
	 * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
	 */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return (0, $6q27g.getRGBComponents)(rgbColor);
    }
    /**
	 * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
	 * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
	 *
	 * @param rect - The rectangle dimensions to draw
	 * @param timestamp - The timestamp to associate with this drawing operation
	 */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
	 * Calculates the number of pixels drawn for each timestamp.
	 * This method:
	 * 1. Reads the pixel data from the canvas
	 * 2. Counts pixels of each unique color
	 * 3. Maps colors back to their timestamps
	 * 4. Adjusts counts based on the scale factor
	 *
	 * @returns A Map containing timestamp to pixel count mappings
	 */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await (0, $h7F0r.calculateDrawnPixelsRaw)(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = (0, $6q27g.getRGBComponents)(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
}

});
parcelRegister("h7F0r", function(module, exports) {
$parcel$export(module.exports, "calculateDrawnPixelsRaw", () => $550bed04ba3d49b0$export$fafc9be44839f9c8);

var $fUGpj = parcelRequire("fUGpj");
async function $550bed04ba3d49b0$export$fafc9be44839f9c8(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $fUGpj.default)();
    }
    return arr;
}

});
parcelRegister("fUGpj", function(module, exports) {
$parcel$export(module.exports, "default", () => $34e1cee5a5dda2b2$export$2e2bcd8739ae039);
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $34e1cee5a5dda2b2$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $34e1cee5a5dda2b2$export$2e2bcd8739ae039 = $34e1cee5a5dda2b2$var$taskYield;

});


parcelRegister("6q27g", function(module, exports) {
$parcel$export(module.exports, "getRGBComponents", () => $921b798ed8f5ed39$export$54591583ed0b20ce);
function $921b798ed8f5ed39$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}

});



parcelRegister("hc4ku", function(module, exports) {
$parcel$export(module.exports, "detectLayoutShiftCause", () => $3f61237e8bc65678$export$93ce39b765ea2cd3);
const $3f61237e8bc65678$var$calculateOffenderState = (current, matchesCurrentEntry)=>{
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    const entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
const $3f61237e8bc65678$var$calculateLayoutShiftMovement = (layoutShiftEntries)=>{
    const movements = layoutShiftEntries.map((lsEntry)=>{
        const rect = lsEntry.rect;
        const previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        const dx = rect.x - previousRect.x;
        const dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    const hasMovement = (m)=>m !== null;
    const validMovements = movements.filter(hasMovement);
    const allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    const first = validMovements[0];
    const allMovedSameWay = validMovements.every((m)=>m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY);
    const allMovedSameAmount = allMovedSameWay && validMovements.every((m)=>m.absDx === first.absDx && m.absDy === first.absDy);
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
const $3f61237e8bc65678$export$93ce39b765ea2cd3 = ({ viewportEntries: viewportEntries, layoutShiftEntries: layoutShiftEntries, time: time, startTime: startTime, offenderWindowMs: offenderWindowMs = 250 })=>{
    const checkpointTimestamp = startTime + time;
    const filteredLSPotentialOffenders = viewportEntries.filter((viewportEntry)=>(viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift');
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    const layoutShiftVariables = $3f61237e8bc65678$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    const layoutShiftOffenders = filteredLSPotentialOffenders.reduce((acc, offender)=>{
        const offenderData = offender.data;
        const offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        const offenderTimestamp = offenderData.originalMutationTimestamp ?? offender.time;
        const happenedBefore = offenderTimestamp <= checkpointTimestamp;
        const offenderLeft = offenderRect.x;
        const offenderRight = offenderRect.x + offenderRect.width;
        const offenderTop = offenderRect.y;
        const offenderBottom = offenderRect.y + offenderRect.height;
        const shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        let isAbove = null;
        let isLeft = null;
        let isRight = null;
        let hasHorizontalOverlap = null;
        let hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) for (const lsEntry of layoutShiftEntries){
            const lsRect = lsEntry.rect;
            if (!lsRect) continue;
            const lsLeft = lsRect.x;
            const lsRight = lsRect.x + lsRect.width;
            const lsTop = lsRect.y;
            const lsBottom = lsRect.y + lsRect.height;
            isAbove = $3f61237e8bc65678$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
            isLeft = $3f61237e8bc65678$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
            isRight = $3f61237e8bc65678$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
            hasHorizontalOverlap = $3f61237e8bc65678$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
            hasVerticalOverlap = $3f61237e8bc65678$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
        }
        let matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            const dx = offenderRect.x - offenderData.previousRect.x;
            const dy = offenderRect.y - offenderData.previousRect.y;
            const isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            const isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove ?? 'none',
            isLeft: isLeft ?? 'none',
            isRight: isRight ?? 'none',
            hasHorizontalOverlap: hasHorizontalOverlap ?? 'none',
            hasVerticalOverlap: hasVerticalOverlap ?? 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};

});

parcelRegister("cScib", function(module, exports) {
$parcel$export(module.exports, "default", () => $b57befee25b7bc4f$export$2e2bcd8739ae039);
function $b57befee25b7bc4f$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $b57befee25b7bc4f$export$2e2bcd8739ae039 = $b57befee25b7bc4f$var$getViewportHeight;

});

parcelRegister("aBafO", function(module, exports) {
$parcel$export(module.exports, "default", () => $721ff4b5e5b9b6ee$export$2e2bcd8739ae039);
function $721ff4b5e5b9b6ee$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $721ff4b5e5b9b6ee$export$2e2bcd8739ae039 = $721ff4b5e5b9b6ee$var$getViewportWidth;

});

parcelRegister("lHKTe", function(module, exports) {
$parcel$export(module.exports, "default", () => $be92fbd96d6e495f$export$2e2bcd8739ae039);
function $be92fbd96d6e495f$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $be92fbd96d6e495f$export$2e2bcd8739ae039 = $be92fbd96d6e495f$var$isViewportEntryData;

});


parcelRegister("hOXsq", function(module, exports) {
$parcel$export(module.exports, "KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS", () => $1a0cdd6aa351339e$export$98812f4e79596e2b);
$parcel$export(module.exports, "NON_VISUAL_ARIA_ATTRIBUTES", () => $1a0cdd6aa351339e$export$44331555a87fcd9e);
$parcel$export(module.exports, "THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES", () => $1a0cdd6aa351339e$export$c4351da6279bef53);
$parcel$export(module.exports, "MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES", () => $1a0cdd6aa351339e$export$2492353b2cc31cc0);
$parcel$export(module.exports, "DARK_READER_BROWSER_EXTENSION_ATTRIBUTES", () => $1a0cdd6aa351339e$export$5a7b359ee5e32a5b);
// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
const $1a0cdd6aa351339e$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id',
    'data-access-level'
];
const $1a0cdd6aa351339e$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const $1a0cdd6aa351339e$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
const $1a0cdd6aa351339e$export$2492353b2cc31cc0 = [
    'fdprocessedid',
    'data-dashlane-classification'
];
const $1a0cdd6aa351339e$export$5a7b359ee5e32a5b = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];

});


parcelRegister("6b6PA", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa512a795be49cd9$export$2e2bcd8739ae039);

var $iqfTZ = parcelRequire("iqfTZ");

var $gEk1Y = parcelRequire("gEk1Y");

var $hOXsq = parcelRequire("hOXsq");
const $fa512a795be49cd9$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
const $fa512a795be49cd9$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
const $fa512a795be49cd9$var$fy26_04_excluded_attributes = [
    'data-is-hovered'
];
class $fa512a795be49cd9$export$2e2bcd8739ae039 extends (0, $gEk1Y.default) {
    constructor(revisionNo = 'fy26.04'){
        super(revisionNo);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const extra_fy26_04_excluded_attributes = [
            'data-fabric-mode'
        ];
        const entryData = entry.data;
        const { attributeName: attributeName } = entryData;
        if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV3 && !$fa512a795be49cd9$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        if (entry.data.type === 'mutation:attribute' && (!attributeName || $fa512a795be49cd9$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $iqfTZ.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
        const thirdPartyAttributes = [
            ...(0, $hOXsq.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES),
            ...(0, $hOXsq.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES),
            ...(0, $iqfTZ.fg)('platform_ufo_exclude_fdprocessedid_attribute') ? (0, $hOXsq.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES) : []
        ];
        if (entryData.type === 'mutation:display-contents-children-attribute') {
            if (!attributeName || attributeName.startsWith('data-test') || (0, $hOXsq.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName) || (0, $hOXsq.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
            return true;
        }
        return $fa512a795be49cd9$var$getConsideredEntryTypes().includes(entry.data.type);
    }
}

});

parcelRegister("d9eH4", function(module, exports) {
$parcel$export(module.exports, "default", () => $89fb86f787538278$export$2e2bcd8739ae039);

var $6b6PA = parcelRequire("6b6PA");
const $89fb86f787538278$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
const $89fb86f787538278$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [];
    return consideredEntryTypes;
};
const $89fb86f787538278$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [];
    return excludedEntryTypes;
};
class $89fb86f787538278$export$2e2bcd8739ae039 extends (0, $6b6PA.default) {
    constructor(){
        super('next');
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const isEntryIncludedInV4 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV4 && !$89fb86f787538278$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        return $89fb86f787538278$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($89fb86f787538278$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    if (eventType === 'keydown') dirtyReason = 'keypress';
                    else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                    else dirtyReason = eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});

parcelRegister("flnPm", function(module, exports) {
$parcel$export(module.exports, "default", () => $96d2963771a1af32$export$2e2bcd8739ae039);

var $gmMRH = parcelRequire("gmMRH");

var $fPWhX = parcelRequire("fPWhX");

var $cScib = parcelRequire("cScib");

var $aBafO = parcelRequire("aBafO");
const $96d2963771a1af32$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $96d2963771a1af32$var$MAX_OBSERVATIONS = 200;
const $96d2963771a1af32$var$encodeRect = (rect)=>[
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
const $96d2963771a1af32$var$areRectsEqual = (left, right)=>left.every((value, index)=>value === right[index]);
function $96d2963771a1af32$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
class $96d2963771a1af32$export$2e2bcd8739ae039 {
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($96d2963771a1af32$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    async getRawData({ entries: entries, startTime: startTime, stopTime: stopTime, isPageVisible: isPageVisible }) {
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(entries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isPageVisible) return {
            revision: this.revisionNo,
            clean: false,
            'metric:vc90': null,
            abortReason: 'browser_backgrounded',
            abortTimestamp: (0, $fPWhX.getEarliestHiddenTiming)(startTime, stopTime) ?? -1,
            viewport: {
                w: (0, $aBafO.default)(),
                h: (0, $cScib.default)()
            }
        };
        const viewportEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
        });
        const windowEventEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && $96d2963771a1af32$var$isWindowEventEntryData(entry.data);
        });
        const targetNameToIdMap = new Map();
        const elementMapEntriesMap = {};
        let nextElementId = 1;
        const typeMap = new Map();
        const typeMapEntriesMap = {};
        let nextTypeId = 1;
        const attributeMap = new Map();
        const attributeEntriesMap = {};
        let nextAttributeId = 1;
        const eventTypeMap = new Map();
        const eventTypeMapEntriesMap = {};
        let nextEventTypeId = 1;
        const labelStacksMap = {};
        let rawObservations = viewportEntries.map((entry)=>{
            const viewportEntry = entry.data;
            const targetName = viewportEntry.elementName || '';
            const type = viewportEntry.type || '';
            const rect = viewportEntry.rect;
            const attributeName = viewportEntry.attributeName || '';
            let eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
            if (eid === 0) {
                eid = nextElementId;
                nextElementId += 1;
                targetNameToIdMap.set(targetName, eid);
                elementMapEntriesMap[eid] = targetName;
            }
            // Capture labelStacks per element (only stored once per unique element)
            if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                const labelInfo = {
                    s: viewportEntry.labelStacks.segment,
                    l: viewportEntry.labelStacks.labelStack
                };
                const shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
            }
            let chg = typeMap.get(type || '') || 0;
            if (chg === 0) {
                chg = nextTypeId;
                nextTypeId += 1;
                typeMap.set(type, chg);
                typeMapEntriesMap[chg] = type;
            }
            let att = 0;
            if (attributeName) {
                att = attributeMap.get(attributeName) || 0;
                if (att === 0) {
                    att = nextAttributeId;
                    nextAttributeId += 1;
                    attributeMap.set(attributeName, att);
                    attributeEntriesMap[att] = attributeName;
                }
            }
            const encodedRect = $96d2963771a1af32$var$encodeRect(rect);
            const encodedPreviousRect = viewportEntry.previousRect ? $96d2963771a1af32$var$encodeRect(viewportEntry.previousRect) : null;
            const shouldIncludePreviousRect = encodedPreviousRect === null || !$96d2963771a1af32$var$areRectsEqual(encodedRect, encodedPreviousRect);
            const observation = {
                t: Math.round(entry.time - startTime),
                r: encodedRect,
                ...shouldIncludePreviousRect ? {
                    pr: encodedPreviousRect
                } : {},
                chg: chg,
                eid: eid || 0,
                ...att > 0 ? {
                    att: att
                } : {}
            };
            return observation;
        });
        let rawEventObservations = windowEventEntries.map((entry)=>{
            const windowEventEntry = entry.data;
            const eventType = windowEventEntry.eventType;
            let evtId = eventTypeMap.get(eventType) || 0;
            if (evtId === 0) {
                evtId = nextEventTypeId;
                nextEventTypeId += 1;
                eventTypeMap.set(eventType, evtId);
                eventTypeMapEntriesMap[evtId] = eventType;
            }
            let eventTargetId = 0;
            const eventTargetName = windowEventEntry.elementName || '';
            if (eventTargetName) {
                eventTargetId = targetNameToIdMap.get(eventTargetName) || 0;
                if (eventTargetId === 0) {
                    eventTargetId = nextElementId;
                    nextElementId += 1;
                    targetNameToIdMap.set(eventTargetName, eventTargetId);
                    elementMapEntriesMap[eventTargetId] = eventTargetName;
                }
            }
            const eventObservation = {
                t: Math.round(entry.time - startTime),
                evt: evtId,
                ...eventTargetId > 0 ? {
                    eid: eventTargetId
                } : {}
            };
            return eventObservation;
        });
        const shouldTrimEventObservations = rawEventObservations.length > $96d2963771a1af32$var$MAX_OBSERVATIONS;
        const shouldTrimViewportObservations = rawObservations.length > $96d2963771a1af32$var$MAX_OBSERVATIONS;
        // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        if (shouldTrimEventObservations) {
            const firstEventObservation = rawEventObservations[0];
            const lastEventObservations = rawEventObservations.slice(-$96d2963771a1af32$var$MAX_OBSERVATIONS);
            rawEventObservations = [
                firstEventObservation,
                ...lastEventObservations
            ];
        }
        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
        // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
        if (shouldTrimViewportObservations) {
            const firstObservation = rawObservations[0];
            const lastObservations = rawObservations.slice(-$96d2963771a1af32$var$MAX_OBSERVATIONS);
            // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
            const ssrEid = targetNameToIdMap.get('SSR');
            const ssrObservation = ssrEid ? rawObservations.find((obs)=>obs.eid === ssrEid && obs !== firstObservation) : undefined;
            // Include SSR observation if it exists and is not already in the kept observations
            const ssrAlreadyIncluded = ssrObservation && lastObservations.some((obs)=>obs === ssrObservation);
            rawObservations = [
                firstObservation,
                ...ssrObservation && !ssrAlreadyIncluded ? [
                    ssrObservation
                ] : [],
                ...lastObservations
            ];
        }
        if (shouldTrimViewportObservations || shouldTrimEventObservations) {
            // Collect referenced IDs from final retained observations. Keep this inside the trim
            // guard so the common untrimmed path avoids extra Set allocations and scans.
            const referencedEids = new Set();
            const referencedChgs = new Set();
            const referencedAtts = new Set();
            const referencedEvts = new Set();
            const referencedEventTargetEids = new Set();
            for (const observation of rawObservations){
                if (observation.eid > 0) referencedEids.add(observation.eid);
                if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
            }
            for (const observation of rawEventObservations){
                if (observation.evt > 0) referencedEvts.add(observation.evt);
                if (observation.eid !== undefined && observation.eid > 0) referencedEventTargetEids.add(observation.eid);
            }
            for (const eid of Object.keys(elementMapEntriesMap).map(Number))if (!referencedEids.has(eid) && !referencedEventTargetEids.has(eid)) {
                delete elementMapEntriesMap[eid];
                delete labelStacksMap[eid];
            }
            if (shouldTrimViewportObservations) {
                for (const chg of Object.keys(typeMapEntriesMap).map(Number))if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                for (const att of Object.keys(attributeEntriesMap).map(Number))if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
            }
            if (shouldTrimEventObservations) {
                // Event type map cleanup is only needed when event observations were trimmed.
                // If only viewport observations were trimmed, all event observations remain and
                // therefore every event type ID in the map is still referenced.
                for (const evt of Object.keys(eventTypeMapEntriesMap).map(Number))if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
            }
        }
        // FedRAMP-Moderate scrubbing.
        //
        // In commercial environments the raw-handler payload includes:
        //   - `rawData.att` / `obs[].att`  → DOM attribute names from
        //     `MutationRecord.attributeName`. These are *names* (not values),
        //     but custom product attributes can in principle embed
        //     identifiers (e.g. `data-user-{id}-state`).
        //   - `rawData.lbl`                → UFO labelStacks. Generally
        //     curated product paths but in poorly-instrumented call sites
        //     could embed dynamic identifiers.
        //
        // Server-side TTVC reconstruction does not require these fields
        // (it is driven by timestamps, rectangles, and mutation kind),
        // so dropping them in FedRAMP is safe and removes residual PII risk.
        const isFedrampScrubbed = (0, $gmMRH.isFedrampOverrideActive)();
        const scrubbedObservations = isFedrampScrubbed ? rawObservations.map(({ att: _att, ...rest })=>rest) : rawObservations;
        const result = {
            revision: this.revisionNo,
            clean: isVCClean,
            'metric:vc90': null,
            rawData: {
                obs: scrubbedObservations ?? undefined,
                eid: elementMapEntriesMap ?? undefined,
                chg: typeMapEntriesMap ?? undefined,
                att: isFedrampScrubbed ? undefined : attributeEntriesMap ?? undefined,
                evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                lbl: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                lblMode: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
            },
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
            viewport: {
                w: (0, $aBafO.default)(),
                h: (0, $cScib.default)()
            }
        };
        return result;
    }
    constructor(){
        this.revisionNo = 'raw-handler';
    }
}

});

parcelRegister("iZFHi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0553efcefee8d84$export$2e2bcd8739ae039);

var $iqfTZ = parcelRequire("iqfTZ");

var $9Fepe = parcelRequire("9Fepe");

var $fHmhN = parcelRequire("fHmhN");

var $evPcU = parcelRequire("evPcU");

var $dAL8H = parcelRequire("dAL8H");

var $lzdBF = parcelRequire("lzdBF");

var $9xWiN = parcelRequire("9xWiN");

var $fI0UR = parcelRequire("fI0UR");

var $e8tkq = parcelRequire("e8tkq");

var $5JaQD = parcelRequire("5JaQD");

var $gGrdX = parcelRequire("gGrdX");

var $fdNLe = parcelRequire("fdNLe");

var $6LBUp = parcelRequire("6LBUp");

var $lbfKQ = parcelRequire("lbfKQ");

var $dOSlt = parcelRequire("dOSlt");

var $kNvJw = parcelRequire("kNvJw");
const $b0553efcefee8d84$var$createElementMutationsWatcher = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $6LBUp.default)(target)) return 'mutation:remount';
        if ((0, $9Fepe.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinGenAISegment) return 'mutation:gen-ai-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        const isInIgnoreLsMarker = (0, $6LBUp.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, $lzdBF.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, $dOSlt.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
const $b0553efcefee8d84$var$createElementMutationsWatcherNew = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $6LBUp.default)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $9Fepe.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinGenAISegment) return {
            type: 'mutation:gen-ai-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isInIgnoreLsMarker = (0, $6LBUp.default)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isRLLPlaceholder = (0, $lzdBF.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        const wasDeleted = removedNodeRects.some((nr)=>(0, $dOSlt.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
class $b0553efcefee8d84$export$2e2bcd8739ae039 {
    constructor({ onChange: onChange, getSSRState: getSSRState, getSSRPlaceholderHandler: getSSRPlaceholderHandler, trackLayoutShiftOffenders: trackLayoutShiftOffenders = false, searchPageConfig: searchPageConfig }){
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = (0, $fdNLe.isElementVisible)(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = async ({ target: target, addedNodes: addedNodes, removedNodes: removedNodes, timestamp: timestamp })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            const targetNode = target.deref();
            for (const addedNodeRef of addedNodes){
                const addedNode = addedNodeRef.deref();
                if (!addedNode) continue;
                const hasSameDeletedNode = removedNodes.find((ref)=>{
                    const n = ref.deref();
                    if (!n || !addedNode) return false;
                    return n.isEqualNode(addedNode);
                });
                const { isWithin: isWithinThirdPartySegment } = (0, $5JaQD.default)(addedNode, 'UFOThirdPartySegment', this.mapIs3pResult);
                const { isWithin: isWithinGenAISegment } = (0, $5JaQD.default)(addedNode, 'UFOGenAISegment', this.mapIsGenAIResult);
                const isWithinSmartAnswersSegment = Boolean(this.shouldCheckSmartAnswersMutations() && (0, $gGrdX.isContainedWithinSmartAnswers)(addedNode));
                const isTargetReactRoot = targetNode === this.getSSRState?.()?.reactRootElement;
                this.intersectionObserver?.watchAndTag(addedNode, (this.trackLayoutShiftOffenders ? $b0553efcefee8d84$var$createElementMutationsWatcherNew : $b0553efcefee8d84$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, this.getSSRState, this.getSSRPlaceholderHandler));
            }
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue, timestamp: timestamp })=>{
            this.intersectionObserver?.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $9Fepe.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const { isWithin: isWithinThirdPartySegment } = (0, $5JaQD.default)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
                const { isWithin: isWithinGenAISegment } = (0, $5JaQD.default)(target, 'UFOGenAISegment', this.mapIsGenAIResult);
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (isWithinGenAISegment) return {
                    type: 'mutation:gen-ai-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (this.shouldCheckSmartAnswersMutations() && (0, $gGrdX.isContainedWithinSmartAnswers)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $fHmhN.default)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $evPcU.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                // Pragmatic Drag and Drop attributes added during post-paint
                // registration; do not affect layout or paint.
                if ((0, $dAL8H.default)({
                    target: target,
                    attributeName: attributeName
                }) && (0, $iqfTZ.fg)('platform_ufo_exclude_pdnd_attributes_from_vc')) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $lbfKQ.isInputNameMutation)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const isRLLPlaceholder = (0, $lzdBF.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $kNvJw.isSameRectSize)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) {
                    const isSameCurrentAndPreviousRects = (0, $dOSlt.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                    this.onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                    });
                }
            }
        };
        this.shouldCheckSmartAnswersMutations = ()=>{
            return this.searchPageConfig?.enableSmartAnswersMutations && this.searchPageConfig?.searchPageRoute && window?.location?.pathname && window.location.pathname === this.searchPageConfig.searchPageRoute;
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.mapIsGenAIResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $9xWiN.createIntersectionObserver)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $fI0UR.default)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $e8tkq.default)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        if (this.isStarted) return;
        this.initializeObservers();
        this.mutationObserver?.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performanceObserver?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        if (!this.isStarted) return;
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.performanceObserver?.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, $5JaQD.cleanupCaches)(this.mapIs3pResult);
    }
}

});
parcelRegister("dAL8H", function(module, exports) {
$parcel$export(module.exports, "default", () => $949b39f43c6328fb$export$2e2bcd8739ae039);
/**
 * Attributes that Pragmatic Drag and Drop adds via `setAttribute` during its
 * post-paint registration step. They are used purely for hit testing and
 * registration bookkeeping, and do not affect layout, paint, or visible
 * styling, so they are safe to ignore for VC measurement.
 *
 * Drop target attributes follow `data-drop-target-for-<typeKey>` and are
 * handled by the prefix below (covers shipped and custom adapters).
 */ const $949b39f43c6328fb$export$bcd335ae574a0717 = new Set([
    // @atlaskit/pragmatic-drag-and-drop (core)
    'draggable',
    // Honey pot lives on a transient element; included for completeness.
    'data-pdnd-honey-pot',
    // @atlaskit/pragmatic-drag-and-drop-auto-scroll
    'data-auto-scrollable',
    // @atlaskit/pragmatic-drag-and-drop/react-beautiful-dnd-migration
    'data-rbd-draggable-droppable-id',
    'data-rbd-draggable-index',
    'data-rbd-droppable-type',
    'data-rbd-droppable-direction',
    'data-rbd-droppable-id',
    'data-rbd-droppable-context-id',
    'data-rbd-style-context-id'
]);
const $949b39f43c6328fb$export$846396c2d8be3710 = 'data-drop-target-for-';
function $949b39f43c6328fb$export$2e2bcd8739ae039({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (!attributeName) return false;
    if ($949b39f43c6328fb$export$bcd335ae574a0717.has(attributeName)) return true;
    if (attributeName.startsWith($949b39f43c6328fb$export$846396c2d8be3710)) return true;
    return false;
}

});

parcelRegister("9xWiN", function(module, exports) {
$parcel$export(module.exports, "createIntersectionObserver", () => $7cfc7a5d2de7421c$export$c3799d33e0ae80a5);

var $bx3lh = parcelRequire("bx3lh");
function $7cfc7a5d2de7421c$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $7cfc7a5d2de7421c$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement)) return;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $bx3lh.isZeroDimensionRectangle)(entry.intersectionRect)) {
                const zeroDimensionRectangleTagCallback = (props)=>{
                    const tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        const { attributeName: attributeName, oldValue: oldValue, newValue: newValue } = tagOrCallbackResult.mutationData;
                        const isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                for (const child of Array.from(entry.target.children)){
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!$7cfc7a5d2de7421c$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved?.({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});
parcelRegister("bx3lh", function(module, exports) {
$parcel$export(module.exports, "isZeroDimensionRectangle", () => $71bf2c2fcdb645b0$export$80d6b07c2266a1c6);
function $71bf2c2fcdb645b0$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

});


parcelRegister("fI0UR", function(module, exports) {
$parcel$export(module.exports, "default", () => $868fee2326d1b5dd$export$2e2bcd8739ae039);

var $eawzt = parcelRequire("eawzt");
function $868fee2326d1b5dd$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if ((0, $eawzt.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                /*
					"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
					I think it might have been something along the lines that for consistency every setAttribute call should create a record.
					Conceptually there is after all a mutation: there is an old value replaced with a new one,
					and whether or not they are the same doesn't really matter.
					And Custom elements should work the same way as MutationObserver."
					https://github.com/whatwg/dom/issues/520#issuecomment-336574796
				*/ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: mut.timestamp || performance.now()
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp: timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                // Accumulate added nodes
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                });
                // Accumulate removed nodes
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished?.({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $868fee2326d1b5dd$export$2e2bcd8739ae039 = $868fee2326d1b5dd$var$createMutationObserver;

});

parcelRegister("e8tkq", function(module, exports) {
$parcel$export(module.exports, "default", () => $798ad49059ded672$export$2e2bcd8739ae039);

var $lSFeb = parcelRequire("lSFeb");
function $798ad49059ded672$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: (0, $lSFeb.convertPhysicalToLogicalResolution)(attr.currentRect),
                    previousRect: (0, $lSFeb.convertPhysicalToLogicalResolution)(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$798ad49059ded672$export$2e2bcd8739ae039 = $798ad49059ded672$var$createPerformanceObserver;

});
parcelRegister("lSFeb", function(module, exports) {
$parcel$export(module.exports, "convertPhysicalToLogicalResolution", () => $ed88bbe67b5dfe9d$export$5e3f54cad8cb65e2);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $ed88bbe67b5dfe9d$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}

});


parcelRegister("5JaQD", function(module, exports) {
$parcel$export(module.exports, "cleanupCaches", () => $6a5bed61035b2dc3$export$6a35c3789c327630);
$parcel$export(module.exports, "default", () => $6a5bed61035b2dc3$export$2e2bcd8739ae039);

var $iqfTZ = parcelRequire("iqfTZ");

var $erszr = parcelRequire("erszr");

var $fsIGm = parcelRequire("fsIGm");

var $kzUxX = parcelRequire("kzUxX");
const $6a5bed61035b2dc3$var$OLD_DOM_WALK_MAX_LEVEL = 40;
const $6a5bed61035b2dc3$var$OLD_FIBER_WALK_MAX_LEVEL = 40;
const $6a5bed61035b2dc3$var$NEW_DOM_WALK_MAX_LEVEL = 400;
const $6a5bed61035b2dc3$var$NEW_FIBER_WALK_MAX_LEVEL = 400;
// Cache cleanup
let $6a5bed61035b2dc3$var$callCount = 0;
const $6a5bed61035b2dc3$var$CLEANUP_THRESHOLD = 50;
function $6a5bed61035b2dc3$var$maybeCleanup(resultCache) {
    $6a5bed61035b2dc3$var$callCount++;
    if ($6a5bed61035b2dc3$var$callCount >= $6a5bed61035b2dc3$var$CLEANUP_THRESHOLD && (0, $erszr.default)(0.3)) $6a5bed61035b2dc3$export$6a35c3789c327630(resultCache);
}
function $6a5bed61035b2dc3$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    $6a5bed61035b2dc3$var$callCount = 0;
    return resultCache;
}
function $6a5bed61035b2dc3$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $6a5bed61035b2dc3$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) return {
        isWithin: resultCache.get(node) ?? false
    };
    const checkedNodes = [];
    const shouldUseBumpedWalkLevels = (0, $iqfTZ.fg)('ufo-bump-walk-levels');
    const DOM_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $6a5bed61035b2dc3$var$NEW_DOM_WALK_MAX_LEVEL : $6a5bed61035b2dc3$var$OLD_DOM_WALK_MAX_LEVEL;
    const FIBER_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $6a5bed61035b2dc3$var$NEW_FIBER_WALK_MAX_LEVEL : $6a5bed61035b2dc3$var$OLD_FIBER_WALK_MAX_LEVEL;
    // Always use cached fiber strategy to handle non-React elements reliably
    const { fiber: fiber, cachedResult: cachedResult } = (0, $kzUxX.default)(node, DOM_WALK_MAX_LEVEL, checkedNodes, shouldUseBumpedWalkLevels ? resultCache : undefined);
    if (cachedResult !== undefined) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, cachedResult);
        });
        return {
            isWithin: cachedResult
        };
    }
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, $fsIGm.default)(fiber, targetComponentName, FIBER_WALK_MAX_LEVEL);
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

});
parcelRegister("fsIGm", function(module, exports) {
$parcel$export(module.exports, "default", () => $768e09a546b715ad$export$2e2bcd8739ae039);

var $kMXIV = parcelRequire("kMXIV");
function $768e09a546b715ad$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, $kMXIV.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $768e09a546b715ad$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}

});
parcelRegister("kMXIV", function(module, exports) {
$parcel$export(module.exports, "default", () => $23a2fa91e08decca$export$2e2bcd8739ae039);
// Helper function to extract component name from fiber
function $23a2fa91e08decca$export$2e2bcd8739ae039(fiber) {
    const type = fiber?.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}

});


parcelRegister("kzUxX", function(module, exports) {
$parcel$export(module.exports, "default", () => $9db6b1e20bb66ffe$export$2e2bcd8739ae039);

var $h8xSD = parcelRequire("h8xSD");
function $9db6b1e20bb66ffe$export$2e2bcd8739ae039(element, maxLevel, checkedNodes, resultCache) {
    let currentElement = element;
    let remainingLevels = maxLevel;
    while(currentElement && remainingLevels > 0){
        const cachedResult = resultCache?.get(currentElement);
        if (cachedResult !== undefined) return {
            fiber: null,
            cachedResult: cachedResult
        };
        checkedNodes.push(currentElement);
        const fiber = (0, $h8xSD.default)(currentElement);
        if (fiber) return {
            fiber: fiber
        };
        currentElement = currentElement.parentElement;
        remainingLevels--;
    }
    return {
        fiber: null
    };
}

});
parcelRegister("h8xSD", function(module, exports) {
$parcel$export(module.exports, "default", () => $81458004a5eb5bf2$export$2e2bcd8739ae039);
// Helper function to find React fiber on an element
function $81458004a5eb5bf2$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

});



parcelRegister("gGrdX", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinSmartAnswers", () => $c6f293e18cbdf14b$export$16c2770458939f21);

var $eIbOZ = parcelRequire("eIbOZ");
function $c6f293e18cbdf14b$export$16c2770458939f21(node) {
    const doc = (0, $eIbOZ.getDocument)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}

});
parcelRegister("eIbOZ", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $7f4a7c0f97808ba2$export$f65ca476c09acec0);
const $7f4a7c0f97808ba2$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("fdNLe", function(module, exports) {
$parcel$export(module.exports, "isElementVisible", () => $d31c629e4609cc1d$export$e989c0fffaa6b27a);
function $d31c629e4609cc1d$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch  {
        // there is no support for checkVisibility
        return true;
    }
}

});

parcelRegister("6LBUp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f23bf50b77c6c854$export$2e2bcd8739ae039);
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $f23bf50b77c6c854$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $f23bf50b77c6c854$export$2e2bcd8739ae039(element.parentElement);
}

});

parcelRegister("lbfKQ", function(module, exports) {
$parcel$export(module.exports, "isInputNameMutation", () => $6cec1d6442bb6fd6$export$80a5724ceedcfd3d);
// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $6cec1d6442bb6fd6$export$80a5724ceedcfd3d({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}

});

parcelRegister("dOSlt", function(module, exports) {
$parcel$export(module.exports, "isSameRectDimensions", () => $1e991ea754e8d7cb$export$fde63bc968551821);
const $1e991ea754e8d7cb$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $1e991ea754e8d7cb$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $1e991ea754e8d7cb$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $1e991ea754e8d7cb$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $1e991ea754e8d7cb$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $1e991ea754e8d7cb$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});

parcelRegister("kNvJw", function(module, exports) {
$parcel$export(module.exports, "isSameRectSize", () => $ad38aecc2644c251$export$597b41700f7dcd36);
const $ad38aecc2644c251$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $ad38aecc2644c251$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $ad38aecc2644c251$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $ad38aecc2644c251$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});


parcelRegister("G7jF8", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6ffb850c9cca4ec$export$2e2bcd8739ae039);

var $glbdM = parcelRequire("glbdM");
class $b6ffb850c9cca4ec$export$2e2bcd8739ae039 {
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = opts.onEvent;
    }
    bindEvent(type) {
        const unbindCallback = (0, $glbdM.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    /**
	 * Binds a scroll listener on `document` using the capture phase.
	 * The `scroll` event does not bubble, so listening on `window` only catches
	 * document-level scrolls. By using `{ capture: true }` on `document`, we can
	 * detect scroll events from any element in the DOM tree, including inner
	 * scrollable containers (e.g. when the user drags a scrollbar).
	 */ bindCaptureScrollEvent() {
        const unbindCallback = (0, $glbdM.bind)(document, {
            type: 'scroll',
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: 'scroll-container',
                    event: event
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
        this.bindCaptureScrollEvent();
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
}

});




parcelRegister("5BIjs", function(module, exports) {
$parcel$export(module.exports, "interactions", () => $878637d4fe9c490a$export$cc97b17ef9aeb088);
const $878637d4fe9c490a$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("l84xV", function(module, exports) {
$parcel$export(module.exports, "default", () => $6255cddfadf14775$export$2e2bcd8739ae039);

var $gmMRH = parcelRequire("gmMRH");

var $fPWhX = parcelRequire("fPWhX");

var $k45ha = parcelRequire("k45ha");
const $6255cddfadf14775$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $6255cddfadf14775$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $k45ha.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
	 * Set the VC result as per the last interaction
	 * Used to compare diffs of VC updates vs post interaction VC observer
	 * @param result - VC result as calculated by UFO create payload
	 */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
	 * Set the fn that would be invoked to process / send the observation data
	 */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
	 * Reset state of the log
	 */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
	 * Check if there is data in the log
	 */ hasData() {
        return this.reactProfilerTimings?.length > 0;
    }
    /**
	 * Send the log if there is data
	 */ async sendPostInteractionLog() {
        if (!this.lastInteractionFinish || !this.sinkHandlerFn) {
            this.reset();
            this.vcObserver?.stop();
            return;
        }
        const pageVisibilityState = (0, $fPWhX.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, $gmMRH.getConfig)();
        const postInteractionFinishVCResult = await this.vcObserver?.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config?.vc?.includeSSRInV3,
            includeSSRRatio: config?.vc?.includeSSRRatio,
            ...this.vcObserverSSRConfig,
            interactionType: this.lastInteractionFinish.type,
            isPageVisible: isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        });
        this.vcObserver?.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
	 * This fn should be invoked when an interaction has finished
	 * Basic details about the finished interaction will be recorded
	 * A timeout will be setup to send the post interaction observation after some time.
	 */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, errors: errors }) {
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            errors: errors
        };
        const timeout = (0, $gmMRH.getConfig)()?.timeWindowForLateMutationsInMilliseconds || $6255cddfadf14775$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
	 * This fn should be invoked when a React render happens after interaction has finished
	 */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name: name,
            labelStack: labelStack,
            start: start
        });
    }
    constructor(){
        /**
	 * Basic info about interaction that has just finished
	 */ this.lastInteractionFinish = null;
        /**
	 * Array of observed react render timings
	 */ this.reactProfilerTimings = [];
        /**
	 * Store the scheduled sink timeout Id so that it can be cancelled when needed
	 */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
	 * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
	 */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        /**
	 * Handler function to process / send the observation data
	 */ this.sinkHandlerFn = ()=>{};
    }
}
$6255cddfadf14775$export$2e2bcd8739ae039.displayName = "PostInteractionLog";

});


parcelRegister("i43Rz", function(module, exports) {
$parcel$export(module.exports, "matchRoute", () => $456480fa09b20e51$export$b4ee0d6794375c82);

var $iRqaL = parcelRequire("iRqaL");

var $9v0fx = parcelRequire("9v0fx");

var $awn9R = parcelRequire("awn9R");

var $gz2q3 = parcelRequire("gz2q3");
function $456480fa09b20e51$export$b4ee0d6794375c82(routes, pathname, queryParams = {}, basePath = '') {
    const queryParamObject = typeof queryParams === 'string' ? (0, $awn9R.parseQuery)(queryParams) : queryParams;
    // fast return if there is no route or only one route
    if (routes.length === 0) return null;
    if (routes.length === 1) return (0, $9v0fx.getRouteMatch)(routes[0], pathname, queryParamObject, basePath);
    const tree = (0, $gz2q3.treeifyRoutes)(routes);
    const route = (0, $iRqaL.findRoute)(tree, pathname, queryParamObject, basePath) || tree.fallbackRoute;
    return (0, $9v0fx.getRouteMatch)(route, pathname, queryParamObject, basePath);
}

});
parcelRegister("iRqaL", function(module, exports) {
$parcel$export(module.exports, "findRoute", () => $1a94f63efffed62e$export$4fa936acba669006);

var $hJfWN = parcelRequire("hJfWN");

var $7Fmbd = parcelRequire("7Fmbd");

var $gz2q3 = parcelRequire("gz2q3");
/**
 * Helper function to prioritize nodes with capturing groups in their segment patterns.
 * Nodes with capturing groups (e.g., `:id(\\d+)`) are considered more specific than
 * nodes without them (e.g., `:id`), so they are placed at the beginning of the array.
 *
 * @param arr - Array of nodes to modify
 * @param node - Node to add to the array
 *
 * @example
 * // Node with pattern `:id(\\d+)` will be placed before node with pattern `:id`
 * pushOrUnshiftByCaptureGroup(nodes, nodeWithCaptureGroup);
 */ function $1a94f63efffed62e$var$pushOrUnshiftByCaptureGroup(arr, node) {
    if (node.segmentPattern.includes('(') && node.segmentPattern.includes(')')) // Segment pattern has capturing group, making it more specific
    // Place it at the beginning for higher priority
    arr.unshift(node);
    else // No capturing group, place at the end of the array
    arr.push(node);
}
// Find matching nodes by segment
// sort the nodes by specificity
function $1a94f63efffed62e$var$matchChildren(node, segments) {
    // how do we define specificity? This is a tricky question.
    // the specificity goes like this:
    // 1. if the segment is an exact match, of course it's the most specific
    // 2. the rest is regex match, within the regex match, we have to consider:
    // 		2.1 the length of segments and if node has descendants. /jira/:id/summary is more specific than /jira/:id if the request URL is /jira/123/summary
    // 3 after checking the length, we have to consider if the segmentPattern has any capturing group. /jira/:id(\d+) is more specific than /jira/:id
    //
    // This is not a comprehensive solution to the specificity problem
    // I will use production urls to verify this heuristic
    const exactMatch = []; // segment is an exact match e.g. /jira matches /jira
    const lengthMatch = []; // check #2.1 from the above comment
    const rest = [];
    const { children: children } = node;
    // treat url segment as empty string if it's undefined
    // possible if we have optional segmentPattern
    const segment = segments[node.level] || '';
    // check if there is next segment
    const hasNextSegment = segments.length > node.level;
    for(const segmentPattern in children)if (Object.prototype.hasOwnProperty.call(children, segmentPattern)) {
        const child = children[segmentPattern];
        if (segment === segmentPattern) // we have exact segment match
        exactMatch.push(child);
        else {
            const regex = (0, $7Fmbd.pathToRegexp)(segmentPattern, [], {
                end: true,
                strict: true,
                sensitive: false
            });
            if (regex.test(segment)) {
                const nodeAhasChildren = Object.keys(child.children).length > 0;
                if (hasNextSegment && nodeAhasChildren) // if there is a next segment, we should prioritize nodes with children
                $1a94f63efffed62e$var$pushOrUnshiftByCaptureGroup(lengthMatch, child);
                else if (!hasNextSegment && !nodeAhasChildren) // if there is no next segment, we should prioritize nodes without children
                $1a94f63efffed62e$var$pushOrUnshiftByCaptureGroup(lengthMatch, child);
                else $1a94f63efffed62e$var$pushOrUnshiftByCaptureGroup(rest, child);
            }
        }
    }
    return [
        ...exactMatch,
        ...lengthMatch,
        ...rest
    ];
}
/**
 * Recursively searches for routes in optional segment nodes.
 * This function handles patterns like `/:a?/:b?/:c?` where segments can be omitted.
 * It traverses the tree looking for routes that can match with missing segments.
 *
 * @param node - Current node to examine
 * @param queryParams - Query parameters to match against route constraints
 * @returns Matched route if found, undefined otherwise
 *
 * @example
 * // For pattern `/:projectId?/:viewType?` and URL `/`
 * // This function will check if the `:projectId?` node has a matching route
 */ function $1a94f63efffed62e$var$recursivelyFindOptionalNodes(node, queryParams = {}) {
    const { segmentPattern: segmentPattern, children: children, routes: routes } = node;
    // Only process nodes with optional segment patterns (ending with '?')
    if (segmentPattern.endsWith('?')) {
        // Try to find a route at this level that matches the query parameters
        const maybeMatchedRoute = $1a94f63efffed62e$var$matchRoutesByQuery(routes, queryParams);
        if (maybeMatchedRoute) return maybeMatchedRoute;
        // If no route found at this level, recursively check child nodes
        for(const key in children){
            if (Object.prototype.hasOwnProperty.call(children, key)) return $1a94f63efffed62e$var$recursivelyFindOptionalNodes(children[key], queryParams);
        }
    }
}
/**
 * Matches routes based on query parameters, returning the most specific match.
 * This function filters routes first (for efficiency) then sorts by specificity.
 *
 * Specificity ranking (highest to lowest):
 * 1. Routes with more query parameters (length-based)
 * 2. Routes with exact value matches (e.g., "param=value")
 * 3. Routes ordered by __unsafeOrder (fallback for ties)
 */ function $1a94f63efffed62e$var$matchRoutesByQuery(routes, queryParamObject) {
    // Early return if no routes to process
    if (routes.length === 0) return null;
    // STEP 1: Filter routes to only include those that match the query parameters
    // This is done first for performance - no point sorting routes that won't match
    const filteredRoutes = routes.filter((route)=>{
        // Routes without query constraints match any query parameters
        if (route.query === undefined) return true;
        // Create a fake match object for the matchQuery function
        // We only need to check if the query matches, not extract actual values
        const fakeMatch = {
            params: {},
            query: {},
            isExact: false,
            path: '',
            url: ''
        };
        // Use the matchQuery function to determine if this route's query constraints
        // are satisfied by the current query parameters
        return !!(0, $hJfWN.matchQuery)(route.query, queryParamObject, fakeMatch);
    });
    // Early return if no routes match the query parameters
    if (filteredRoutes.length === 0) return null;
    // STEP 2: Sort the filtered routes by specificity (most specific first)
    const sortedRoutes = filteredRoutes.sort((a, b)=>{
        // 1st sort criterion: number of query parameters
        // Routes with more query parameters are considered more specific
        const aQueryLength = a.query?.length || 0;
        const bQueryLength = b.query?.length || 0;
        // If query lengths differ, prioritize the route with more parameters
        if (bQueryLength !== aQueryLength) return bQueryLength - aQueryLength; // Descending order (more params first)
        // 2nd sort criterion: query parameter specificity type
        // Helper function to classify the specificity of query parameters
        const getQuerySpecificity = (query)=>{
            if (!query) return 0;
            // These are most specific as they require exact parameter values (e.g., "mode=edit", "type=issue")
            if (query.some((q)=>q.includes('='))) return 1; // Medium specificity
            return 0;
        };
        const aSpecificity = getQuerySpecificity(a.query);
        const bSpecificity = getQuerySpecificity(b.query);
        // If specificity levels differ, prioritize higher specificity
        if (aSpecificity !== bSpecificity) return bSpecificity - aSpecificity; // Descending order (higher specificity first)
        // 3rd sort criterion: fallback to __unsafeOrder for deterministic sorting
        const aOrder = a.__unsafeOrder || 0;
        const bOrder = b.__unsafeOrder || 0;
        return aOrder - bOrder; // Ascending order (lower order first)
    });
    // Return the most specific route that matches the query parameters
    // Since the array is sorted by specificity (most specific first),
    // the first element is our best match
    return sortedRoutes[0];
}
function $1a94f63efffed62e$export$4fa936acba669006(tree, p, queryParams = {}, basePath) {
    // Remove base path to get the relative pathname for matching
    const pathname = p.replace(basePath, '');
    // Split pathname into individual segments for tree traversal
    // Example: '/jira/projects/123' becomes ['', 'jira', 'projects', '123']
    const segments = pathname.split('/');
    // Clean up segments array by removing empty strings from leading/trailing slashes
    if (segments[0] === '') segments.shift(); // Remove leading empty string from initial '/'
    if (segments[segments.length - 1] === '') segments.pop(); // Remove trailing empty string from final '/'
    // Initialize breadth-first search queue with the root node
    // The queue can contain either Node objects (to continue traversal) or
    // InvariantRoute objects (representing potential matches to return)
    const stack = [
        tree.root
    ];
    // Safety mechanism to prevent infinite loops in malformed trees
    let count = 0;
    const maxCount = 2000;
    // Main traversal loop: continue until queue is empty or match found
    while(stack.length > 0 && count < maxCount){
        count += 1;
        // Process next item from queue (FIFO for breadth-first behavior)
        const node = stack.shift();
        // TypeScript safety check (should never be null in practice)
        if (!node) return null;
        // If we encounter a route object instead of a Node, we've found our match
        // This happens when a non-exact route was added to the queue for later evaluation
        if (!(node instanceof (0, $gz2q3.Node))) return node; // Return the matched route
        // Extract node properties for evaluation
        const { children: children, routes: routes, level: level } = node;
        let maybeMatchedRoute = null;
        let shouldMatchChildren = true;
        // SCENARIO 1: Leaf node (no children) - check for terminal route match
        if (Object.keys(children).length === 0) {
            // Structural integrity check - leaf nodes must have routes
            if (!routes.length) throw new Error(`Route tree structural error: Reached a leaf node with no routes. ` + `This indicates the route tree was not built correctly. ` + `Every leaf node should have at least one route associated with it.`);
            // Attempt to match the routes at this leaf node
            maybeMatchedRoute = $1a94f63efffed62e$var$matchRoutesByQuery(routes, queryParams);
            if (maybeMatchedRoute) {
                // Check if we have unmatched segments remaining
                if (segments.length > level) // We have leftover segments but nowhere to go in the tree
                // Only proceed if the route allows non-exact matching
                {
                    if (maybeMatchedRoute.exact) // Route requires exact matching, so this isn't a valid match
                    maybeMatchedRoute = null;
                }
            }
        } else if (segments.length === level) // We've consumed all URL segments, see if current node has a matching route
        {
            if (routes.length) maybeMatchedRoute = $1a94f63efffed62e$var$matchRoutesByQuery(routes, queryParams);
        } else if (segments.length < level) {
            // We've run out of segments but the tree goes deeper
            // This can happen with optional patterns like /:a?/:b?/:c?
            shouldMatchChildren = false; // Don't continue normal traversal
            // Look for optional segment patterns that can match with missing segments
            maybeMatchedRoute = $1a94f63efffed62e$var$recursivelyFindOptionalNodes(node, queryParams);
        } else {
            // We have more segments to match and this node has children to explore
            // Check if current node has a non-exact route that could serve as fallback
            // Non-exact routes can match even when there are additional segments
            const lowSpecifityRoute = $1a94f63efffed62e$var$matchRoutesByQuery(routes, queryParams);
            if (lowSpecifityRoute && !lowSpecifityRoute.exact) // Add this route to the queue for later consideration
            // It will be returned if no more specific match is found
            stack.unshift(lowSpecifityRoute);
        }
        // If we found a match, return it immediately
        if (maybeMatchedRoute) return maybeMatchedRoute;
        // Continue tree traversal if appropriate
        if (shouldMatchChildren) {
            // Find child nodes that match the current segment, sorted by specificity
            const matchingChildren = $1a94f63efffed62e$var$matchChildren(node, segments);
            // Add matching children to the front of the queue for priority processing
            // More specific matches will be processed first due to sorting in matchChildren
            stack.unshift(...matchingChildren);
        }
    // Continue to next iteration to process the next item in the queue
    }
    // No match found after exhausting all possibilities
    return null;
}

});
parcelRegister("hJfWN", function(module, exports) {
$parcel$export(module.exports, "matchQuery", () => $88d5ecf6e37fcd98$export$c5d1efe363797780);
function $88d5ecf6e37fcd98$export$c5d1efe363797780(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? {
        ...pathMatch,
        query: queryMatch
    } : null;
}

});

parcelRegister("7Fmbd", function(module, exports) {
$parcel$export(module.exports, "pathToRegexp", () => $573ade1303522674$export$71304158c7e35877);
// Taken from https://github.com/pillarjs/path-to-regexp/blob/v6.2.1/src/index.ts
// To address version mismatch with root package.json
/**
 * Tokenizer results.
 */ /**
 * Tokenize input string.
 */ function $573ade1303522674$var$lexer(str) {
    const tokens = [];
    let i = 0;
    while(i < str.length){
        const char = str[i];
        if (char === '*' || char === '+' || char === '?') {
            tokens.push({
                type: 'MODIFIER',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === '\\') {
            tokens.push({
                type: 'ESCAPED_CHAR',
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === '{') {
            tokens.push({
                type: 'OPEN',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === '}') {
            tokens.push({
                type: 'CLOSE',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ':') {
            let name = '';
            let j = i + 1;
            while(j < str.length){
                const code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError(`Missing parameter name at ${i}`);
            tokens.push({
                type: 'NAME',
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === '(') {
            let count = 1;
            let pattern = '';
            let j = i + 1;
            if (str[j] === '?') throw new TypeError(`Pattern cannot start with "?" at ${j}`);
            while(j < str.length){
                if (str[j] === '\\') {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ')') {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === '(') {
                    count++;
                    if (str[j + 1] !== '?') throw new TypeError(`Capturing groups are not allowed at ${j}`);
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError(`Unbalanced pattern at ${i}`);
            if (!pattern) throw new TypeError(`Missing pattern at ${i}`);
            tokens.push({
                type: 'PATTERN',
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: 'CHAR',
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: 'END',
        index: i,
        value: ''
    });
    return tokens;
}
function $573ade1303522674$export$98e6a39c04603d36(str, options = {}) {
    const tokens = $573ade1303522674$var$lexer(str);
    const { prefixes: prefixes = './' } = options;
    const defaultPattern = `[^${$573ade1303522674$var$escapeString(options.delimiter || '/#?')}]+?`;
    const result = [];
    let key = 0;
    let i = 0;
    let path = '';
    const tryConsume = (type)=>{
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    const mustConsume = (type)=>{
        const value = tryConsume(type);
        if (value !== undefined) return value;
        const { type: nextType, index: index } = tokens[i];
        throw new TypeError(`Unexpected ${nextType} at ${index}, expected ${type}`);
    };
    const consumeText = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
        let result = '';
        let value;
        // eslint-disable-next-line no-cond-assign -- ERROR TO BE FIXED
        while(value = tryConsume('CHAR') || tryConsume('ESCAPED_CHAR'))result += value;
        return result;
    };
    while(i < tokens.length){
        const char = tryConsume('CHAR');
        const name = tryConsume('NAME');
        const pattern = tryConsume('PATTERN');
        if (name || pattern) {
            let prefix = char || '';
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = '';
            }
            if (path) {
                result.push(path);
                path = '';
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: '',
                pattern: pattern || defaultPattern,
                modifier: tryConsume('MODIFIER') || ''
            });
            continue;
        }
        const value = char || tryConsume('ESCAPED_CHAR');
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = '';
        }
        const open = tryConsume('OPEN');
        if (open) {
            const prefix = consumeText();
            // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
            const name = tryConsume('NAME') || '';
            // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
            const pattern = tryConsume('PATTERN') || '';
            const suffix = consumeText();
            mustConsume('CLOSE');
            result.push({
                name: name || (pattern ? key++ : ''),
                pattern: name && !pattern ? defaultPattern : pattern,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume('MODIFIER') || ''
            });
            continue;
        }
        mustConsume('END');
    }
    return result;
}
function $573ade1303522674$export$ef7acd7185315e22(str, options) {
    return $573ade1303522674$export$5b9bad9e403cf3d9($573ade1303522674$export$98e6a39c04603d36(str, options), options);
}
function $573ade1303522674$export$5b9bad9e403cf3d9(tokens, options = {}) {
    const reFlags = $573ade1303522674$var$flags(options);
    const { encode: encode = (x)=>x, validate: validate = true } = options;
    // Compile all the tokens into regexps.
    // eslint-disable-next-line array-callback-return -- ERROR TO BE FIXED
    const matches = tokens.map((token)=>{
        if (typeof token === 'object') return new RegExp(`^(?:${token.pattern})$`, reFlags);
    });
    return (data)=>{
        let path = '';
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            const value = data ? data[token.name] : undefined;
            const optional = token.modifier === '?' || token.modifier === '*';
            const repeat = token.modifier === '*' || token.modifier === '+';
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError(`Expected "${token.name}" to not repeat, but got an array`);
                if (value.length === 0) {
                    // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
                    if (optional) continue;
                    throw new TypeError(`Expected "${token.name}" to not be empty`);
                }
                for(let j = 0; j < value.length; j++){
                    const segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError(`Expected all "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === 'string' || typeof value === 'number') {
                const segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError(`Expected "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                path += token.prefix + segment + token.suffix;
                continue;
            }
            // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
            if (optional) continue;
            const typeOfMessage = repeat ? 'an array' : 'a string';
            throw new TypeError(`Expected "${token.name}" to be ${typeOfMessage}`);
        }
        return path;
    };
}
function $573ade1303522674$export$4659b591c19bdf3d(str, options) {
    const keys = [];
    const re = $573ade1303522674$export$71304158c7e35877(str, keys, options);
    return $573ade1303522674$export$968e97c88708237a(re, keys, options);
}
function $573ade1303522674$export$968e97c88708237a(re, keys, options = {}) {
    const { decode: decode = (x)=>x } = options;
    return function(pathname) {
        const m = re.exec(pathname);
        if (!m) return false;
        const { 0: path, index: index } = m;
        const params = Object.create(null);
        for(let i = 1; i < m.length; i++){
            // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
            if (m[i] === undefined) continue;
            const key = keys[i - 1];
            if (key.modifier === '*' || key.modifier === '+') params[key.name] = m[i].split(key.prefix + key.suffix).map((value)=>decode(value, key));
            else params[key.name] = decode(m[i], key);
        }
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $573ade1303522674$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}
/**
 * Get the flags for a regexp from the options.
 */ function $573ade1303522674$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 */ function $573ade1303522674$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    const groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    let index = 0;
    let execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: '',
            suffix: '',
            modifier: '',
            pattern: ''
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $573ade1303522674$var$arrayToRegexp(paths, keys, options) {
    const parts = paths.map((path)=>$573ade1303522674$export$71304158c7e35877(path, keys, options).source);
    return new RegExp(`(?:${parts.join('|')})`, $573ade1303522674$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $573ade1303522674$var$stringToRegexp(path, keys, options) {
    return $573ade1303522674$export$9a9303716def6456($573ade1303522674$export$98e6a39c04603d36(path, options), keys, options);
}
function $573ade1303522674$export$9a9303716def6456(tokens, keys, options = {}) {
    const { strict: strict = false, start: start = true, end: end = true, encode: encode = (x)=>x, delimiter: delimiter = '/#?', endsWith: endsWith = '' } = options;
    const endsWithRe = `[${$573ade1303522674$var$escapeString(endsWith)}]|$`;
    const delimiterRe = `[${$573ade1303522674$var$escapeString(delimiter)}]`;
    let route = start ? '^' : '';
    // Iterate over the tokens and create our regexp string.
    for (const token of tokens)if (typeof token === 'string') route += $573ade1303522674$var$escapeString(encode(token));
    else {
        const prefix = $573ade1303522674$var$escapeString(encode(token.prefix));
        const suffix = $573ade1303522674$var$escapeString(encode(token.suffix));
        if (token.pattern) {
            if (keys) keys.push(token);
            if (prefix || suffix) {
                if (token.modifier === '+' || token.modifier === '*') {
                    const mod = token.modifier === '*' ? '?' : '';
                    route += `(?:${prefix}((?:${token.pattern})(?:${suffix}${prefix}(?:${token.pattern}))*)${suffix})${mod}`;
                } else route += `(?:${prefix}(${token.pattern})${suffix})${token.modifier}`;
            } else if (token.modifier === '+' || token.modifier === '*') route += `((?:${token.pattern})${token.modifier})`;
            else route += `(${token.pattern})${token.modifier}`;
        } else route += `(?:${prefix}${suffix})${token.modifier}`;
    }
    if (end) {
        if (!strict) route += `${delimiterRe}?`;
        route += !options.endsWith ? '$' : `(?=${endsWithRe})`;
    } else {
        const endToken = tokens[tokens.length - 1];
        const isEndDelimited = typeof endToken === 'string' ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += `(?:${delimiterRe}(?=${endsWithRe}))?`;
        if (!isEndDelimited) route += `(?=${delimiterRe}|${endsWithRe})`;
    }
    return new RegExp(route, $573ade1303522674$var$flags(options));
}
function $573ade1303522674$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $573ade1303522674$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $573ade1303522674$var$arrayToRegexp(path, keys, options);
    return $573ade1303522674$var$stringToRegexp(path, keys, options);
}

});

parcelRegister("gz2q3", function(module, exports) {
$parcel$export(module.exports, "Node", () => $40f7b7741aa06e7b$export$85c928794f8d04d4);
$parcel$export(module.exports, "treeifyRoutes", () => $40f7b7741aa06e7b$export$6e055daf7492da67);
/* eslint-disable max-classes-per-file */ class $40f7b7741aa06e7b$export$85c928794f8d04d4 {
    constructor(level, segmentPattern){
        this.children = {};
        this.routes = [];
        this.level = level;
        this.segmentPattern = segmentPattern;
    }
}
class $40f7b7741aa06e7b$export$7fbedc92909ed28e {
    constructor(){
        // fallback route is the routes that match everything.
        // this is normally useful for 404 pages
        // we specifically handle this route for performance reason
        // because if we put it into the tree, it will always get traversed and has the least specificity.
        this.fallbackRoute = null;
        this.root = new $40f7b7741aa06e7b$export$85c928794f8d04d4(0, '');
    }
    insert(segmentPatterns, route) {
        let current = this.root;
        for(let i = 0; i < segmentPatterns.length; i++){
            const segmentPattern = segmentPatterns[i];
            if (!current.children[segmentPattern]) current.children[segmentPattern] = new $40f7b7741aa06e7b$export$85c928794f8d04d4(i + 1, segmentPattern);
            current = current.children[segmentPattern];
        }
        current.routes.push(route);
    }
}
const $40f7b7741aa06e7b$var$trim = (segmentPatterns)=>{
    // remove the first empty string
    if (segmentPatterns[0] === '') segmentPatterns.shift();
    // remove the last empty string
    if (segmentPatterns[segmentPatterns.length - 1] === '') segmentPatterns.pop();
};
const $40f7b7741aa06e7b$var$getSegmentPatterns = (path)=>{
    const segmentPatterns = path.split('/');
    $40f7b7741aa06e7b$var$trim(segmentPatterns);
    return segmentPatterns;
};
const $40f7b7741aa06e7b$var$handleFallbackRoute = (route, tree)=>{
    if (typeof route.path !== 'string' || route.path === '' || route.path === '/*' || route.path === '*') {
        if (tree.fallbackRoute) throw new Error('There should be only one route that mates everything.');
        tree.fallbackRoute = route;
        return true;
    }
    return false;
};
function $40f7b7741aa06e7b$export$6e055daf7492da67(routes) {
    const tree = new $40f7b7741aa06e7b$export$7fbedc92909ed28e();
    routes.forEach((route)=>{
        if ($40f7b7741aa06e7b$var$handleFallbackRoute(route, tree)) return;
        // Don't be intimidated by the regex, it's not that complicated.
        // The regex will match ":projectType(software|software/c|servicedesk|core)" or "(/secure/|/)".
        // It handles the case where we need to split the path into multiple segments.
        const match = /(:[a-zA-Z]*)?\(([^()]*\/+[^()]*)\)/.exec(route.path);
        if (match) {
            // Given the route.path is "/jira/:projectType(software|software/c)/foo"
            // `match` looks like [":projectType(software|software/c|servicedesk|core)", ":projectType", "software|software/c|servicedesk|core"]
            const segment = match[0];
            const captureGroup = match[2];
            // We create several branches, e.g.
            // /jira/:projectType(software|software/c)/foo
            // becomes
            // - /jira/software/foo
            // - /jira/software/c/foo
            // although they appear in different position in the tree, they should share the same route
            captureGroup.split('|').forEach((projectType)=>{
                const path = route.path.replace(segment, projectType);
                tree.insert($40f7b7741aa06e7b$var$getSegmentPatterns(path), route);
            });
        } else tree.insert($40f7b7741aa06e7b$var$getSegmentPatterns(route.path), route);
    });
    return tree;
}

});


parcelRegister("9v0fx", function(module, exports) {
$parcel$export(module.exports, "getRouteMatch", () => $10c21cdef7b9b359$export$b4cb787dccedb024);

var $71ffJ = parcelRequire("71ffJ");

var $hJfWN = parcelRequire("hJfWN");
/* This should match what react-router does to compute a root match. */ const $10c21cdef7b9b359$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $10c21cdef7b9b359$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $71ffJ.matchPath)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $10c21cdef7b9b359$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $hJfWN.matchQuery)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = {
        ...pathMatch,
        query: {}
    };
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
function $10c21cdef7b9b359$export$b4cb787dccedb024(route, pathname, queryParamObject, basePath) {
    if (route) {
        const matchedRoute = $10c21cdef7b9b359$var$execRouteMatching(route, pathname, queryParamObject, basePath);
        if (matchedRoute) return matchedRoute;
    }
    return null;
}

});
parcelRegister("71ffJ", function(module, exports) {
$parcel$export(module.exports, "matchPath", () => $9d3f985b8812e03b$export$81336c211d5ff295);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $7Fmbd = parcelRequire("7Fmbd");
const $9d3f985b8812e03b$var$cache = {};
const $9d3f985b8812e03b$var$cacheLimit = 10000;
let $9d3f985b8812e03b$var$cacheCount = 0;
function $9d3f985b8812e03b$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $9d3f985b8812e03b$var$cache[cacheKey] || ($9d3f985b8812e03b$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $7Fmbd.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($9d3f985b8812e03b$var$cacheCount < $9d3f985b8812e03b$var$cacheLimit) {
        pathCache[path] = result;
        $9d3f985b8812e03b$var$cacheCount++;
    }
    return result;
}
function $9d3f985b8812e03b$export$81336c211d5ff295(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) // eslint-disable-next-line no-param-reassign
    options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $9d3f985b8812e03b$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            url: path === '/' && url === '' ? '/' : url,
            isExact: isExact,
            params: keys.reduce((memo, key, index)=>{
                // eslint-disable-next-line no-param-reassign
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}

});


parcelRegister("awn9R", function(module, exports) {
$parcel$export(module.exports, "parseQuery", () => $e935881a245614e4$export$1e8473eaf75b0d10);
// Source: https://github.com/unshiftio/querystringify/blob/2.2.0/index.js
// Purpose: Eliminate dependencies from `@atlassian/match-route` for micro-optimization
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $e935881a245614e4$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
function $e935881a245614e4$export$1e8473eaf75b0d10(query) {
    const parser = /([^=?#&]+)=?([^&]*)/g;
    const result = {};
    let part;
    while(part = parser.exec(query)){
        var key = $e935881a245614e4$var$decode(part[1]), value = $e935881a245614e4$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}

});


parcelRegister("3zT69", function(module, exports) {
$parcel$export(module.exports, "default", () => $5932de20e9a2c119$export$2e2bcd8739ae039);
// import uuid from 'uuid/v4';
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $6pOqP = parcelRequire("6pOqP");

var $lW33F = parcelRequire("lW33F");

var $iUH6d = parcelRequire("iUH6d");
const $5932de20e9a2c119$var$packageVersion = "0.0.0-use.local";
const $5932de20e9a2c119$var$originParamName = 'atlOrigin';
const $5932de20e9a2c119$var$originVersioningAttributes = {
    originLibrary: `origin-tracing.js@${$5932de20e9a2c119$var$packageVersion}`
};
class $5932de20e9a2c119$export$2e2bcd8739ae039 {
    constructor({ id: id = $5932de20e9a2c119$export$2e2bcd8739ae039.generateId(), product: product, dangerouslySkipValidation: dangerouslySkipValidation = false }){
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
    static isValidId(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
    }
    static isValidProduct(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
    }
    static generateId() {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, $6pOqP.default)();
        // Dash positions are fixed so they don't add to uniqueness.
        // Remove them to save space in the encoded form.
        return id.replace(/-/g, '');
    }
    static createEmpty() {
        return new $5932de20e9a2c119$var$EmptyOriginTracer();
    }
    static createMalformed() {
        return new $5932de20e9a2c119$var$MalformedOriginTracer();
    }
    static fromUrl(url) {
        let params = new ((0, $iUH6d.getEnv)()).URLSearchParams();
        $5932de20e9a2c119$var$replaceQuery(url, (queryString)=>{
            params = new ((0, $iUH6d.getEnv)()).URLSearchParams(queryString);
        });
        return $5932de20e9a2c119$export$2e2bcd8739ae039.fromEncoded(params.get($5932de20e9a2c119$var$originParamName));
    }
    static fromEncoded(encoded) {
        if (!encoded) return $5932de20e9a2c119$export$2e2bcd8739ae039.createEmpty();
        try {
            return $5932de20e9a2c119$export$2e2bcd8739ae039.decode(encoded);
        } catch (e) {
            return $5932de20e9a2c119$export$2e2bcd8739ae039.createMalformed();
        }
    }
    static removeFromUrl(url) {
        return $5932de20e9a2c119$var$replaceQuery(url, (queryString)=>{
            const params = new ((0, $iUH6d.getEnv)()).URLSearchParams(queryString);
            params.delete($5932de20e9a2c119$var$originParamName);
            return params.toString();
        });
    }
    static decode(encodedOrigin) {
        const originData = (0, $lW33F.decode)(encodedOrigin);
        return new $5932de20e9a2c119$export$2e2bcd8739ae039(originData);
    }
    encode() {
        return (0, $lW33F.encode)({
            id: this.id,
            product: this.product
        });
    }
    addToUrl(url) {
        return $5932de20e9a2c119$var$replaceQuery(url, (originalQueryString)=>{
            const params = new ((0, $iUH6d.getEnv)()).URLSearchParams(originalQueryString);
            params.set($5932de20e9a2c119$var$originParamName, this.encode());
            return params.toString();
        });
    }
    containsOrigin(urlString) {
        const url = new ((0, $iUH6d.getEnv)()).URL(urlString);
        const params = new URLSearchParams(url.search);
        return params.has($5932de20e9a2c119$var$originParamName);
    }
    isEmpty() {
        return false;
    }
    isMalformed() {
        return !this.isEmpty() && !this.isValid();
    }
    isValid() {
        return true;
    }
    toAnalyticsAttributes({ transformValue: transformValue = (v)=>v === null ? undefined : v, hasGeneratedId: hasGeneratedId = false } = {}) {
        // `originIdGenerated` should be used in analytic events that generated this originId.
        // Subsequent events should use `originId`.
        // No two events should have the same value of originIdGenerated.
        const originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
        return {
            [originIdProp]: transformValue(this.id),
            originProduct: transformValue(this.product),
            ...$5932de20e9a2c119$var$originVersioningAttributes
        };
    }
    validate() {
        if (!$5932de20e9a2c119$export$2e2bcd8739ae039.isValidId(this.id)) throw new TypeError('Invalid Origin id');
        if (!$5932de20e9a2c119$export$2e2bcd8739ae039.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
    }
}
class $5932de20e9a2c119$var$EmptyOriginTracer extends $5932de20e9a2c119$export$2e2bcd8739ae039 {
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    isValid() {
        return false;
    }
    isEmpty() {
        return true;
    }
    toAnalyticsAttributes() {
        return {
            ...$5932de20e9a2c119$var$originVersioningAttributes
        };
    }
}
class $5932de20e9a2c119$var$MalformedOriginTracer extends $5932de20e9a2c119$export$2e2bcd8739ae039 {
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    isValid() {
        return false;
    }
    isEmpty() {
        return false;
    }
    toAnalyticsAttributes() {
        return {
            originMalformed: true,
            ...$5932de20e9a2c119$var$originVersioningAttributes
        };
    }
}
function $5932de20e9a2c119$var$replaceQuery(url, replacer) {
    const urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    const urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, (_wholeMatch, beforeQuery, queryString, afterQuery)=>{
        let newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = `?${newQueryString}`;
        return `${beforeQuery}${newQueryString}${afterQuery}`;
    });
}

});
parcelRegister("lW33F", function(module, exports) {
$parcel$export(module.exports, "encode", () => $a21d1c3fa55c53a3$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $a21d1c3fa55c53a3$export$2f872c0f2117be69);

var $dDiGc = parcelRequire("dDiGc");

var $iUH6d = parcelRequire("iUH6d");
const $a21d1c3fa55c53a3$var$productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function $a21d1c3fa55c53a3$export$c564cdbbe6da493(originData) {
    const json = JSON.stringify($a21d1c3fa55c53a3$export$4bc4b533a565aabe(originData));
    const base64 = (0, $iUH6d.getEnv)().btoa(json);
    return (0, $dDiGc.base64ToBase64Url)(base64);
}
function $a21d1c3fa55c53a3$export$2f872c0f2117be69(encodedOriginString) {
    const base64 = (0, $dDiGc.base64UrlToBase64)(encodedOriginString);
    const json = (0, $iUH6d.getEnv)().atob(base64);
    return $a21d1c3fa55c53a3$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $a21d1c3fa55c53a3$export$4bc4b533a565aabe({ id: id, product: product }) {
    return {
        i: id,
        p: product && product in $a21d1c3fa55c53a3$var$productShorthands ? $a21d1c3fa55c53a3$var$productShorthands[product] : product
    };
}
function $a21d1c3fa55c53a3$export$46d5cda6b884b7ab(originJSONObject) {
    const originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $a21d1c3fa55c53a3$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $a21d1c3fa55c53a3$var$expandProductShorthand(maybeShorthand) {
    const products = Object.keys($a21d1c3fa55c53a3$var$productShorthands);
    for(let i = 0; i < products.length; i++){
        const product = products[i];
        const shorthand = $a21d1c3fa55c53a3$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}

});
parcelRegister("dDiGc", function(module, exports) {
$parcel$export(module.exports, "base64ToBase64Url", () => $7d09a4c3c331cd7b$export$3b91e21dac1023c6);
$parcel$export(module.exports, "base64UrlToBase64", () => $7d09a4c3c331cd7b$export$47c5265a25535d02);
/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $7d09a4c3c331cd7b$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $7d09a4c3c331cd7b$export$47c5265a25535d02(base64url) {
    if (base64url == null) return '';
    const base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - base64url.length % 4) % 4;
    const pad = '==='.slice(0, padLength);
    return base64 + pad;
}

});

parcelRegister("iUH6d", function(module, exports) {
$parcel$export(module.exports, "getEnv", () => $26fc23e68e9d2621$export$4bd44a2aa29d3d6e);

var $3oBOI = parcelRequire("3oBOI");


const $26fc23e68e9d2621$export$d3cd91e0fdbfdbc0 = ()=>({
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, $3oBOI.Buffer) !== 'undefined' && ((encoded)=>(0, $3oBOI.Buffer).from(encoded, 'base64').toString()),
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $3oBOI.Buffer) !== 'undefined' && ((str)=>(0, $3oBOI.Buffer).from(str).toString('base64')),
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (parcelRequire("5BjZr")).URLSearchParams,
        URL: typeof URL === 'function' && URL || (parcelRequire("5BjZr")).URL
    });
let $26fc23e68e9d2621$var$env;
const $26fc23e68e9d2621$export$4bd44a2aa29d3d6e = ()=>$26fc23e68e9d2621$var$env || ($26fc23e68e9d2621$var$env = $26fc23e68e9d2621$var$validateEnv($26fc23e68e9d2621$export$d3cd91e0fdbfdbc0()));
const $26fc23e68e9d2621$var$validateEnv = (env)=>{
    if (!(env.atob && env.btoa && env.URLSearchParams && env.URL)) throw new TypeError(`Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).`);
    return env;
};

});



parcelRegister("hIipg", function(module, exports) {
$parcel$export(module.exports, "envType", () => $83c3cc7ff9d146e6$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $83c3cc7ff9d146e6$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $83c3cc7ff9d146e6$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $83c3cc7ff9d146e6$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $83c3cc7ff9d146e6$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $83c3cc7ff9d146e6$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $83c3cc7ff9d146e6$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $83c3cc7ff9d146e6$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $83c3cc7ff9d146e6$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $83c3cc7ff9d146e6$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $83c3cc7ff9d146e6$export$62a500c02dc63ee);
$parcel$export(module.exports, "perimeterType", () => $83c3cc7ff9d146e6$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $83c3cc7ff9d146e6$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $83c3cc7ff9d146e6$export$e73680b18d9b7c6e);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.


var $83c3cc7ff9d146e6$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $83c3cc7ff9d146e6$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $83c3cc7ff9d146e6$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
	 *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
	 */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $83c3cc7ff9d146e6$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $83c3cc7ff9d146e6$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $83c3cc7ff9d146e6$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $83c3cc7ff9d146e6$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $83c3cc7ff9d146e6$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $83c3cc7ff9d146e6$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $83c3cc7ff9d146e6$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $83c3cc7ff9d146e6$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
var $83c3cc7ff9d146e6$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $83c3cc7ff9d146e6$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $83c3cc7ff9d146e6$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $83c3cc7ff9d146e6$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("6aMTG", function(module, exports) {
$parcel$export(module.exports, "objectValues", () => $8f54c8eaccfce6ad$export$ad1854f4a08c15f8);
function $8f54c8eaccfce6ad$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}

});

parcelRegister("kTskK", function(module, exports) {
$parcel$export(module.exports, "isType", () => $8b73694bd48b98ab$export$26b9f946b448f23e);
function $8b73694bd48b98ab$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}

});

parcelRegister("gL9hl", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf36a8c612f48c08$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $fS5dR = parcelRequire("fS5dR");

var $SqSph = parcelRequire("SqSph");

var $hIipg = parcelRequire("hIipg");

var $i3RqP = parcelRequire("i3RqP");

var $jLrHi = parcelRequire("jLrHi");

var $1LxMA = parcelRequire("1LxMA");

var $lFpQ1 = parcelRequire("lFpQ1");

var $1RwPs = parcelRequire("1RwPs");

var $gpdox = parcelRequire("gpdox");

var $jbQ2X = parcelRequire("jbQ2X");

var $8nQRc = parcelRequire("8nQRc");

var $bap8Z = parcelRequire("bap8Z");

var $aO4YE = parcelRequire("aO4YE");

var $ic1gZ = parcelRequire("ic1gZ");

var $9A3q9 = parcelRequire("9A3q9");

var $aBsbe = parcelRequire("aBsbe");

var $kTskK = parcelRequire("kTskK");

var $dYhqx = parcelRequire("dYhqx");

var $6aMTG = parcelRequire("6aMTG");

var $1hdMB = parcelRequire("1hdMB");

var $7qRhc = parcelRequire("7qRhc");

var $frSBj = parcelRequire("frSBj");

var $9D7ff = parcelRequire("9D7ff");

var $7WJYu = parcelRequire("7WJYu");

var $aSmPV = parcelRequire("aSmPV");

var $iNnXU = parcelRequire("iNnXU");

var $1ZXfv = parcelRequire("1ZXfv");

var $5bWrF = parcelRequire("5bWrF");

var $l9sD2 = parcelRequire("l9sD2");

var $jgjT6 = parcelRequire("jgjT6");

var $izroy = parcelRequire("izroy");

var $faM8Y = parcelRequire("faM8Y");

var $jFH3o = parcelRequire("jFH3o");

var $hQNbB = parcelRequire("hQNbB");

var $3haPF = parcelRequire("3haPF");

var $eZGnl = parcelRequire("eZGnl");

var $9FUav = parcelRequire("9FUav");

var $3QIuh = parcelRequire("3QIuh");

var $7tjDg = parcelRequire("7tjDg");
const $bf36a8c612f48c08$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $bf36a8c612f48c08$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $gpdox.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $gpdox.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($bf36a8c612f48c08$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch  {
                this._safeSessionStorage.removeItem($bf36a8c612f48c08$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($bf36a8c612f48c08$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $hIipg.eventType).UI:
                case (0, $hIipg.eventType).OPERATIONAL:
                case (0, $hIipg.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $hIipg.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $hIipg.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
   * Calling this function in the intialisation of the client in product
   * captures specified 'origin tracing' URL params and fires a single origin landed event
   * <p>
   * This function expects a mapping between the keys for any URL parameters
   *  that should be captured and removed for origin tracing
   * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
   * Each handler function should return an object with two items
   * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
   * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
   *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
   * </p>
   * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
   * e.g. from a share or email
   *
   * An example calling this function using an external decoding library, with taskSessionId specified to persist
   * analyticsWebClient.setOriginTracingHandlers({
        atlOrigin: encodedOrigin => {
            const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
            return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
        },
    });
   *
   * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
   * @this {AnalyticsWebClient}
   */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            const keys = Object.keys(capturedOriginTraces);
            keys.forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            keys.forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (keys.length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $hIipg.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $kTskK.isType)((0, $hIipg.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $6aMTG.objectValues)((0, $hIipg.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setCollaborationContextInfo = (collaborationContextAri)=>{
            if (!collaborationContextAri) throw new Error('Missing collaborationContextAri');
            this._collaborationContextInfo = {
                collaborationContextAri: collaborationContextAri
            };
        };
        this.clearCollaborationContextInfo = ()=>{
            this._collaborationContextInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $faM8Y.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $kTskK.isType)((0, $hIipg.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $6aMTG.objectValues)((0, $hIipg.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $kTskK.isType)((0, $hIipg.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $6aMTG.objectValues)((0, $hIipg.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.appendUIViewedAttributes = (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = {
                ...this._uiViewedAttributes,
                ...attributes
            };
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $hIipg.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
	 * @deprecated
	 * please use {@link sendScreenEvent instead)
	 */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
	 * send screen event
	 * @param event The event / For retrocompatibility event name is still supported here.
	 * @param callback
	 * @param attributes. Deprecated, will get ignored if using an event object as first param.
	 */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $3haPF.validateScreenEvent)(screenName);
            (0, $izroy.validateContainers)(screenContainers);
            const builtEvent = (0, $1RwPs.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $3QIuh.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $eZGnl.validateTrackEvent)(event);
            const builtEvent = (0, $jLrHi.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $hIipg.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $1LxMA.buildActionName)(event), builtEvent, this._context, (0, $3QIuh.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $9FUav.validateUIEvent)(event);
            const builtEvent = (0, $jLrHi.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $hIipg.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $1LxMA.buildActionName)(event), builtEvent, this._context, (0, $3QIuh.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $jFH3o.validateOperationalEvent)(event);
            const builtEvent = (0, $jLrHi.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $hIipg.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $1LxMA.buildActionName)(event), builtEvent, this._context, (0, $3QIuh.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = this.createUIViewedEvent(callback);
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.signalUserActive = ()=>{
            let uiViewedEvent = this._uiViewedEvent || this.createUIViewedEvent(null);
            uiViewedEvent.signalUserActive();
        };
        this.createUIViewedEvent = (callback)=>{
            return new (0, $5bWrF.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $hIipg.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $hIipg.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $hIipg.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $hIipg.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $hIipg.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $6aMTG.objectValues)((0, $hIipg.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $kTskK.isType)((0, $hIipg.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $6aMTG.objectValues)((0, $hIipg.envType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $hIipg.originType).WEB;
        else if (!(0, $kTskK.isType)((0, $hIipg.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $6aMTG.objectValues)((0, $hIipg.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $hIipg.originType).WEB ? (0, $hIipg.platformType).WEB : (0, $hIipg.platformType).DESKTOP;
        else (0, $hQNbB.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, $fS5dR.isFedrampModerate)()) productInfo.perimeter = (0, $hIipg.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn('Failed to auto-detect perimeter: %s', e instanceof Error ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, $hIipg.perimeterType).COMMERCIAL;
        if (!(0, $kTskK.isType)((0, $hIipg.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be a perimeterType: [${(0, $6aMTG.objectValues)((0, $hIipg.perimeterType))}]`);
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            const icId = (0, $SqSph.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn('Failed to auto-detect isolation context: %s', e instanceof Error ? e.message : String(e));
        }
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo?.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $9A3q9.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $aBsbe.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $lFpQ1.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $7WJYu.default)();
        const useStargate = this._useStargate(settings.useStargate);
        const apiHost = (0, $frSBj.selectHost)({
            useStargate: useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $7tjDg.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $ic1gZ.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $aO4YE.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: (0, $dYhqx.LoggingResponseCallback).getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings?.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $7qRhc.default)();
        this._tabTracking = new (0, $aSmPV.default)();
        this._sessionTracking = new (0, $9D7ff.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $iNnXU.default)();
        this._originTracing = new (0, $1hdMB.default)();
        this._eventProcessor.setOriginTracingClient(this._originTracing);
        // Init Apdex
        this._apdexEvent = new (0, $i3RqP.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $8nQRc.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $bap8Z.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $1ZXfv.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $jgjT6.default)();
        this._workspaceInfo = {};
        this._collaborationContextInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $jbQ2X.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $l9sD2.TestSupport).isGeminiVREnvironment() && !(0, $l9sD2.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $l9sD2.TestSupport).isGeminiVREnvironment() && !(0, $l9sD2.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
	 * @private
	 * @deprecated
	 * Please avoid using internal properties. They are not part of the public
	 * API and may change without notice.
	 *
	 * This property has been exposed for backward compatibility with existing
	 * tests in external code
	 */ get task() {
        return this._task;
    }
    /**
	 * @private
	 * @deprecated
	 * Please avoid using internal properties.
	 * They are not part of the public API and may change without notice.
	 *
	 * This property has been exposed for backward compatibility with existing
	 * tests in external code
	 */ get _productInfo() {
        return this._internalProductInfo;
    }
}

});
parcelRegister("SqSph", function(module, exports) {
$parcel$export(module.exports, "isolationContextId", () => $a90a0c040bfb6470$export$839b022803d38d4d);

var $39qy8 = parcelRequire("39qy8");

var $lRYAe = parcelRequire("lRYAe");
function $a90a0c040bfb6470$export$839b022803d38d4d() {
    if (typeof document === 'undefined') // @ts-ignore
    return (0, $lRYAe.isIsolatedCloud)() ? globalThis.ssrContext?.icName : undefined;
    const atlCtxCookieValues = (0, $39qy8.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icId;
}

});
parcelRegister("lRYAe", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $884da93962a662a0$export$9186ccba8effc5de);

var $f1C81 = parcelRequire("f1C81");

var $39qy8 = parcelRequire("39qy8");
function $884da93962a662a0$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInIC ?? false;
    const atlCtxCookieValues = (0, $39qy8.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $f1C81.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}

});
parcelRegister("f1C81", function(module, exports) {
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $9963c986af0f87ec$export$d8347b4aae768c2d);

const $9963c986af0f87ec$export$d8347b4aae768c2d = [
    (0, $8fdfc4bb9d992697$export$f005e2e9f707cb5f)
];

});



parcelRegister("i3RqP", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ba988961eb7e522$export$2e2bcd8739ae039);

var $hIipg = parcelRequire("hIipg");

var $kTskK = parcelRequire("kTskK");

var $7qRhc = parcelRequire("7qRhc");

var $hblSZ = parcelRequire("hblSZ");
class $1ba988961eb7e522$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $hIipg.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
		 * For initialLoad type:
		 * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
		 *
		 * For transition type:
		 * 1. active status is tracked in active events map (_isActiveEvents)
		 *
		 * For any type, if startTime or stopTime is specified:
		 * 1. If currently active (!_isHidden)
		 */ if (event.type === (0, $hIipg.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $hIipg.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $kTskK.isType)((0, $hIipg.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
		 * For a transition, if the startTime was not specified,
		 * the start event should have been present.
		 */ if (!event.startTime && event.type === (0, $hIipg.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $7qRhc.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $hblSZ.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("7qRhc", function(module, exports) {
$parcel$export(module.exports, "default", () => $4740668ee65c8b63$export$2e2bcd8739ae039);
class $4740668ee65c8b63$export$2e2bcd8739ae039 {
    constructor(){
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("hblSZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ffd25c9bb3c8fc1$export$2e2bcd8739ae039);
class $0ffd25c9bb3c8fc1$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("jLrHi", function(module, exports) {
$parcel$export(module.exports, "buildActionEvent", () => $8eda03003576ed68$export$7bf451af4a8e3dd9);

var $jcAyj = parcelRequire("jcAyj");

var $ijl7J = parcelRequire("ijl7J");

var $4Losw = parcelRequire("4Losw");

var $9dXzR = parcelRequire("9dXzR");

var $fx1sJ = parcelRequire("fx1sJ");

var $5l7lX = parcelRequire("5l7lX");

var $i9GRa = parcelRequire("i9GRa");

var $c0j4C = parcelRequire("c0j4C");

var $l3Hn0 = parcelRequire("l3Hn0");

var $67LW9 = parcelRequire("67LW9");

var $2nrJ7 = parcelRequire("2nrJ7");
function $8eda03003576ed68$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, aliases, groups) {
    const productFields = (0, $i9GRa.buildProductFields)(productInfo, (0, $2nrJ7.extractProductOverrides)(event));
    const tenantFields = (0, $c0j4C.buildTenantFields)(tenantInfo);
    const orgFields = (0, $5l7lX.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $67LW9.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $4Losw.buildCollaborationContextFields)(collaborationContextInfo);
    const userFields = (0, $l3Hn0.buildUserFields)(userInfo);
    const actionFields = (0, $jcAyj.buildActionFields)(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...(0, $9dXzR.buildEventOverrides)(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...(0, $ijl7J.buildAliases)(aliases),
        ...(0, $fx1sJ.buildGroups)(groups)
    };
}

});
parcelRegister("jcAyj", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $1bcac521ae108efa$export$655ecf7241feac42);

var $c1M3d = parcelRequire("c1M3d");
function $1bcac521ae108efa$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...(0, $c1M3d.buildContainersWithName)(event.containers)
    };
}

});
parcelRegister("c1M3d", function(module, exports) {
$parcel$export(module.exports, "buildContainersWithName", () => $5e2e097e1cf11717$export$f045f238d77c002a);

var $2b4YY = parcelRequire("2b4YY");

var $9rKPo = parcelRequire("9rKPo");

var $bHWuA = parcelRequire("bHWuA");
function $5e2e097e1cf11717$export$f045f238d77c002a(containers) {
    if ((0, $bHWuA.isNotEmptyObject)(containers)) {
        const validContainers = (0, $9rKPo.filterAndBuildContainers)(containers);
        return (0, $2b4YY.buildAttributesWithName)('containers', validContainers);
    }
    return undefined;
}

});
parcelRegister("2b4YY", function(module, exports) {
$parcel$export(module.exports, "buildAttributesWithName", () => $4e92a435e098943b$export$55b70947967d0b50);

var $bHWuA = parcelRequire("bHWuA");
function $4e92a435e098943b$export$55b70947967d0b50(name, attrObject) {
    return (0, $bHWuA.isNotEmptyObject)(attrObject) ? {
        [name]: attrObject
    } : undefined;
}

});
parcelRegister("bHWuA", function(module, exports) {
$parcel$export(module.exports, "isNotEmptyObject", () => $df34daae35810f9a$export$e0287cc73292b477);

var $d98zn = parcelRequire("d98zn");
function $df34daae35810f9a$export$e0287cc73292b477(obj) {
    return (0, $d98zn.isPlainObject)(obj) && Object.keys(obj).length > 0;
}

});
parcelRegister("d98zn", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $60bcf14f8d5c7789$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $60bcf14f8d5c7789$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $60bcf14f8d5c7789$var$isObjectObject(o) {
    return $60bcf14f8d5c7789$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $60bcf14f8d5c7789$export$53b83ca8eaab0383(o) {
    if ($60bcf14f8d5c7789$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($60bcf14f8d5c7789$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});



parcelRegister("9rKPo", function(module, exports) {
$parcel$export(module.exports, "filterAndBuildContainers", () => $b78ea9e79de7bdd9$export$3f5115a568819c1a);
function $b78ea9e79de7bdd9$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}

});



parcelRegister("ijl7J", function(module, exports) {
$parcel$export(module.exports, "buildAliases", () => $26764b80cf5180e8$export$2c4ef8ee173bbcaa);

var $bHWuA = parcelRequire("bHWuA");
function $26764b80cf5180e8$export$2c4ef8ee173bbcaa(aliases) {
    if ((0, $bHWuA.isNotEmptyObject)(aliases)) return {
        aliases: aliases
    };
    return undefined;
}

});

parcelRegister("4Losw", function(module, exports) {
$parcel$export(module.exports, "buildCollaborationContextFields", () => $afd34270e8868d72$export$d138783ff9effae1);
function $afd34270e8868d72$export$d138783ff9effae1(collaborationContextInfo) {
    return {
        collaborationContextAri: collaborationContextInfo.collaborationContextAri
    };
}

});

parcelRegister("9dXzR", function(module, exports) {
$parcel$export(module.exports, "buildEventOverrides", () => $64bb4f7178bfd041$export$469803cc371327c2);
function $64bb4f7178bfd041$export$469803cc371327c2(event) {
    let result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}

});

parcelRegister("fx1sJ", function(module, exports) {
$parcel$export(module.exports, "buildGroups", () => $fd82396caf27594c$export$680f59e10d3eb269);

var $bHWuA = parcelRequire("bHWuA");
function $fd82396caf27594c$export$680f59e10d3eb269(groups) {
    if ((0, $bHWuA.isNotEmptyObject)(groups)) return {
        groups: groups
    };
    return undefined;
}

});

parcelRegister("5l7lX", function(module, exports) {
$parcel$export(module.exports, "buildOrgFields", () => $65e1a049996edccb$export$19ccbe55c9aa75d5);
function $65e1a049996edccb$export$19ccbe55c9aa75d5(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}

});

parcelRegister("i9GRa", function(module, exports) {
$parcel$export(module.exports, "buildProductFields", () => $e31c72e5641f1d4f$export$bd1896e45d2ef8e8);

var $59nKG = parcelRequire("59nKG");
function $e31c72e5641f1d4f$export$bd1896e45d2ef8e8(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = (0, $59nKG.getProductField)(productInfo.env, overrides.env);
    const product = (0, $59nKG.getProductField)(productInfo.product, overrides.product);
    const subproduct = (0, $59nKG.getProductField)(productInfo.subproduct(), overrides.subproduct);
    const version = (0, $59nKG.getProductField)(productInfo.version, overrides.version);
    const origin = (0, $59nKG.getProductField)(productInfo.origin, overrides.origin);
    const platform = (0, $59nKG.getProductField)(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    const cdp = productInfo.cdp;
    const csp = productInfo.csp;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic,
        cdp: cdp,
        csp: csp
    };
}

});
parcelRegister("59nKG", function(module, exports) {
$parcel$export(module.exports, "getProductField", () => $cdb10f9d95063819$export$690c718dc8037b2e);
function $cdb10f9d95063819$export$690c718dc8037b2e(field, override) {
    return override === undefined ? field : override;
}

});


parcelRegister("c0j4C", function(module, exports) {
$parcel$export(module.exports, "buildTenantFields", () => $41160a9603262a3a$export$ab02ab56ae59d840);
function $41160a9603262a3a$export$ab02ab56ae59d840(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}

});

parcelRegister("l3Hn0", function(module, exports) {
$parcel$export(module.exports, "buildUserFields", () => $80ee1039272934ad$export$4557a3fdd8921d68);
function $80ee1039272934ad$export$4557a3fdd8921d68(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}

});

parcelRegister("67LW9", function(module, exports) {
$parcel$export(module.exports, "buildWorkspaceFields", () => $a17da133ed643463$export$73c41604cd4b31da);
function $a17da133ed643463$export$73c41604cd4b31da(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}

});

parcelRegister("2nrJ7", function(module, exports) {
$parcel$export(module.exports, "extractProductOverrides", () => $ec3c07c75d91c3e4$export$e3d99b4bfec06f6e);
function $ec3c07c75d91c3e4$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}

});


parcelRegister("1LxMA", function(module, exports) {
$parcel$export(module.exports, "buildActionName", () => $085e5a4b82236bff$export$9c5623a792efc9b0);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $085e5a4b82236bff$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}

});

parcelRegister("lFpQ1", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $1b07ac8f43536310$export$3a7fe28f9bf4f3d9);

var $bzz1e = parcelRequire("bzz1e");
const $1b07ac8f43536310$var$libraryVersion = "0.0.0-use.local";
function $1b07ac8f43536310$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return (0, $bzz1e.validationMode).QUIET;
    if (environment.includes('prod')) return (0, $bzz1e.validationMode).QUIET;
    return (0, $bzz1e.validationMode).COMPLETE;
}
function $1b07ac8f43536310$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $1b07ac8f43536310$var$libraryVersion
            },
            validationMode: $1b07ac8f43536310$var$getDefaultValidationMode(productInfo)
        }
    };
}

});
parcelRegister("bzz1e", function(module, exports) {
$parcel$export(module.exports, "validationMode", () => $060ba5cd7f39a7dc$export$fbd92247fb4d6159);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $060ba5cd7f39a7dc$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});

});


parcelRegister("1RwPs", function(module, exports) {
$parcel$export(module.exports, "buildScreenEvent", () => $9a3d54d35dd5ae32$export$c7d9a5f56acc4b19);

var $hIipg = parcelRequire("hIipg");

var $ijl7J = parcelRequire("ijl7J");

var $2b4YY = parcelRequire("2b4YY");

var $4Losw = parcelRequire("4Losw");

var $c1M3d = parcelRequire("c1M3d");

var $9dXzR = parcelRequire("9dXzR");

var $fx1sJ = parcelRequire("fx1sJ");

var $lGg9J = parcelRequire("lGg9J");

var $5l7lX = parcelRequire("5l7lX");

var $i9GRa = parcelRequire("i9GRa");

var $c0j4C = parcelRequire("c0j4C");

var $l3Hn0 = parcelRequire("l3Hn0");

var $67LW9 = parcelRequire("67LW9");
function $9a3d54d35dd5ae32$var$buildAttributes(attributes) {
    return (0, $2b4YY.buildAttributesWithName)('attributes', attributes);
}
function $9a3d54d35dd5ae32$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return (0, $2b4YY.buildAttributesWithName)('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $9a3d54d35dd5ae32$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, event, containers, aliases, groups) {
    const productFields = (0, $i9GRa.buildProductFields)(productInfo);
    const tenantFields = (0, $c0j4C.buildTenantFields)(tenantInfo);
    const userFields = (0, $l3Hn0.buildUserFields)(userInfo);
    const orgFields = (0, $5l7lX.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $67LW9.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $4Losw.buildCollaborationContextFields)(collaborationContextInfo);
    return {
        eventType: (0, $hIipg.eventType).SCREEN,
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...(0, $lGg9J.buildLocationFields)(event),
        ...$9a3d54d35dd5ae32$var$buildAttributes(attributes),
        ...$9a3d54d35dd5ae32$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...(0, $c1M3d.buildContainersWithName)(containers),
        ...(0, $9dXzR.buildEventOverrides)(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...(0, $ijl7J.buildAliases)(aliases),
        ...(0, $fx1sJ.buildGroups)(groups)
    };
}

});
parcelRegister("lGg9J", function(module, exports) {
$parcel$export(module.exports, "buildLocationFields", () => $3b7743ae6938a3b7$export$6dfd201add24e54d);
function $3b7743ae6938a3b7$export$6dfd201add24e54d(event) {
    const payload = typeof event === 'object' ? event : undefined;
    return {
        title: '',
        path: typeof payload?.path === 'string' ? payload.path : '',
        url: typeof payload?.url === 'string' ? payload.url : '',
        referrer: '',
        search: ''
    };
}

});


parcelRegister("gpdox", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5efbc9f78fa6044$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $a5efbc9f78fa6044$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $a5efbc9f78fa6044$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($a5efbc9f78fa6044$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("jbQ2X", function(module, exports) {
$parcel$export(module.exports, "default", () => $3198d8ef729d8b40$export$2e2bcd8739ae039);

var $2VLFm = parcelRequire("2VLFm");

var $c0bP9 = parcelRequire("c0bP9");

var $3IGfS = parcelRequire("3IGfS");

var $hIipg = parcelRequire("hIipg");

var $lS5kg = parcelRequire("lS5kg");
const $3198d8ef729d8b40$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $c0bP9.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $3198d8ef729d8b40$export$2e2bcd8739ae039 {
    constructor(options){
        this.validProduct = false;
        this.isEnabled = options.perimeter !== (0, $hIipg.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $3IGfS.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $lS5kg.default)($3198d8ef729d8b40$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $c0bP9.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $c0bP9.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch  {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $2VLFm.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
	 * Validates the cross product interaction session parameters parsed from the URL (if present)
	 * If the Base64-encoded URL does not decode into a valid JSON object
	 *
	 * This method must be called out of the constructor, as the sendEventCallback we expect here
	 * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
	 */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ]
        });
    }
}

});
parcelRegister("2VLFm", function(module, exports) {
$parcel$export(module.exports, "default", () => $d10a08373361e645$export$2e2bcd8739ae039);

var $41FAq = parcelRequire("41FAq");

var $fS5dR = parcelRequire("fS5dR");

var $iqfTZ = parcelRequire("iqfTZ");

var $9qTx3 = parcelRequire("9qTx3");

var $iIQGE = parcelRequire("iIQGE");
const $d10a08373361e645$export$b9dd752fb13352ce = 'interactionSession.source';
const $d10a08373361e645$export$e04e3c50573f9af7 = 'interactionSession.bridge';
class $d10a08373361e645$export$2e2bcd8739ae039 {
    constructor(interactionSessionOptions, bridge, interactionSource){
        this.getCurrentInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
        this.getPreviousInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
        this.getBridge = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($d10a08373361e645$export$e04e3c50573f9af7) : null;
        this.getInteractionSource = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($d10a08373361e645$export$b9dd752fb13352ce) : null;
        const shouldDisable = (0, $iqfTZ.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $41FAq.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $fS5dR.isFedrampModerate)();
        this.isEnabled = !shouldDisable;
        if (this.isEnabled) {
            // Get singleton interaction session tracking instance
            this.interactionSessionTracking = (0, $9qTx3.default).getInstance();
            let isValidPersistedId = false;
            if (this.interactionSessionTracking) {
                if (interactionSessionOptions) {
                    this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                    isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
                }
            }
            this.safeSessionStorage = new (0, $iIQGE.default)();
            // Store other interaction session parameters directly in session storage if ID has been validated
            if (isValidPersistedId) {
                bridge && this.safeSessionStorage.setItem($d10a08373361e645$export$e04e3c50573f9af7, bridge);
                interactionSource && this.safeSessionStorage.setItem($d10a08373361e645$export$b9dd752fb13352ce, interactionSource);
            }
        }
    }
}

});
parcelRegister("41FAq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $ljgqH = parcelRequire("ljgqH");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $ljgqH.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $ljgqH.isFeatureEnabled;
    }
});

});
parcelRegister("ljgqH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAuditState = module.exports.configureAuditState = module.exports.shouldEnableForAudit = module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $fS5dR = parcelRequire("fS5dR");
var $lRYAe = parcelRequire("lRYAe");
var $SqSph = parcelRequire("SqSph");

var $lbbJD = parcelRequire("lbbJD");

var $eQHTz = parcelRequire("eQHTz");

var $9Mbnm = parcelRequire("9Mbnm");
const $f8381de9a195f6ad$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX = "aem-audit";
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @returns if the environment block is available in the current cloud environment
 */ function $f8381de9a195f6ad$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $f8381de9a195f6ad$var$getBoundaryKey();
    return (0, $lbbJD.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $f8381de9a195f6ad$var$isEnvironmentBlockEnabled;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param offeringPredicates Optional map of boundary keys to predicate functions. When a predicate
 *   is provided for the current boundary, the feature is only considered enabled if both
 *   the AEM state and the predicate return true.
 * @returns if the feature is available in the current cloud environment
 */ function $f8381de9a195f6ad$var$isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    const override = (0, $eQHTz.getFeatureOverride)(environmentBlockName, featureName);
    if (override !== null) return override;
    const boundaryKey = $f8381de9a195f6ad$var$getBoundaryKey();
    const aemResult = (0, $lbbJD.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    // Keep predicate evaluation deferred until AEM or an explicit fallback resolves the feature as enabled.
    const isAllowedForCurrentOffering = ()=>{
        const predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
        return predicate ? predicate() : true;
    };
    if (!aemResult) {
        const metadata = (0, $lbbJD.getFeatureAvailabilityMetadataForBoundary)(environmentBlockName, featureName, boundaryKey);
        if ($f8381de9a195f6ad$var$shouldEnableForIcPreRelease(metadata, boundaryKey)) return isAllowedForCurrentOffering();
        if ((0, $9Mbnm.isSSR)()) return false; // SSR: fallback to standard AEM resolution
        if (metadata && metadata.auditPhase) return $f8381de9a195f6ad$var$shouldEnableForAudit(metadata.auditPhase, environmentBlockName, featureName);
        return false; // fallback to default behavior when not in audit state
    }
    return isAllowedForCurrentOffering();
}
module.exports.isFeatureEnabled = $f8381de9a195f6ad$var$isFeatureEnabled;
/** Enables IC pre-release features only for the pre-release isolation context. */ function $f8381de9a195f6ad$var$shouldEnableForIcPreRelease(metadata, boundaryKey) {
    return boundaryKey === $lbbJD.ISOLATED_CLOUD_COMMERCIAL_KEY && (0, $SqSph.isolationContextId)() === "ic-dr6" && metadata !== undefined && metadata.preRelease === true;
}
/**
 * Determines whether a feature that is not enabled via standard AEM resolution
 * should be enabled due to an active audit phase.
 *
 * This function should only be called for excluded features in browser contexts that have an active
 * audit phase. It applies the following rules:
 *
 * | Phase            | Environment | localStorage key set? | Result  |
 * | ---------------- | ----------- | --------------------- | ------- |
 * | internal-audit   | non-prod    | any                   | true    |
 * | internal-audit   | prod        | any                   | false   |
 * | external-audit   | non-prod    | any                   | true    |
 * | external-audit   | prod        | yes ("true")          | true    |
 * | external-audit   | prod        | no                    | false   |
 *
 * In SSR contexts (no window/localStorage), this falls back to false
 * for any case that would require a localStorage check.
 */ function $f8381de9a195f6ad$var$shouldEnableForAudit(auditPhase, environmentBlockName, featureName) {
    const envType = (0, $9Mbnm.getEnvironmentType)();
    if (envType === "non-prod") return true;
    if (auditPhase === $lbbJD.UnderAuditPhase.EXTERNAL_AUDIT && !(0, $9Mbnm.isSSR)() && localStorage.getItem(`${$f8381de9a195f6ad$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`) === "true") return true;
    return false;
}
module.exports.shouldEnableForAudit = $f8381de9a195f6ad$var$shouldEnableForAudit;
function $f8381de9a195f6ad$var$getBoundaryKey() {
    if ((0, $fS5dR.isFedrampModerate)()) return $lbbJD.FED_MOD_KEY;
    if ((0, $lRYAe.isIsolatedCloud)()) return $lbbJD.ISOLATED_CLOUD_COMMERCIAL_KEY;
    return $lbbJD.COMMERCIAL_KEY;
}
function $f8381de9a195f6ad$var$configureAuditState(environmentBlockName, featureName, value) {
    localStorage.setItem(`${$f8381de9a195f6ad$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`, value);
}
module.exports.configureAuditState = $f8381de9a195f6ad$var$configureAuditState;
function $f8381de9a195f6ad$var$clearAuditState(environmentBlockName, featureName) {
    localStorage.removeItem(`${$f8381de9a195f6ad$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`);
}
module.exports.clearAuditState = $f8381de9a195f6ad$var$clearAuditState;
// Register global API on window for browser dev tools usage
if (typeof window !== "undefined") window.__AEM_FEATURE_JS__ = {
    checkFeature: $f8381de9a195f6ad$var$isFeatureEnabled,
    overrideFeature: $eQHTz.overrideFeature,
    clearFeatureOverride: $eQHTz.clearFeatureOverride,
    clearAllOverrides: $eQHTz.clearAllOverrides,
    configureAuditState: $f8381de9a195f6ad$var$configureAuditState,
    clearAuditState: $f8381de9a195f6ad$var$clearAuditState
};

});
parcelRegister("lbbJD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $hysJS = parcelRequire("hysJS");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $hysJS.isEnvironmentBlockEnabledForBoundary;
    }
});

var $hysJS = parcelRequire("hysJS");
Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $hysJS.isFeatureEnabledForBoundary;
    }
});

var $hysJS = parcelRequire("hysJS");
Object.defineProperty(module.exports, "getFeatureAvailabilityMetadataForBoundary", {
    enumerable: true,
    get: function() {
        return $hysJS.getFeatureAvailabilityMetadataForBoundary;
    }
});

var $8vWVR = parcelRequire("8vWVR");
Object.defineProperty(module.exports, "BOUNDARY_KEYS_LIST", {
    enumerable: true,
    get: function() {
        return $8vWVR.BOUNDARY_KEYS_LIST;
    }
});
Object.defineProperty(module.exports, "UnderAuditPhase", {
    enumerable: true,
    get: function() {
        return $8vWVR.UnderAuditPhase;
    }
});
Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $8vWVR.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $8vWVR.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $8vWVR.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});

});
parcelRegister("hysJS", function(module, exports) {
"use strict";
var $cc7be79ad670623c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $cc7be79ad670623c$var$sdk_data_json_1 = $cc7be79ad670623c$var$__importDefault((parcelRequire("cmYvc")));
const $cc7be79ad670623c$var$aemEnvironmentBlockData = $cc7be79ad670623c$var$sdk_data_json_1.default;
// Build reverse map: offeringId -> offeringShortKeyId, derived from compositionKeyMap (offeringShortKeyId -> offeringId)
const $cc7be79ad670623c$var$offeringToOfferingShortKeyId = Object.fromEntries(Object.entries($cc7be79ad670623c$var$aemEnvironmentBlockData.compositionKeyMap).map(([offeringShortKeyId, offeringId])=>[
        offeringId,
        offeringShortKeyId
    ]));
/**
 * Translates a full offering ID (BoundaryKey) to its short SDK key name.
 * Falls back to the original key if no mapping exists.
 */ function $cc7be79ad670623c$var$toofferingShortKeyId(boundaryKey) {
    const mapped = $cc7be79ad670623c$var$offeringToOfferingShortKeyId[boundaryKey];
    return mapped !== undefined && mapped !== null ? mapped : boundaryKey;
}
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $cc7be79ad670623c$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $cc7be79ad670623c$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $cc7be79ad670623c$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $cc7be79ad670623c$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($cc7be79ad670623c$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $cc7be79ad670623c$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        const feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[$cc7be79ad670623c$var$toofferingShortKeyId(boundaryKey)] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $cc7be79ad670623c$var$isFeatureEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns the availability metadata for the feature in the given boundary, or undefined if none
 */ function $cc7be79ad670623c$var$getFeatureAvailabilityMetadataForBoundary(environmentBlockName, featureName, boundaryKey) {
    const block = $cc7be79ad670623c$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return undefined;
    const feature = block.features[featureName];
    if (!feature) return undefined;
    return feature.availabilityMetadata && feature.availabilityMetadata[$cc7be79ad670623c$var$toofferingShortKeyId(boundaryKey)];
}
module.exports.getFeatureAvailabilityMetadataForBoundary = $cc7be79ad670623c$var$getFeatureAvailabilityMetadataForBoundary;
function $cc7be79ad670623c$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    const block = $cc7be79ad670623c$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[$cc7be79ad670623c$var$toofferingShortKeyId(boundaryKey)] === true;
}

});
parcelRegister("cmYvc", function(module, exports) {
module.exports = JSON.parse("{\"compositionKeyMap\":{\"cc\":\"commercial-cloud\",\"ic\":\"isolated-cloud-commercial\",\"fm\":\"fedramp-moderate\"},\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"adminhub-access-requests\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-beta-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-collections-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-discover-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-enterprise-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-add-app-standalone-apps-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-product\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-ai-enabled-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-api-token-and-key-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-api-token-controls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-app-requests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-app-updates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-atlassian-guard-standard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-audit-log\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-authentication-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-automations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-backup-and-restore\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-billing-console\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-billing-preview\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-byok\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-cart\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-code-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-connected-emoji\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-connected-sources\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-connector-protection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-contacts\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-custom-domain-email-notification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-classifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-residency\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-data-transfer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-delta-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-disaster-recovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-apps-shadow-it\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-new-products\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-enable-user-merge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-encryption\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-environments\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-experiment-controls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-footprint\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-freeze-windows\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-help\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-jsm-scim\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-llm\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-login-customisation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-marketplace-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-mcp-settings\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-nested-side-navigation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-org-create\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-org-deletion\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-performance-monitoring\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-platform-usage\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-portfolio-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights-workflow-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-product-recommendation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-product-urls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-release-tracks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-revamped-organization-overview\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-access\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-rovo-chat-protection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-insights\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-rovo-mcp-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-settings\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"adminhub-saml-sso\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-sandbox\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-searchbar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-security-checklist\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-sensitive-data-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-signup\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-site-rename\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-site-transfer\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-system-health\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-team-site-assignment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-teamwork-graph-cli\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-units\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-use-available-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-access-invites\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-connected-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-counts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-workspaces-table-plans\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"core-adminhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"assets\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"assets-data-manager-client-tools-distribution\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"assets-data-manager-ui\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-data-manager\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"assets-recent-items\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-reports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-rovo-search\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-assets\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-commerce-sentry\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-cross-product-interaction-client\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-atlassian-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"bitbucket\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"bitbucket-development-events-and-status\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-merge-queue\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-slack-app\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-ssh-key-validation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"pipelines\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"chat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"compass\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"ccma\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"confluence-anonymous-access\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-canvas-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-canvas-relay\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-company-hub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-content-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-content-manager\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-create-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-databases\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"external-audit\"}}},\"confluence-editing-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-edition-awareness\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-editor-offline-storage\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-embedded-pages\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-employee-directory\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-invitations\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-legacy-collaborative-editor\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-legacy-ssr-frontend\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-loom-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-mission-control\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-mobile-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-monolith-isolated-cloud\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"confluence-monolith\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-page-analytics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-page-tree\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-premium-onboarding\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-presenter-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-public-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-questions-native-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-questions\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-recap\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-remix\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-single-space-guests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-slack-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-slides\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-smart-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-space-analytics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-team-calendars\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-view-page\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-whiteboards\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"external-audit\"}}},\"core-confluence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"moved-to-monolith-awaiting-deprecation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"customer-service-management-ai-agent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"dx\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"feedback\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"focus\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"asks-and-planning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"goals\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"goals-townsquare-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"guard-premium\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"guard-premium-atlassian-guard-premium-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"guard-premium-full-site-security-scanning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"home\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"basic-home-experience\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":true}},\"home-cross-app-create\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-dashboard-experience\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"home-ms-teams-and-slack-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-org-chart-analytics-pipeline\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-rerouting-services\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-status-backend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"home-where-you-work\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"jira\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-jira\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"issue-transition-customisation-for-srb\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jcma-x2c\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jcma\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-admin-oauth-credentials\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ai-issue-classification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-ai-planner\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-ai-snippet\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ai-upsell-in-editor-free\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-apps-menu\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-audit-log\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-backlogs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-boards-and-views\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-calendar-view\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-components\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-dashboard-public-sharing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-development-hub\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-development-tab-druid-metric-cards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab-issue-centric-deployments\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-devinfo-async-pull-request-icon\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-devops-toolchain\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-edition-awareness\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-figma-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-forms\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-github-for-jira\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"jira-github-workflows\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-global-issue-create-smart-fields\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-goals-nav\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-import-work-sidebar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-in-product-help\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-individual-capacity-planning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-invite-people\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-issue\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-jinx-blue-green-jql-search\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-jpd-nav-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-jpd-roadmap-on-timeline-cross-sell\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-loom-banner\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-marketplace-sidebar-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-mobile-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-monolith-isolated-cloud\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"jira-monolith\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-next-best-task\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-oasis-reports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-opsgenie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-planned-deprecated-jira-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-plans\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-theme-unsplash\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-project\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-quickstart-pages\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-releases\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-roadmap-in-nav\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-search-investigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-share\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-site-optimiser\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-slack\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-smart-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-smart-related-issues\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-devops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-cycle-time\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-deployment-frequency\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-spreadsheets-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-synced-blocks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-team-managed-projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-unsplash\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-whiteboards-backlog-experiment\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-work-suggestions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-workflow-configuration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"modern-issue-transition-connect-app-fields\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"jira-align\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"jira-service-management-help-center\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-ai-core-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-ai-ops\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-ai-services\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-approvals\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-assets-vertical\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-automation-playbook\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-canned-responses\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-case-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-change-ai-risk-assessment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-calendar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management-deployment-vendors\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-change-risk-assessment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-change-risk-reporter-configuration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-jira-event-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-chat-ops-ic-custom-apps\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"jsm-chat-ops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-slack-and-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-chat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-cloud-megatron\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-csat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-customer-account-directory\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-developer-escalations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-email-requests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-entity-migration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-forms\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-halp-admin-panel\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-help-center-change-password\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-help-center-password-login\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-help-center-rovo-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-virtual-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-hr-employee-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-conference-calls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-management-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-issue\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-journey-builder\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-lightweight-frontend\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-multi-language-support\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-ops-gatekeeper\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-conference-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-queues\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-related-issues\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-reports-operations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-request-intake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-shield\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-sla-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-status-page-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-support-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-surveys\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-templates-and-views\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-workforce-management-and-smart-routing\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-workforce\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-automation-actions\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-bitbucket-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-internal-ops\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"opsgenie-onboarding\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-postmortem\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-url-shortener\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie-web-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"loom\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"loom-ai-evaluation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"projects-townsquare-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"rovo\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-ai-app-availability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-atlassian-intelligence-app-availability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-machine-learning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-natural-language-in-automation-rule-creation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-projects\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-smart-features-based-on-machine-learning-tecton-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-editor-ai-panels\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"rovo-dev\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-dev-agents\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"statuspage\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"studio\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"talent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"teams-directory-frontend\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"teams-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"teams-profile-media-token-fetch\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"teams-third-party-invites\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"unified-profile\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"user-provided-banners-on-profile-pictures\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"trello\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"trello-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"anti-abuse-classification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"core-anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"atlassian-cli\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"atlassian-new-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-analytics-chart-export\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-monolith\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-rovo-skills\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"automation-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"admin-experience-connector\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-barrel-next-gen\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-barrel\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-network-and-key-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"automation-platform-actions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-branches\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-conditions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-legacy\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-sieve\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-triggers\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-provisioner\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-automation-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"central-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"agentic-runtime-session-execution\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-3p-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"ai-3p-lifecycle\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-3p-permissions\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-managed-objects\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-safety\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"alta\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"convo-ai-legacy\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"convo-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"gen-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"knowledge-ai-tecton\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"knowledge-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"knowledge-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"machine-learning-platform-supporting-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"machine-learning-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"cloud-to-data-center-connection-bridge\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"code-assist\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"userbase-merge\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"commerce-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"commerce-platform-self-serve\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-commerce-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-configuration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-configuration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"orcs\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"org-policy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"site-admin\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"customer-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"druid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"link-paste-anonymization\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"plato-data-lake-proxy\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"plato-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"socrates-demux\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"starrocks\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"customer-facing-observability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"customer-support-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"aggregated-support-help\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"ecosystem-forge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-ecosystem-forge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"dac-get-help-widget\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"developer-atlassian-community\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"docs-atlassian-com\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ecosystem-oauth\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"ecosystem-outbound-auth-flow\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"expression-playground\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"forge-ac-checker-fedramp\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-ac-checker\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"forge-app-client-events\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-apps-bff\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-cli\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-developer-console\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-entity-storage\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-object-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-remote-capabilities\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-runtime-logs-api\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-sql-storage\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-storage-control-plane\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"forge-system-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-ui-ic-cdn-auth\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}}}},\"editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"block-service\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"real-time-presence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"experience-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-experience-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"growth-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"auto-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"bxp-signup\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-growth-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"cross-flow\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"feedback-collection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"growth-content-generation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"growth-unified-profile\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"identity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"authz-consistency-checker\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"core-identity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-cache\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"identity-core-post-m4\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-deprecated-for-gcp-m5\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-gsuite-bridge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"identity-microsoft-azure-ad-bridge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"identity-mobile-integrity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"identity-userbase-merge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"identity-virality\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"suspicious-login-blocking\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"learning-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"marketplace\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"marketplace-amkt-fe-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"marketplace-app-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"data-center-to-agc\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"migration-link-fixing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"migrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"ai-powered-migration-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"app-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"brie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"continuous-import-export-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-migrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"dare-app-migration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"data-center-to-cloud-migration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"file-migration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"lio-synthetic-consumer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"media-migration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"migration-admin-ui\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"sandbox-promotion\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"monolith-key-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"navigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-navigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"navigation-home-entry-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"navigation-identity-ic-routing\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"navigation-switcher-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"navigation-switcher-rovo-scas-visibility\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"units-icons\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"notifications-fpn-link\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"post-office\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-post-office\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-mail-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"post-office-rml-frontend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"product-integrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-product-integrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"external-user-directory-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"gitlab-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"google-workspace-apps-integrations\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"sign-in-with-slack-usage-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"product-license-enforcement-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-product-license-enforcement-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"reporting-lines\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-reporting-lines\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"search-identity-dare-isolated\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"search-identity-user-validator\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"search-townsquare-tab\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"user-search-indexing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"xpsearch-forward-store\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-third-party-smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"core-smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"linking-platform-cdn\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"linking-platform-user-preferences\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"stakeholder-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"collaboration-graph\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"core-teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"flock\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"usage-based-pricing-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"usage-tracking-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-usage-tracking-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"user-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"user-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-platform-deployer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"atlassian-secure-sandbox-platform\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-workflow-platform-temporal\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"batched-data-replication-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-batched-data-replication-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"kamino-ingestion\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"kamino-portal\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"batched-data-replication-platform-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-batched-data-replication-platform-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"browser-remote-update-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"build-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"artifact-distribution\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"deployment-gating\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"deployments\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"kitt-source-control\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"racs-refapp-archetype\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"racs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"secrets\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"change-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"change-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"experimentation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"feature-flag\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"flag-distribution\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"cloud-governance-and-inventory\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cdp-cell-provisioning\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}}}},\"cloud-telemetry\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"compliance-posture-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"configuration-distribution\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"config-registry\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"shipyard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"consent-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"consenthub\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"core-network-automation-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cdp-network\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"fedramp-network\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"isolated-cloud-network\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"core-network-automation-telemetry\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cna-theia\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"cna-theid\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}}}},\"cross-boundary-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-cross-boundary-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"cpg-federal\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"data-policy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"icg-commercial\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"icg-ic\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"isolated-cloud-network\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-data-lake-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-access-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-center-diagnostics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"data-depot-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-depot-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"data-depot-legacy-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-exchange-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"phoenix-tester\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"pubsub-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"queuing-platform\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}},\"streaming-processing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"streaming-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"topic-osb\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"emperor-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-platform-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-platform-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"hydra\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"pii-mapper\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"data-store-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-data-store-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"postgres-telemetry-agent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"telemetry-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"detection-and-response-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"region-failover-orchestration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"edge-cloudfront\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"edge-diagnostics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"edge-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"edge-sliver-refapp-archetype\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}},\"envoy-partitions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"encryption-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cryptor-ref-client\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"cryptor\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"kms-proxy\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"environment-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"error-tracking-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"sentry-opsgenie-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"event-demux-and-routing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-event-demux-and-routing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"event-demux\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"flight-deck-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"gasv3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"analytics-service\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"gasv3-tester\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"golden-ami\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"rapid-investigation-framework\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"internal-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"airlock-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"job-execution-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-execution-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"job-orchestration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-orchestration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"kitt-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlaskube\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"kitt-fleet-scoped\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"kitt-fleet-unscoped\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"kitt-fleet\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"logging-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"management-plane\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"media-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-media-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"media-cdn-delivery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"media-control-plane\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"messaging-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"metrics-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-network-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"network-extension-routing\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"observability-visualization-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"opensearch\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"per-tenant-loop\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"performance-testing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"provisioning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"core-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"public-backend-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-public-backend-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"heimdall-tester\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"hofund-platform-tester\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"relational-database-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"homa\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"postgresql\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"sql\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"release-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"release-tracks\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"resiliency-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"wiremock\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"security-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"service-authentication\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"identity-provider\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"key-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"poco\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"rollcall\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"slauth\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"service-mesh\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"sp-ref-kitt-consumer-archetype\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}},\"sp-ref-kitt-provider\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false}}}},\"shard-and-cell-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"raptor-archetype\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"shard-lifecycle-service\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"slauth-auth-slack-notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"software-system-of-record-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"staff-directory\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"static-app-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cookie-reference-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"ssr-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"static-app-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"statsig\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"atlassian-statsig-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"targeting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-targeting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tdp-control-plane\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"tdp-entity-relationship-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tdp-entity-relationship-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tdp-object-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tdp-object-store\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tenant-context\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-context\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"tcs-ref-client\":{\"compositions\":{\"cc\":false,\"ic\":false,\"fm\":false},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"tenant-lifecycle\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"tenant-data-destroyer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"tenant-passivation-removal\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"testing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"polliwhirl\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"testing-platform-legacy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"tracing-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"vector-database\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"violation-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"volt-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"volt-platform-app\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"availabilityMetadata\":{\"ic\":{\"preRelease\":true}}}}},\"workplace-infra\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}}}}");

});


parcelRegister("8vWVR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY
];
var $632eeeb7fe2dcbfd$var$UnderAuditPhase;
(function(UnderAuditPhase) {
    UnderAuditPhase["INTERNAL_AUDIT"] = "internal-audit";
    UnderAuditPhase["EXTERNAL_AUDIT"] = "external-audit";
})($632eeeb7fe2dcbfd$var$UnderAuditPhase || (module.exports.UnderAuditPhase = $632eeeb7fe2dcbfd$var$UnderAuditPhase = {}));

});


parcelRegister("eQHTz", function(module, exports) {
"use strict";
/**
 * Manages feature overrides stored in browser localStorage.
 * No-ops when not in a browser context.
 *
 * localStorage key: "AEM_FEATURE_OVERRIDES"
 * localStorage value: JSON-encoded string mapping "{environmentBlockName}::{featureName}" to boolean
 *
 * Example:
 *   "AEM_FEATURE_OVERRIDES": "{\"confluence::my_feature\":true,\"jira::other_feature\":false}"
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllOverrides = module.exports.clearFeatureOverride = module.exports.overrideFeature = module.exports.getFeatureOverride = module.exports.STORAGE_KEY = void 0;
module.exports.STORAGE_KEY = "AEM_FEATURE_OVERRIDES";
function $acf7f8b488a69cd5$var$buildKey(environmentBlockName, featureName) {
    return `${environmentBlockName}::${featureName}`;
}
function $acf7f8b488a69cd5$var$isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}
function $acf7f8b488a69cd5$var$getOverridesMap() {
    const featureOverrideValue = window.localStorage.getItem(module.exports.STORAGE_KEY);
    if (featureOverrideValue) try {
        return JSON.parse(featureOverrideValue);
    } catch (e) {
        console.warn("Failed to parse AEM_FEATURE_OVERRIDES from localStorage", e);
    }
    return {};
}
function $acf7f8b488a69cd5$var$setOverridesMap(map) {
    window.localStorage.setItem(module.exports.STORAGE_KEY, JSON.stringify(map));
}
/**
 * Returns the override value for a feature if one exists, or null if no override is set.
 * Returns null in non-browser environments.
 */ function $acf7f8b488a69cd5$var$getFeatureOverride(environmentBlockName, featureName) {
    if (!$acf7f8b488a69cd5$var$isBrowserEnvironment()) return null;
    const map = $acf7f8b488a69cd5$var$getOverridesMap();
    const key = $acf7f8b488a69cd5$var$buildKey(environmentBlockName, featureName);
    if (key in map) return map[key];
    return null;
}
module.exports.getFeatureOverride = $acf7f8b488a69cd5$var$getFeatureOverride;
/**
 * Sets a feature override in localStorage.
 */ function $acf7f8b488a69cd5$var$overrideFeature(environmentBlockName, featureName, value) {
    if (!$acf7f8b488a69cd5$var$isBrowserEnvironment()) return;
    const map = $acf7f8b488a69cd5$var$getOverridesMap();
    map[$acf7f8b488a69cd5$var$buildKey(environmentBlockName, featureName)] = value;
    $acf7f8b488a69cd5$var$setOverridesMap(map);
}
module.exports.overrideFeature = $acf7f8b488a69cd5$var$overrideFeature;
/**
 * Removes a single feature override from localStorage. Removes the key entirely if no overrides are left.
 */ function $acf7f8b488a69cd5$var$clearFeatureOverride(environmentBlockName, featureName) {
    if (!$acf7f8b488a69cd5$var$isBrowserEnvironment()) return;
    const map = $acf7f8b488a69cd5$var$getOverridesMap();
    delete map[$acf7f8b488a69cd5$var$buildKey(environmentBlockName, featureName)];
    if (Object.keys(map).length === 0) window.localStorage.removeItem(module.exports.STORAGE_KEY);
    else $acf7f8b488a69cd5$var$setOverridesMap(map);
}
module.exports.clearFeatureOverride = $acf7f8b488a69cd5$var$clearFeatureOverride;
/**
 * Clears all feature overrides from localStorage.
 */ function $acf7f8b488a69cd5$var$clearAllOverrides() {
    if (!$acf7f8b488a69cd5$var$isBrowserEnvironment()) return;
    window.localStorage.removeItem(module.exports.STORAGE_KEY);
}
module.exports.clearAllOverrides = $acf7f8b488a69cd5$var$clearAllOverrides;

});

parcelRegister("9Mbnm", function(module, exports) {

var $gIMgJ = parcelRequire("gIMgJ");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEnvironmentType = module.exports.isSSR = void 0;
/** Returns true when running in a server-side rendering context (no browser window). */ function $71e16bc53752fcca$var$isSSR() {
    return typeof window === "undefined" || typeof document === "undefined" || Boolean(typeof $gIMgJ !== "undefined" && $gIMgJ && $gIMgJ.env && undefined); // see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/7377575ff0ec8a6f78257788b224e37c2bae8f66/platform/packages/editor/editor-common/src/core-utils/is-ssr.ts#lines-6
}
module.exports.isSSR = $71e16bc53752fcca$var$isSSR;
/**
 * Returns the current environment type.
 * Defaults to "prod" in unknown cases.
 *
 * In SSR contexts, reads from globalThis.ssrContext.environmentType.
 * In browser contexts, infers from window.location.hostname.
 */ function $71e16bc53752fcca$var$getEnvironmentType() {
    // 1. SSR: Use ssrContext if available
    if (typeof window === "undefined") {
        // @ts-expect-error — ssrContext in globalThis type
        const ssrContext = globalThis.ssrContext;
        if (ssrContext && ssrContext.environmentType) {
            const type = ssrContext.environmentType;
            if (type === "dev") return "non-prod";
            if (type === "staging") return "non-prod";
            if (type === "prod") return "prod";
        }
        return "prod";
    }
    // 2. Browser: Use hostname-based detection with all patterns
    const host = window.location.hostname.toLowerCase();
    if (!host) // default to prod if no location available
    return "prod";
    // Exact matches
    if (host === "localhost" || host === "127.0.0.1") return "non-prod";
    // Staging patterns
    if (host.endsWith(".jira-dev.com") || host.includes(".stg.") || host.includes(".staging.") || host.endsWith(".atlassian-stg-fedm.net") || host.endsWith(".atlassian-stg-fedm.com")) return "non-prod";
    // Development patterns
    if (host.includes(".dev.") || host.includes(".ddev.")) return "non-prod";
    if (host.endsWith(".atlassian.net") || host.endsWith(".atlassian-us-gov-mod.com") || host.endsWith(".atlassian.com")) return "prod";
    return "prod";
}
module.exports.getEnvironmentType = $71e16bc53752fcca$var$getEnvironmentType;

});



parcelRegister("9qTx3", function(module, exports) {
$parcel$export(module.exports, "default", () => $056b909d372cc5a8$export$2e2bcd8739ae039);

var $jBnvq = parcelRequire("jBnvq");
const $056b909d372cc5a8$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $056b909d372cc5a8$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($056b909d372cc5a8$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$056b909d372cc5a8$export$7bc189309d2ad463];
            else {
                // Initialise InteractionSessionTracking on global window object
                window[$056b909d372cc5a8$export$7bc189309d2ad463] = new (0, $jBnvq.default)();
                interactionSessionTracking = window[$056b909d372cc5a8$export$7bc189309d2ad463];
            }
        } catch (error) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}

});
parcelRegister("jBnvq", function(module, exports) {
$parcel$export(module.exports, "INTERACTION_SESSION_ID_UPDATED_EVENT", () => $7b823907c3e85ae6$export$5d4c4eab0863aae3);
$parcel$export(module.exports, "default", () => $7b823907c3e85ae6$export$2e2bcd8739ae039);

var $iIQGE = parcelRequire("iIQGE");
const $7b823907c3e85ae6$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
const $7b823907c3e85ae6$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
const $7b823907c3e85ae6$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
const $7b823907c3e85ae6$export$285f6bddd927a06d = 1800000; // 30 minutes
const $7b823907c3e85ae6$export$d050a4cab1b9f734 = 86400000; // 24 hours
const $7b823907c3e85ae6$export$a92e915d70316eb2 = 5000; // 5 seconds
const $7b823907c3e85ae6$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $7b823907c3e85ae6$var$INTEGER_REGEX = /^\d+$/;
const $7b823907c3e85ae6$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
class $7b823907c3e85ae6$export$2e2bcd8739ae039 {
    constructor(){
        this.analyticsReady = false;
        this.generateNewSessionId = ()=>{
            if (!this.analyticsReady) return null;
            const currentSessionId = this.safeSessionStorage.getItem($7b823907c3e85ae6$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            const newSessionId = Date.now().toString();
            this.safeSessionStorage.setItem($7b823907c3e85ae6$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            const { isValidSession: isValidSession } = this.getCurrentSessionParams();
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                this.safeSessionStorage.setItem($7b823907c3e85ae6$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                this.sendInteractionSessionEvent('renewed');
            } else this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($7b823907c3e85ae6$export$5d4c4eab0863aae3));
            return newSessionId;
        };
        this.updateSessionExpiry = ()=>{
            const expiry = Date.now() + this.sessionExpiryTime;
            this.safeSessionStorage.setItem($7b823907c3e85ae6$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this.debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { updateSessionExpiry: updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this.sessionExpiryDebounceThresholdPercentage * this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (this.sessionExpiryDebounceTimer) clearTimeout(this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this.sessionExpiryDebounceTimer = setTimeout(()=>{
                    updateSessionExpiry();
                }, this.sessionExpiryDebounce);
            }
        };
        this.sessionExpiryTime = $7b823907c3e85ae6$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $7b823907c3e85ae6$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $7b823907c3e85ae6$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $iIQGE.default)();
    }
    getCurrentInteractionSessionId() {
        try {
            const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this.getCurrentSessionParams();
            // If we have an existing valid session we can return the sessionId straight away
            if (isValidSession) {
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return sessionId;
            }
            // To generate a new session ID we must ensure analytics is ready
            if (this.analyticsReady) {
                // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                // into issues of calls attempting to read the session ID before a valid expiry had been set
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return this.generateNewSessionId();
            }
        } catch (err) {
        // Silently swallow exception
        }
        return null;
    }
    getPreviousInteractionSessionId() {
        return this.safeSessionStorage.getItem($7b823907c3e85ae6$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
    }
    setInteractionSessionId(persistedSessionId) {
        if (this.validateSessionId(persistedSessionId)) {
            const currentSessionId = this.safeSessionStorage.getItem($7b823907c3e85ae6$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            // If we are already on the required session ID, just return true and make no changes
            // This can happen if the persisted session ID in options is the same as the current session ID
            // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
            // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
            if (currentSessionId === persistedSessionId) return false;
            // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
            // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(0);
            this.safeSessionStorage.setItem($7b823907c3e85ae6$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
            this.safeSessionStorage.removeItem($7b823907c3e85ae6$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            document.dispatchEvent(new Event($7b823907c3e85ae6$export$5d4c4eab0863aae3));
            return true;
        }
        return false;
    }
    // Must be called with a valid sendEvent function for other methods to work
    setAnalyticsCallback(sendEventCallback) {
        if (this.analyticsReady) // If we already have a valid callback, don't over-write it
        return;
        if (sendEventCallback && typeof sendEventCallback === 'function') {
            this.sendEventCallback = sendEventCallback;
            this.analyticsReady = true;
        } else this.analyticsReady = false;
    }
    validateSessionId(sessionId) {
        // Check if persisted session ID can parse as valid Unix timestamp
        if (sessionId && $7b823907c3e85ae6$var$INTEGER_REGEX.test(sessionId)) {
            const sessionAge = Date.now() - parseInt(sessionId, 10);
            // Validate that timestamp is not a future time, and is also within the TTL
            if (sessionAge >= 0 && sessionAge <= $7b823907c3e85ae6$export$d050a4cab1b9f734) return true;
        }
        return false;
    }
    /*
	 * This function retrieves the current session ID and expiry from SessionStorage
	 * It runs the necessary checks to ensure the session ID is valid and within expiry
	 *
	 * It returns the values along with a `validSession` boolean
	 */ getCurrentSessionParams() {
        const sessionId = this.safeSessionStorage.getItem($7b823907c3e85ae6$var$INTERACTION_SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this.safeSessionStorage.getItem($7b823907c3e85ae6$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
	 * This function sends a GASv3 analytics event indicating the interaction session has started or renewed
	 * It requires this.sendEventCallback to be set via Analytics Web Client to a valid operational event sender function
	 *
	 * Note that Analytics Web Client's callback function will make its own call to getCurrentInteractionSessionId to retrieve the session ID
	 * to attach to the event, so a valid session ID/expiry must be retrievable from SessionStorage before this function is called to avoid infinite loops.
	 *
	 * This is not an ideal solution but it works with the current architecture of Analytics Web Client.
	 */ sendInteractionSessionEvent(action) {
        this.sendEventCallback && this.sendEventCallback({
            action: action,
            actionSubject: 'interactionSession',
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ]
        });
    }
}

});
parcelRegister("iIQGE", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5e05dd00f4a962c$export$2e2bcd8739ae039);

var $jETI0 = parcelRequire("jETI0");

var $9osyD = parcelRequire("9osyD");
class $f5e05dd00f4a962c$export$2e2bcd8739ae039 extends (0, $9osyD.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = window.sessionStorage || (0, $jETI0.default);
        } catch (err) {
            storageToUse = (0, $jETI0.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("jETI0", function(module, exports) {
$parcel$export(module.exports, "default", () => $7becdd7365319feb$export$2e2bcd8739ae039);

var $9Q4B7 = parcelRequire("9Q4B7");
// eslint-disable-next-line import/no-anonymous-default-export
const $7becdd7365319feb$var$inmemorystorage = new (0, $9Q4B7.InMemoryStore)();
var $7becdd7365319feb$export$2e2bcd8739ae039 = $7becdd7365319feb$var$inmemorystorage;

});
parcelRegister("9Q4B7", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $33550c384d9977c0$export$90e3e001bcac59c7);
class $33550c384d9977c0$export$90e3e001bcac59c7 {
    constructor(){
        this.data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this.data[key] = value;
            this.length = Object.keys(this.data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this.data) return this.data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this.data) delete this.data[key];
            this.length = Object.keys(this.data).length;
            return null;
        };
        this.clear = ()=>{
            this.data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this.data)[index];
    }
}

});


parcelRegister("9osyD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4e890ea6a72ffb3$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $MJFr7 = parcelRequire("MJFr7");

var $jETI0 = parcelRequire("jETI0");

var $9yy5Y = parcelRequire("9yy5Y");
const $d4e890ea6a72ffb3$export$41c06fdd37b7e9a5 = 'awc';
const $d4e890ea6a72ffb3$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
class $d4e890ea6a72ffb3$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this.store;
        this.getItem = (key)=>this.store.getItem(this.createKey(key));
        this.removeItem = (key)=>this.store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this.store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this.store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this.store === (0, $jETI0.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this.store || {});
            let inMemoryStorage;
            if ((0, $9yy5Y.isSupported)(window[$d4e890ea6a72ffb3$export$770aa8bc07b3de03])) inMemoryStorage = window[$d4e890ea6a72ffb3$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $jETI0.default);
                if (!window[$d4e890ea6a72ffb3$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$d4e890ea6a72ffb3$export$770aa8bc07b3de03] = (0, $jETI0.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this.store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this.store = inMemoryStorage;
        };
        this.clear = ()=>this.store.clear();
        this.key = (index)=>this.store.key(index);
        this.getPrefix = ()=>this.prefix;
        this.createKey = (key)=>{
            if (this.prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($d4e890ea6a72ffb3$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $MJFr7.envType).PROD) prefixes.push(options.envPrefix);
        this.prefix = prefixes.join('-');
        if ((0, $9yy5Y.isSupported)(storageToUse)) this.store = storageToUse;
        else this.swapToInMemory();
    }
}

});
parcelRegister("MJFr7", function(module, exports) {
$parcel$export(module.exports, "envType", () => $5e967e0c6aa51274$export$56ac8ebc9870b1b9);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // This type has been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $5e967e0c6aa51274$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});

});

parcelRegister("9yy5Y", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $ba2df777ad6843e2$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ function $ba2df777ad6843e2$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});






parcelRegister("c0bP9", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $1f7eb51b83b53338$export$81d16f1428ce0486);
$parcel$export(module.exports, "generateUrlWithParams", () => $1f7eb51b83b53338$export$2e3999ec51334ffe);
const $1f7eb51b83b53338$export$81d16f1428ce0486 = 'xpis';
const $1f7eb51b83b53338$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    let partialUrl = false;
    let urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch  {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($1f7eb51b83b53338$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

});

parcelRegister("3IGfS", function(module, exports) {
$parcel$export(module.exports, "validProducts", () => $eab992c9ed553417$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
const $eab992c9ed553417$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom',
    'atlassianStudio',
    'bitbucket',
    'admin',
    'mercury',
    'talent',
    'trello',
    'analyticsVisualizationPlatform'
];

});

parcelRegister("lS5kg", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c983563ee2f23da$export$2e2bcd8739ae039);

var $1shin = parcelRequire("1shin");

var $8nQRc = parcelRequire("8nQRc");

var $JYWrF = parcelRequire("JYWrF");
const $7c983563ee2f23da$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = (0, $8nQRc.defaultHistoryReplaceFn))=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $1shin.parseUrl)(removedFragmentURL);
    const captureParams = (0, $JYWrF.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $JYWrF.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $1shin.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7c983563ee2f23da$export$2e2bcd8739ae039 = $7c983563ee2f23da$var$urlParamExtractor;

});
parcelRegister("1shin", function(module, exports) {
$parcel$export(module.exports, "stringify", () => $10f5d27bf4463635$export$fac44ee5b035f737, (v) => $10f5d27bf4463635$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $10f5d27bf4463635$export$7a5253c0f62e0150, (v) => $10f5d27bf4463635$export$7a5253c0f62e0150 = v);
var $10f5d27bf4463635$export$f9380c9a627682d3;
var $10f5d27bf4463635$export$98e6a39c04603d36;
var $10f5d27bf4463635$export$fac44ee5b035f737;
var $10f5d27bf4463635$export$7a5253c0f62e0150;
var $10f5d27bf4463635$export$a8c1621ea79325d3;
var $10f5d27bf4463635$export$357523c63a2253b9;
var $10f5d27bf4463635$export$44c361b8ec72ef7f;
'use strict';

var $2M9Wc = parcelRequire("2M9Wc");

var $e9Lvx = parcelRequire("e9Lvx");

var $c6Dsu = parcelRequire("c6Dsu");

var $kO9sb = parcelRequire("kO9sb");
const $10f5d27bf4463635$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $10f5d27bf4463635$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $10f5d27bf4463635$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $10f5d27bf4463635$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $10f5d27bf4463635$var$encode(key, options),
                            '[',
                            $10f5d27bf4463635$var$encode(index, options),
                            ']=',
                            $10f5d27bf4463635$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $10f5d27bf4463635$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $10f5d27bf4463635$var$encode(key, options),
                            '[]=',
                            $10f5d27bf4463635$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $10f5d27bf4463635$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $10f5d27bf4463635$var$encode(key, options),
                            ':list=',
                            $10f5d27bf4463635$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $10f5d27bf4463635$var$encode(key, options),
                                keyValueSep,
                                $10f5d27bf4463635$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $10f5d27bf4463635$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $10f5d27bf4463635$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $10f5d27bf4463635$var$encode(key, options),
                            '=',
                            $10f5d27bf4463635$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $10f5d27bf4463635$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $10f5d27bf4463635$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $10f5d27bf4463635$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$10f5d27bf4463635$var$decode(item, options)) : value === null ? value : $10f5d27bf4463635$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $10f5d27bf4463635$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$10f5d27bf4463635$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $10f5d27bf4463635$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $10f5d27bf4463635$var$encode(value, options) {
    if (options.encode) return options.strict ? $2M9Wc(value) : encodeURIComponent(value);
    return value;
}
function $10f5d27bf4463635$var$decode(value, options) {
    if (options.decode) return $e9Lvx(value);
    return value;
}
function $10f5d27bf4463635$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $10f5d27bf4463635$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $10f5d27bf4463635$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $10f5d27bf4463635$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $10f5d27bf4463635$var$extract(input) {
    input = $10f5d27bf4463635$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $10f5d27bf4463635$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $10f5d27bf4463635$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $10f5d27bf4463635$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $10f5d27bf4463635$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $c6Dsu(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $10f5d27bf4463635$var$decode(value, options);
        formatter($10f5d27bf4463635$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $10f5d27bf4463635$var$parseValue(value[k], options);
        else ret[key] = $10f5d27bf4463635$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $10f5d27bf4463635$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$10f5d27bf4463635$export$f9380c9a627682d3 = $10f5d27bf4463635$var$extract;
$10f5d27bf4463635$export$98e6a39c04603d36 = $10f5d27bf4463635$var$parse;
$10f5d27bf4463635$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $10f5d27bf4463635$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $10f5d27bf4463635$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $10f5d27bf4463635$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $10f5d27bf4463635$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $10f5d27bf4463635$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $10f5d27bf4463635$var$encode(key, options) + '=' + $10f5d27bf4463635$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$10f5d27bf4463635$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $c6Dsu(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $10f5d27bf4463635$var$parse($10f5d27bf4463635$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $10f5d27bf4463635$var$decode(hash, options)
    } : {});
};
$10f5d27bf4463635$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$10f5d27bf4463635$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $10f5d27bf4463635$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $10f5d27bf4463635$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $10f5d27bf4463635$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $10f5d27bf4463635$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $10f5d27bf4463635$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$10f5d27bf4463635$var$encodeFragmentIdentifier] ? $10f5d27bf4463635$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$10f5d27bf4463635$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$10f5d27bf4463635$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $10f5d27bf4463635$export$7a5253c0f62e0150(input, options);
    return $10f5d27bf4463635$export$a8c1621ea79325d3({
        url: url,
        query: $kO9sb(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$10f5d27bf4463635$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $10f5d27bf4463635$export$357523c63a2253b9(input, exclusionFilter, options);
};

});

parcelRegister("8nQRc", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $3df87150f1d6ce08$export$600dd5bf1b049f11);
const $3df87150f1d6ce08$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);

});

parcelRegister("JYWrF", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $8f9590dbb5c28388$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $8f9590dbb5c28388$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $8f9590dbb5c28388$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $8f9590dbb5c28388$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $8f9590dbb5c28388$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $8f9590dbb5c28388$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $8f9590dbb5c28388$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $8f9590dbb5c28388$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $8f9590dbb5c28388$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $8f9590dbb5c28388$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $8f9590dbb5c28388$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $8f9590dbb5c28388$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $8f9590dbb5c28388$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$8f9590dbb5c28388$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $8f9590dbb5c28388$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});



parcelRegister("bap8Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $8bf71bec129b200e$export$2e2bcd8739ae039);


var $8i2EM = parcelRequire("8i2EM");

var $eQ9x8 = parcelRequire("eQ9x8");
class $8bf71bec129b200e$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $a858cae85500b1b2$export$cf090d5281b5ae06), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $a858cae85500b1b2$export$8575e30be0feb909)) : (0, $a858cae85500b1b2$export$8575e30be0feb909);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $eQ9x8.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $eQ9x8.StopLowPriorityEventDelayReason).MANUAL)=>{
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            this.delayCallback?.(reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $8i2EM.default)(fireDelayedEvent, compressors);
    }
}

});
const $a858cae85500b1b2$export$cf090d5281b5ae06 = 10000;
const $a858cae85500b1b2$export$8575e30be0feb909 = 30000;

parcelRegister("8i2EM", function(module, exports) {
$parcel$export(module.exports, "default", () => $680af33dfc8e2b4b$export$2e2bcd8739ae039);

var $1LxMA = parcelRequire("1LxMA");

var $JYWrF = parcelRequire("JYWrF");

var $4lp2K = parcelRequire("4lp2K");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $680af33dfc8e2b4b$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $680af33dfc8e2b4b$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $680af33dfc8e2b4b$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $680af33dfc8e2b4b$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $680af33dfc8e2b4b$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $JYWrF.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $JYWrF.equals)(group.userInfo, args.userInfo) && (0, $JYWrF.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $1LxMA.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $4lp2K.default)(compressionRules);
    }
}

});
parcelRegister("4lp2K", function(module, exports) {
$parcel$export(module.exports, "default", () => $38569cb430c01c5e$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $jcAyj = parcelRequire("jcAyj");

var $JYWrF = parcelRequire("JYWrF");

var $dwKyh = parcelRequire("dwKyh");
class $38569cb430c01c5e$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $jcAyj.buildActionFields)(event, event.eventType);
                    contextFields = (0, $JYWrF.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $JYWrF.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $dwKyh.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("dwKyh", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $03a4873b59e3f2cf$export$89b3253ddfd2e6e8);

var $iHF0g = parcelRequire("iHF0g");

var $JYWrF = parcelRequire("JYWrF");

var $eIOKf = parcelRequire("eIOKf");

var $4IQeo = parcelRequire("4IQeo");
class $03a4873b59e3f2cf$export$89b3253ddfd2e6e8 {
    /**
	 * @callback EventPredicate
	 * @param {object} event An analytics event
	 * @returns {boolean} A flag indicating whether or not the event matches the conditions
	 */ /**
	 * @callback CompressionFunction
	 * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
	 * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
	 */ /**
	 * This constructor defines a new rule for compressing analytics events.
	 * @param {EventPredicate} predicate
	 * @param {CompressionFunction} compressFn
	 */ constructor(predicate, compressFn){
        /**
	 * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
	 * @param event
	 * @returns {boolean}
	 */ this.canCompress = (event)=>{
            try {
                return event && (0, $iHF0g.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
	 * This function compresses as many events in the given collection as possible.<p>
	 * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
	 * appended to the end of the resulting array.
	 *
	 * @param events A collection of analytic events to compress
	 * @returns {Array.<Object>} The action fields for the resulting compressed events
	 */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $JYWrF.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $4IQeo.validateActionEventType)(event.eventType);
                (0, $eIOKf.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("iHF0g", function(module, exports) {
$parcel$export(module.exports, "isActionEventType", () => $f3cf26d92ace4f1b$export$d19cebda16f7579a);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $hIipg = parcelRequire("hIipg");
function $f3cf26d92ace4f1b$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $hIipg.eventType).OPERATIONAL:
        case (0, $hIipg.eventType).TRACK:
        case (0, $hIipg.eventType).UI:
            return true;
        default:
            return false;
    }
}

});

parcelRegister("eIOKf", function(module, exports) {
$parcel$export(module.exports, "validateActionEvent", () => $6e30b1da5054d5e7$export$e0c121325c66ed4c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $izroy = parcelRequire("izroy");
function $6e30b1da5054d5e7$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    (0, $izroy.validateContainers)(event.containers);
}

});
parcelRegister("izroy", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $d65d524b827adc49$export$e63ea5d8477971d3);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $7Xodo = parcelRequire("7Xodo");
function $d65d524b827adc49$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>(0, $7Xodo.validateContainersObject)(container));
}

});
parcelRegister("7Xodo", function(module, exports) {
$parcel$export(module.exports, "validateContainersObject", () => $2101337da89e113e$export$df8ff30e3c960006);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $d98zn = parcelRequire("d98zn");
function $2101337da89e113e$export$df8ff30e3c960006(container) {
    if (!(0, $d98zn.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}

});



parcelRegister("4IQeo", function(module, exports) {
$parcel$export(module.exports, "validateActionEventType", () => $ee82e938ac019155$export$4a8d7476662aebcc);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $hIipg = parcelRequire("hIipg");

var $iHF0g = parcelRequire("iHF0g");
const $ee82e938ac019155$var$actionEventTypes = Object.freeze([
    (0, $hIipg.eventType).OPERATIONAL,
    (0, $hIipg.eventType).TRACK,
    (0, $hIipg.eventType).UI
]);
function $ee82e938ac019155$export$4a8d7476662aebcc(type) {
    if (!(0, $iHF0g.isActionEventType)(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$ee82e938ac019155$var$actionEventTypes}]`);
    return true;
}

});




parcelRegister("eQ9x8", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $f6318f00d24d20c3$export$fa6e3729c21cb8f);
var $f6318f00d24d20c3$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("aO4YE", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c70f85d739c7aee$export$2e2bcd8739ae039);

var $6y5Yk = parcelRequire("6y5Yk");

var $4X9FF = parcelRequire("4X9FF");

var $jgjT6 = parcelRequire("jgjT6");

var $dpagP = parcelRequire("dpagP");

var $7NaFf = parcelRequire("7NaFf");

var $6oXlX = parcelRequire("6oXlX");

var $cep6Q = parcelRequire("cep6Q");

var $bDn8X = parcelRequire("bDn8X");

var $lCUtP = parcelRequire("lCUtP");

var $crx0o = parcelRequire("crx0o");

var $kWgqd = parcelRequire("kWgqd");

var $eeQEx = parcelRequire("eeQEx");

var $6qny7 = parcelRequire("6qny7");

var $7n4aj = parcelRequire("7n4aj");

var $6i6sY = parcelRequire("6i6sY");

var $4AUeK = parcelRequire("4AUeK");
class $5c70f85d739c7aee$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
}
class $5c70f85d739c7aee$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $5c70f85d739c7aee$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $5c70f85d739c7aee$export$2e2bcd8739ae039 {
    constructor(options){
        this.originTracingClient = null;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: this.lastSendEventsError?.message || null,
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: metadataInfo?.props || null,
                metadataClientMetrics: this.metadataClient?.metrics || null
            };
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                this.applyExclusions(item);
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $7n4aj.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                this.originTracingClient?.cleanupOriginParameters(items);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $lCUtP.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $kWgqd.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $6i6sY.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $kWgqd.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $cep6Q.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $4AUeK.default)(this.options?.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $4X9FF.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $6y5Yk.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $6i6sY.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $6i6sY.SegmentEventTypes).TRACK,
            properties: (0, $6qny7.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $6i6sY.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $6i6sY.SegmentEventTypes).PAGE,
            properties: (0, $6qny7.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $6i6sY.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $6i6sY.SegmentEventTypes).IDENTIFY,
            traits: (0, $6qny7.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $eeQEx.prepareEventContext)(context);
        const segmentContext = (0, $6oXlX.buildContext)(clonedContext, overrides);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $jgjT6.default)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    applyExclusions(item) {
        const msg = item.msg;
        const properties = msg.properties;
        const traits = msg.traits;
        const excluded = msg.context?.excludedProperties;
        if (!excluded) return;
        if (excluded.anonymousId === true) msg.anonymousId = undefined;
        if (excluded.interactionSession === true) {
            if (properties) properties.interactionSession = undefined;
        }
        if (excluded.sessionId === true) {
            if (properties) properties.sessionId = undefined;
        }
        if (excluded.pageLoadId === true) {
            if (properties) properties.pageLoadId = undefined;
        }
        if (excluded.tabId === true) {
            if (properties) properties.tabId = undefined;
        }
        if (excluded.taskSessions === true) {
            if (properties) properties.taskSessions = undefined;
        }
        if (excluded.userId === true) {
            msg.userId = undefined;
            if (properties) properties.userIdType = undefined;
        }
        if (excluded.xid === true) {
            if (properties) properties.xid = undefined;
            if (traits) traits.xid = undefined;
        }
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo?.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch  {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $5c70f85d739c7aee$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $5c70f85d739c7aee$var$Message(responseObject.message?.error || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $5c70f85d739c7aee$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $dpagP.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    /** @internal Used by AnalyticsWebClient to wire up origin tracing cleanup. */ setOriginTracingClient(client) {
        this.originTracingClient = client;
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
}
class $5c70f85d739c7aee$var$BatchInterceptor {
    static{
        this.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;
    }
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                analyticsAPIResponse.validationReports?.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new (0, $bDn8X.EventResponse)(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new (0, $7NaFf.AnalyticsResponse)(success, statusCode, (0, $crx0o.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = analyticsAPIResponse.message?.error !== null ? analyticsAPIResponse.message.error : (0, $crx0o.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $crx0o.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $crx0o.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $bDn8X.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $7NaFf.AnalyticsResponse)(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error?.message) {
            const match = error.message.match($5c70f85d739c7aee$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $bDn8X.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $7NaFf.AnalyticsResponse)(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new (0, $bDn8X.EventResponse)(item.msg.messageId, [], item.msg));
        });
        return new (0, $7NaFf.AnalyticsResponse)(false, -1, (0, $crx0o.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}

});
parcelRegister("6y5Yk", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a37180d403a22a6$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $h4E4L = parcelRequire("h4E4L");

var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$6a37180d403a22a6$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $h4E4L.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("h4E4L", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $d745cf08c813f039$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $d745cf08c813f039$export$2e2bcd8739ae039);

var $5Gd0x = parcelRequire("5Gd0x");

var $kwACA = parcelRequire("kwACA");

var $1veV1 = parcelRequire("1veV1");

var $lapZo = parcelRequire("lapZo");

var $cKlpa = parcelRequire("cKlpa");

var $4X9FF = parcelRequire("4X9FF");

var $4nqFi = parcelRequire("4nqFi");

var $76Ppe = parcelRequire("76Ppe");

var $ci1pT = parcelRequire("ci1pT");

var $lC88c = parcelRequire("lC88c");
const $d745cf08c813f039$var$ONE_MINUTE = 60000;
const $d745cf08c813f039$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $d745cf08c813f039$var$ONE_MINUTE,
    minRetryDelay: $d745cf08c813f039$var$ONE_MINUTE,
    maxRetryDelay: $d745cf08c813f039$var$ONE_MINUTE
};
const $d745cf08c813f039$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $d745cf08c813f039$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $1veV1.default)(product, {
            logger: logger,
            maxAttempts: options?.maxAttempts,
            maxEventLimit: options?.maxQueueSize || $d745cf08c813f039$export$d219df4fe04c04a7.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $76Ppe.default)({
            ...this.options,
            waitInterval: options?.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $76Ppe.default)({
            ...$d745cf08c813f039$var$LONG_POLLING_OPTIONS,
            waitInterval: $d745cf08c813f039$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $4X9FF.default)();
        this.networkStatus = new (0, $4nqFi.default)((status)=>{
            if (status === (0, $lC88c.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $lapZo.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $lC88c.NetworkStatusEnum).OFFLINE) {
            done((0, $ci1pT.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $cKlpa.CallbackProcessingErrorName)) {
                done((0, $ci1pT.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $5Gd0x.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $kwACA.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $lapZo.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $ci1pT.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $ci1pT.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $ci1pT.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || $d745cf08c813f039$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : $d745cf08c813f039$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || $d745cf08c813f039$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || $d745cf08c813f039$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || $d745cf08c813f039$export$d219df4fe04c04a7.flushWaitMs,
            maxQueueSize: options?.maxQueueSize || $d745cf08c813f039$export$d219df4fe04c04a7.maxQueueSize,
            maxAttempts: options?.maxAttempts || $d745cf08c813f039$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || $d745cf08c813f039$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || $d745cf08c813f039$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("5Gd0x", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1f6a02954dbbe88$export$2e2bcd8739ae039);

var $e70g5 = parcelRequire("e70g5");

var $j9voX = parcelRequire("j9voX");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $e1f6a02954dbbe88$var$validSuffixs = Object.values((0, $e70g5.LocalStorageKeySuffix));
var $e1f6a02954dbbe88$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $e1f6a02954dbbe88$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $e70g5.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $j9voX.createLocalStorageKeys)(prefix, id);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(queue);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimStart);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("e70g5", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $ca44a64302627ed3$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $ca44a64302627ed3$export$8bb2c1fb2b1765a9);
var $ca44a64302627ed3$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $ca44a64302627ed3$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("j9voX", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $d66b5714be61a676$export$8433d54f767cbec5);

var $e70g5 = parcelRequire("e70g5");
const $d66b5714be61a676$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $e70g5.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $e70g5.LocalStorageKeySuffix).ACK}`,
        [(0, $e70g5.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $e70g5.LocalStorageKeySuffix).QUEUE}`,
        [(0, $e70g5.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $e70g5.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $e70g5.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $e70g5.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $e70g5.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $e70g5.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("kwACA", function(module, exports) {
$parcel$export(module.exports, "default", () => $019febb697e1a9cf$export$2e2bcd8739ae039);

var $jgjT6 = parcelRequire("jgjT6");

var $e70g5 = parcelRequire("e70g5");

var $j9voX = parcelRequire("j9voX");
const $019febb697e1a9cf$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $019febb697e1a9cf$var$findOtherQueues = (queuePrefix)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $e70g5.LocalStorageKeySuffix).ACK) try {
                // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $e70g5.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch  {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch  {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $019febb697e1a9cf$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(ack, start.toString());
    await $019febb697e1a9cf$var$promisedSetTimeout((0, $e70g5.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $e70g5.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $019febb697e1a9cf$var$promisedSetTimeout((0, $e70g5.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $e70g5.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $019febb697e1a9cf$var$reclaim(options, callback);
};
const $019febb697e1a9cf$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $019febb697e1a9cf$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $019febb697e1a9cf$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $019febb697e1a9cf$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.queue);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.inProgress);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimEnd);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.ack);
};
var $019febb697e1a9cf$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $jgjT6.default)();
    const queuesToReclaim = $019febb697e1a9cf$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$019febb697e1a9cf$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $j9voX.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});
parcelRegister("jgjT6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6c98f22f847fb33$export$2e2bcd8739ae039);
// UUID v4 generator with fallback for non-secure contexts
function $d6c98f22f847fb33$export$2e2bcd8739ae039() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch  {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

});


parcelRegister("1veV1", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b5b638a42c2971b$export$2e2bcd8739ae039);

var $ksrWU = parcelRequire("ksrWU");
var $8b5b638a42c2971b$export$2e2bcd8739ae039 = (0, $ksrWU.default);

});
parcelRegister("ksrWU", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5d1a4635653c48e$export$2e2bcd8739ae039);

var $lapZo = parcelRequire("lapZo");

var $78oXs = parcelRequire("78oXs");

var $8z91X = parcelRequire("8z91X");

var $jRiw1 = parcelRequire("jRiw1");

var $bTEoz = parcelRequire("bTEoz");

var $ipUV9 = parcelRequire("ipUV9");
class $e5d1a4635653c48e$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $78oXs.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $bTEoz.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $8z91X.default))) options.logger?.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
        }
        return new (0, $ipUV9.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $lapZo.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $lapZo.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $jRiw1.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $lapZo.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $ipUV9.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $lapZo.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("lapZo", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $26725212fb0136b8$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $26725212fb0136b8$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $26725212fb0136b8$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $26725212fb0136b8$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $26725212fb0136b8$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $26725212fb0136b8$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $26725212fb0136b8$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $26725212fb0136b8$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $26725212fb0136b8$export$7710d69e6f450f20);
const $26725212fb0136b8$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $26725212fb0136b8$export$8cad224051643259 = 'analytics-web-client';
const $26725212fb0136b8$export$3d8420be07b276ab = 'analytics-resilience';
const $26725212fb0136b8$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $26725212fb0136b8$export$89d9c1ff8ac91862 = 'timeAdded';
const $26725212fb0136b8$export$a37d385bcd713809 = 'retryAttempts';
const $26725212fb0136b8$export$6d8635fed0e4b14d = 15000;
var $26725212fb0136b8$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $26725212fb0136b8$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("78oXs", function(module, exports) {
$parcel$export(module.exports, "createOptionsWithDefaults", () => $55f87a4b40066c65$export$ddc6718318090f71);

var $7MhxY = parcelRequire("7MhxY");
const $55f87a4b40066c65$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $7MhxY.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $7MhxY.EVENT_COUNT_LIMIT)
    });

});
parcelRegister("7MhxY", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $fd98af4f63c9799f$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $fd98af4f63c9799f$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $fd98af4f63c9799f$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $fd98af4f63c9799f$export$1188664dfff364c8);
const $fd98af4f63c9799f$export$b6df3d334cec060f = 7;
const $fd98af4f63c9799f$export$14ef152a03a4b6ee = 60000;
const $fd98af4f63c9799f$export$da9ab7b2fd5998e8 = 10;
const $fd98af4f63c9799f$export$1188664dfff364c8 = 8000;

});


parcelRegister("8z91X", function(module, exports) {
$parcel$export(module.exports, "default", () => $21c1e1a3440976a4$export$2e2bcd8739ae039);
const $21c1e1a3440976a4$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $21c1e1a3440976a4$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $21c1e1a3440976a4$export$2e2bcd8739ae039.prototype);
        this.name = $21c1e1a3440976a4$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("jRiw1", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $f5d2edcf0647cdf3$export$74101021e0969375);

var $gT8qc = parcelRequire("gT8qc");

var $cKlpa = parcelRequire("cKlpa");

var $ijErU = parcelRequire("ijErU");
const $f5d2edcf0647cdf3$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $gT8qc.AbandonWriteErrorName) || errorWithName.name === (0, $cKlpa.CallbackProcessingErrorName) || errorWithName.name === (0, $ijErU.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("gT8qc", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $7e552a7c34a2053d$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $7e552a7c34a2053d$export$2e2bcd8739ae039);
const $7e552a7c34a2053d$export$ba95206613c96b28 = 'AbandonWriteError';
class $7e552a7c34a2053d$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $7e552a7c34a2053d$export$2e2bcd8739ae039.prototype);
        this.name = $7e552a7c34a2053d$export$ba95206613c96b28;
    }
}

});

parcelRegister("cKlpa", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $84cd2a2b1a82c571$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $84cd2a2b1a82c571$export$2e2bcd8739ae039);
const $84cd2a2b1a82c571$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $84cd2a2b1a82c571$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $84cd2a2b1a82c571$export$2e2bcd8739ae039.prototype);
        this.name = $84cd2a2b1a82c571$export$a409c8de90e11e14;
    }
}

});

parcelRegister("ijErU", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $81869f245df636f1$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $81869f245df636f1$export$2e2bcd8739ae039);
const $81869f245df636f1$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $81869f245df636f1$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $81869f245df636f1$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("bTEoz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e5bb982fd6e062a$export$2e2bcd8739ae039);

var $6tf5H = parcelRequire("6tf5H");

var $lapZo = parcelRequire("lapZo");

var $j7bx7 = parcelRequire("j7bx7");

var $78oXs = parcelRequire("78oXs");

var $7MhxY = parcelRequire("7MhxY");

var $cKlpa = parcelRequire("cKlpa");

var $ijErU = parcelRequire("ijErU");

var $8z91X = parcelRequire("8z91X");

var $jRiw1 = parcelRequire("jRiw1");

var $hl3GA = parcelRequire("hl3GA");

var $b5DV6 = parcelRequire("b5DV6");

var $96VBN = parcelRequire("96VBN");
class $9e5bb982fd6e062a$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $8z91X.default)());
                    }, (0, $lapZo.INDEXEDDB_TIMEOUT));
                    /*
				 * The database version number can never change.
				 * An upgrade transaction is limited to only one connection to the database.
				 * Once this is done, we cannot open any connections with older versions of the schema.
				 * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
				 *
				 * Due to the nature of how AWC is used (multiple tabs that are very long lived),
				 * we will not be able to run version upgrades via indexeddb.
				 *
				 * This does not mean we cant change what is stored in the tables,
				 * this limitation just prevents us from:
				 *   - Creating new ObjectStores in this database connection, and
				 *   - Creating new indexes on our ObjectStores
				 *
				 * Any upgrades we wish to run in the future will have to create a new database,
				 * and migrate all the data from older databases.
				 *
				 * This also means any migrations we make will have to be supported until we have evidence
				 * that no events are coming from old versions of the database.
				 * This may take a long time.
				 */ const request = window.indexedDB.open((0, $lapZo.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $lapZo.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $lapZo.TIME_TO_PROCESS_AFTER_INDEX), (0, $lapZo.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $lapZo.RETRY_INDEX), (0, $lapZo.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $lapZo.TIME_ADDED_INDEX), (0, $lapZo.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $lapZo.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $8z91X.default)());
                    };
                    try {
                        await (0, $96VBN.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $8z91X.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $8z91X.default)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $lapZo.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $j7bx7.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $lapZo.GuardPolicy).IGNORE) throw new (0, $ijErU.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $jRiw1.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $lapZo.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $j7bx7.convertToItemWrapper)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $jRiw1.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $7MhxY.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $7MhxY.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $lapZo.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $7MhxY.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $b5DV6.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $b5DV6.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $6tf5H.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $6tf5H.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $lapZo.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $96VBN.requestToPromise)(request);
            await (0, $6tf5H.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $7MhxY.GET_ITEM_COUNT))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $cKlpa.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $96VBN.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $lapZo.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $lapZo.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $78oXs.createOptionsWithDefaults)(options);
        this.namespace = namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $8z91X.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
		 *
		 * This class will enforce the number of analytics events we can store in our IndexedDB object store
		 * if asked before adding items to the object store.
		 */ this.globalEventLimitGuard = new (0, $hl3GA.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $lapZo.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("6tf5H", function(module, exports) {
$parcel$export(module.exports, "commitTransaction", () => $4a63666eb0ca25c3$export$feab8418f018df89);

var $gIUxN = parcelRequire("gIUxN");
const $4a63666eb0ca25c3$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return (0, $gIUxN.transactionToPromise)(transaction);
};

});
parcelRegister("gIUxN", function(module, exports) {
$parcel$export(module.exports, "transactionToPromise", () => $f4e9709c790e8a86$export$2a5213bce1720b42);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $f4e9709c790e8a86$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("j7bx7", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $9b80f63f7089d204$export$aec476f33d77be11);

var $jgjT6 = parcelRequire("jgjT6");
const $9b80f63f7089d204$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $jgjT6.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });

});

parcelRegister("hl3GA", function(module, exports) {
$parcel$export(module.exports, "default", () => $741c6fbcc7695a55$export$2e2bcd8739ae039);

var $6tf5H = parcelRequire("6tf5H");

var $lapZo = parcelRequire("lapZo");

var $gT8qc = parcelRequire("gT8qc");

var $96VBN = parcelRequire("96VBN");
class $741c6fbcc7695a55$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
	 * This query fetches the oldest events currently stored in AWC IndexedDb object store
	 * and deletes them sequentially
	 */ this.deleteOldestNEvents = async (objectStore, count)=>{
            const productTimeAddedIndex = objectStore.index((0, $lapZo.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $96VBN.requestToPromise)(getAllRequest);
            const result = event?.target?.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
	 * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
	 * will evict the oldest events in favour of the events we want to add.
	 *
	 * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
	 *
	 * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
	 *
	 * @param countOfEventsToAdd - The number of events we are proposing to add.
	 */ async insertItems(objectStore, items, policy = (0, $lapZo.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $lapZo.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $lapZo.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $lapZo.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $96VBN.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $6tf5H.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $gT8qc.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
	 * This query returns the count of items held in AWC IndexedDB object store per product.
	 */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $lapZo.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $96VBN.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("96VBN", function(module, exports) {
$parcel$export(module.exports, "requestToPromise", () => $2d09e4a302b23822$export$85ceed0783e42041);
// Not to be used on cursors or other requests that may call onsuccess multiple times.
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $2d09e4a302b23822$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("b5DV6", function(module, exports) {
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $cac96b83f41a3874$export$342d941b6f724995);
const $cac96b83f41a3874$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});


parcelRegister("ipUV9", function(module, exports) {
$parcel$export(module.exports, "default", () => $40ec21350100e9c7$export$2e2bcd8739ae039);

var $lapZo = parcelRequire("lapZo");

var $j7bx7 = parcelRequire("j7bx7");

var $78oXs = parcelRequire("78oXs");

var $7MhxY = parcelRequire("7MhxY");

var $cKlpa = parcelRequire("cKlpa");

var $ijErU = parcelRequire("ijErU");

var $jVyx7 = parcelRequire("jVyx7");
class $40ec21350100e9c7$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $78oXs.createOptionsWithDefaults)(options);
        /**
		 * This class will enforce the number of analytics events we can store in our MemoryDb
		 */ this.globalEventLimitGuard = new (0, $jVyx7.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
	 * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
	 * to removes oldest events when limit is reached.
	 */ async addItem(item, options = {}, policy = (0, $lapZo.GuardPolicy).ABANDON) {
        if (policy === (0, $lapZo.GuardPolicy).IGNORE) throw new (0, $ijErU.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $j7bx7.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $lapZo.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $j7bx7.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
	 * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
	 */ bulkAddItemWrapperType(items, policy = (0, $lapZo.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $7MhxY.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $7MhxY.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $7MhxY.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $7MhxY.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $cKlpa.default)(error);
        }
    }
    storeType() {
        return (0, $lapZo.StoreType).MEMORY;
    }
    /**
	 * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
	 * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
	 * memoryStore much faster.
	 *
	 * @param itemsToAdd
	 */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
	 * This function checks the number of events currently in AWC MemoryDb and if necessary,
	 * will evict the oldest events in favour of the events we want to add.
	 *
	 * @param countOfEventsToAdd - The number of events we are proposing to add.
	 */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("jVyx7", function(module, exports) {
$parcel$export(module.exports, "default", () => $c46425c0408b8884$export$2e2bcd8739ae039);

var $lapZo = parcelRequire("lapZo");

var $gT8qc = parcelRequire("gT8qc");
class $c46425c0408b8884$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
	 * Unlike IndexedDb, we cannot take advantage of any index. So we are,
	 * treating the memory store as a sorted set when adding items.
	 */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $lapZo.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $lapZo.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $lapZo.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $gT8qc.default)((0, $lapZo.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("4X9FF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e80da14f0762deb3$export$2e2bcd8739ae039);

var $8rkLC = parcelRequire("8rkLC");
let $e80da14f0762deb3$var$cachedMetricsClient = null;
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$e80da14f0762deb3$export$2e2bcd8739ae039 = ()=>{
    if (!$e80da14f0762deb3$var$cachedMetricsClient) $e80da14f0762deb3$var$cachedMetricsClient = new (0, $8rkLC.MetricsCollector)();
    return $e80da14f0762deb3$var$cachedMetricsClient;
};

});
parcelRegister("8rkLC", function(module, exports) {
$parcel$export(module.exports, "MetricsCollector", () => $93ebbdfa0a4d4a9c$export$4b62ee5120ab50a8);

var $lC88c = parcelRequire("lC88c");
class $93ebbdfa0a4d4a9c$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $lC88c.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}

});
parcelRegister("lC88c", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $d834666c2565dd9d$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $d834666c2565dd9d$export$ee138fa712d11b84);
var $d834666c2565dd9d$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $d834666c2565dd9d$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});



parcelRegister("4nqFi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1d13c90b99d5e0f$export$2e2bcd8739ae039);

var $lC88c = parcelRequire("lC88c");
class $b1d13c90b99d5e0f$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $lC88c.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $lC88c.NetworkStatusEnum).ONLINE));
        }
    }
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $lC88c.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $lC88c.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $lC88c.NetworkStatusEnum).ONLINE;
        return (0, $lC88c.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("76Ppe", function(module, exports) {
$parcel$export(module.exports, "default", () => $efa4ab84854d0199$export$2e2bcd8739ae039);

var $51PLR = parcelRequire("51PLR");

var $ci1pT = parcelRequire("ci1pT");
const $efa4ab84854d0199$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $efa4ab84854d0199$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $efa4ab84854d0199$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.schedule = ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $ci1pT.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $ci1pT.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $51PLR.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $ci1pT.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $efa4ab84854d0199$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $efa4ab84854d0199$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $efa4ab84854d0199$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $efa4ab84854d0199$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $efa4ab84854d0199$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $efa4ab84854d0199$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $51PLR.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("51PLR", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $11c4558a83442541$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $11c4558a83442541$export$590a718599f8f8b3);
var $11c4558a83442541$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $11c4558a83442541$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $11c4558a83442541$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("ci1pT", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $a6cab3ac0fb380c0$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $a6cab3ac0fb380c0$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("dpagP", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $8041620135a10914$export$c21270cab66ab290);

var $2VDkc = parcelRequire("2VDkc");
async function $8041620135a10914$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>(0, $2VDkc.attachXidToSingleEvent)(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("2VDkc", function(module, exports) {
$parcel$export(module.exports, "attachXidToSingleEvent", () => $c88956862f244301$export$c9c3aaf655d6f275);

var $6i6sY = parcelRequire("6i6sY");
function $c88956862f244301$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $6i6sY.SegmentEventTypes).PAGE || item.msg.type === (0, $6i6sY.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $6i6sY.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}

});
parcelRegister("6i6sY", function(module, exports) {
$parcel$export(module.exports, "SegmentEventTypes", () => $fc40f2fefdb77809$export$ddf929981dc6feb3);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $fc40f2fefdb77809$export$96f086dcf574a9e2);
var $fc40f2fefdb77809$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $fc40f2fefdb77809$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $fc40f2fefdb77809$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
const $fc40f2fefdb77809$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});



parcelRegister("7NaFf", function(module, exports) {
$parcel$export(module.exports, "AnalyticsResponse", () => $a5fd2c524958c175$export$133650fcdde1b226);
class $a5fd2c524958c175$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}

});

parcelRegister("6oXlX", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $c7b083ea482cbaf4$export$3a7fe28f9bf4f3d9);

var $8Qrxq = parcelRequire("8Qrxq");
// Shallow removal of all falsey properties from an object, returning a new object.
const $c7b083ea482cbaf4$var$removeFalseyProperties = (obj)=>{
    const result = {};
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
const $c7b083ea482cbaf4$export$3a7fe28f9bf4f3d9 = (context, overrides)=>{
    const result = {
        ...context.context,
        userAgent: navigator.userAgent
    };
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides?.excludedProperties) result.excludedProperties = {
        ...result.excludedProperties,
        ...(0, $8Qrxq.nestedRemoveUndefinedValues)(overrides.excludedProperties, '$.excludedProperties')
    };
    if (overrides?.userConsents) result.userConsents = {
        ...result.userConsents,
        ...(0, $8Qrxq.nestedRemoveUndefinedValues)(overrides.userConsents, '$.userConsents')
    };
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = $c7b083ea482cbaf4$var$removeFalseyProperties(result.excludedProperties);
    return result;
};

});
parcelRegister("8Qrxq", function(module, exports) {
$parcel$export(module.exports, "nestedRemoveUndefinedValues", () => $a7b088d194fa185e$export$2250ccecd1e040fd);
const $a7b088d194fa185e$export$2250ccecd1e040fd = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});


parcelRegister("cep6Q", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $d74e921d5d80e930$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $d74e921d5d80e930$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $d74e921d5d80e930$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $d74e921d5d80e930$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $d74e921d5d80e930$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $d74e921d5d80e930$export$6f1c008dd0c3b67e);
const $d74e921d5d80e930$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $d74e921d5d80e930$export$8fddcd1eff390364 = 60000; // 60 seconds
const $d74e921d5d80e930$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $d74e921d5d80e930$export$6649d5c857717efe = 5000; // 5 seconds
const $d74e921d5d80e930$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $d74e921d5d80e930$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("bDn8X", function(module, exports) {
$parcel$export(module.exports, "EventResponse", () => $67effb0f4aefe27a$export$51e0b986fdbf3840);
class $67effb0f4aefe27a$export$51e0b986fdbf3840 {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}

});

parcelRegister("lCUtP", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $bd77007251be7412$export$26e841bcf1aeb894);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $bd77007251be7412$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}

});

parcelRegister("crx0o", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $cbcce9ca8c015e61$export$ba118f9de1e5ac63);
const $cbcce9ca8c015e61$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("kWgqd", function(module, exports) {
$parcel$export(module.exports, "LastError", () => $12c502e08bb5f8fa$export$a63e16b3351b8c36);

var $lCUtP = parcelRequire("lCUtP");
class $12c502e08bb5f8fa$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof (0, $lCUtP.FetchError) ? error.statusCode : null;
    }
}

});

parcelRegister("eeQEx", function(module, exports) {
$parcel$export(module.exports, "prepareEventContext", () => $74dcfe916d5e55f1$export$6b26e26d40264200);
// @ts-ignore

var $hM7YN = parcelRequire("hM7YN");

var $8Qrxq = parcelRequire("8Qrxq");
const $74dcfe916d5e55f1$export$6b26e26d40264200 = (context)=>{
    const propertiesWithoutUndefined = (0, $8Qrxq.nestedRemoveUndefinedValues)(context, '$.context');
    return (0, (/*@__PURE__*/$parcel$interopDefault($hM7YN)))(propertiesWithoutUndefined);
};

});

parcelRegister("6qny7", function(module, exports) {
$parcel$export(module.exports, "prepareEventProperties", () => $9cac338f3be64df9$export$44d22e5fb02cc68e);
// @ts-ignore

var $hM7YN = parcelRequire("hM7YN");

var $8Qrxq = parcelRequire("8Qrxq");
const $9cac338f3be64df9$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = (0, $8Qrxq.nestedRemoveUndefinedValues)(properties, '$.properties');
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hM7YN)))(propertiesWithoutUndefined);
};

});

parcelRegister("7n4aj", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $8ca85230054bd8a6$export$8e8f0180c1b41fad);

var $emCaV = parcelRequire("emCaV");

var $lCUtP = parcelRequire("lCUtP");
const $8ca85230054bd8a6$export$8e8f0180c1b41fad = async (options)=>{
    const signal = $8ca85230054bd8a6$var$createOrGetAbortController(options)?.signal;
    const corsOptions = $8ca85230054bd8a6$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, {
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal,
        ...corsOptions
    });
    if (response.status !== 200) throw new (0, $lCUtP.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    try {
        let responseBody = await response.clone().json();
        if (responseBody.success === true) return response;
    } catch  {}
    throw new (0, $lCUtP.FetchError)('Invalid HTTP Response (Invalid response body)', 200, 'Invalid response body');
};
const $8ca85230054bd8a6$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $8ca85230054bd8a6$var$getCorsForUrl = (0, $emCaV.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("4AUeK", function(module, exports) {
$parcel$export(module.exports, "default", () => $21709df2d6b490b1$export$2e2bcd8739ae039);

var $fZkaH = parcelRequire("fZkaH");

var $l4GuM = parcelRequire("l4GuM");

var $jfAQ6 = parcelRequire("jfAQ6");

var $3WXNg = parcelRequire("3WXNg");

var $jgjT6 = parcelRequire("jgjT6");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $21709df2d6b490b1$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $21709df2d6b490b1$var$SAFE = 'SAFE';
const $21709df2d6b490b1$var$UNSAFE = 'UNSAFE';
const $21709df2d6b490b1$var$NOT_FOUND = 'NOT_FOUND';
const $21709df2d6b490b1$var$COOKIE = 'COOKIE';
const $21709df2d6b490b1$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $21709df2d6b490b1$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $3WXNg.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $jfAQ6.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
		 * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
		 * If not set in localStorage, check cookies. Also set localStorage for future attempts.
		 * If not in cookies, generate a new one. Set both cookie and localStorage keys.
		 */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $l4GuM.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $l4GuM.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $21709df2d6b490b1$var$LOCAL_STORAGE ? this.store.getItem((0, $l4GuM.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $l4GuM.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $21709df2d6b490b1$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $21709df2d6b490b1$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch  {
                /*
				 * Segments new Analytics-next client will store strings as strings without stringifing.
				 * The legacy Segment client and AWC always stringify and parse cookies and values.
				 * If the new Segment analytics-client stores a cookie and local storage value first, it will
				 * breaking old clients.
				 *
				 * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
				 *
				 * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
				 */ return unsafeValue;
            }
        }
        return {
            type: $21709df2d6b490b1$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($21709df2d6b490b1$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $fZkaH.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $21709df2d6b490b1$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $21709df2d6b490b1$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $21709df2d6b490b1$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $21709df2d6b490b1$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($21709df2d6b490b1$var$COOKIE);
        switch(cookieValue.type){
            case $21709df2d6b490b1$var$SAFE:
            case $21709df2d6b490b1$var$UNSAFE:
                this.store.setItem((0, $l4GuM.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $21709df2d6b490b1$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return (0, $jgjT6.default)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("l4GuM", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $5d231ae97031eaf9$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $5d231ae97031eaf9$export$d4cb17942ea57c95);
var $5d231ae97031eaf9$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $5d231ae97031eaf9$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $5d231ae97031eaf9$var$isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $5d231ae97031eaf9$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $5d231ae97031eaf9$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $5d231ae97031eaf9$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $5d231ae97031eaf9$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $5d231ae97031eaf9$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $5d231ae97031eaf9$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $5d231ae97031eaf9$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("jfAQ6", function(module, exports) {
$parcel$export(module.exports, "default", () => $72c72c7e39767936$export$2e2bcd8739ae039);

var $lO5Ez = parcelRequire("lO5Ez");

var $l4GuM = parcelRequire("l4GuM");

var $jQBgv = parcelRequire("jQBgv");

var $kegGY = parcelRequire("kegGY");
class $72c72c7e39767936$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $kegGY.canUseCookie)(disableCookiePersistence) ? (0, $lO5Ez.default) : new (0, $jQBgv.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $l4GuM.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $l4GuM.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $l4GuM.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $kegGY.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $l4GuM.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $l4GuM.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $l4GuM.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $l4GuM.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
}

});
parcelRegister("jQBgv", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b0f897f54f46b05$export$2e2bcd8739ae039);

var $3WXNg = parcelRequire("3WXNg");
class $4b0f897f54f46b05$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $3WXNg.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("3WXNg", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3a12aeaed7140b2$export$2e2bcd8739ae039);

var $52t1L = parcelRequire("52t1L");

var $gdfSo = parcelRequire("gdfSo");
class $f3a12aeaed7140b2$export$2e2bcd8739ae039 extends (0, $gdfSo.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.localStorage || (0, $52t1L.default);
        } catch (err) {
            storageToUse = (0, $52t1L.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("52t1L", function(module, exports) {
$parcel$export(module.exports, "default", () => $66a44925e3f68129$export$2e2bcd8739ae039);

var $3ueqP = parcelRequire("3ueqP");
// eslint-disable-next-line import/no-anonymous-default-export
const $66a44925e3f68129$var$inmemorystorage = new (0, $3ueqP.InMemoryStore)();
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$66a44925e3f68129$export$2e2bcd8739ae039 = $66a44925e3f68129$var$inmemorystorage;

});
parcelRegister("3ueqP", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $154055642dc7c93a$export$90e3e001bcac59c7);
class $154055642dc7c93a$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}

});


parcelRegister("gdfSo", function(module, exports) {
$parcel$export(module.exports, "default", () => $e44cfc93be1eeeaa$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $hIipg = parcelRequire("hIipg");

var $52t1L = parcelRequire("52t1L");

var $jQA5Y = parcelRequire("jQA5Y");
const $e44cfc93be1eeeaa$export$41c06fdd37b7e9a5 = 'awc';
const $e44cfc93be1eeeaa$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
class $e44cfc93be1eeeaa$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $52t1L.default) || typeof globalThis === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ((0, $jQA5Y.isSupported)(globalThis[$e44cfc93be1eeeaa$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$e44cfc93be1eeeaa$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $52t1L.default);
                if (!globalThis[$e44cfc93be1eeeaa$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                globalThis[$e44cfc93be1eeeaa$export$770aa8bc07b3de03] = (0, $52t1L.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($e44cfc93be1eeeaa$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $hIipg.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ((0, $jQA5Y.isSupported)(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});
parcelRegister("jQA5Y", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $7a81e403d60fbde4$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $7a81e403d60fbde4$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});




parcelRegister("kegGY", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $89fdae4e62d5acaa$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $89fdae4e62d5acaa$export$de6821eed3d5f32d);

var $lO5Ez = parcelRequire("lO5Ez");

var $emCaV = parcelRequire("emCaV");

var $l4GuM = parcelRequire("l4GuM");
const $89fdae4e62d5acaa$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $89fdae4e62d5acaa$export$eb80e1beaa8dacf8 = (0, $l4GuM.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $89fdae4e62d5acaa$export$19164982d36535d8 = 'tld_test';
const $89fdae4e62d5acaa$export$de6821eed3d5f32d = (0, $emCaV.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, $lO5Ez.default).set($89fdae4e62d5acaa$export$eb80e1beaa8dacf8, $89fdae4e62d5acaa$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, $lO5Ez.default).get($89fdae4e62d5acaa$export$eb80e1beaa8dacf8) === $89fdae4e62d5acaa$export$19164982d36535d8) {
            (0, $lO5Ez.default).remove($89fdae4e62d5acaa$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});




parcelRegister("ic1gZ", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", () => $371166be84c525d4$export$1ac223ae496131c9);

var $3MSpW = parcelRequire("3MSpW");

var $4nqFi = parcelRequire("4nqFi");

var $h4E4L = parcelRequire("h4E4L");

var $76Ppe = parcelRequire("76Ppe");

var $ci1pT = parcelRequire("ci1pT");

var $lC88c = parcelRequire("lC88c");

var $l9sD2 = parcelRequire("l9sD2");

var $cep6Q = parcelRequire("cep6Q");

var $lCUtP = parcelRequire("lCUtP");

var $lFu5l = parcelRequire("lFu5l");

var $10ksq = parcelRequire("10ksq");

var $6i6sY = parcelRequire("6i6sY");
class $371166be84c525d4$export$1ac223ae496131c9 {
    static{
        this.INITIAL_REFRESH_DELAY = 1;
    }
    static{
        this.Factory = (apiHostProtocol, apiHost, product)=>{
            return new $371166be84c525d4$export$1ac223ae496131c9(apiHostProtocol, apiHost, product);
        };
    }
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $3MSpW.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, $cep6Q.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $cep6Q.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $76Ppe.default)({
            ...this._options,
            waitInterval: (0, $cep6Q.DEFAULT_METADATA_REFRESH_INTERVAL)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
	 * Starts the metadata client. This will start the scheduler and begin
	 * fetching metadata.
	 *
	 * @param allowRestart - If false, the client will not be restarted if it has already been stopped
	 *						 by a call to stop().
	 */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $371166be84c525d4$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        this._fetchAbortController?.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $4nqFi.default)((status)=>{
            if (status === (0, $lC88c.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        if ((0, $l9sD2.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        this._fetchAbortController?.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $lFu5l.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $cep6Q.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $10ksq.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $lCUtP.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $6i6sY.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        if (this._userInfo?.userId === userInfo?.userId && this._userInfo?.userIdType === userInfo?.userIdType) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        if (this._tenantInfo?.tenantId === tenantInfo?.tenantId && this._tenantInfo?.tenantIdType === tenantInfo?.tenantIdType) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        if (this._networkStatus?.getNetworkStatus() === (0, $lC88c.NetworkStatusEnum).OFFLINE) {
            done((0, $ci1pT.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $ci1pT.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch  {
            done((0, $ci1pT.DoneState).ERROR);
        }
    }
    /**
	 * Schedules a refresh of the metadata when the user or tenant info changes. There is
	 * a short delay to allow for multiple changes to be batched together, such as when the
	 * callers sets the user info and tenant info in quick succession.
	 */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $cep6Q.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || (0, $h4E4L.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : (0, $h4E4L.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            maxRetryDelay: options?.maxRetryDelay || (0, $h4E4L.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || (0, $h4E4L.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
}

});
parcelRegister("3MSpW", function(module, exports) {
$parcel$export(module.exports, "isStargateProxyPath", () => $ae6fe14db237c0b3$export$83a9dd8d74be72c);

var $frSBj = parcelRequire("frSBj");
function $ae6fe14db237c0b3$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === (0, $frSBj.stargateProxyUrl)();
}

});
parcelRegister("frSBj", function(module, exports) {
$parcel$export(module.exports, "stargateProxyUrl", () => $cd3eec28b8a6ff23$export$78e02cfb66671ad0);
$parcel$export(module.exports, "selectHost", () => $cd3eec28b8a6ff23$export$18c0b81944902eae);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $hIipg = parcelRequire("hIipg");

const $cd3eec28b8a6ff23$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $cd3eec28b8a6ff23$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $cd3eec28b8a6ff23$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $cd3eec28b8a6ff23$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $cd3eec28b8a6ff23$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $cd3eec28b8a6ff23$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $cd3eec28b8a6ff23$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $cd3eec28b8a6ff23$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $cd3eec28b8a6ff23$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
/**
 * Returns the full Stargate proxy URL (host + proxy path) for the current host.
 *
 * This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
 * and Oasis IC environments. Using the first-party proxy works around browser
 * restrictions with third-party cookies.
 *
 * In non-browser environments (e.g. SSR) where `window` is not defined, the host
 * portion is omitted and the function returns only `STARGATE_PROXY_PATH`
 * (i.e. `/gateway/api/gasv3/api/v1`).
 */ function $cd3eec28b8a6ff23$export$78e02cfb66671ad0() {
    return (typeof window !== 'undefined' ? window.location.host : '') + $cd3eec28b8a6ff23$export$5df9262e102d0c32;
}
const $cd3eec28b8a6ff23$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $hIipg.envType).LOCAL || env === (0, $hIipg.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $hIipg.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $hIipg.envType).PROD ? $cd3eec28b8a6ff23$var$FEDRAMP_PROD_HOST : $cd3eec28b8a6ff23$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $hIipg.envType).PROD ? $cd3eec28b8a6ff23$var$STARGATE_FEDRAMP_PROD_HOST : $cd3eec28b8a6ff23$var$STARGATE_FEDRAMP_STAGING_HOST;
    return $cd3eec28b8a6ff23$export$78e02cfb66671ad0();
};
const $cd3eec28b8a6ff23$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $hIipg.envType).PROD ? $cd3eec28b8a6ff23$var$PROD_HOST : $cd3eec28b8a6ff23$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $hIipg.envType).PROD ? $cd3eec28b8a6ff23$var$STARGATE_PROD_HOST : $cd3eec28b8a6ff23$var$STARGATE_STAGING_HOST;
    return $cd3eec28b8a6ff23$export$78e02cfb66671ad0();
};
function $cd3eec28b8a6ff23$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride, apiHost: apiHost }) {
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.');
        return $cd3eec28b8a6ff23$export$78e02cfb66671ad0();
    }
    if (perimeter === (0, $hIipg.perimeterType).FEDRAMP_MODERATE) return $cd3eec28b8a6ff23$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $cd3eec28b8a6ff23$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});


parcelRegister("l9sD2", function(module, exports) {
$parcel$export(module.exports, "TestSupport", () => $241ac5272fc957e4$export$44b578549c42d779);
class $241ac5272fc957e4$export$44b578549c42d779 {
    static{
        this.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
    }
    static{
        this.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
    }
    static{
        this.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
    }
    static{
        this.SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';
    }
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($241ac5272fc957e4$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($241ac5272fc957e4$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($241ac5272fc957e4$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($241ac5272fc957e4$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}

});

parcelRegister("lFu5l", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", () => $74cbfe3a58963232$export$55b0d0261469055);

var $emCaV = parcelRequire("emCaV");

var $lCUtP = parcelRequire("lCUtP");
const $74cbfe3a58963232$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    const requestAbortController = $74cbfe3a58963232$var$createRequestAbortController(timeout, signal);
    const corsOptions = $74cbfe3a58963232$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${params.userInfo?.userId || ''}`,
        userIdType: `${params.userInfo?.userIdType || ''}`,
        tenantId: `${params.tenantInfo?.tenantId || ''}`,
        tenantIdType: `${params.tenantInfo?.tenantIdType || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $lCUtP.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $74cbfe3a58963232$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal?.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $74cbfe3a58963232$var$getCorsForUrl = (0, $emCaV.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("10ksq", function(module, exports) {
$parcel$export(module.exports, "MetadataResponse", () => $1b2b283a9f2f40a6$export$4b1a5e5486cc0d80);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $1b2b283a9f2f40a6$export$4b1a5e5486cc0d80 {
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json?.url) ? json.url.trim() : '';
        return new $1b2b283a9f2f40a6$export$4b1a5e5486cc0d80(json?.props || null, url.startsWith('http') ? url : null);
    }
}

});


parcelRegister("9A3q9", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", () => $74e70ab41e5e7649$export$f56713ced121eb91);

var $hIipg = parcelRequire("hIipg");
const $74e70ab41e5e7649$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $hIipg.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};

});

parcelRegister("aBsbe", function(module, exports) {
$parcel$export(module.exports, "isThirdParty", () => $184877061f56dbef$export$ab34f90cc32c8960);

var $hIipg = parcelRequire("hIipg");
const $184877061f56dbef$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $hIipg.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("dYhqx", function(module, exports) {
$parcel$export(module.exports, "LoggingResponseCallback", () => $898847e38d5668c9$export$48361b6ed38f1b0);
class $898847e38d5668c9$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $898847e38d5668c9$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}

});

parcelRegister("1hdMB", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4ee8ef7aa0ac1f2$export$2e2bcd8739ae039);

var $hIipg = parcelRequire("hIipg");

var $lS5kg = parcelRequire("lS5kg");
class $c4ee8ef7aa0ac1f2$export$2e2bcd8739ae039 {
    static{
        this.messageEvent = 'origin landed';
    }
    constructor(){
        this.pendingCleanup = null;
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $hIipg.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture params WITHOUT removing from URL (explicit no-op required because
            // urlParamExtractor defaults to calling history.replaceState if omitted)
            const paramExtractorReplace = ()=>{};
            const capturedURLParams = (0, $lS5kg.default)(isCaptureParam, paramExtractorReplace);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const capturedOriginTraces = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            if (Object.keys(capturedOriginTraces).length > 0) this.pendingCleanup = ()=>{
                (0, $lS5kg.default)(isCaptureParam, historyReplaceFn);
            };
            return capturedOriginTraces;
        };
        this._originStore = {};
    }
    /** Executes and clears any pending origin param cleanup. No-op if nothing is pending. */ _cleanupOriginParams() {
        if (this.pendingCleanup) {
            const cleanup = this.pendingCleanup;
            this.pendingCleanup = null;
            cleanup();
        }
    }
    /**
	 * Designed to be invoked after a successful flush with the batch of flushed events.
	 */ cleanupOriginParameters(events) {
        try {
            if (this.pendingCleanup) {
                const hasOriginLanded = events.some((item)=>'event' in item.msg && item.msg.event === $c4ee8ef7aa0ac1f2$export$2e2bcd8739ae039.messageEvent);
                if (hasOriginLanded) this._cleanupOriginParams();
            }
        } catch  {
        // Silently ignore cleanup errors to avoid disrupting the flush cycle
        }
    }
}

});

parcelRegister("9D7ff", function(module, exports) {
$parcel$export(module.exports, "default", () => $07cac2b8e92713e5$export$2e2bcd8739ae039);

var $iqfTZ = parcelRequire("iqfTZ");

var $fyTg6 = parcelRequire("fyTg6");

var $3WXNg = parcelRequire("3WXNg");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $07cac2b8e92713e5$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $07cac2b8e92713e5$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $07cac2b8e92713e5$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $07cac2b8e92713e5$export$285f6bddd927a06d = 1800000;
const $07cac2b8e92713e5$export$a92e915d70316eb2 = 5000;
const $07cac2b8e92713e5$export$de43760b2dc10c19 = 0.9;
class $07cac2b8e92713e5$export$2e2bcd8739ae039 {
    constructor(options = {}){
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($07cac2b8e92713e5$var$SESSION_ID_STORAGE_KEY, newSessionId);
            if ((0, $iqfTZ.fg)('awc_session_id_early_exit')) {
                // If session is not valid at this point, something has gone wrong with Local Storage access
                // Calling the callback may result in possible recursion errors (see HOT-304742). Feature
                // gating roll-out of this early exit condition
                const { isValidSession: isValidSession } = this._getCurrentSessionParams();
                if (!isValidSession) return '';
            }
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($07cac2b8e92713e5$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $07cac2b8e92713e5$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $07cac2b8e92713e5$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $07cac2b8e92713e5$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : (0, $fyTg6.NOOP);
        this._safeLocalStorage = new (0, $3WXNg.default)();
    }
    /*
	 * This function retrieves the current session ID and expiry from SessionStorage
	 * It runs the necessary checks to ensure the session ID is valid and within expiry
	 *
	 * It returns the values along with a `validSession` boolean
	 */ _getCurrentSessionParams() {
        const sessionId = this._safeLocalStorage.getItem($07cac2b8e92713e5$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($07cac2b8e92713e5$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        // REGEX test: Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (sessionId && !Number.isNaN(sessionExpiry) && $07cac2b8e92713e5$var$ONLY_NUMBERS_REGEX.test(sessionId) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
	 * Session ID SHOULD always be a timestamp, however due to new Browser Storage Controls key classifications, it is
	 * technically possible that writing Session ID to local storage is intercepted by BSC, in which case we can potentially
	 * read a null value from storage, in which case we will return empty String
	 */ getCurrentSessionId() {
        const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this._getCurrentSessionParams();
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        // If we have an existing valid session we can return the sessionId straight away
        if (isValidSession) return sessionId;
        else return this._generateNewSessionId();
    }
}

});
parcelRegister("fyTg6", function(module, exports) {
$parcel$export(module.exports, "NOOP", () => $6a240da2c64dabee$export$5702a91a6f42969f);
// 90% of expiry
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $6a240da2c64dabee$export$5702a91a6f42969f = ()=>{};

});


parcelRegister("7WJYu", function(module, exports) {
$parcel$export(module.exports, "default", () => $328723194bbf944f$export$2e2bcd8739ae039);

var $52t1L = parcelRequire("52t1L");

var $gdfSo = parcelRequire("gdfSo");
class $328723194bbf944f$export$2e2bcd8739ae039 extends (0, $gdfSo.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.sessionStorage || (0, $52t1L.default);
        } catch (err) {
            storageToUse = (0, $52t1L.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("aSmPV", function(module, exports) {
$parcel$export(module.exports, "default", () => $039c614b9c5a8dab$export$2e2bcd8739ae039);

var $7WJYu = parcelRequire("7WJYu");

var $jgjT6 = parcelRequire("jgjT6");
const $039c614b9c5a8dab$var$STORAGE_KEY = 'tab.id';
class $039c614b9c5a8dab$export$2e2bcd8739ae039 {
    constructor(){
        this._generateNewTabId = ()=>{
            const newTabId = (0, $jgjT6.default)();
            this._safeSessionStorage.setItem($039c614b9c5a8dab$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $7WJYu.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($039c614b9c5a8dab$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("iNnXU", function(module, exports) {
$parcel$export(module.exports, "default", () => $19f0fbdb7c9ba7fa$export$2e2bcd8739ae039);

var $1shin = parcelRequire("1shin");

var $hIipg = parcelRequire("hIipg");

var $JYWrF = parcelRequire("JYWrF");

var $7WJYu = parcelRequire("7WJYu");

var $lS5kg = parcelRequire("lS5kg");

var $jgjT6 = parcelRequire("jgjT6");
const $19f0fbdb7c9ba7fa$var$STORAGE_KEY = 'taskSessions';
const $19f0fbdb7c9ba7fa$var$INIT_KEY = 'taskSessionsInit';
const $19f0fbdb7c9ba7fa$var$AWC_PARAM_PREFIX = 'awc.';
const $19f0fbdb7c9ba7fa$var$TASK_SESSION_RELOAD_TIME = 3000;
class $19f0fbdb7c9ba7fa$export$2e2bcd8739ae039 {
    constructor(){
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($19f0fbdb7c9ba7fa$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($19f0fbdb7c9ba7fa$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($19f0fbdb7c9ba7fa$var$INIT_KEY) || '0', 10) < currentTimestamp - $19f0fbdb7c9ba7fa$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($19f0fbdb7c9ba7fa$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($19f0fbdb7c9ba7fa$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($19f0fbdb7c9ba7fa$var$STORAGE_KEY) || '');
            } catch  {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($19f0fbdb7c9ba7fa$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch  {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = (0, $jgjT6.default)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $1shin.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $JYWrF.pick)(currentState, includedTaskSessions) : (0, $JYWrF.omit)(currentState, Object.values((0, $hIipg.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $JYWrF.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$19f0fbdb7c9ba7fa$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $1shin.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $JYWrF.mapKeys)((0, $lS5kg.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $7WJYu.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($19f0fbdb7c9ba7fa$var$INIT_KEY, currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch  {}
    }
}

});

parcelRegister("1ZXfv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d1347c36a83c318$export$2e2bcd8739ae039);

var $lO5Ez = parcelRequire("lO5Ez");

var $l4GuM = parcelRequire("l4GuM");

var $l9sD2 = parcelRequire("l9sD2");
const $9d1347c36a83c318$var$MAX_CACHE_SIZE = 100;
const $9d1347c36a83c318$var$COOKIE_NAME = (0, $l4GuM.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $9d1347c36a83c318$var$DEBUG_TAG = 'synthetic';
class $9d1347c36a83c318$var$TestingCache {
    constructor(syntheticFlagOverride, enableTestingCache){
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $9d1347c36a83c318$var$TestingCache.getDebugCookie();
        this.bind();
    }
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch  {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch  {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $9d1347c36a83c318$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($9d1347c36a83c318$var$DEBUG_TAG)) event.tags.push($9d1347c36a83c318$var$DEBUG_TAG);
        } else event.tags = [
            $9d1347c36a83c318$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $l9sD2.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, $lO5Ez.default).get($9d1347c36a83c318$var$COOKIE_NAME) || 'false') === true;
        } catch  {
            (0, $lO5Ez.default).remove($9d1347c36a83c318$var$COOKIE_NAME);
        }
        return false;
    }
}
var $9d1347c36a83c318$export$2e2bcd8739ae039 = $9d1347c36a83c318$var$TestingCache;

});

parcelRegister("5bWrF", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef41806fc788b5e6$export$2e2bcd8739ae039);

var $hIipg = parcelRequire("hIipg");

var $eJO2o = parcelRequire("eJO2o");

var $3WXNg = parcelRequire("3WXNg");
const $ef41806fc788b5e6$var$DEFAULT_DELAY = 2000; // 2 seconds
const $ef41806fc788b5e6$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $ef41806fc788b5e6$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $ef41806fc788b5e6$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
var $ef41806fc788b5e6$var$SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}($ef41806fc788b5e6$var$SendEventDecision || {});
class $ef41806fc788b5e6$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this.signalUserActive = ()=>{
            this._sendUserActiveEvents();
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleDwellTimerTriggered, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch  {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._handleDwellTimerTriggered = ()=>{
            const document = (0, $eJO2o.getDocument)();
            if (document && !document.hasFocus()) return;
            this._sendUserActiveEvents();
        };
        this._sendUserActiveEvents = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context, false);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const sendEventDecision = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(sendEventDecision){
                case 3:
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 1:
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $hIipg.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 1;
                return 2;
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 3;
            return 4;
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $ef41806fc788b5e6$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $ef41806fc788b5e6$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $ef41806fc788b5e6$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $ef41806fc788b5e6$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $3WXNg.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("eJO2o", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $efe9c3ffdb5a37f8$export$f65ca476c09acec0);
const $efe9c3ffdb5a37f8$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("faM8Y", function(module, exports) {
$parcel$export(module.exports, "validateIdentifyEvent", () => $c462b557fc528b03$export$c16a4e16aa4026c0);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $hIipg = parcelRequire("hIipg");

var $kTskK = parcelRequire("kTskK");

var $6aMTG = parcelRequire("6aMTG");
function $c462b557fc528b03$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $kTskK.isType)((0, $hIipg.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $6aMTG.objectValues)((0, $hIipg.userType))}]`);
}

});

parcelRegister("jFH3o", function(module, exports) {
$parcel$export(module.exports, "validateOperationalEvent", () => $67f339b25b8a7b79$export$1e561554275607ef);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $eIOKf = parcelRequire("eIOKf");
function $67f339b25b8a7b79$export$1e561554275607ef(event) {
    (0, $eIOKf.validateActionEvent)(event);
}

});

parcelRegister("hQNbB", function(module, exports) {
$parcel$export(module.exports, "validatePlatform", () => $1dff46cb626e0d8e$export$801b46c35394d316);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $hIipg = parcelRequire("hIipg");

var $kTskK = parcelRequire("kTskK");

var $6aMTG = parcelRequire("6aMTG");
function $1dff46cb626e0d8e$export$801b46c35394d316(productInfo) {
    if (!(0, $kTskK.isType)((0, $hIipg.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $6aMTG.objectValues)((0, $hIipg.platformType))}]`);
    if (productInfo.origin === (0, $hIipg.originType).DESKTOP && !(0, $kTskK.isType)((0, $hIipg.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $hIipg.originType).WEB && !(0, $kTskK.isType)((0, $hIipg.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});

parcelRegister("3haPF", function(module, exports) {
$parcel$export(module.exports, "validateScreenEvent", () => $597e57f16c212f56$export$dc993432a592dc27);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ function $597e57f16c212f56$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}

});

parcelRegister("eZGnl", function(module, exports) {
$parcel$export(module.exports, "validateTrackEvent", () => $75dd7f0ebfe68717$export$8c014fd74b0c8b99);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $eIOKf = parcelRequire("eIOKf");
function $75dd7f0ebfe68717$export$8c014fd74b0c8b99(event) {
    (0, $eIOKf.validateActionEvent)(event);
}

});

parcelRegister("9FUav", function(module, exports) {
$parcel$export(module.exports, "validateUIEvent", () => $f89f23af5b0500e0$export$e5bac0930c812e90);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $eIOKf = parcelRequire("eIOKf");
function $f89f23af5b0500e0$export$e5bac0930c812e90(event) {
    (0, $eIOKf.validateActionEvent)(event);
}

});

parcelRegister("3QIuh", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cd633a4c0b240b3$export$2e2bcd8739ae039);
function $3cd633a4c0b240b3$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("7tjDg", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $9a38913b475d743f$export$fbe53bbbe682bcdd);

var $go9tG = parcelRequire("go9tG");
const $9a38913b475d743f$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $go9tG.createTimeoutXid)()), (0, $go9tG.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $go9tG.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("go9tG", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $f05fc312708baf56$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $f05fc312708baf56$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $f05fc312708baf56$export$fa341d0c750d705b);

var $dF84q = parcelRequire("dF84q");
const $f05fc312708baf56$export$545bcbd53afabfa3 = 5000;
const $f05fc312708baf56$export$af4087e36d63846 = ()=>[
        {
            type: (0, $dF84q.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $dF84q.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $f05fc312708baf56$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $dF84q.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $dF84q.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("dF84q", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $b4b8d6138c08c9b7$export$92ca0438bcb0d396);
var $b4b8d6138c08c9b7$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $b4b8d6138c08c9b7$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("9Ndfs", function(module, exports) {
$parcel$export(module.exports, "canCompress", () => $dcb58b8e949754a9$export$ec3662f84d9f778c);
$parcel$export(module.exports, "buildCompressionFunction", () => $dcb58b8e949754a9$export$20de0576abb0bcc5);
const $dcb58b8e949754a9$export$ec3662f84d9f778c = (event)=>event.actionSubject === 'feature' && event.action === 'exposed' && event.eventType === 'operational' && event.attributes && event.tags && event.tags.includes('measurement') && !event.tags.includes('hasCustomAttributes');
const $dcb58b8e949754a9$export$ca25d5d7792a4f37 = (events, batchSize = 50)=>{
    if (!events || events.length <= 0) return [];
    if (batchSize <= 0) throw new Error('Batch size must be greater than 0');
    // Extract evaluations and reduce into a single array
    const flagEvaluations = events.map((currentEvent)=>{
        const { flagKey: flagKey, value: value, reason: reason, ruleId: ruleId, errorKind: errorKind } = currentEvent.attributes;
        return {
            key: flagKey,
            value: value,
            ...reason && {
                reason: reason
            },
            ...ruleId && {
                ruleId: ruleId
            },
            ...errorKind && {
                errorKind: errorKind
            }
        };
    });
    // Batch evaluations into specified batchSize
    return $dcb58b8e949754a9$var$createBatches(flagEvaluations, batchSize);
};
const $dcb58b8e949754a9$var$createBatches = (array, batchSize)=>{
    let compressedEvaluations = [];
    for(let i = 0; i < array.length; i += batchSize){
        let evaluationBatch = array.slice(i, i + batchSize);
        compressedEvaluations.push({
            actionSubject: 'features',
            action: 'exposed',
            eventType: 'operational',
            attributes: {
                evaluations: evaluationBatch
            },
            tags: [
                'measurement'
            ],
            source: '@atlassian/exposure-events-compressor'
        });
    }
    return compressedEvaluations;
};
const $dcb58b8e949754a9$export$20de0576abb0bcc5 = (batchSize)=>(events)=>$dcb58b8e949754a9$export$ca25d5d7792a4f37(events, batchSize);

});

parcelRegister("Cs8MU", function(module, exports) {
$parcel$export(module.exports, "default", () => $03b2d547b42cfdce$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
const $03b2d547b42cfdce$var$interactionContext = (0, $euxye.createContext)(null);
var $03b2d547b42cfdce$export$2e2bcd8739ae039 = $03b2d547b42cfdce$var$interactionContext;

});

parcelRegister("gjqtf", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa2d46dacff34b20$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $kTviw = parcelRequire("kTviw");

var $kQcUG = parcelRequire("kQcUG");

var $22G6U = parcelRequire("22G6U");

var $ldPWL = parcelRequire("ldPWL");
const $fa2d46dacff34b20$var$EngagementProviderWithEvents = (0, $kTviw.default)()((0, $ldPWL.EngagementProvider));
const $fa2d46dacff34b20$var$EngagementProviderWithDefaultStore = (props)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)($fa2d46dacff34b20$var$EngagementProviderWithEvents, {
        ...props,
        store: (0, $22G6U.default)(props.config)
    });
};
$fa2d46dacff34b20$var$EngagementProviderWithDefaultStore.displayName = "EngagementProviderWithDefaultStore";
// eslint-disable-next-line camelcase
const $fa2d46dacff34b20$var$_default_1 = (0, $kQcUG.default)($fa2d46dacff34b20$var$EngagementProviderWithDefaultStore);
var // eslint-disable-next-line camelcase
$fa2d46dacff34b20$export$2e2bcd8739ae039 = $fa2d46dacff34b20$var$_default_1;

});
parcelRegister("kQcUG", function(module, exports) {
$parcel$export(module.exports, "default", () => $668023aa0710f955$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
function $668023aa0710f955$export$2e2bcd8739ae039(Component) {
    const PreventNestedInstancesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createContext(false);
    return function PreventNestedInstances(props) {
        return(// TODO: Replace usage of PreventNestedInstancesContext.Consumer with useContext(PreventNestedInstancesContext)
        /*#__PURE__*/ (0, $e79Pd.jsx)(PreventNestedInstancesContext.Consumer, {
            children: (shouldPreventInstantiation)=>shouldPreventInstantiation ? props.children : /*#__PURE__*/ (0, $e79Pd.jsx)(PreventNestedInstancesContext.Provider, {
                    value: true,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                        ...props
                    })
                })
        }));
    };
}

});

parcelRegister("22G6U", function(module, exports) {
$parcel$export(module.exports, "store", () => $98012c310e3a8a44$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "default", () => $98012c310e3a8a44$export$2e2bcd8739ae039);

var $bxhpq = parcelRequire("bxhpq");

var $13ZYC = parcelRequire("13ZYC");

var $3HVgM = parcelRequire("3HVgM");

var $jGBYI = parcelRequire("jGBYI");

var $gUVk0 = parcelRequire("gUVk0");

var $9EqKP = parcelRequire("9EqKP");
const $98012c310e3a8a44$export$36d128238e6b60f5 = {
    messageMapping: new Map(),
    current: null,
    initialized: false,
    initializing: false,
    config: {
        cloudId: '',
        aaid: '',
        locale: '',
        product: '',
        stargateUrl: '',
        orgId: '',
        workspaceId: ''
    }
};
let $98012c310e3a8a44$var$processMessagesCancellationToken = (0, $3HVgM.createCancellationToken)();
function $98012c310e3a8a44$export$7a10f46f72407bc5(messageMapping, component) {
    const newMapping = new Map();
    messageMapping.forEach((value, key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(value.component, component)) newMapping.set(key, value);
    });
    return newMapping;
}
const $98012c310e3a8a44$export$6f57813fe9f31bf9 = (0, $13ZYC.createStore)((state = $98012c310e3a8a44$export$36d128238e6b60f5, action)=>{
    switch(action.type){
        case 0, $gUVk0.SET_MESSAGE_MAPPING:
            return {
                ...state,
                initialized: true,
                initializing: false,
                messageMapping: action.messageMapping
            };
        case 0, $gUVk0.SET_INITIALIZING:
            return {
                ...state,
                config: action.config,
                initializing: true
            };
        case 0, $gUVk0.SET_CURRENT:
            {
                const { eventMapping: eventMapping } = action;
                const { message: message, component: component } = eventMapping;
                const messageMapping = $98012c310e3a8a44$export$7a10f46f72407bc5(state.messageMapping, component);
                return {
                    ...state,
                    current: {
                        messageId: message.messageId,
                        variationId: message.variationId,
                        ...component
                    },
                    messageMapping: messageMapping
                };
            }
        case 0, $gUVk0.CLEAR_CURRENT:
            return {
                ...state,
                current: null
            };
        case 0, $gUVk0.RESET_STORE:
            return $98012c310e3a8a44$export$36d128238e6b60f5;
        default:
            return state;
    }
});
var $98012c310e3a8a44$export$2e2bcd8739ae039 = (config)=>{
    const state = $98012c310e3a8a44$export$6f57813fe9f31bf9.getState();
    if (state.initializing || state.initialized) {
        if (state.config.cloudId === config.cloudId) return $98012c310e3a8a44$export$6f57813fe9f31bf9;
        // CloudId has changed, cancel any in process processMessages request
        $98012c310e3a8a44$var$processMessagesCancellationToken.isCancelled = true;
        $98012c310e3a8a44$var$processMessagesCancellationToken = (0, $3HVgM.createCancellationToken)();
        $98012c310e3a8a44$export$6f57813fe9f31bf9.dispatch((0, $gUVk0.resetStore)());
    }
    const newConfig = {
        ...config
    };
    newConfig.locale = newConfig.locale.replace('_', '-');
    $98012c310e3a8a44$export$6f57813fe9f31bf9.dispatch((0, $gUVk0.initialize)(newConfig));
    if ((0, $jGBYI.isMessagingEnabled)()) (0, $9EqKP.processMessages)($98012c310e3a8a44$export$6f57813fe9f31bf9, newConfig, $98012c310e3a8a44$var$processMessagesCancellationToken);
    return $98012c310e3a8a44$export$6f57813fe9f31bf9;
};

});
parcelRegister("3HVgM", function(module, exports) {
$parcel$export(module.exports, "createCancellationToken", () => $7208a5045c55f8d3$export$eac027797b968991);
function $7208a5045c55f8d3$export$eac027797b968991(isCancelled = false) {
    return {
        isCancelled: isCancelled
    };
}

});

parcelRegister("jGBYI", function(module, exports) {
$parcel$export(module.exports, "isMessagingEnabled", () => $f82be5734a051270$export$a77934ac158768dd);

var $l1vE2 = parcelRequire("l1vE2");
function $f82be5734a051270$export$a77934ac158768dd() {
    return !(0, $l1vE2.isFedRamp)();
}

});

parcelRegister("gUVk0", function(module, exports) {
$parcel$export(module.exports, "SET_MESSAGE_MAPPING", () => $58adc99d8ffd727c$export$d05fe3e897340c89);
$parcel$export(module.exports, "SET_INITIALIZING", () => $58adc99d8ffd727c$export$eacd3ec165715d8);
$parcel$export(module.exports, "RESET_STORE", () => $58adc99d8ffd727c$export$874c5149d7f0e3b8);
$parcel$export(module.exports, "CLEAR_CURRENT", () => $58adc99d8ffd727c$export$cb5041d68cb18859);
$parcel$export(module.exports, "SET_CURRENT", () => $58adc99d8ffd727c$export$a9319af002a4c677);
$parcel$export(module.exports, "resetStore", () => $58adc99d8ffd727c$export$a20a1205b2a2b7e4);
$parcel$export(module.exports, "initialize", () => $58adc99d8ffd727c$export$2a47f398eeff8b01);
$parcel$export(module.exports, "setMessageMapping", () => $58adc99d8ffd727c$export$375dd0a76fecd4c7);
$parcel$export(module.exports, "setCurrent", () => $58adc99d8ffd727c$export$5f80f094fd31fffd);
$parcel$export(module.exports, "clearCurrent", () => $58adc99d8ffd727c$export$96105f873ade39d7);
const $58adc99d8ffd727c$export$d05fe3e897340c89 = 'SET_MESSAGE_MAPPING';
const $58adc99d8ffd727c$export$eacd3ec165715d8 = 'SET_INITIALIZING';
const $58adc99d8ffd727c$export$874c5149d7f0e3b8 = 'RESET_STORE';
const $58adc99d8ffd727c$export$cb5041d68cb18859 = 'CLEAR_CURRENT';
const $58adc99d8ffd727c$export$a9319af002a4c677 = 'SET_CURRENT';
const $58adc99d8ffd727c$export$a20a1205b2a2b7e4 = ()=>({
        type: $58adc99d8ffd727c$export$874c5149d7f0e3b8
    });
const $58adc99d8ffd727c$export$2a47f398eeff8b01 = (config)=>({
        type: $58adc99d8ffd727c$export$eacd3ec165715d8,
        config: config
    });
const $58adc99d8ffd727c$export$375dd0a76fecd4c7 = (messageMapping)=>({
        type: $58adc99d8ffd727c$export$d05fe3e897340c89,
        messageMapping: messageMapping
    });
function $58adc99d8ffd727c$export$5f80f094fd31fffd(eventMapping) {
    return {
        type: $58adc99d8ffd727c$export$a9319af002a4c677,
        eventMapping: eventMapping
    };
}
function $58adc99d8ffd727c$export$96105f873ade39d7() {
    return {
        type: $58adc99d8ffd727c$export$cb5041d68cb18859
    };
}

});

parcelRegister("9EqKP", function(module, exports) {
$parcel$export(module.exports, "processMessages", () => $ded702e5dc7e5f20$export$d2e92820f98a2592);

var $hqF4Z = parcelRequire("hqF4Z");

var $gUVk0 = parcelRequire("gUVk0");

var $22G6U = parcelRequire("22G6U");
const $ded702e5dc7e5f20$export$a9d4ce3abb5d2365 = (messages)=>{
    const mapping = new Map();
    messages.forEach((message)=>{
        const components = message.components;
        components.forEach((component, index)=>{
            component.triggers.forEach((trigger)=>{
                mapping.set(trigger, {
                    message: message,
                    component: {
                        componentId: index,
                        isLast: index === components.length - 1,
                        ...component
                    }
                });
            });
        });
    });
    return mapping;
};
async function $ded702e5dc7e5f20$export$d2e92820f98a2592(engagementStore, config, cancellationToken) {
    if (cancellationToken.isCancelled) return;
    const state = (0, $22G6U.store).getState();
    const { cloudId: cloudId, stargateUrl: stargateUrl, product: product, locale: locale } = config;
    let messages, interval;
    try {
        const results = await (0, $hqF4Z.getMessages)(cloudId, stargateUrl, product, locale);
        if (cancellationToken.isCancelled) return;
        messages = results.messages;
        interval = results.interval;
    } catch (e) {
        // TODO: Configure metal to monitor errors here
        // Give up, don't try fetching again
        return;
    }
    // Don't overwrite the messageMapping if there's an active message
    if (state.current === null) {
        const messageMapping = $ded702e5dc7e5f20$export$a9d4ce3abb5d2365(messages);
        engagementStore.dispatch((0, $gUVk0.setMessageMapping)(messageMapping));
    }
    if (interval !== 0) setTimeout(()=>{
        $ded702e5dc7e5f20$export$d2e92820f98a2592(engagementStore, config, cancellationToken);
    }, interval * 1000);
// TODO: Configure metal to monitor success response here
}

});
parcelRegister("hqF4Z", function(module, exports) {
$parcel$export(module.exports, "getMessages", () => $5f8b82a648d04e7e$export$8c20ab16ac9cf14f);
$parcel$export(module.exports, "startMessage", () => $5f8b82a648d04e7e$export$7a77c9a7b182680b);
$parcel$export(module.exports, "stopMessage", () => $5f8b82a648d04e7e$export$159ff839f1f095d2);
$parcel$export(module.exports, "sendUserResponse", () => $5f8b82a648d04e7e$export$e1fd1449cf83c1f5);
$parcel$export(module.exports, "markAsSeenAndFatigued", () => $5f8b82a648d04e7e$export$3683393f780c6905);
/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars -- Deprecated API stubs retain public signature for compatibility */ 
var $avY0H = parcelRequire("avY0H");
const $5f8b82a648d04e7e$export$f4d1b02d312560f5 = '2';
async function $5f8b82a648d04e7e$export$8c20ab16ac9cf14f(_cloudId, _stargateUrl, _product, _locale) {
    return {
        messages: [],
        interval: 0
    };
}
var $5f8b82a648d04e7e$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
// Initialize the choreographer plugin on module load
// const choreographerPlugin = new EngagekitChoreographerPlugin();
let $5f8b82a648d04e7e$var$choreographerPlugin;
async function $5f8b82a648d04e7e$export$7a77c9a7b182680b(startMessageConfig, options) {
    if (options?.enableChoreographer) return $5f8b82a648d04e7e$var$startMessageWithChoreographer(startMessageConfig, options);
    return $5f8b82a648d04e7e$var$startMessageWithCoordination(startMessageConfig);
}
async function $5f8b82a648d04e7e$export$159ff839f1f095d2(stopMessageConfig, options) {
    if (options?.enableChoreographer) return $5f8b82a648d04e7e$var$stopMessageWithChoreographer(stopMessageConfig, options);
    return $5f8b82a648d04e7e$var$stopMessageWithCoordination(stopMessageConfig);
}
async function $5f8b82a648d04e7e$var$startMessageWithChoreographer(startMessageConfig, options) {
    if (!$5f8b82a648d04e7e$var$choreographerPlugin) $5f8b82a648d04e7e$var$choreographerPlugin = new (0, $avY0H.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $5f8b82a648d04e7e$var$choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, ()=>$5f8b82a648d04e7e$var$startMessageWithCoordination(startMessageConfig, true), options.additionalData);
}
async function $5f8b82a648d04e7e$var$stopMessageWithChoreographer(stopMessageConfig, options) {
    if (!$5f8b82a648d04e7e$var$choreographerPlugin) $5f8b82a648d04e7e$var$choreographerPlugin = new (0, $avY0H.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $5f8b82a648d04e7e$var$choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, ()=>$5f8b82a648d04e7e$var$stopMessageWithCoordination(stopMessageConfig, true), options.additionalData);
}
async function $5f8b82a648d04e7e$var$startMessageWithCoordination(_startMessageConfig, _choreographerEnabled = false) {
    return false;
}
async function $5f8b82a648d04e7e$var$stopMessageWithCoordination(_stopMessageConfig, _choreographerEnabled = false) {
    return false;
}
async function $5f8b82a648d04e7e$export$e1fd1449cf83c1f5(_cloudId, _stargateUrl, _messageId, _payload) {
    return Promise.resolve();
}
async function $5f8b82a648d04e7e$export$3683393f780c6905(_seenMessageConfig) {
    return Promise.resolve();
}

});
parcelRegister("avY0H", function(module, exports) {
$parcel$export(module.exports, "EngagekitChoreographerPlugin", () => $43b3c3d036d11f3d$export$da23bd36e2d631b);

var $ilQ8n = parcelRequire("ilQ8n");

var $kNBjd = parcelRequire("kNBjd");

var $4NFBi = parcelRequire("4NFBi");

var $2kDEl = parcelRequire("2kDEl");

var $blN8U = parcelRequire("blN8U");
const $43b3c3d036d11f3d$export$63ce1a41d951945d = 300000; // 5m timeout for duplicate request attempts
class $43b3c3d036d11f3d$export$da23bd36e2d631b extends (0, $blN8U.ChoreographerPlugin) {
    constructor(env, metaMetricsData = {}){
        super((0, $kNBjd.ProductIds).ENGAGEKIT, env, metaMetricsData);
    }
    /**
	 * Informs the Logger utility class to *NOT* log the provided event if it contains a blockedByProductId
	 * attribute of the Engagekit product. EP is _super_ noisy when it comes to logging, and we get no value
	 * out of the events it logs for its own message starts that are blocked, by any messages. The reason is
	 * that EP tries to start all of its messages all of the time, and lets the gateway determine whether to
	 * actually display the message. Roughly 99.9% of messages fail to start for reasons of prior exposure,
	 * the user being in the holdout group, or any number of other reasons, so we're logging roughly 1000x what
	 * we get any value out of. This filter will now prevent all of those extra, more useless logs, from being
	 * actually fired off, and will keep just the log entries from which we can derive some actual value.
	 *
	 * @param event OperationalEventPayload
	 * @returns boolean
	 */ shouldLogEvent(event) {
        return event.actionSubject !== (0, $kNBjd.MessageAction).START || event.action !== (0, $kNBjd.MessageDeliveryStatus).BLOCKED;
    }
    isValidDuplicateStartRequest(messageId) {
        const currentMessage = (0, $ilQ8n.Choreographer).getInstance().getCurrentMessage() ?? (0, $ilQ8n.Choreographer).getInstance().getCurrentPendingMessage();
        return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < $43b3c3d036d11f3d$export$63ce1a41d951945d);
    }
    async startMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $4NFBi.DebugLogger)(this.state.productId, messageId);
        const actionSubject = (0, $kNBjd.MessageAction).START;
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::startMessageWithPlugin`
        });
        /**
		 * The Choreographer sets a 5m TTL for any message that opens, before forcefully closing it.
		 * EP also allows a messageId to re-request its start if it hasn't yet been dismissed (this is a
		 * feature of HISI. For this reason, we can mimic that functionality here (otherwise, Choreographer
		 * will block the subsequest start request attempt altogether), by checking the Choreographer's
		 * currentMessage against our productId/messageId combo here. If this *is* the currentMessage being
		 * displayed, it means it hasn't been dismissed, and we let the request dispatch for EP to make the call.
		 */ const isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
        if (isValidDuplicateStartRequest) {
            const logger = new (0, $2kDEl.Logger)(actionSubject, messageId, {
                ...this.state.metaMetricsData,
                ...additionalData
            }, this.analyticsClient);
            const didStart = Boolean(await callback());
            if (didStart) {
                logger.started();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        plugin: this.constructor.name,
                        disposition: (0, $kNBjd.MessageDeliveryStatus).STARTED,
                        timestamp: performance.now()
                    }
                });
            }
            return didStart;
        }
        // Do a just-in-time message start subscription with our callback to stargate
        this.onStart(messageId, callback);
        /**
		 * Dispatch the request to start the message, and return the response, which will
		 * either be 'started' if successful, and anything else if unsuccessful. Convert
		 * that value with a boolean check, because the consumer only cares about true/false.
		 */ const result = await this.startMessage(messageId, additionalData);
        return result === (0, $kNBjd.MessageDeliveryStatus).STARTED;
    }
    async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $4NFBi.DebugLogger)(this.state.productId, messageId);
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::stopMessageWithPlugin`
        });
        // Do a just-in-time message stop subscription with our callback to stargate
        this.onStop(messageId, callback);
        /**
		 * Dispatch the request to stop the message, and return the response, which will
		 * either be 'stopped' if successful, and anything else if unsuccessful. Convert
		 * that value with a boolean check, because the consumer only cares about true/false.
		 */ const result = await this.stopMessage(messageId, additionalData);
        return result === (0, $kNBjd.MessageDeliveryStatus).STOPPED;
    }
}

});
parcelRegister("ilQ8n", function(module, exports) {
$parcel$export(module.exports, "Choreographer", () => $e6651ed7e0b13729$export$236158f15971c92e);

var $iqfTZ = parcelRequire("iqfTZ");

var $kNBjd = parcelRequire("kNBjd");

var $4NFBi = parcelRequire("4NFBi");

var $2kDEl = parcelRequire("2kDEl");

var $kDVb4 = parcelRequire("kDVb4");

var $lEbpq = parcelRequire("lEbpq");
// This timeout is used for any long-running messages that are either stuck for some reason, or that the user has yet to clear, to ensure that messaging doesn't stay blocked indefinitely
const $e6651ed7e0b13729$var$CHOREOGRAPHER_MESSAGE_TTL = 300000; // 5 minute TTL for messages
// Lazily instantiate this the first time it's requested
let $e6651ed7e0b13729$var$singleton;
class $e6651ed7e0b13729$export$236158f15971c92e {
    /**
	 * Static method to create and/or return a singleton of the choreographer API.
	 *
	 * @returns Shared instance of choreographer API.
	 */ static getInstance() {
        if (typeof window !== 'undefined') {
            if (window.postOffice?.choreographer?.singleton) return window.postOffice.choreographer.singleton;
            window.postOffice = {
                ...window.postOffice,
                choreographer: {
                    ...window.postOffice?.choreographer,
                    singleton: new this()
                }
            };
            return window.postOffice.choreographer.singleton;
        }
        if (!$e6651ed7e0b13729$var$singleton) $e6651ed7e0b13729$var$singleton = new this();
        return $e6651ed7e0b13729$var$singleton;
    }
    constructor(){
        this.shouldBeChoreographed = (productId, analyticsClient, metricsData = {}, props, coordinationOptions, toggleableProp)=>{
            /*
		 * TODO: Remove this once we have enough transactional message data!!! This is a hacky TEMPORARY solution to get a sense
		 * of how many transactional messages we are showing to users.
		 *
		 * We have to track which messages have been seen because shouldBeChoreographed is called on every rerender of
		 * Choreographer-integrated components. So, if we log every call, we'll get an inaccurate number of transactional
		 * messages that are actually being shown to users.
		 *
		 * Thus, we track which messages have been seen and only log the first time we see a transactional message.
		 */ // Check if we should log the shouldBeChoreographed call
            const isTransactional = props?.messageType === (0, $kNBjd.MessageTypesEnum).TRANSACTIONAL;
            const isTransactionalLoggingEnabled = (0, $iqfTZ.fg)('post-office_choreographer_log_transactional_msg');
            const seen = props?.messageId && this.state.seenTransactionalMessages.get(productId)?.has(props.messageId);
            // If the component is toggleable, we only want to log the message if it is actually rendered
            const isRendered = !toggleableProp || toggleableProp && props?.[toggleableProp];
            if (isTransactional && props?.messageId && isTransactionalLoggingEnabled && isRendered && !seen) {
                // Mark the messageId as seen to prevent duplicate logging on rerenders
                if (!this.state.seenTransactionalMessages.has(productId)) this.state.seenTransactionalMessages.set(productId, new Set());
                this.state.seenTransactionalMessages.get(productId)?.add(props.messageId);
                const logger = new (0, $2kDEl.Logger)('messageStart', props.messageId, {
                    ...metricsData,
                    messageId: props.messageId,
                    currentMessageId: this.getCurrentMessage()?.messageId,
                    messageType: props.messageType
                }, analyticsClient);
                logger.requested();
            }
            // Call the original function that actually determines if a message should be choreographed
            return (0, $kDVb4.shouldBeChoreographed)(props, coordinationOptions);
        };
        this.state = {
            currentMessage: null,
            isDisabled: false,
            messages: new Map(),
            messageQueue: [],
            messageTtl: null,
            plugins: new Map(),
            queueingBehindMessage: null,
            shouldQueueMessages: false,
            seenTransactionalMessages: new Map()
        };
    }
    stopCurrentMessage() {
        if (this.state.currentMessage) this.stopMessageInternal(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData, this.state.currentMessage.plugin, true).then(()=>{
            // Manually clear the message TTL and reenable plugins here just in case the unregistered plugin's message denied the
            // stop request. We may still get a collision on-screen, but we're considering the message forcibly stopped at this
            // point, so need to allow new requests.
            this.clearMessageTtl();
            this.enablePlugins();
        });
    }
    /**
	 * Enables the message queue, and logs which message everybody else is queueing up behind.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request blocking others.
	 * @param messageId Unique identifier for the messageId blocking others.
	 */ queueMessages(productId, messageId) {
        this.state.shouldQueueMessages = true;
        this.state.queueingBehindMessage = {
            productId: productId,
            messageId: messageId,
            timestamp: Date.now()
        };
    }
    /**
	 * Pushes all data associated with a startMessage request onto an internal queue, to potentially be processed at a later time.
	 * If a pending message request opts out (or otherwise fails to start), this data will be used to reinitiate the startMessage
	 * request for this message request instance. Returns a Promise that the caller can await as normal, and which will eventually
	 * either be resolved as 'blocked' if any prior pending message is started, or will be resolved with its eventual outcome when
	 * its startMessage request is processed.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request being queued.
	 * @param messageId Unique identifier for the messageId being queued.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
        return new Promise((resolve)=>{
            this.state.messageQueue.push({
                productId: productId,
                messageId: messageId,
                timestamp: Date.now(),
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                plugin: plugin,
                resolve: resolve
            });
        });
    }
    /**
	 * Responsible for pulling a previously queued message request that was received while a message request was already in flight.
	 * Shift the first message off the top of the queue, and use the stored resolve function to kickstart another pass through the
	 * startMessage function, ultimately resolving with the final disposition of the request. Set the internal state for shouldQueueMessages
	 * to false if we're restarting a startMessage request, so that this doesn't get immediately thrown back into the queue. If it
	 * makes it through to its start callback being fired, that code will turn the shouldQueueMessages state back on.
	 */ processQueuedMessage() {
        const queuedMessage = this.state.messageQueue.shift();
        // Disable the shouldQueueMessages state here. If we have a queued message, it will turn the shouldQueueMessages state back on when it
        // hits the call to its message's startCallback function. Otherwise, the queue is now empty, and we let things process normally.
        this.state.shouldQueueMessages = false;
        // Also null out the queueingBehindMessage value, which will be recreated if/when another message opens the queue below.
        this.state.queueingBehindMessage = null;
        if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
    }
    /**
	 * Responsible for flushing out any queued messages and resolving their Promises as "blocked". We don't officially consider a
	 * message as "blocked" until one of the prior calls has signaled a valid "started" state. This way, any async callbacks that
	 * are in flight can allow additional messages to queue up, and if they eventually opt out, we can move on to the next message
	 * in the queue and see if it will signal success. Only when we get a successful start to we consider all queued up messages to
	 * be "blocked". Run a loop to shift each of them off of the array and resolve them as blocked, until the array is empty.
	 *
	 * @param [plugin] An optional plugin instance
	 */ destroyMessageQueue(plugin) {
        this.state.shouldQueueMessages = false;
        this.state.queueingBehindMessage = null;
        while(this.state.messageQueue.length > 0){
            const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
            const attributes = {
                ...metricsData,
                productId: productId,
                messageId: messageId
            };
            const actionSubject = (0, $kNBjd.MessageAction).START;
            const logger = new (0, $2kDEl.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
            const debugLogger = new (0, $4NFBi.DebugLogger)(productId, messageId);
            logger.blocked({
                blockedByProductId: this.state.currentMessage?.productId,
                blockedByMessageId: this.state.currentMessage?.messageId
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $kNBjd.MessageDeliveryStatus).BLOCKED,
                    blockedByProductId: this.state.currentMessage?.productId,
                    blockedByMessageId: this.state.currentMessage?.messageId
                }
            });
            resolve((0, $kNBjd.MessageDeliveryStatus).BLOCKED);
        }
    }
    /**
	 * Sets a timeout to auto-expire any messaging that stays open for too long, to prevent messaging from being blocked indefinitely.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
	 * @param messageId Unique identifier for the messageId that triggered this message timeout.
	 * @param AnalyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @param [messageTtl] Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use default TTL (5 minutes).
	 */ setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin, messageTtl) {
        this.state.currentMessage = {
            productId: productId,
            messageId: messageId,
            analyticsClient: analyticsClient,
            metricsData: metricsData,
            plugin: plugin,
            timestamp: Date.now()
        };
        // If TTL is 0, disable TTL for this message
        if (messageTtl === 0) return;
        // Use provided TTL or default to CHOREOGRAPHER_MESSAGE_TTL
        this.state.messageTtl = setTimeout(()=>{
            if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
        }, messageTtl ?? $e6651ed7e0b13729$var$CHOREOGRAPHER_MESSAGE_TTL);
    }
    /**
	 * Checks to see if the requesting productId/messageId pair matches the data for the currently-displayed message.
	 *
	 * @param productId Unique identifier for the product being checked for a current message match.
	 * @param messageId Unique identifier for the messageId being checked for a current message match.
	 */ isCurrentMessage(productId, messageId) {
        return Boolean(this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId);
    }
    /**
	 * Returns the currentMessage object.
	 */ getCurrentMessage() {
        return this.state.currentMessage;
    }
    /**
	 * Returns the queueingBehindMessage object.
	 */ getCurrentPendingMessage() {
        return this.state.queueingBehindMessage;
    }
    /**
	 * Returns a snapshot of messages currently queued behind an in-flight start or stop request.
	 */ getQueuedMessages() {
        return this.state.messageQueue.map(({ messageId: messageId, productId: productId, timestamp: timestamp })=>({
                messageId: messageId,
                productId: productId,
                timestamp: timestamp
            }));
    }
    /**
	 * Clears the timeout that was established for the currently-displayed message.
	 */ clearMessageTtl() {
        this.state.currentMessage = null;
        if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
    }
    /**
	 * Disables all plugins that are currently registered with the choreographer when loaded in an iframe. For apps that
	 * are shown within iframes (e.g. smart link embeds) we typically do not want to show in-product messages as they
	 * may conflict with messages shown in parent frames.
	 *
	 * If called outside an iframe then this function is a noop.
	 *
	 * @returns A cleanup function to re-enable plugins, or `undefined` if the function was called outside an iframe.
	 */ disableChoreographerForIframe() {
        // Exit if we're not in an iframe
        if (!(0, $lEbpq.isIframe)()) return;
        this.disablePlugins();
        // Cleanup function to re-enable plugins
        return ()=>this.enablePlugins();
    }
    /**
	 * Disables all plugins that are currently registered with the choreographer, called when a startMessage call is being dispatched.
	 *
	 * @param [exceptFor] An optional plugin instance.
	 */ disablePlugins(exceptFor) {
        this.state.isDisabled = true;
        [
            ...this.state.plugins.values()
        ].forEach((p)=>{
            if (p !== exceptFor) p.disable();
        });
    }
    /**
	 * Enables all plugins that are currently registered with the choreographer, called when a matching stopMessage call is successful.
	 */ enablePlugins() {
        [
            ...this.state.plugins.values()
        ].forEach((p)=>p.enable());
        this.state.isDisabled = false;
    }
    /**
	 * A callback used to remove a plugin from the list of subscribers for the choreographer service.
	 *
	 * @param productId A unique string representing the plugin to be unregistered from the choreographer API.
	 */ unregisterPlugin(productId) {
        // If we're unregistering this productId's plugin, and the currentMessage is from this productId, we need to stop it to clear the choreographer
        if (this.state.currentMessage?.productId === productId) this.stopCurrentMessage();
        this.state.messages.delete(productId);
        this.state.plugins.delete(productId);
        this.state.seenTransactionalMessages.delete(productId);
    }
    /**
	 * Determines whether any message is currently being displayed, by checking its own status and optionally, asking each registered plugin for its individual status.
	 *
	 * @returns A value reflecting whether a message is currently being displayed on screen.
	 */ isDisplayingMessage() {
        return Boolean(this.state.currentMessage || [
            ...this.state.plugins.values()
        ].reduce((isDisplayingMessage, p)=>{
            return isDisplayingMessage || p.isDisplayingMessage();
        }, false));
    }
    /**
	 * Returns the registered messages for a product. This is used by diagnostics and tests to inspect
	 * the current Choreographer registry without mutating it.
	 *
	 * @param productId Unique identifier for the product whose messages are being requested.
	 * @returns A Map of IMessage objects, keyed by unique messageId strings.
	 */ getMessages(productId) {
        return this.state.messages.get(productId) ?? new Map();
    }
    /**
	 * Requests to start a message via the choreographer service, ensuring only a single message instance at a time on the screen.
	 * A successful request will block any other message attempts until such time as the matching stopMessage request is received,
	 * or a message TTL timeout has expired.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
	 * @param messageId Unique identifier for the messageId that triggered this message timeout.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param [metricsData] Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @param [messageTtl] Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use default TTL (5 minutes).
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin, messageTtl) {
        const debugLogger = new (0, $4NFBi.DebugLogger)(productId, messageId);
        const actionSubject = (0, $kNBjd.MessageAction).START;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $2kDEl.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            if (!this.hasMessageRecord(productId, messageId)) {
                // Bail early here, before even checking if we're in a queueing situation, or blocked, or anything else
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $kNBjd.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $kNBjd.MessageDeliveryStatus).UNREGISTERED;
            }
            // If we're currently queueing messages, push this one onto the queue and return the new Promise
            if (this.state.shouldQueueMessages) {
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: `queued behind ${this.state.queueingBehindMessage?.productId} ${this.state.queueingBehindMessage?.messageId}`
                    }
                });
                return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
            }
            if (this.state.isDisabled || this.isDisplayingMessage()) {
                logger.blocked({
                    blockedByProductId: this.state.currentMessage?.productId,
                    blockedByMessageId: this.state.currentMessage?.messageId
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $kNBjd.MessageDeliveryStatus).BLOCKED,
                        blockedByProductId: this.state.currentMessage?.productId,
                        blockedByMessageId: this.state.currentMessage?.messageId
                    }
                });
                return (0, $kNBjd.MessageDeliveryStatus).BLOCKED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            this.queueMessages(productId, messageId);
            const didStart = await message.start?.() ?? true;
            if (didStart) {
                // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                message.onStart?.();
                logger.started();
                this.disablePlugins(plugin);
                this.setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin, messageTtl);
                // Successfully started the message, flush the queue and mark any pending requests as "blocked"
                this.destroyMessageQueue(plugin);
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $kNBjd.MessageDeliveryStatus).STARTED
                    }
                });
                return (0, $kNBjd.MessageDeliveryStatus).STARTED;
            }
            // Check to see if we have any pending requests in the message queue and attempt to start the next one in line
            this.processQueuedMessage();
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $kNBjd.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $kNBjd.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $kNBjd.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $kNBjd.MessageDeliveryStatus).ERROR;
        }
    }
    /**
	 * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
	 * This version of the stopMessage function is private, and only intended to be called internally, so that it can make use of the forceStop parameter without exposing that to external callers.
	 *
	 * @param productId Unique identifier for the product making the current stopMessage request.
	 * @param messageId Unique identifier for the messageId to be stopped.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param [metricsData] Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @param [forceStop] A boolean to denote whether to forcefully clear the Choreographer's blocked state (used for TTL expiration and unregistering a plugin).
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessageInternal(productId, messageId, analyticsClient, metricsData = {}, plugin, forceStop = false) {
        const debugLogger = new (0, $4NFBi.DebugLogger)(productId, messageId);
        const actionSubject = (0, $kNBjd.MessageAction).STOP;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $2kDEl.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            if (!this.hasMessageRecord(productId, messageId)) {
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $kNBjd.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $kNBjd.MessageDeliveryStatus).UNREGISTERED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            // Enable the message queue *if* the current stopMessage request matches the currentMessage data.
            // Any incoming startMessage requests will be queued while this stopMessage request is in-flight,
            // so that they can be immediately honored if this request comes back successfully.
            if (this.isCurrentMessage(productId, messageId)) this.queueMessages(productId, messageId);
            const didStop = await message.stop?.() ?? true;
            // If we're hitting this from stopCurrentMessage, it means either a TTL has expired, or we're
            // unregistering a plugin. We forceStop the choreographer blocked state here, even if the stop
            // callback returned false.We don't want to block the UI indefinitely, we'll just have to risk
            // 1 additional message collision if the current message's stop callback refuses to clear.
            if (didStop || forceStop) {
                if (this.isCurrentMessage(productId, messageId)) {
                    // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    message.onStop?.();
                    // Only log this even if we're stopping the current message, so we have a 1:1 mapping of starts to stops.
                    // If this is a forced stop, log that in the attributes, so we can track those events specifically.
                    // Also log the value of didStop, so we know if this was a rejected stop attempt that *had* to be force stopped.
                    logger.stopped(forceStop ? {
                        forceStop: forceStop,
                        didStop: didStop
                    } : undefined);
                    // Only clear the message TTL and reenable plugins if we're stopping the *current* message
                    this.clearMessageTtl();
                    this.enablePlugins();
                }
                // Check to see if we have any pending requests in the message queue and attempt to start them
                this.processQueuedMessage();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $kNBjd.MessageDeliveryStatus).STOPPED
                    }
                });
                return (0, $kNBjd.MessageDeliveryStatus).STOPPED;
            }
            // Stopping the message failed, so the UI is still intentionally blocked, flush the queue and mark any pending requests as "blocked"
            this.destroyMessageQueue(plugin);
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $kNBjd.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $kNBjd.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $kNBjd.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $kNBjd.MessageDeliveryStatus).ERROR;
        }
    }
    /**
	 * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
	 *
	 * @param productId Unique identifier for the product making the current stopMessage request.
	 * @param messageId Unique identifier for the messageId to be stopped.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param [metricsData] Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        return this.stopMessageInternal(productId, messageId, analyticsClient, metricsData, plugin);
    }
    /**
	 * Registers a plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
	 *
	 * @param productId Unique identifier to register as the product owner of this plugin.
	 * @param plugin A plugin instance to be registered with the choreographer instance.
	 * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
	 */ registerPlugin(productId, plugin) {
        if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
        this.state.plugins = this.state.plugins.set(productId, plugin);
        this.state.seenTransactionalMessages.set(productId, new Set());
        if (this.state.isDisabled) plugin.disable();
        return ()=>{
            this.unregisterPlugin(productId);
        };
    }
    /**
	 * Validates that a message record is present and ready to be retrieved and/or manipulated.
	 * Creates the message instance if it doesn't yet exist, initializing both start and stop callbacks to noop functions.
	 *
	 * @param productId Unique identifier to retrieve map of IMessage objects.
	 * @param messageId Unique identifier for the messageId to be retrieved.
	 * @returns IMessage object for the requested productId/messageId combination.
	 */ ensureMessageRecord(productId, messageId) {
        let productMessages = this.state.messages.get(productId);
        if (!productMessages) {
            productMessages = new Map();
            this.state.messages.set(productId, productMessages);
        }
        let message = productMessages.get(messageId);
        if (!message) {
            message = {};
            productMessages.set(messageId, message);
        }
        return message;
    }
    /**
	 * Checks for the existance of a message record for a given productId/messageId combination.
	 *
	 * @param productId Unique identifier to check for a map of IMessage objects.
	 * @param messageId Unique identifier to check for within the map of productId IMessage objects.
	 * @returns Boolean indicating whether or not an IMessage record exists for the requested productId/messageId combination.
	 */ hasMessageRecord(productId, messageId) {
        return Boolean(this.state.messages.get(productId)?.has?.(messageId));
    }
    /**
	 * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param options An object containing optional start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ on(productId, messageId, options = {}, finalizers = {}) {
        const message = {
            ...this.ensureMessageRecord(productId, messageId),
            ...options,
            ...finalizers
        };
        this.state.messages.get(productId).set(messageId, message);
    }
    /**
	 * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param startCallback A callback to be invoked upon successful requests to startMessage.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ onStart(productId, messageId, startCallback, finalizers) {
        this.on(productId, messageId, {
            start: startCallback
        }, finalizers);
    }
    /**
	 * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ onStop(productId, messageId, stopCallback, finalizers = {}) {
        this.on(productId, messageId, {
            stop: stopCallback
        }, finalizers);
    }
    /**
	 * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for unsubscribing this message.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for unsubscribing this message.
	 */ off(productId, messageId) {
        this.state.messages.get(productId)?.delete?.(messageId);
    }
    /**
	 * This should only be used for test cleanup purposes.
	 * Clears the seen transactional messages cache for a given productId.
	 *
	 * @param productId Unique identifier to clear the seen transactional messages cache for.
	 */ clearSeenTransactionalMessages(productId) {
        this.state.seenTransactionalMessages.get(productId)?.clear();
    }
}

});
parcelRegister("kNBjd", function(module, exports) {
$parcel$export(module.exports, "MessageEventType", () => $4d9a3881b285b064$export$d33b097e0a285bc2);
$parcel$export(module.exports, "MessageDeliveryStatus", () => $4d9a3881b285b064$export$f6a9504bc1305cf0);
$parcel$export(module.exports, "ProductIds", () => $4d9a3881b285b064$export$7fb117db98868be6);
$parcel$export(module.exports, "MessageTypesEnum", () => $4d9a3881b285b064$export$94e85cf3348f045a);
$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $4d9a3881b285b064$export$dbe9e38c9d6f26d0);
$parcel$export(module.exports, "MessageAction", () => $4d9a3881b285b064$export$865c0eaaa43d90f8);
const $4d9a3881b285b064$export$d33b097e0a285bc2 = {
    START: 'start',
    STOP: 'stop'
};
const $4d9a3881b285b064$export$f6a9504bc1305cf0 = {
    BLOCKED: 'blocked',
    CANCELED: 'canceled',
    ERROR: 'error',
    STARTED: 'started',
    STOPPED: 'stopped',
    UNREGISTERED: 'unregistered',
    // TEMPORARY: used to track when a transactional message is requested to be choreographed
    // when the choreographer is currently blocked.
    REQUESTED: 'requested'
};
var $4d9a3881b285b064$export$7fb117db98868be6 = /*#__PURE__*/ function(ProductIds) {
    ProductIds["CONFLUENCE"] = "confluence";
    ProductIds["ENGAGEKIT"] = "Engagekit";
    ProductIds["INTERCOM"] = "intercom";
    ProductIds["JIRA"] = "jira";
    ProductIds["PENDO"] = "pendo";
    ProductIds["CLOUDADMIN"] = "cloudadmin";
    ProductIds["BITBUCKET"] = "bitbucket";
    ProductIds["POST_OFFICE"] = "post-office";
    ProductIds["LOOM"] = "loom";
    ProductIds["TRELLO"] = "trello";
    return ProductIds;
}({});
const $4d9a3881b285b064$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $4d9a3881b285b064$export$dbe9e38c9d6f26d0 = [
    $4d9a3881b285b064$export$94e85cf3348f045a.ENGAGEMENT,
    $4d9a3881b285b064$export$94e85cf3348f045a.MARKETING
];
const $4d9a3881b285b064$export$865c0eaaa43d90f8 = {
    START: 'messageStart',
    STOP: 'messageStop'
};
const $4d9a3881b285b064$export$fc6a8b8cb405f50 = {
    INFO: 'info',
    VERBOSE: 'verbose'
};

});

parcelRegister("4NFBi", function(module, exports) {
$parcel$export(module.exports, "DebugLogger", () => $8569b70486acd1c2$export$21e6cc849c1dc1ab);
function $8569b70486acd1c2$var$getCurrentLoggingLevel() {
    return window.choreographerLoggingLevel;
}
function $8569b70486acd1c2$var$logMessageIfValidLoggingLevel(loggingLevel, data) {
    if ($8569b70486acd1c2$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.table(data);
}
function $8569b70486acd1c2$var$traceMessageIfValidLoggingLevel(loggingLevel, productId, messageId, message) {
    if ($8569b70486acd1c2$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.log(`CHOREOGRAPHER - ${productId} - ${messageId} - ${message}`);
}
class $8569b70486acd1c2$export$21e6cc849c1dc1ab {
    constructor(productId, messageId){
        /**
	 * A function that takes an object of properties for each logging level
	 * name, e.g. log.info and log.verbose, which are functions that take an
	 * object of any key/value pairs, which will be merged with the productId
	 * and the messageId values passed to the constructor, and output via
	 * console.table.
	 *
	 * Example: debugLogger.log({
	 *   info: { foo: true },
	 *   verbose: {
	 *     foo: true,
	 *     bar: 123,
	 *     baz 'abc',
	 *     timestamp: performance.now()
	 *   },
	 * });
	 *
	 * @param messages Record<LoggingLevels, Record<string, unknown>> An object
	 * keyed by the desired log-level, with each value being an object of any
	 * key/value pairs to be output to console.table.
	 */ this.log = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $8569b70486acd1c2$var$logMessageIfValidLoggingLevel(loggingLevel, {
                    productId: this.state.productId,
                    messageId: this.state.messageId,
                    ...messages[loggingLevel] ?? {},
                    ...loggingLevel === 'verbose' ? {
                        timestamp: performance.now()
                    } : {}
                });
            });
        };
        /**
	 * A function that takes an object of properties for each logging level
	 * name, e.g. trace.info and trace.verbose, which are functions that take
	 * a string to be used as the label for a stack trace via console.trace.
	 *
	 * Example: debugLogger.trace({
	 *   info: 'This is a stack trace',
	 *   verbose: `This is a stack trace with a much more verbose message which
	 * contains data about the ${productId} and ${messageId} within my function,
	 * invoked at ${performance.now()}ms`,
	 * });
	 *
	 * @param messages Record<LoggingLevels, string> An object keyed by the
	 * desired log-level, with each value being a string to be output as the
	 * label to console.trace.
	 */ this.trace = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $8569b70486acd1c2$var$traceMessageIfValidLoggingLevel(loggingLevel, this.state.productId, this.state.messageId, `${messages[loggingLevel]}${loggingLevel === 'verbose' ? ` (${performance.now()})` : ''}`);
            });
        };
        this.state = {
            productId: productId,
            messageId: messageId
        };
    }
}

});

parcelRegister("2kDEl", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $23ea23a5de0d7f2d$export$efa9a398d6368992);

var $kNBjd = parcelRequire("kNBjd");
class $23ea23a5de0d7f2d$export$efa9a398d6368992 {
    /**
	 * Utility class to simplify and allow for wider use of sending operational event to the Analytics web client for logging/metrics.
	 *
	 * @param actionSubject A (MessageActions) string denoting either the start or stop phase of a message.
	 * @param actionSubjectId Unique messageId to be logged with this even.
	 * @param metricsData Additional data from plugin to be sent with event for metrics logging.
	 * @param analyticsClient An instance of AnalyticsWebClient, unique to each caller
	 * @param [plugin] An optional plugin instance.
	 */ constructor(actionSubject, actionSubjectId, metricsData, analyticsClient, plugin){
        this.state = {
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            metricsData: metricsData,
            analyticsClient: analyticsClient,
            plugin: plugin
        };
    }
    /**
	 * Send operational event to the Analytics web client for logging/metrics.
	 *
	 * @param action A (MessageDeliveryStatuses) string denoting the ultimate disposition of this message start or stop request.
	 */ sendOperationalEvent(action, additionalAttributes) {
        const { analyticsClient: analyticsClient, actionSubject: actionSubject, actionSubjectId: actionSubjectId, metricsData: attributes, plugin: plugin } = this.state;
        const event = {
            source: 'choreographer',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...attributes ?? {},
                ...additionalAttributes ?? {}
            },
            tags: [
                'postOffice'
            ]
        };
        if (plugin?.shouldLogEvent?.(event) ?? true) analyticsClient.sendOperationalEvent(event);
    }
    blocked(additionalAttributes) {
        this.sendOperationalEvent((0, $kNBjd.MessageDeliveryStatus).BLOCKED, additionalAttributes);
    }
    error(additionalAttributes) {
        this.sendOperationalEvent((0, $kNBjd.MessageDeliveryStatus).ERROR, additionalAttributes);
    }
    unregistered(additionalAttributes) {
        this.sendOperationalEvent((0, $kNBjd.MessageDeliveryStatus).UNREGISTERED, additionalAttributes);
    }
    started(additionalAttributes) {
        this.sendOperationalEvent((0, $kNBjd.MessageDeliveryStatus).STARTED, additionalAttributes);
    }
    stopped(additionalAttributes) {
        this.sendOperationalEvent((0, $kNBjd.MessageDeliveryStatus).STOPPED, additionalAttributes);
    }
    requested(additionalAttributes) {
        this.sendOperationalEvent((0, $kNBjd.MessageDeliveryStatus).REQUESTED, additionalAttributes);
    }
}

});

parcelRegister("kDVb4", function(module, exports) {
$parcel$export(module.exports, "shouldBeChoreographed", () => $f7a5ebd0622d109b$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "wrapComponentForChoreographer", () => $f7a5ebd0622d109b$export$51d40de083bcc6e7);
$parcel$export(module.exports, "wrapToggleableComponentForChoreographer", () => $f7a5ebd0622d109b$export$7c574bc7a8b74124);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kNBjd = parcelRequire("kNBjd");
const $f7a5ebd0622d109b$export$a8ba9111c7eec9ac = (props, coordinationOptions)=>{
    return Boolean(coordinationOptions?.enableChoreographer) && props?.messageType !== undefined && (0, $kNBjd.IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
};
const $f7a5ebd0622d109b$export$51d40de083bcc6e7 = (Component)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedRender: withChoreographedRender, ...props }) {
        const ChoreographedComponent = (0, $euxye.useMemo)(()=>withChoreographedRender(Component), [
            withChoreographedRender
        ]);
        if (shouldBeChoreographedProp(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, $e79Pd.jsx)(ChoreographedComponent, {
                ...rest
            });
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
            ...rest
        });
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};
const $f7a5ebd0622d109b$export$7c574bc7a8b74124 = (Component, toggleableProp)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedToggle: withChoreographedToggle, ...props }) {
        const ChoreographedComponent = (0, $euxye.useMemo)(()=>withChoreographedToggle(Component, toggleableProp), [
            withChoreographedToggle
        ]);
        if (shouldBeChoreographedProp(props, toggleableProp)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, $e79Pd.jsx)(ChoreographedComponent, {
                ...rest
            });
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
            ...rest
        });
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};

});

parcelRegister("lEbpq", function(module, exports) {
$parcel$export(module.exports, "isIframe", () => $53d528bf824b0b39$export$e6c5ffa684aac4d7);
/**
 * Returns `true` if window is currently nested within an iframe.
 */ function $53d528bf824b0b39$export$e6c5ffa684aac4d7() {
    return window.self !== window.top;
}

});


parcelRegister("blN8U", function(module, exports) {
$parcel$export(module.exports, "ChoreographerPlugin", () => $508a3d7db96bd98f$export$71324a662782c710);

var $gL9hl = parcelRequire("gL9hl");

var $hIipg = parcelRequire("hIipg");

var $ilQ8n = parcelRequire("ilQ8n");
class $508a3d7db96bd98f$export$71324a662782c710 {
    /**
	 * Instantiates a plugin to be used with the main choreographer API. Requires a productId string
	 * to be used for segmenting registered messageIds in other parts of the API, which ensures uniqueness
	 * between individual products for tracking purposes.
	 *
	 * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
	 * @param env The environment type for the product, to be used for analytics events.
	 * @param metaMetricsData An object containing additional metadata to be sent along with every message request.
	 * @returns A new instance of this plugin to use for integrating a 1P or 3P product with the choreographer API.
	 */ constructor(productId, env, metaMetricsData = {}){
        this.state = {
            isDisabled: false,
            isDisplayingMessage: false,
            metaMetricsData: metaMetricsData,
            productId: productId,
            unregisterPlugin: ()=>{}
        };
        this.analyticsClient = this.createAnalyticsClient(env);
        /**
		 * These finalizers are callbacks to be invoked after a valid start or stop request in the Choreographer core.
		 * Declaring them in the constructor because it's the same onStart/onStop pair that will be passed ot all of the
		 * .on, .onStart, and .onStop function registrations.
		 *
		 * This behavior used to be managed by a decorator function that would auto-set the isDisplayingMessage value
		 * whenever its start or stop callbacks were invoked. However, those start and stop callbacks are optional from
		 * this layer, so if a consumer did *not* register a stop callback, the display state would never be cleared here
		 * in the plugin, and would continue blocking messages.
		 *
		 * We're now passing these onStart and onStop callbacks as part of the message registration, so that any time a
		 * message is started or stopped at the core layer, we can fire these callbacks to update the plugin's local state,
		 * whether or not an actual start or stop callback was registered by the consumer.
		 */ this.finalizers = {
            onStart: ()=>this.blockDisplayState(),
            onStop: ()=>this.clearDisplayState()
        };
        this.state.unregisterPlugin = this.registerPlugin(productId);
    }
    /**
	 * Public method to clean up this plugin instance, which will handle unregistering it from the choreographer API.
	 */ destroy() {
        this.state.unregisterPlugin();
    }
    /**
	 * Determines whether this plugin is currently displaying a message on the screen. By default, is a simple boolean
	 * toggle that gets flipped back and forth, but it could also be a function that checks the DOM for a given message
	 * container to be present, or checks with some external API to tell it whether a message is being displayed, or
	 * anything else. The logic is up to the consumer to implement, if something custom is desired.
	 *
	 * @returns A boolean that represents whether this plugin is currently displaying a message on the screen.
	 */ isDisplayingMessage() {
        return this.state.isDisplayingMessage;
    }
    /**
	 * Sets the internal isDisplayingMessage state to true, to denote that this plugin is currently blocking the UI.
	 */ blockDisplayState() {
        this.state.isDisplayingMessage = true;
    }
    /**
	 * Sets the internal isDisplayingMessage state to false, to denote that this plugin is no longer blocking the UI.
	 */ clearDisplayState() {
        this.state.isDisplayingMessage = false;
    }
    /**
	 * Disables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
	 * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
	 * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
	 */ disable() {
        this.state.isDisabled = true;
    }
    /**
	 * Enables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
	 * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
	 * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
	 */ enable() {
        this.state.isDisabled = false;
    }
    /**
	 * Returns the Analytics Web Client instance for this plugin.
	 *
	 * @returns AnalyticsWebClient instance
	 */ getAnalyticsClient() {
        return this.analyticsClient;
    }
    /**
	 * Makes a request to start a message through the choreographer API. Will immediately return false if this plugin
	 * is currently in a disabled state, and will otherwise return the ultimate result of the startMessage request.
	 *
	 * @param messageId The messageId for the message to be started through the choreographer API.
	 * @param additionalData An object containing additional metadata to be sent along with the message start request
	 * @param messageTtl Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use global default (5 minutes).
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ async startMessage(messageId, additionalData = {}, messageTtl) {
        return (0, $ilQ8n.Choreographer).getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        }, this, messageTtl);
    }
    /**
	 * Makes a request to stop a message through the choreographer API. Will return the ultimate result of the stopMessage request.
	 *
	 * @param messageId The messageId for the message to be stopped through the choreographer API.
	 * @param additionalData An object containing additional metadata to be sent along with the message stop request
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessage(messageId, additionalData = {}) {
        return (0, $ilQ8n.Choreographer).getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        });
    }
    /**
	 * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param options An object containing start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
	 */ on(messageId, options = {}) {
        return (0, $ilQ8n.Choreographer).getInstance().on(this.state.productId, messageId, options, this.finalizers);
    }
    /**
	 * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param startCallback A callback to be invoked upon successful requests to startMessage.
	 */ onStart(messageId, startCallback) {
        return (0, $ilQ8n.Choreographer).getInstance().onStart(this.state.productId, messageId, startCallback, this.finalizers);
    }
    /**
	 * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
	 */ onStop(messageId, stopCallback) {
        return (0, $ilQ8n.Choreographer).getInstance().onStop(this.state.productId, messageId, stopCallback, this.finalizers);
    }
    /**
	 * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for unsubscribing this message subscription.
	 */ off(messageId) {
        return (0, $ilQ8n.Choreographer).getInstance().off(this.state.productId, messageId);
    }
    shouldBeChoreographed(props, coordinationOptions, toggleableProp) {
        return (0, $ilQ8n.Choreographer).getInstance().shouldBeChoreographed(this.state.productId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            productId: this.state.productId
        }, props, coordinationOptions, toggleableProp);
    }
    /**
	 * Registers this plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
	 *
	 * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
	 * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
	 */ registerPlugin(productId) {
        return (0, $ilQ8n.Choreographer).getInstance().registerPlugin(productId, this);
    }
    /**
	 * Creates a new instance of the Analytics Web Client for a plugin to use for sending analytics events.
	 *
	 * @param env environment type used to create the analytics client
	 * @returns AnalyticsWebClient instance
	 */ createAnalyticsClient(env) {
        const analyticsClient = new (0, $gL9hl.default)({
            env: env,
            product: 'postOffice',
            origin: (0, $hIipg.originType).WEB
        });
        return analyticsClient;
    }
}

});





parcelRegister("ldPWL", function(module, exports) {
$parcel$export(module.exports, "EngagementProvider", () => $38995a36740a2461$export$83b8ae7ce7b4d59c);
/* eslint-disable max-lines */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $de6m4 = parcelRequire("de6m4");

var $5vPx9 = parcelRequire("5vPx9");

var $bUjzO = parcelRequire("bUjzO");

var $dKGGs = parcelRequire("dKGGs");

var $bEzCm = parcelRequire("bEzCm");

var $f6SzU = parcelRequire("f6SzU");

var $kNBjd = parcelRequire("kNBjd");
var $kDVb4 = parcelRequire("kDVb4");

var $hqF4Z = parcelRequire("hqF4Z");

var $UNic7 = parcelRequire("UNic7");

var $96WS0 = parcelRequire("96WS0");

var $80M6B = parcelRequire("80M6B");

var $jGBYI = parcelRequire("jGBYI");

var $gUVk0 = parcelRequire("gUVk0");

var $9zL0W = parcelRequire("9zL0W");
const $38995a36740a2461$var$MAX_EVENT_QUEUE_SIZE = 100;
const $38995a36740a2461$var$EK_LOADED_EVENT = 'engagement.inproduct.loaded';
const $38995a36740a2461$export$5306bd00631dbf8c = 'ep.analyticEvent';
function $38995a36740a2461$var$collapseEventToPayload(event) {
    const payload = {
        ...event.payload,
        context: {}
    };
    Object.assign(payload.context, ...event.context);
    return payload;
}
function $38995a36740a2461$var$findMatchingTrigger(messageMapping, payload) {
    return Array.from(messageMapping.keys()).find((trigger)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($de6m4)))(payload, trigger);
    });
}
function $38995a36740a2461$var$fireExposureEvent(attributes, clientOrPromise) {
    const analyticsEvent = new (0, $bEzCm.default)({
        payload: {
            action: 'exposed',
            actionSubject: 'feature',
            actionSubjectId: attributes.flagKey,
            source: 'engagement-platform',
            attributes: attributes
        }
    });
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendTrackEvent(analyticsEvent.payload);
    });
}
function $38995a36740a2461$var$getExposureAttributes(messageId, cohort, additionalProps) {
    return {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        flagKey: `engagement.inproduct.${messageId}`,
        value: cohort,
        ...additionalProps
    };
}
function $38995a36740a2461$var$getBaseAttributes(messageId, variationId, componentId, locale) {
    return {
        messageId: messageId,
        variationId: variationId,
        componentIndex: componentId,
        locale: locale
    };
}
async function $38995a36740a2461$export$473a2bbbfd90c87b(eventMapping, config, store, clientOrPromise, coordinationOptions, componentConfig) {
    const { locale: locale } = config;
    const { message: message, component: component } = eventMapping;
    if (message.holdout) {
        await (0, $hqF4Z.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        await (0, $hqF4Z.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        $38995a36740a2461$var$fireExposureEvent($38995a36740a2461$var$getExposureAttributes(message.messageId, 'holdout', {
            locale: locale
        }), clientOrPromise);
        return;
    }
    if (component.componentId === 0) {
        const success = await (0, $hqF4Z.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions?.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(success ? (0, $kNBjd.MessageDeliveryStatus).STARTED : (0, $kNBjd.MessageDeliveryStatus).BLOCKED);
        if (success) {
            $38995a36740a2461$var$fireExposureEvent($38995a36740a2461$var$getExposureAttributes(message.messageId, message.variationId, {
                locale: locale
            }), clientOrPromise);
            store.dispatch((0, $gUVk0.setCurrent)(eventMapping));
        }
    } else {
        $38995a36740a2461$var$fireExposureEvent($38995a36740a2461$var$getExposureAttributes(message.messageId, message.variationId, {
            locale: locale
        }), clientOrPromise);
        store.dispatch((0, $gUVk0.setCurrent)(eventMapping));
    }
}
class $38995a36740a2461$export$83b8ae7ce7b4d59c extends (0, $euxye.Component) {
    static{
        this.componentConfig = new Map();
    }
    static{
        this.childContextTypes = {
            subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($bUjzO))).func,
            setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($bUjzO))).func
        };
    }
    static{
        this.defaultProps = {
            eventTarget: (0, (/*@__PURE__*/$parcel$interopDefault($dKGGs)))
        };
    }
    static{
        /*
	 * We use this flag for ensuring that we only fire the engagement.inproduct.loaded event once. This is an interim solution
	 * until we can more holistically rethink our code architecture to eliminate duplicate behaviour across EngagementProviders.
	 */ this.hasInitializedAtLeastOneEngagementProvider = false;
    }
    constructor(props){
        super(props), this.onStoreChange = (state)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const config = this.getConfig();
            const { locale: locale } = config;
            if (state.initialized) {
                if (!$38995a36740a2461$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider) {
                    this.sendOperationalEventWithClient({
                        action: 'loaded',
                        actionSubject: 'messages',
                        actionSubjectId: undefined,
                        source: 'engagekit',
                        attributes: {
                            locale: locale
                        }
                    });
                    const browserInfo = (0, $96WS0.getBrowserInfo)();
                    this.onEvent(createAnalyticsEvent({
                        event: $38995a36740a2461$var$EK_LOADED_EVENT,
                        properties: {
                            browser: browserInfo.name,
                            browserVersion: browserInfo.version
                        }
                    }));
                    $38995a36740a2461$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = true;
                }
                this.analyticsEventQueue.flush(this.onEvent);
                if (this.unsubscribeFromStore) this.unsubscribeFromStore();
            }
        }, this.onEvent = (event)=>{
            const state = this.getState();
            if (!state.initialized) {
                const success = this.analyticsEventQueue.enqueue(event);
                if (!success) this.fireQueueOverflowEvent();
                return;
            }
            const { eventTarget: eventTarget, store: store, analyticsClientInstance: analyticsClientInstance } = this.props;
            const config = this.getConfig();
            const { current: current, messageMapping: messageMapping } = state;
            const payload = $38995a36740a2461$var$collapseEventToPayload(event);
            eventTarget.dispatchEvent((0, $80M6B.default)({
                eventName: $38995a36740a2461$export$5306bd00631dbf8c,
                canBubble: false,
                cancellable: false,
                detail: payload
            }));
            if (!(0, $jGBYI.isMessagingEnabled)()) return;
            // existing message found
            if (current) return;
            const trigger = $38995a36740a2461$var$findMatchingTrigger(messageMapping, payload);
            // No messages found for trigger
            if (!trigger) return;
            const eventMapping = messageMapping.get(trigger);
            let componentConfig;
            if (eventMapping.component?.componentType) {
                const componentConfigId = this.getConfigId(eventMapping.component.componentType, eventMapping.component.target);
                componentConfig = $38995a36740a2461$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
            }
            const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
            $38995a36740a2461$export$473a2bbbfd90c87b(eventMapping, config, store, analyticsClientInstance, coordinationOptions, componentConfig);
        }, this.onEngagementEvent = (event)=>{
            const { action: action, clickType: clickType, ekMessageId: ekMessageId, ekVariationId: ekVariationId, ekComponentId: ekComponentId, ekComponentType: ekComponentType, ekIsLast: ekIsLast } = event.payload;
            const config = this.getConfig();
            const { locale: locale } = config;
            const attributes = $38995a36740a2461$var$getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
            if (action === 'click') {
                this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
                attributes.buttonType = clickType;
                this.sendUIEventWithClient({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: `${clickType}Button`,
                    source: `engagement_${ekComponentType}`,
                    attributes: attributes
                });
            } else {
                if (action === 'shown') {
                    attributes.componentType = ekComponentType;
                    this.sendScreenEventWithClient({
                        name: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
                if (action === 'hidden') {
                    attributes.isLast = ekIsLast;
                    this.sendUIEventWithClient({
                        action: 'hid',
                        actionSubject: 'component',
                        actionSubjectId: undefined,
                        source: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
            }
            this.onEvent(event);
        }, this.subscribeEngagementState = (callback)=>{
            const { store: store } = this.props;
            callback(store.getState());
            return store.subscribe(()=>{
                callback(store.getState());
            });
        }, this.getComponentCoordinationOptions = (componentConfig)=>{
            // Default enableChoreographer to the EngagementProvider's coordinationOptions
            const enableChoreographer = Boolean(this.props.coordinationOptions?.enableChoreographer);
            return {
                ...this.props.coordinationOptions,
                enableChoreographer: componentConfig?.messageType ? // regardless of the EngagementProvider's coordinationOptions
                (0, $kDVb4.shouldBeChoreographed)(componentConfig, {
                    enableChoreographer: true
                }) : enableChoreographer
            };
        }, this.getConfigId = (componentType, engagementId)=>{
            return engagementId ? `${componentType}-${engagementId}` : componentType;
        }, this.setComponentConfig = (componentType, config, engagementId)=>{
            const configId = this.getConfigId(componentType, engagementId);
            $38995a36740a2461$export$83b8ae7ce7b4d59c.componentConfig.set(configId, config);
            return ()=>this.removeComponentConfig(configId);
        }, this.removeComponentConfig = (configId)=>{
            if ($38995a36740a2461$export$83b8ae7ce7b4d59c.componentConfig.has(configId)) $38995a36740a2461$export$83b8ae7ce7b4d59c.componentConfig.delete(configId);
        };
        const { analyticsClientInstance: analyticsClientInstance } = this.props;
        this.sendUIEventWithClient = (0, $UNic7.sendUIEvent).bind(null, analyticsClientInstance);
        this.sendScreenEventWithClient = (0, $UNic7.sendScreenEvent).bind(null, analyticsClientInstance);
        this.sendOperationalEventWithClient = (0, $UNic7.sendOperationalEvent).bind(null, analyticsClientInstance);
        this.analyticsEventQueue = new (0, $9zL0W.default)($38995a36740a2461$var$MAX_EVENT_QUEUE_SIZE);
        this.unsubscribeFromStore = this.subscribeEngagementState(this.onStoreChange);
        this.fireQueueOverflowEvent = (0, (/*@__PURE__*/$parcel$interopDefault($5vPx9)))(// TODO: create metric for this with Metal
        ()=>{});
    }
    getConfig() {
        const { config: config } = this.getState();
        return config;
    }
    getChildContext() {
        return {
            subscribeEngagementState: this.subscribeEngagementState,
            setComponentConfig: this.setComponentConfig
        };
    }
    getState() {
        return this.props.store.getState();
    }
    getActiveMessage() {
        return this.getState().current;
    }
    async completeMessage(messageId, componentConfig) {
        const config = this.getConfig();
        const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
        const disposition = await (0, $hqF4Z.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(disposition ? (0, $kNBjd.MessageDeliveryStatus).STOPPED : (0, $kNBjd.MessageDeliveryStatus).CANCELED);
    }
    handleClickEvent(messageId, variationId, componentId) {
        const activeMessage = this.getActiveMessage();
        // It is important to check that the event we're handling matches the
        // current active message because it is possible for an event to come
        // through for a past message. We don't want to mess up the current
        // message by calling clearCurrent just because the old message is done.
        if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) return;
        let componentConfig;
        if (activeMessage.componentType) {
            const componentConfigId = this.getConfigId(activeMessage.componentType, activeMessage.target);
            componentConfig = $38995a36740a2461$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
        }
        if (activeMessage.isLast) this.completeMessage(messageId, componentConfig);
        this.props.store.dispatch((0, $gUVk0.clearCurrent)());
    }
    componentWillUnmount() {
        this.unsubscribeFromStore && this.unsubscribeFromStore();
    }
    render() {
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f6SzU.default), {
            channel: "*",
            onEvent: this.onEvent,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f6SzU.default), {
                channel: "engagement",
                onEvent: this.onEngagementEvent,
                children: this.props.children
            })
        });
    }
}
$38995a36740a2461$export$83b8ae7ce7b4d59c.displayName = "EngagementProvider";

});
parcelRegister("UNic7", function(module, exports) {
$parcel$export(module.exports, "sendScreenEvent", () => $2259d9e51f5f556f$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendUIEvent", () => $2259d9e51f5f556f$export$1aecf263098db667);
$parcel$export(module.exports, "sendOperationalEvent", () => $2259d9e51f5f556f$export$e5f89b51c6d4e36b);
function $2259d9e51f5f556f$export$22a3b1671f38a193(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendScreenEvent(payload);
    });
}
function $2259d9e51f5f556f$export$1aecf263098db667(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendUIEvent(payload);
    });
}
function $2259d9e51f5f556f$export$e5f89b51c6d4e36b(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendOperationalEvent(payload);
    });
}

});

parcelRegister("96WS0", function(module, exports) {
$parcel$export(module.exports, "getBrowserInfo", () => $855e2c14a683894f$export$6c724a6ffa2dc3e1);
const $855e2c14a683894f$var$browserMatchers = [
    {
        name: 'IE',
        pattern: /Trident\/.*; rv:([^;)]+)/
    },
    {
        name: 'Chrome',
        pattern: /Chrome\/([^ )]+)/
    },
    {
        name: 'Firefox',
        pattern: /Firefox\/([^ )]+)/
    }
];
const $855e2c14a683894f$export$cda2203640e08931 = {
    name: 'unknown',
    version: 'unknown'
};
function $855e2c14a683894f$export$6c724a6ffa2dc3e1(userAgent) {
    if (!window.navigator) return $855e2c14a683894f$export$cda2203640e08931;
    if (!userAgent) userAgent = window.navigator.userAgent;
    for (const matcher of $855e2c14a683894f$var$browserMatchers){
        const versionMatch = userAgent.match(matcher.pattern);
        if (versionMatch) return {
            name: matcher.name,
            version: versionMatch[1]
        };
    }
    return $855e2c14a683894f$export$cda2203640e08931;
}

});

parcelRegister("80M6B", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0cc3c51162a0c54$export$2e2bcd8739ae039);
const $e0cc3c51162a0c54$var$createCustomEvent = ({ eventName: eventName, canBubble: canBubble, cancellable: cancellable, detail: detail })=>{
    const customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(eventName, canBubble, cancellable, detail);
    return customEvent;
};
var $e0cc3c51162a0c54$export$2e2bcd8739ae039 = $e0cc3c51162a0c54$var$createCustomEvent;

});

parcelRegister("9zL0W", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c6b7c805a48f462$export$2e2bcd8739ae039);
class $7c6b7c805a48f462$export$2e2bcd8739ae039 {
    constructor(maxSize){
        this.queue = [];
        this.maxSize = maxSize;
    }
    enqueue(item) {
        if (this.queue.length === this.maxSize) return false;
        this.queue.push(item);
        return true;
    }
    flush(callback) {
        this.queue.forEach(callback);
        this.queue = [];
    }
    getSize() {
        return this.queue.length;
    }
}

});



parcelRegister("8dImz", function(module, exports) {
$parcel$export(module.exports, "createLoaderError", () => $614f665c6ef0ab83$export$c73a6a6f0bf7d425);
$parcel$export(module.exports, "isLoaderError", () => $614f665c6ef0ab83$export$16a03aca4a3508b4);
const $614f665c6ef0ab83$export$6aa69c1258005366 = Symbol.for('@atlassian/react-loosely-lazy/loader-error');
const $614f665c6ef0ab83$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$614f665c6ef0ab83$export$6aa69c1258005366]: true
    });
    return error;
};
const $614f665c6ef0ab83$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($614f665c6ef0ab83$export$6aa69c1258005366);

});

parcelRegister("2OUOK", function(module, exports) {
$parcel$export(module.exports, "setCurrent", () => $86035c011f620560$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $86035c011f620560$export$5a25eca35e5debcb);
$parcel$export(module.exports, "useLazyPhase", () => $86035c011f620560$export$1dc361b277327f88);

var $euxye = parcelRequire("euxye");

var $80sUF = parcelRequire("80sUF");

var $c1NIs = parcelRequire("c1NIs");

var $2EKh3 = parcelRequire("2EKh3");
let $86035c011f620560$var$CURRENT_PHASE = (0, $80sUF.PHASE).PAINT;
const $86035c011f620560$export$5f80f094fd31fffd = (phase)=>{
    $86035c011f620560$var$CURRENT_PHASE = phase;
    (0, $c1NIs.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $86035c011f620560$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $euxye.createContext)({
    subscribe: (0, $2EKh3.createSubscribe)((0, $c1NIs.LISTENERS)),
    currentValue: ()=>$86035c011f620560$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $86035c011f620560$export$5f80f094fd31fffd((0, $80sUF.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$86035c011f620560$export$5f80f094fd31fffd((0, $80sUF.PHASE).PAINT)
    }
});
const $86035c011f620560$export$1dc361b277327f88 = ()=>{
    const v = (0, $euxye.useContext)($86035c011f620560$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("80sUF", function(module, exports) {
$parcel$export(module.exports, "PHASE", () => $e96ff9bdb019aca4$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $e96ff9bdb019aca4$export$4831ef3968ea94ef);
const $e96ff9bdb019aca4$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $e96ff9bdb019aca4$export$4831ef3968ea94ef = new Map();

});

parcelRegister("c1NIs", function(module, exports) {
$parcel$export(module.exports, "LISTENERS", () => $f8781e20bc6a21f7$export$81b9c458a026d68f);
const $f8781e20bc6a21f7$export$81b9c458a026d68f = [];

});

parcelRegister("2EKh3", function(module, exports) {
$parcel$export(module.exports, "createSubscribe", () => $d1b48dd87828a3f1$export$364097d812234b3f);
const $d1b48dd87828a3f1$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});


parcelRegister("8tMC2", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $83d2a3478d203439$export$9ba3fe09d15de47b);

var $euxye = parcelRequire("euxye");

var $cBQLp = parcelRequire("cBQLp");
const $83d2a3478d203439$export$9ba3fe09d15de47b = (0, $euxye.createContext)({
    subscribe: ()=>(0, $cBQLp.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("cBQLp", function(module, exports) {
$parcel$export(module.exports, "noopCleanup", () => $fe2995d47191912c$export$276c7dbda7675aec);
const $fe2995d47191912c$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};

});


parcelRegister("6x5Yw", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $5b04cceb441b2779$export$256c542058532d6f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1bdwq = parcelRequire("1bdwq");

var $isKx1 = parcelRequire("isKx1");
var $ewaCu = parcelRequire("ewaCu");

var $9iZcB = parcelRequire("9iZcB");
class $5b04cceb441b2779$export$256c542058532d6f extends (0, $euxye.Component) {
    constructor(props){
        super(props), this.state = {
            getIsBoundaryInitialized: ()=>Boolean(this.hydrationFallback),
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted && !(0, $isKx1.getConfig)().react18) this.forceUpdate();
            },
            name: this.props.name
        }, this.hydrationFallback = null, this.mounted = false, this.renderedSuspenseFallback = false, this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $euxye.useLayoutEffect)(()=>{
                if (!outsideSuspense) this.renderedSuspenseFallback = true;
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        }, this.DynamicReact18Fallback = ({ children: children })=>{
            (0, $euxye.useLayoutEffect)(()=>{
                this.renderedSuspenseFallback = true;
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    // - this is more "stable" way that tracking completion inside createComponentClient
                    // - we are done when fallback is removed
                    this.state.setFallback(null);
                };
            }, []);
            if ((0, $isKx1.getConfig)().mode === (0, $ewaCu.MODE).HYDRATE) return children(this.props.fallback);
            return children(this.hydrationFallback || this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
        this.DynamicReact18Fallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
        // It is possible that the fallback is never rendered if React already
        // knows the lazy component was already resolved. In our case this means
        // nothing has suspended in the last render cycle. In that case, when the
        // component is mounted, renderedSuspenseFallback will not be set and
        // there is nothing that can clean up the hydration fallback, and we
        // can immediately clean it here.
        // Also see https://atlassian.slack.com/archives/CFGR2NAUA/p1741009492576969
        if (!this.renderedSuspenseFallback) this.state.setFallback(null);
    }
    shouldComponentUpdate() {
        const { mode: mode, react18: react18 } = (0, $isKx1.getConfig)();
        if (react18 && mode === (0, $ewaCu.MODE).HYDRATE) // This is a workaround to prevent Suspense during hydration
        // from switching to the fallback if a re-render occurs
        // https://github.com/facebook/react/issues/22692
        // is shouldComponentUpdate => false if it's "busy"
        return this.hydrationFallback ? false : true;
        return true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, $e79Pd.jsx)(DynamicFallback, {
            outsideSuspense: outsideSuspense,
            children: (fallback)=>fallback
        });
    }
    renderReact18Fallback() {
        const { DynamicReact18Fallback: DynamicReact18Fallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, $e79Pd.jsx)(DynamicReact18Fallback, {
            children: (fallback)=>fallback
        });
    }
    renderServer() {
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9iZcB.LazySuspenseContext).Provider, {
            value: this.state,
            children: this.props.children
        });
    }
    renderClient() {
        return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $9iZcB.LazySuspenseContext).Provider, {
            value: this.state,
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
                    fallback: this.renderFallback(false),
                    children: this.props.children
                }),
                (!this.mounted || this.hydrationFallback) && this.renderFallback(true)
            ]
        });
    }
    render() {
        const { react18: react18 } = (0, $isKx1.getConfig)();
        if (react18) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9iZcB.LazySuspenseContext).Provider, {
            value: this.state,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
                fallback: this.renderReact18Fallback(),
                children: this.props.children
            })
        });
        return (0, $1bdwq.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}
$5b04cceb441b2779$export$256c542058532d6f.displayName = "LazySuspense";

});
parcelRegister("1bdwq", function(module, exports) {
$parcel$export(module.exports, "getExport", () => $b586f81372930c2a$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $b586f81372930c2a$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $b586f81372930c2a$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $b586f81372930c2a$export$62bf630d0de3d781);

var $4JGPE = parcelRequire("4JGPE");
const $b586f81372930c2a$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $b586f81372930c2a$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $b586f81372930c2a$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $b586f81372930c2a$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("4JGPE", function(module, exports) {
$parcel$export(module.exports, "default", () => $2abc4d7e29802490$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $2abc4d7e29802490$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-ignore TS7029 fallthrough
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-ignore TS7029 fallthrough
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("isKx1", function(module, exports) {
$parcel$export(module.exports, "getConfig", () => $71c9eca6994f7f9a$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $71c9eca6994f7f9a$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("ewaCu")).MODE);

var $ewaCu = parcelRequire("ewaCu");
const $71c9eca6994f7f9a$var$DEFAULT_CROSS_ORIGIN = undefined;
const $71c9eca6994f7f9a$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $71c9eca6994f7f9a$var$DEFAULT_MODE = (0, $ewaCu.MODE).HYDRATE;
const $71c9eca6994f7f9a$var$DEFAULT_RETRY = 2;
const $71c9eca6994f7f9a$var$nullFunction = ()=>{};
const $71c9eca6994f7f9a$var$config = {
    crossOrigin: $71c9eca6994f7f9a$var$DEFAULT_CROSS_ORIGIN,
    manifest: $71c9eca6994f7f9a$var$DEFAULT_MANIFEST,
    mode: $71c9eca6994f7f9a$var$DEFAULT_MODE,
    retry: $71c9eca6994f7f9a$var$DEFAULT_RETRY,
    react18: false,
    onChunkRender: $71c9eca6994f7f9a$var$nullFunction,
    usePostTaskPhases: false,
    modernErrorFallback: false,
    markedForPreload: [],
    environment: undefined
};
const $71c9eca6994f7f9a$export$44487a86467333c3 = ()=>$71c9eca6994f7f9a$var$config;
const $71c9eca6994f7f9a$export$940a7873bb071df8 = (nextConfig)=>{
    $71c9eca6994f7f9a$var$config.crossOrigin = nextConfig.crossOrigin ?? $71c9eca6994f7f9a$var$DEFAULT_CROSS_ORIGIN;
    $71c9eca6994f7f9a$var$config.manifest = nextConfig.manifest ?? $71c9eca6994f7f9a$var$DEFAULT_MANIFEST;
    $71c9eca6994f7f9a$var$config.mode = nextConfig.mode ?? $71c9eca6994f7f9a$var$DEFAULT_MODE;
    $71c9eca6994f7f9a$var$config.retry = nextConfig.retry ?? $71c9eca6994f7f9a$var$DEFAULT_RETRY;
    $71c9eca6994f7f9a$var$config.react18 = nextConfig.react18 ?? false;
    $71c9eca6994f7f9a$var$config.onChunkRender = nextConfig.onChunkRender ?? $71c9eca6994f7f9a$var$nullFunction;
    $71c9eca6994f7f9a$var$config.usePostTaskPhases = nextConfig.usePostTaskPhases ?? false;
    $71c9eca6994f7f9a$var$config.modernErrorFallback = nextConfig.modernErrorFallback ?? false;
    $71c9eca6994f7f9a$var$config.markedForPreload = nextConfig.markedForPreload ?? undefined;
    $71c9eca6994f7f9a$var$config.environment = nextConfig.environment ?? undefined;
};

});
parcelRegister("ewaCu", function(module, exports) {
$parcel$export(module.exports, "MODE", () => $d423dd18a8dc2c6d$export$e48589d9e4824227);
const $d423dd18a8dc2c6d$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("9iZcB", function(module, exports) {
$parcel$export(module.exports, "LazySuspenseContext", () => $d58545bd3aa1b4a4$export$c33990e84065970c);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $isKx1 = parcelRequire("isKx1");
var $ewaCu = parcelRequire("ewaCu");
const $d58545bd3aa1b4a4$export$c33990e84065970c = /*#__PURE__*/ (0, $euxye.createContext)({
    getIsBoundaryInitialized: ()=>false,
    fallback: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {}),
    setFallback: ()=>{
        if ((0, $isKx1.getConfig)().mode === (0, $ewaCu.MODE).RENDER) // render mode MUST have a properly configured boundary
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});


parcelRegister("l8G1z", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => $b3078c781045bf7e$export$c952e5f94576010e);
$parcel$export(module.exports, "lazyAfterPaint", () => $b3078c781045bf7e$export$291dd592399bdafa);
$parcel$export(module.exports, "lazy", () => $b3078c781045bf7e$export$488013bae63b21da);

var $a5UQ3 = parcelRequire("a5UQ3");

var $bCiN9 = parcelRequire("bCiN9");

var $isKx1 = parcelRequire("isKx1");

var $80sUF = parcelRequire("80sUF");

var $1bdwq = parcelRequire("1bdwq");
var $4JGPE = parcelRequire("4JGPE");

var $ads5G = parcelRequire("ads5G");

var $1hpgH = parcelRequire("1hpgH");

var $cpbLS = parcelRequire("cpbLS");

var $f7W9v = parcelRequire("f7W9v");

var $ety4j = parcelRequire("ety4j");

var $2J7hj = parcelRequire("2J7hj");

function $b3078c781045bf7e$var$noop() {}
function $b3078c781045bf7e$var$deferToPhase(phase) {
    switch(phase){
        case (0, $80sUF.PHASE).PAINT:
            return (0, $bCiN9.postTask)($b3078c781045bf7e$var$noop, {
                priority: 'user-blocking'
            });
        case (0, $80sUF.PHASE).AFTER_PAINT:
            return (0, $bCiN9.postTask)($b3078c781045bf7e$var$noop, {
                priority: 'user-visible'
            });
        case (0, $80sUF.PHASE).LAZY:
            return (0, $bCiN9.postTask)($b3078c781045bf7e$var$noop, {
                priority: 'background'
            });
        default:
            return Promise.resolve();
    }
}
function $b3078c781045bf7e$var$lazyProxy(loader, { defer: defer = (0, $80sUF.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $1bdwq.isNodeEnvironment)();
    const dataLazyId = (0, $4JGPE.default)(moduleId);
    // eslint-disable-next-line @typescript-eslint/no-restricted-types
    const LazyInternal = isServer ? (0, $1hpgH.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $ads5G.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $f7W9v.createDeferred)(dataLazyId, {
            loader: ()=>{
                const { retry: maxAttempts, usePostTaskPhases: usePostTaskPhases } = (0, $isKx1.getConfig)();
                const deferredLoader = usePostTaskPhases ? ()=>$b3078c781045bf7e$var$deferToPhase(defer).then(()=>loader()) : loader;
                return (0, $2J7hj.retry)(deferredLoader, {
                    delay: (0, $cpbLS.RETRY_DELAY),
                    factor: (0, $cpbLS.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $1bdwq.displayNameFromId)(moduleId)})`;
    /**
	 * Allows getting module chunks urls
	 */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $isKx1.getConfig)();
        return (0, $a5UQ3.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
	 * Allows imperatively preload/ prefetch the module chunk asset
	 */ const preload = (priority)=>{
        const p = priority ?? (defer === (0, $80sUF.PHASE).PAINT ? (0, $cpbLS.PRIORITY).HIGH : (0, $cpbLS.PRIORITY).LOW);
        return (0, $ety4j.preloadAsset)({
            loader: loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        moduleId: moduleId,
        preload: preload
    });
}
const $b3078c781045bf7e$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $80sUF.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $80sUF.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $80sUF.PHASE).LAZY
    }
};
function $b3078c781045bf7e$export$c952e5f94576010e(loader, opts) {
    return $b3078c781045bf7e$var$lazyProxy(loader, {
        ...$b3078c781045bf7e$export$93ca5d3f8675ae4c.lazyForPaint,
        ...opts || {}
    });
}
function $b3078c781045bf7e$export$291dd592399bdafa(loader, opts) {
    return $b3078c781045bf7e$var$lazyProxy(loader, {
        ...$b3078c781045bf7e$export$93ca5d3f8675ae4c.lazyAfterPaint,
        ...opts || {}
    });
}
function $b3078c781045bf7e$export$488013bae63b21da(loader, opts) {
    return $b3078c781045bf7e$var$lazyProxy(loader, {
        ...$b3078c781045bf7e$export$93ca5d3f8675ae4c.lazy,
        ...opts || {}
    });
}

});
parcelRegister("a5UQ3", function(module, exports) {
$parcel$export(module.exports, "getAssetUrlsFromId", () => $b01a050036c7a944$export$303f43e55cf1ef2f);
const $b01a050036c7a944$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("bCiN9", function(module, exports) {
$parcel$export(module.exports, "postTask", () => $2ea673e7e242f4f3$export$13c9d02ca54955a3);
async function $2ea673e7e242f4f3$var$toPromise(callback) {
    return callback();
}
function $2ea673e7e242f4f3$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $2ea673e7e242f4f3$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $2ea673e7e242f4f3$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("ca3Mx")).then(()=>$2ea673e7e242f4f3$var$getScheduler(globalThis).postTask(callback, options));
        return $2ea673e7e242f4f3$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}

});
parcelRegister("ca3Mx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jxnjo").then(()=>parcelRequire('d6x8a'));

});
parcelRegister("4cvLQ", function(module, exports) {
"use strict";

function $30f0ed6275c09e08$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("96thM")).resolve(id));
}
module.exports = $30f0ed6275c09e08$var$load;

});
parcelRegister("96thM", function(module, exports) {
$parcel$export(module.exports, "register", () => $6a0b641ff72a0641$export$6503ec6e8aabbaf, (v) => $6a0b641ff72a0641$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $6a0b641ff72a0641$export$f7ad0328861e2f03, (v) => $6a0b641ff72a0641$export$f7ad0328861e2f03 = v);
var $6a0b641ff72a0641$export$6503ec6e8aabbaf;
var $6a0b641ff72a0641$export$f7ad0328861e2f03;
"use strict";
var $6a0b641ff72a0641$var$mapping = new Map();
function $6a0b641ff72a0641$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$6a0b641ff72a0641$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $6a0b641ff72a0641$var$resolve(id) {
    var resolved = $6a0b641ff72a0641$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$6a0b641ff72a0641$export$6503ec6e8aabbaf = $6a0b641ff72a0641$var$register;
$6a0b641ff72a0641$export$f7ad0328861e2f03 = $6a0b641ff72a0641$var$resolve;

});




parcelRegister("ads5G", function(module, exports) {
$parcel$export(module.exports, "createComponentClient", () => $497d76a3746aba7d$export$6898b5504b58699a);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $isKx1 = parcelRequire("isKx1");
var $ewaCu = parcelRequire("ewaCu");

var $80sUF = parcelRequire("80sUF");

var $8tMC2 = parcelRequire("8tMC2");

var $2OUOK = parcelRequire("2OUOK");

var $gQRLr = parcelRequire("gQRLr");

var $9iZcB = parcelRequire("9iZcB");

var $8dImz = parcelRequire("8dImz");

var $fhirh = parcelRequire("fhirh");

var $37luI = parcelRequire("37luI");

var $4qiNR = parcelRequire("4qiNR");
function $497d76a3746aba7d$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $euxye.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $euxye.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $80sUF.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $80sUF.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const { usePostTaskPhases: usePostTaskPhases } = (0, $isKx1.getConfig)();
        const { setFallback: setFallback, getIsBoundaryInitialized: getIsBoundaryInitialized } = (0, $euxye.useContext)((0, $9iZcB.LazySuspenseContext));
        const profiler = (0, $euxye.useContext)((0, $gQRLr.ProfilerContext)).current;
        const load = ()=>{
            if (usePostTaskPhases) {
                if (status.started) return;
            } else {
                if (status.started || !status.phase || !status.noWait) return;
            }
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $8dImz.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        if (usePostTaskPhases) // Start loading immediately, as the loader itself will be delayed until the appropriate phase
        (0, $euxye.useMemo)(()=>{
            load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        else {
            // Subscribe to LazyWait context, triggering load when until is true
            (0, $4qiNR.useSubscription)({
                context: (0, $8tMC2.WaitContext),
                load: load,
                onValue: (v)=>status.noWait = v === 1
            });
            if (defer === (0, $80sUF.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $4qiNR.useSubscription)({
                context: (0, $2OUOK.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
        }
        (0, $euxye.useMemo)(()=>{
            // Skip collecting fallbacks if the boundary is already initialized
            if (usePostTaskPhases && getIsBoundaryInitialized()) return;
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $80sUF.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $isKx1.getConfig)().mode === (0, $ewaCu.MODE).RENDER ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $37luI.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fhirh.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback,
            getIsBoundaryInitialized,
            usePostTaskPhases
        ]);
        (0, $euxye.useMemo)(()=>{
            const { mode: mode, react18: react18 } = (0, $isKx1.getConfig)();
            // we dont remove fallback in RENDER mode as it happens too early
            // however it's not a problem for HYDRATION as Suspense will handle all nuances
            if (mode === (0, $ewaCu.MODE).HYDRATE && react18) // Allow hydration to support partials without server components
            // suspense will discard ssr during hydration if re-renders so we
            // set a dummy fallback to block updates from the provider until we resolve
            setFallback(/*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {}));
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, $e79Pd.jsx)(ResolvedLazy, {
            ...props
        });
    };
}

});
parcelRegister("gQRLr", function(module, exports) {
$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $584873d4b8491a1e$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $584873d4b8491a1e$export$8146ab57a3f7a7cb);

var $euxye = parcelRequire("euxye");
const $584873d4b8491a1e$export$e2d53c0cbedd2710 = {
    current: null
};
const $584873d4b8491a1e$export$8146ab57a3f7a7cb = (0, $euxye.createContext)($584873d4b8491a1e$export$e2d53c0cbedd2710);

});

parcelRegister("fhirh", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $cc2e1b30627070ee$export$ca5b8fbc835d95e4);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1bdwq = parcelRequire("1bdwq");
const $cc2e1b30627070ee$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                type: "hidden",
                "data-lazy-begin": id
            }),
            content.map((el, i)=>{
                const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
                const props = Array.from(attributes).reduce((0, $1bdwq.attrToProp), {
                    key: String(i)
                });
                // text node
                if (!tagName) return /*#__PURE__*/ (0, $euxye.createElement)((0, $euxye.Fragment), props, el.textContent);
                // childless tag
                if (!childNodes.length) return /*#__PURE__*/ (0, $euxye.createElement)(tagName.toLowerCase(), props);
                // tag with content
                return /*#__PURE__*/ (0, $euxye.createElement)(tagName.toLowerCase(), {
                    ...props,
                    dangerouslySetInnerHTML: {
                        __html: ''
                    },
                    suppressHydrationWarning: true
                });
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                type: "hidden",
                "data-lazy-end": id
            })
        ]
    });
};
$cc2e1b30627070ee$export$ca5b8fbc835d95e4.displayName = "PlaceholderFallbackHydrate";

});

parcelRegister("37luI", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackRender", () => $27eef539faa64a32$export$d55db778a3e1446b);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $gQRLr = parcelRequire("gQRLr");

var $8tMC2 = parcelRequire("8tMC2");

var $9iZcB = parcelRequire("9iZcB");
function $27eef539faa64a32$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $27eef539faa64a32$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $euxye.useRef)(null);
    const { current: ssrDomNodes } = (0, $euxye.useRef)(content || []);
    const profilerContext = (0, $euxye.useContext)((0, $gQRLr.ProfilerContext)).current;
    const waitContext = (0, $euxye.useContext)((0, $8tMC2.WaitContext));
    const suspenseContext = (0, $euxye.useContext)((0, $9iZcB.LazySuspenseContext));
    (0, $euxye.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext?.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($27eef539faa64a32$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext?.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>node.parentNode?.removeChild(node));
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $27eef539faa64a32$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $27eef539faa64a32$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
$27eef539faa64a32$export$d55db778a3e1446b.displayName = "PlaceholderFallbackRender";

});

parcelRegister("4qiNR", function(module, exports) {
$parcel$export(module.exports, "useSubscription", () => $98b90075c05eba74$export$368b4214baeb914c);

var $euxye = parcelRequire("euxye");
function $98b90075c05eba74$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $euxye.useContext)(context);
    (0, $euxye.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("1hpgH", function(module, exports) {
$parcel$export(module.exports, "createComponentServer", () => $a306b786e2672730$export$eb2e4b04351cdd9e);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $a5UQ3 = parcelRequire("a5UQ3");

var $isKx1 = parcelRequire("isKx1");
var $ewaCu = parcelRequire("ewaCu");

var $80sUF = parcelRequire("80sUF");

var $9iZcB = parcelRequire("9iZcB");

var $1bdwq = parcelRequire("1bdwq");

var $8dImz = parcelRequire("8dImz");
function $a306b786e2672730$var$load(moduleId, loader) {
    try {
        return (0, $1bdwq.getExport)(loader());
    } catch (err) {
        throw (0, $8dImz.createLoaderError)(err);
    }
}
function $a306b786e2672730$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        const { fallback: fallback } = (0, $euxye.useContext)((0, $9iZcB.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest, onChunkRender: onChunkRender, mode: mode, react18: react18, modernErrorFallback: modernErrorFallback, environment: environment } = (0, $isKx1.getConfig)();
        const shouldLoad = ssr || environment === 'client';
        const Resolved = shouldLoad ? $a306b786e2672730$var$load(moduleId, loader) : null;
        onChunkRender(dataLazyId, moduleId, defer);
        if (mode === (0, $ewaCu.MODE).HYDRATE && react18) {
            if (!Resolved) throw new $a306b786e2672730$var$ReactLooselyLazyNoSsrError(moduleId);
            return /*#__PURE__*/ (0, $e79Pd.jsx)(Resolved, {
                ...props
            });
        }
        if (modernErrorFallback) {
            if (!Resolved) // lets just return the fallback without extra fuzz
            // and "error" fallback is usually totally empty, so why bother?
            return fallback;
        }
        return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                    type: "hidden",
                    "data-lazy-begin": dataLazyId
                }),
                defer !== (0, $80sUF.PHASE).LAZY && (0, $a5UQ3.getAssetUrlsFromId)(manifest, moduleId)?.map((url)=>/*#__PURE__*/ (0, $e79Pd.jsx)("link", {
                        rel: defer === (0, $80sUF.PHASE).PAINT ? 'preload' : 'prefetch',
                        href: url,
                        crossOrigin: crossOrigin,
                        as: "script"
                    }, url)),
                Resolved ? /*#__PURE__*/ (0, $e79Pd.jsx)(Resolved, {
                    ...props
                }) : fallback,
                /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                    type: "hidden",
                    "data-lazy-end": dataLazyId
                })
            ]
        });
    };
}
class $a306b786e2672730$var$ReactLooselyLazyNoSsrError extends Error {
    constructor(moduleId){
        super(`[no-error] React-Loosely-Lazy SSR opt out - ${moduleId}`);
        // This error is used to indicate to React that this component should not
        // render in SSR (it will instead trigger the nearest Suspense boundary)
        // so we mark it as ignored in SSR reporting.
        this.skipSsr = true;
    }
}
$a306b786e2672730$var$ReactLooselyLazyNoSsrError.displayName = "ReactLooselyLazyNoSsrError";

});

parcelRegister("cpbLS", function(module, exports) {
$parcel$export(module.exports, "PRIORITY", () => $248eae72c31407f4$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $248eae72c31407f4$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $248eae72c31407f4$export$ba64c908e55507fe);
const $248eae72c31407f4$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $248eae72c31407f4$export$a339266ad71b2447 = 300;
const $248eae72c31407f4$export$ba64c908e55507fe = 1;

});

parcelRegister("f7W9v", function(module, exports) {
$parcel$export(module.exports, "preloadMarkedIds", () => $70ee02e5e7747b4e$export$ac21d099cbc8d569);
$parcel$export(module.exports, "createDeferred", () => $70ee02e5e7747b4e$export$e673efccd97e4223);
/**
 * a map of all created deferred to
 * - ensure there is single deferred created for every lazy (NOT YET ENFORCED/USED)
 * - track list of known LazyComponents so we can, for example, preload them by id
 */ const $70ee02e5e7747b4e$var$lazyIds = new Map();
/**
 * ids "marked" for preload on spot
 */ let $70ee02e5e7747b4e$var$preloadIds;
const $70ee02e5e7747b4e$export$ac21d099cbc8d569 = (preload)=>{
    $70ee02e5e7747b4e$var$preloadIds = preload;
    try {
        $70ee02e5e7747b4e$var$preloadIds.forEach((lazyId)=>{
            const deffered = $70ee02e5e7747b4e$var$lazyIds.get(lazyId);
            if (deffered) // preload dont have any "phases" and visa versa. Just load it ASAP
            deffered.preload();
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('RLL preload', e);
    }
};
const $70ee02e5e7747b4e$export$e673efccd97e4223 = (lazyId, { loader: loader, preload: preload })=>{
    // we dont cache deferred FOR NOW as the goal is to handle networking first
    // the next step would in better pre-resolving deferred, so Suspense might be never triggered
    // if (lazyIds.has(lazyId)) {
    // 	return lazyIds.get(lazyId)!;
    // }
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: ()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        },
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    $70ee02e5e7747b4e$var$lazyIds.set(lazyId, deferred);
    // in case of "just created" deferred is already marked for preload
    // do instant preload
    if ($70ee02e5e7747b4e$var$preloadIds?.includes(lazyId)) deferred.preload();
    return deferred;
};

});

parcelRegister("ety4j", function(module, exports) {
$parcel$export(module.exports, "preloadAsset", () => $280d1f92dc390d45$export$25bad4aa00c45355);

var $a5UQ3 = parcelRequire("a5UQ3");

var $cBQLp = parcelRequire("cBQLp");

var $isKx1 = parcelRequire("isKx1");

var $gQRLr = parcelRequire("gQRLr");

var $1bdwq = parcelRequire("1bdwq");

var $cpbLS = parcelRequire("cpbLS");

var $3cogd = parcelRequire("3cogd");
function $280d1f92dc390d45$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $isKx1.getConfig)();
    const assets = (0, $a5UQ3.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $3cogd.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $280d1f92dc390d45$var$fakePromise = {
    then: ()=>$280d1f92dc390d45$var$fakePromise,
    catch: ()=>$280d1f92dc390d45$var$fakePromise,
    finally: ()=>$280d1f92dc390d45$var$fakePromise
};
function $280d1f92dc390d45$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $3cogd.insertLinkTag)(href, rel));
        return $280d1f92dc390d45$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $280d1f92dc390d45$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $cBQLp.noopCleanup;
}
function $280d1f92dc390d45$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    if ((0, $1bdwq.isNodeEnvironment)()) return 0, $cBQLp.noopCleanup;
    (0, $gQRLr.GlobalReactLooselyLazyProfiler).current?.onPreload(moduleId, priority);
    const rel = priority === (0, $cpbLS.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $280d1f92dc390d45$export$3af04dbcb01bad4d,
        $280d1f92dc390d45$export$1046fd6a49d5e7a,
        $280d1f92dc390d45$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $cBQLp.noopCleanup;
}

});
parcelRegister("3cogd", function(module, exports) {
$parcel$export(module.exports, "insertLinkTag", () => $9c9db44e0cd1d8d0$export$6610512821c8a4ce);

var $cBQLp = parcelRequire("cBQLp");

var $isKx1 = parcelRequire("isKx1");

var $gQRLr = parcelRequire("gQRLr");
function $9c9db44e0cd1d8d0$export$6610512821c8a4ce(href, rel) {
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $cBQLp.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $isKx1.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $gQRLr.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    document.head?.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) document.head?.removeChild(link);
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});


parcelRegister("2J7hj", function(module, exports) {
$parcel$export(module.exports, "retry", () => $6adb8320bbbce965$export$9369b12211e1fce4);
const $6adb8320bbbce965$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $6adb8320bbbce965$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $6adb8320bbbce965$var$getPolicy = (configuration)=>({
        delay: Math.max(0, configuration.delay ?? 0),
        factor: Math.max(0, configuration.factor ?? 0),
        maxAttempts: Math.max(0, configuration.maxAttempts ?? 0)
    });
function $6adb8320bbbce965$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $6adb8320bbbce965$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $6adb8320bbbce965$var$calculateDelay(context, policy);
        if (delay) await $6adb8320bbbce965$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});


parcelRegister("bnIXS", function(module, exports) {
$parcel$export(module.exports, "default", () => $93894541286dde5e$export$2e2bcd8739ae039);

var $cpIwU = parcelRequire("cpIwU");

var $jO1re = parcelRequire("jO1re");
const $93894541286dde5e$var$DEFAULT_TIMING = {
    initialPollInterval: 5000,
    idleTimeout: 30000,
    multiplierCallback: (x)=>x + x
};
class $93894541286dde5e$export$2e2bcd8739ae039 {
    /**
	 * Callback for sending a 'track' analytics event. This callback should either be the
	 * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
	 * The data for the dwell event will be passed to this method for sending.
	 *
	 * @callback trackCallback
	 * @param {Object} eventData - the base event data that will be added to the track event.
	 */ /**
	 * Creates and initialises the DwellTimeHelper.
	 *
	 * @param {trackCallback} trackCallback - the track callback responsible for actually sending
	 * the event.
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * Additional dwell time attributes will be appended to this data. Note that you don't need to
	 * include the 'action' property, as this will be added automatically.
	 * @param {?string} searchSessionId - a unique identifier for the related search session.
	 * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
	 * timing used for measuring dwell time. The following values are possible:
	 * - initialPollInterval: how long to wait before the first dwell milestone event
	 * is fired (in seconds). Default = 5.
	 * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
	 * event. Default = 2.
	 * - idleTimeout: how long to wait for no user activity before pausing
	 * the dwell timer (in seconds). Default = 30s.
	 */ constructor(trackCallback, eventData, searchSessionId, timingOptions){
        /**
	 * Starts the dwell timer. This method should be called upon the initial page load.
	 */ this.start = ()=>{
            this.browserInteractionTime.startTimer();
            this.browserInteractionTime.addTimeIntervalEllapsedCallback({
                callback: (timeInMilliseconds)=>this._sendDwellEvent(this._eventData, this._searchSessionId, timeInMilliseconds, false),
                timeInMilliseconds: this._timing.initialPollInterval,
                multiplier: this._timing.multiplierCallback
            });
            if (typeof window !== 'undefined') window.addEventListener('beforeunload', this._onBeforeUnload);
        };
        /**
	 * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
	 * finalise a dwell measurement without starting a new one. When switching to a new page in a
	 * single-page app, use newPage instead.
	 */ this.stop = ()=>{
            if (this.browserInteractionTime.isRunning()) this._sendDwellEvent(this._eventData, this._searchSessionId, this.browserInteractionTime.getTimeInMilliseconds(), true);
            this.browserInteractionTime.stopTimer();
        };
        /**
	 * Send the final dwell event and reinitialise the dwell timer for a new page.
	 * This method should be called whenever a new page is switched to in a single-page app context.
	 *
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * @param {?string} searchSessionId - the new search session ID.
	 */ this.newPage = (eventData, searchSessionId)=>{
            (0, $jO1re.validateDwellBaseEvent)(eventData);
            this.stop();
            this.browserInteractionTime.reset();
            this.setEventData(eventData);
            this.setSearchSessionId(searchSessionId);
            this.start();
        };
        this.setEventData = (eventData)=>{
            this._eventData = eventData;
        };
        this.getEventData = ()=>this._eventData;
        this.setSearchSessionId = (searchSessionId)=>{
            this._searchSessionId = searchSessionId;
        };
        this.getSearchSessionId = ()=>this._searchSessionId;
        this.destroy = ()=>{
            this.browserInteractionTime.destroy();
            if (typeof window !== 'undefined') window.removeEventListener('beforeunload', this._onBeforeUnload);
        };
        this._onBeforeUnload = ()=>{
            this.stop();
            this.destroy();
        };
        this._sendDwellEvent = (eventData, searchSessionId, timeInMilliseconds, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: timeInMilliseconds,
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: 'dwelled',
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: {
                    ...dwellAttributes,
                    ...eventData.attributes
                },
                tags: eventData.tags
            });
        };
        if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
        (0, $jO1re.validateDwellBaseEvent)(eventData);
        this._trackCallback = trackCallback;
        this._eventData = eventData;
        this._searchSessionId = searchSessionId;
        this._timing = {
            ...$93894541286dde5e$var$DEFAULT_TIMING,
            ...timingOptions
        };
        this.browserInteractionTime = new (0, $cpIwU.default)({
            idleTimeoutMs: this._timing.idleTimeout,
            checkCallbacksIntervalMs: 500
        });
    }
}

});
parcelRegister("jO1re", function(module, exports) {
$parcel$export(module.exports, "validateDwellBaseEvent", () => $19bd3c29a5146bf1$export$39d6334da9a44984);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ function $19bd3c29a5146bf1$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}

});


parcelRegister("gxyIZ", function(module, exports) {
$parcel$export(module.exports, "LooselyLazy", () => $6f4c73b756345cfb$export$33c5f161e1d4706);

var $hJEfu = parcelRequire("hJEfu");

var $isKx1 = parcelRequire("isKx1");

var $c1NIs = parcelRequire("c1NIs");
var $2OUOK = parcelRequire("2OUOK");

var $1bdwq = parcelRequire("1bdwq");

var $f7W9v = parcelRequire("f7W9v");
const $6f4c73b756345cfb$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $isKx1.setConfig)(config);
        (0, $c1NIs.LISTENERS).length = 0;
        (0, $2OUOK.setCurrent)(0);
        if (!(0, $1bdwq.isNodeEnvironment)()) {
            (0, $hJEfu.collect)();
            if (config.markedForPreload) (0, $f7W9v.preloadMarkedIds)(config.markedForPreload);
        }
    }
};

});
parcelRegister("hJEfu", function(module, exports) {
$parcel$export(module.exports, "collect", () => $d8f395a3edc991d9$export$bb44f104e3c54dae);

var $isKx1 = parcelRequire("isKx1");
var $ewaCu = parcelRequire("ewaCu");

var $80sUF = parcelRequire("80sUF");

var $dv02d = parcelRequire("dv02d");

var $jvmCW = parcelRequire("jvmCW");
const $d8f395a3edc991d9$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $isKx1.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $ewaCu.MODE).RENDER ? (0, $dv02d.cloneElements)(markers[i], lazyBegin) : (0, $jvmCW.refElements)(markers[i], lazyBegin);
        if ((0, $80sUF.COLLECTED).has(lazyBegin)) (0, $80sUF.COLLECTED).get(lazyBegin).push(value);
        else (0, $80sUF.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("dv02d", function(module, exports) {
$parcel$export(module.exports, "cloneElements", () => $5f0bd61b4838556c$export$c42217d53a7ebafb);
const $5f0bd61b4838556c$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("jvmCW", function(module, exports) {
$parcel$export(module.exports, "refElements", () => $ce42791bfbc50fd8$export$c69443129766a7fc);
const $ce42791bfbc50fd8$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});



parcelRegister("aoLsE", function(module, exports) {
$parcel$export(module.exports, "LazyWait", () => $16e5c6a6437c9dee$export$7bf6cf03fd32cddb);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $8tMC2 = parcelRequire("8tMC2");
const $16e5c6a6437c9dee$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $euxye.useContext)((0, $8tMC2.WaitContext));
    const value = (0, $euxye.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $euxye.useRef)(new Set());
    const api = (0, $euxye.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $euxye.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8tMC2.WaitContext).Provider, {
        value: api.current,
        children: children
    });
};
$16e5c6a6437c9dee$export$7bf6cf03fd32cddb.displayName = "LazyWait";

});

parcelRegister("iFbIY", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bf7bc6f7732eeea$export$2e2bcd8739ae039);
// @ts-ignore no types for this package :(

var $2IQF9 = parcelRequire("2IQF9");

var $jO1re = parcelRequire("jO1re");
const $9bf7bc6f7732eeea$var$DEFAULT_TIMING = {
    initialPollInterval: 5,
    pollBackoffRate: 2,
    idleTimeout: 30
};
class $9bf7bc6f7732eeea$export$2e2bcd8739ae039 {
    /**
	 * Callback for sending a 'track' analytics event. This callback should either be the
	 * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
	 * The data for the dwell event will be passed to this method for sending.
	 *
	 * @callback trackCallback
	 * @param {Object} eventData - the base event data that will be added to the track event.
	 */ /**
	 * Creates and initialises the DwellTimeHelper.
	 *
	 * @param {trackCallback} trackCallback - the track callback responsible for actually sending
	 * the event.
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * Additional dwell time attributes will be appended to this data. Note that you don't need to
	 * include the 'action' property, as this will be added automatically.
	 * @param {?string} searchSessionId - a unique identifier for the related search session.
	 * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
	 * timing used for measuring dwell time. The following values are possible:
	 * - initialPollInterval: how long to wait before the first dwell milestone event
	 * is fired (in seconds). Default = 5.
	 * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
	 * event. Default = 2.
	 * - idleTimeout: how long to wait for no user activity before pausing
	 * the dwell timer (in seconds). Default = 30s.
	 * @param {?DwellTimeHelperOptions} dwellTimeHelperOptions - options provided to customise behaviour
	 * of the helper.
	 * - iframeDwell = enable detection of activity in iframes.
	 */ constructor(trackCallback, eventData, searchSessionId, timingOptions, dwellTimeHelperOptions){
        this.timeMeInitialized = false;
        /**
	 * Starts the dwell timer. This method should be called upon the initial page load.
	 */ this.start = ()=>{
            if (this.timeMeInitialized) throw new Error('DwellTimeHelper should only be initialised once per page load.');
            this.timeMeInitialized = true;
            this._initDwellTimeCounterAndPolling();
            if (typeof window !== 'undefined') window.addEventListener('beforeunload', ()=>{
                this.stop();
            });
        };
        /**
	 * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
	 * finalise a dwell measurement without starting a new one. When switching to a new page in a
	 * single-page app, use newPage instead.
	 */ this.stop = ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).isUserCurrentlyOnPage) this._sendDwellEvent(this._eventData, this._searchSessionId, true);
            (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).stopAllTimers();
            (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).resetAllRecordedPageTimes();
            (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).timeElapsedCallbacks = [];
            this.timeMeInitialized = false;
        };
        /**
	 * Send the final dwell event and reinitialise the dwell timer for a new page.
	 * This method should be called whenever a new page is switched to in a single-page app context.
	 *
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * @param {?string} searchSessionId - the new search session ID.
	 */ this.newPage = (eventData, searchSessionId)=>{
            (0, $jO1re.validateDwellBaseEvent)(eventData);
            this.stop();
            this._eventData = eventData;
            this._searchSessionId = searchSessionId;
            this._initDwellTimeCounterAndPolling();
        };
        /**
	 * This is a modified version of timeit's original listForIdleEvents function,
	 * which also listens to events inside same-origin iframes (such as Confluence whiteboards and databases).
	 * https://github.com/jasonzissman/TimeMe.js/blob/master/timeme.js#L338
	 */ this._listForIdleEvents = ()=>{
            document.addEventListener('mousemove', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).userActivityDetected();
            });
            document.addEventListener('keyup', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).userActivityDetected();
            });
            document.addEventListener('touchstart', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).userActivityDetected();
            });
            window.addEventListener('scroll', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).userActivityDetected();
            });
            /**
		 * Find all same origin iframes (same origin allow access to contentWindow.document)
		 * and add event listeners to them too.
		 */ const iframes = document.getElementsByTagName('iframe');
            for(let i = 0; i < iframes.length; i++){
                const iframe = iframes[i];
                try {
                    iframe?.contentWindow?.document.addEventListener('mousemove', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).userActivityDetected();
                    });
                    iframe?.contentWindow?.document.addEventListener('keyup', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).userActivityDetected();
                    });
                    iframe?.contentWindow?.document.addEventListener('touchstart', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).userActivityDetected();
                    });
                } catch (e) {
                // do nothing: We don't want to listen to cross-origin iframes
                }
            }
            setInterval(()=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).isUserCurrentlyIdle !== true) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).checkIdleState();
                    // This ensures the timer continues when switching between the iframe and the rest of the page
                    (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).startTimer();
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).checkIdleStateRateMs);
        };
        this._initDwellTimeCounterAndPolling = ()=>{
            // If iframeDwell is enabled, override the listener for idle events to also listen to events in iframes.
            if (this._dwellTimeHelperOptions?.iframeDwell) (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).listForIdleEvents = this._listForIdleEvents;
            (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).initialize({
                idleTimeoutInSeconds: this._timing.idleTimeout
            });
            this._pollDwellTime(this._timing.initialPollInterval, this._searchSessionId, this._eventData);
        };
        this._pollDwellTime = (pollTime, searchSessionId, eventData)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).callAfterTimeElapsedInSeconds(pollTime, ()=>{
                this._sendDwellEvent(eventData, searchSessionId, false);
                this._pollDwellTime(pollTime * this._timing.pollBackoffRate, searchSessionId, eventData);
            });
        };
        this._sendDwellEvent = (eventData, searchSessionId, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: (0, (/*@__PURE__*/$parcel$interopDefault($2IQF9))).getTimeOnCurrentPageInMilliseconds(),
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: 'dwelled',
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                containers: eventData.containers,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: {
                    ...dwellAttributes,
                    ...eventData.attributes
                },
                tags: eventData.tags
            });
        };
        if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
        (0, $jO1re.validateDwellBaseEvent)(eventData);
        this._trackCallback = trackCallback;
        this._eventData = eventData;
        this._searchSessionId = searchSessionId;
        this._timing = {
            ...$9bf7bc6f7732eeea$var$DEFAULT_TIMING,
            ...timingOptions
        };
        this._dwellTimeHelperOptions = dwellTimeHelperOptions;
    }
}

});

/**
 * Character key codes which can be used in keyboard events.
 */ const $48dedd10700aff3c$export$390330c10ff2b9a1 = 'ArrowUp';
const $48dedd10700aff3c$export$a80636c6f41931fe = 'ArrowDown';
const $48dedd10700aff3c$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $48dedd10700aff3c$export$c40f9845adc73fb5 = 'ArrowRight';
const $48dedd10700aff3c$export$4af703091671bc = 'Home';
const $48dedd10700aff3c$export$e2bc30913faa5db7 = 'End';
const $48dedd10700aff3c$export$10f6869ed0a7d75b = 'Tab';
const $48dedd10700aff3c$export$8152f929a25a0ff4 = 'Enter';
const $48dedd10700aff3c$export$e51a3576c045c8d5 = 'Space';
const $48dedd10700aff3c$export$2bb790b9008907b4 = 'Escape';

const $f12a3c5938f2e39b$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $f12a3c5938f2e39b$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $f12a3c5938f2e39b$export$13f57c02915787b3 = 'atlaskit-portal';

const $607cd8ed0bd97f9c$export$ed5835cc67e87f72 = 'akPortalMount';
const $607cd8ed0bd97f9c$export$80816bd900e5bd00 = 'akPortalUnmount';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

/* eslint-disable jira/filename-case */ const $d0b0f317b4f60123$export$881d135f98d8d7d0 = 100;
const $d0b0f317b4f60123$export$9ab5bdcb8a1d6c34 = false;
const $d0b0f317b4f60123$export$f267d0e9ab3eb265 = false;
const $d0b0f317b4f60123$export$12c1dc38ea1692da = 0;
const $d0b0f317b4f60123$export$c6d9b82b8528dcc3 = false;

// same types defined in analytics-web-client but avoid creating dependency with that
const $6d4033511f75ada1$export$a1562d08625f5d7e = 'ui';
const $6d4033511f75ada1$export$947dac6c72b26f81 = 'track';
const $6d4033511f75ada1$export$f1d537d508d2945a = 'screen';
const $6d4033511f75ada1$export$12346a674644c156 = 'operational';
const $6d4033511f75ada1$export$b055de0e665cb20c = 'unknown';

const $9eab319dcc173e7e$export$d6830277b06edd6 = 'normal';
const $9eab319dcc173e7e$export$1eee5ddc4f6d41c5 = 400;

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $c4e639dc1b853f95$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx


$parcel$global.rlb("elvlF")
//# sourceMappingURL=shared~vendor~atlassian~ar.d0bea871.js.map
